var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13503,
    height: 9213,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#fefffe",
    d: "M546.5-.5h1c-.185.67-.519.67-1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.056
    },
    fill: "#fefefe",
    d: "M548.5-.5h12405c.5 1.733 1.3 2.066 2.5 1 188.2 28.679 336.6 122.012 445 280 56 86.841 89.4 181.507 100 284 .3-.916.8-1.582 1.5-2v5c-1.3.333-1.3.667 0 1v8076c-1.3.33-1.3.67 0 1v1c-2.1-.11-2.5.56-1 2-20.2 172.54-97.5 315.04-232 427.5-91.4 72.78-195.1 117.12-311 133-2.9.99-5.9 1.65-9 2 .6.38.9.88 1 1.5H551.5c-2.531-1.8-5.531-2.96-9-3.5-161.913-22.99-296.08-97.49-402.5-223.5-73.182-90.91-118.515-192.91-136-306l-1-14c-.535-3.47-1.702-6.47-3.5-9v-8101c.667 0 1-.333 1-1 18.857-150.541 83.856-279.707 195-387.5C295.896 74.449 412.896 18.949 546.5.5c1.123 1.257 1.789.924 2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#fefffe",
    d: "M-.5 553.5c.667 0 1 .333 1 1l-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#222",
    d: "M1222.5 978.5c57.65-4.511 109.32 10.655 155 45.5 22.39 19.05 39.39 42.05 51 69a5698.235 5698.235 0 0 1-63.5 30.5c-27.43-59.15-73.93-85.99-139.5-80.5-66.92 10.25-109.42 48.08-127.5 113.5-6.94 32.93-7.28 65.93-1 99 15.57 66.91 57.07 106.41 124.5 118.5 36.42 4.92 69.76-2.75 100-23 19.43-15.02 33.93-33.85 43.5-56.5 20.42 9.8 40.92 19.46 61.5 29 .33.67.67 1.33 1 2-6.28 16.58-15.12 31.58-26.5 45-34.07 38.12-76.57 60.62-127.5 67.5-79.29 9.25-145.46-15.59-198.5-74.5-39.98-50.95-57.64-108.95-53-174 5.07-72.67 36.57-130.5 94.5-173.5 32.19-21.563 67.52-34.063 106-37.5ZM3973.5 978.5c-.17 54.67 0 109.33.5 164 .72-.54 1.22-1.21 1.5-2 18.46-23.57 42.8-36.74 73-39.5 46.21-4.39 84.05 11.11 113.5 46.5 13.27 18.54 20.93 39.21 23 62 .5 74.33.67 148.67.5 223h-68c.17-69.33 0-138.67-.5-208-9.74-43.32-36.91-63.48-81.5-60.5-37.63 7.4-58.13 30.23-61.5 68.5-.5 66.67-.67 133.33-.5 200h-67v-454h67Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9d9d",
    d: "M3973.5 978.5c.67 54 1.33 108 2 162-.28.79-.78 1.46-1.5 2-.5-54.67-.67-109.33-.5-164Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#222",
    d: "M8697.5 978.5h67c-.17 90 0 180 .5 270 45.35-46.51 90.52-93.18 135.5-140 28.33-1.17 56.66-1.33 85-.5-40.85 43.35-81.52 86.85-122 130.5 42.58 64.16 84.92 128.5 127 193-26 1.33-52 1.33-78 0-32.75-49.84-65.75-99.51-99-149a3514.969 3514.969 0 0 1-48.5 51c-.5 33-.67 66-.5 99h-67v-454ZM3415.5 1033.5v75h74v60h-74c-.33 54.84 0 109.5 1 164 1.8 23.3 14.13 37.46 37 42.5 13.02.69 26.02.52 39-.5v58a272.305 272.305 0 0 1-57 2.5c-43.63-5.96-71.46-30.13-83.5-72.5-2.04-8.9-3.21-17.9-3.5-27v-167h-57v-60c4.53.32 8.87-.02 13-1 22.62-1.39 36.78-13.06 42.5-35 1.3-12.97 1.8-25.97 1.5-39h67ZM3763.5 1033.5v75h74v60h-74c-.33 54.84 0 109.5 1 164 1.8 23.3 14.13 37.46 37 42.5 13.02.69 26.02.52 39-.5v58a272.305 272.305 0 0 1-57 2.5c-43.63-5.96-71.46-30.13-83.5-72.5-2.04-8.9-3.21-17.9-3.5-27v-167h-57v-60c4.53.32 8.87-.02 13-1 22.62-1.39 36.78-13.06 42.5-35 1.3-12.97 1.8-25.97 1.5-39h67ZM7191.5 1033.5v75h74v60h-74c-.33 54.84 0 109.5 1 164 1.8 23.3 14.13 37.46 37 42.5 13.02.69 26.02.52 39-.5v58a272.305 272.305 0 0 1-57 2.5c-43.63-5.96-71.46-30.13-83.5-72.5-2.04-8.9-3.21-17.9-3.5-27v-167h-57v-60c4.53.32 8.87-.02 13-1 22.62-1.39 36.78-13.06 42.5-35 1.3-12.97 1.8-25.97 1.5-39h67ZM7847.5 1033.5v75h74v60h-74c-.33 54.84 0 109.5 1 164 1.8 23.3 14.13 37.46 37 42.5 13.02.69 26.02.52 39-.5v58a272.305 272.305 0 0 1-57 2.5c-43.63-5.96-71.46-30.13-83.5-72.5-2.04-8.9-3.21-17.9-3.5-27v-167h-57v-60c4.53.32 8.87-.02 13-1 22.62-1.39 36.78-13.06 42.5-35 1.3-12.97 1.8-25.97 1.5-39h67ZM1632.5 1100.5c58.63-3.09 107.13 17.24 145.5 61 29.4 37.57 41.4 80.24 36 128-6.67 55.89-33.84 98.39-81.5 127.5-42.08 22.76-86.42 28.43-133 17-58.25-17.91-97.08-55.75-116.5-113.5-16.32-58.78-5.99-112.12 31-160 31.43-35.8 70.93-55.8 118.5-60ZM1880.5 1432.5v-324h64c-.17 12.67 0 25.34.5 38 .72-.54 1.22-1.21 1.5-2 18.53-25.95 43.86-40.45 76-43.5 46.21-4.39 84.05 11.11 113.5 46.5 13.81 19.09 21.47 40.42 23 64 .5 73.67.67 147.33.5 221h-68c.48-71.36-.02-142.69-1.5-214-6.14-26.13-21.97-43.3-47.5-51.5-34.54-9.59-62.38-.09-83.5 28.5-6.5 11.49-10.16 23.82-11 37-.5 66.67-.67 133.33-.5 200h-67ZM2232.5 1432.5v-324h64c-.17 12.67 0 25.34.5 38 .72-.54 1.22-1.21 1.5-2 18.53-25.95 43.86-40.45 76-43.5 46.21-4.39 84.05 11.11 113.5 46.5 13.81 19.09 21.47 40.42 23 64 .5 73.67.67 147.33.5 221h-68c.48-71.36-.02-142.69-1.5-214-6.14-26.13-21.97-43.3-47.5-51.5-34.54-9.59-62.38-.09-83.5 28.5-6.5 11.49-10.16 23.82-11 37-.5 66.67-.67 133.33-.5 200h-67ZM2716.5 1100.5c39.35-2.66 75.35 6.84 108 28.5 34.82 27.8 54.99 63.97 60.5 108.5.92 17.39.42 34.72-1.5 52h-242c4.17 44.52 27.51 73.68 70 87.5 46.73 9.83 83.06-5 109-44.5 17.54 8.94 35.21 17.61 53 26 1.08.86 1.25 1.86.5 3-18.98 36.63-48.48 60.46-88.5 71.5-58.31 15.86-110.98 5.2-158-32-35.55-32.93-54.38-73.76-56.5-122.5-2.95-61.93 19.89-111.76 68.5-149.5 23.26-16.14 48.93-25.64 77-28.5ZM3091.5 1100.5c53.6-2.65 98.76 15.35 135.5 54 9.08 10.98 16.24 23.15 21.5 36.5-19.33 10-39 19.5-59 28.5-19.31-40.09-51.31-58.59-96-55.5-41.53 7.2-68.37 31.03-80.5 71.5-10.25 40.34-2.91 77 22 110 28.03 29.05 61.53 37.88 100.5 26.5 21-7.66 37.16-21.16 48.5-40.5a39.37 39.37 0 0 0 4.5-11 620.268 620.268 0 0 1 60 29c-19.19 42.45-51.19 70.28-96 83.5-69.13 17.94-127.63.77-175.5-51.5-29.06-37.18-42.06-79.52-39-127 5.23-58.01 32.4-102.18 81.5-132.5 22.57-12.36 46.57-19.53 72-21.5ZM4390.5 1100.5c39.35-2.66 75.35 6.84 108 28.5 34.82 27.8 54.99 63.97 60.5 108.5.92 17.39.42 34.72-1.5 52h-242c4.17 44.52 27.51 73.68 70 87.5 46.73 9.83 83.06-5 109-44.5 17.54 8.94 35.21 17.61 53 26 1.08.86 1.25 1.86.5 3-18.98 36.63-48.48 60.46-88.5 71.5-58.31 15.86-110.98 5.2-158-32-35.55-32.93-54.38-73.76-56.5-122.5-2.95-61.93 19.89-111.76 68.5-149.5 23.26-16.14 48.93-25.64 77-28.5ZM4799.5 1396.5c-.06-.54-.39-.88-1-1-1 52.33-1.33 104.66-1 157h-67v-444h64c-.33 13.75 0 26.75 1 39 28.25-31.1 63.58-46.77 106-47 70.11 1.78 120.27 34.12 150.5 97 12.64 30.13 16.97 61.46 13 94-6.69 53.91-32.52 95.74-77.5 125.5-36.18 20.6-74.85 27.27-116 20-28.7-5.51-52.7-19.01-72-40.5ZM5335.5 1432.5c.33-12.35 0-24.68-1-37-.61.12-.94.46-1 1-28.16 29.01-62.66 43.35-103.5 43-35.04 1.66-65.04-9.68-90-34-17.82-21.84-24.49-46.84-20-75 6.09-32.42 23.93-55.92 53.5-70.5a179.112 179.112 0 0 1 45-15c37.68-6.17 75.34-12.34 113-18.5 2.97-38.54-14.7-60.7-53-66.5-40.84-3.25-70.51 13.25-89 49.5l-54-27c-.33-.67-.67-1.33-1-2 11.55-26.72 30.22-46.88 56-60.5 46.26-23.21 93.6-25.54 142-7 37.08 16.42 59.25 44.58 66.5 84.5.5 78.33.67 156.67.5 235h-64ZM5821.5 1432.5v-324h64c-.33 12.68 0 25.35 1 38 .61-.12.94-.46 1-1 12.84-20.77 31.17-34.27 55-40.5 43.69-10.66 82.69-1.66 117 27 6.84 6.86 12.84 14.36 18 22.5 29.63-42.18 70.3-59.68 122-52.5 43.99 8.57 74.83 33.4 92.5 74.5 3.29 8.76 5.63 17.76 7 27 .5 76.33.67 152.67.5 229h-67c.17-66.67 0-133.33-.5-200-2.32-37.65-21.82-60.48-58.5-68.5-43.56-2.44-69.73 17.72-78.5 60.5-.5 69.33-.67 138.67-.5 208h-68c.17-69.67 0-139.33-.5-209-7.36-38.7-30.7-58.7-70-60-31.27 1.95-52.27 17.61-63 47a99.711 99.711 0 0 0-4 23c-.5 66.33-.67 132.67-.5 199h-67ZM6504.5 1100.5c39.35-2.66 75.35 6.84 108 28.5 34.82 27.8 54.99 63.97 60.5 108.5.92 17.39.42 34.72-1.5 52h-242c4.17 44.52 27.51 73.68 70 87.5 46.73 9.83 83.06-5 109-44.5 17.54 8.94 35.21 17.61 53 26 1.08.86 1.25 1.86.5 3-18.98 36.63-48.48 60.46-88.5 71.5-58.31 15.86-110.98 5.2-158-32-35.55-32.93-54.38-73.76-56.5-122.5-2.95-61.93 19.89-111.76 68.5-149.5 23.26-16.14 48.93-25.64 77-28.5ZM6740.5 1432.5v-324h64c-.17 12.67 0 25.34.5 38 .72-.54 1.22-1.21 1.5-2 18.53-25.95 43.86-40.45 76-43.5 46.21-4.39 84.05 11.11 113.5 46.5 13.81 19.09 21.47 40.42 23 64 .5 73.67.67 147.33.5 221h-68c.48-71.36-.02-142.69-1.5-214-6.14-26.13-21.97-43.3-47.5-51.5-34.54-9.59-62.38-.09-83.5 28.5-6.5 11.49-10.16 23.82-11 37-.5 66.67-.67 133.33-.5 200h-67ZM7535.5 1100.5c38.93-2.68 74.26 7.15 106 29.5 17.43 14.01 30.09 31.51 38 52.5a604.87 604.87 0 0 1-51 25c-22.15-41.24-56.15-56.74-102-46.5-23.18 10.85-29.68 28.02-19.5 51.5 8.63 9.41 19.13 15.91 31.5 19.5 20.29 6.16 40.62 12.16 61 18 29.51 7.82 52.68 24.32 69.5 49.5 12.49 25.36 13.83 51.36 4 78-12.83 27.82-33.99 45.99-63.5 54.5-53.45 16.12-102.78 8.12-148-24-19.62-15.45-33.62-34.95-42-58.5a1221.61 1221.61 0 0 1 51.5-25c11.45 23.11 28.61 40.61 51.5 52.5 21.75 9.25 43.75 9.92 66 2 19.53-8.55 27.36-23.39 23.5-44.5-5.66-11.99-14.83-20.16-27.5-24.5-25.35-7.34-50.68-14.67-76-22-61.85-22.53-83.68-65.36-65.5-128.5 14.27-27.42 36.44-45.25 66.5-53.5 8.79-1.92 17.46-3.76 26-5.5ZM8190.5 1432.5c.33-12.35 0-24.68-1-37-.61.12-.94.46-1 1-28.16 29.01-62.66 43.35-103.5 43-35.04 1.66-65.04-9.68-90-34-17.82-21.84-24.49-46.84-20-75 6.09-32.42 23.93-55.92 53.5-70.5a179.112 179.112 0 0 1 45-15c37.68-6.17 75.34-12.34 113-18.5 2.97-38.54-14.7-60.7-53-66.5-40.84-3.25-70.51 13.25-89 49.5l-54-27c-.33-.67-.67-1.33-1-2 11.55-26.72 30.22-46.88 56-60.5 46.26-23.21 93.6-25.54 142-7 37.08 16.42 59.25 44.58 66.5 84.5.5 78.33.67 156.67.5 235h-64ZM8473.5 1100.5c53.6-2.65 98.76 15.35 135.5 54 9.08 10.98 16.24 23.15 21.5 36.5-19.33 10-39 19.5-59 28.5-19.31-40.09-51.31-58.59-96-55.5-41.53 7.2-68.37 31.03-80.5 71.5-10.25 40.34-2.91 77 22 110 28.03 29.05 61.53 37.88 100.5 26.5 21-7.66 37.16-21.16 48.5-40.5a39.37 39.37 0 0 0 4.5-11 620.268 620.268 0 0 1 60 29c-19.19 42.45-51.19 70.28-96 83.5-69.13 17.94-127.63.77-175.5-51.5-29.06-37.18-42.06-79.52-39-127 5.23-58.01 32.4-102.18 81.5-132.5 22.57-12.36 46.57-19.53 72-21.5ZM9621.5 1100.5c58.63-3.09 107.13 17.24 145.5 61 29.4 37.57 41.4 80.24 36 128-6.67 55.89-33.84 98.39-81.5 127.5-42.08 22.76-86.42 28.43-133 17-58.25-17.91-97.08-55.75-116.5-113.5-16.32-58.78-5.99-112.12 31-160 31.43-35.8 70.93-55.8 118.5-60Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#828181",
    d: "M3415.5 1033.5c1 24.49 1.33 49.16 1 74 24.51-.33 48.84 0 73 1h-74v-75ZM3763.5 1033.5c1 24.49 1.33 49.16 1 74 24.51-.33 48.84 0 73 1h-74v-75Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767575",
    d: "M5700.5 1108.5c24.5-1.33 49.17-1.33 74 0-.12.61-.46.94-1 1-24.16-1-48.49-1.33-73-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#828181",
    d: "M7191.5 1033.5c1 24.49 1.33 49.16 1 74 24.51-.33 48.84 0 73 1h-74v-75ZM7847.5 1033.5c1 24.49 1.33 49.16 1 74 24.51-.33 48.84 0 73 1h-74v-75Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767575",
    d: "M9363.5 1108.5c24.5-1.33 49.17-1.33 74 0-.12.61-.46.94-1 1-24.16-1-48.49-1.33-73-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M1946.5 1144.5c-.28.79-.78 1.46-1.5 2-.5-12.66-.67-25.33-.5-38h-64v324c-1-108.17-1.33-216.5-1-325h66c-.33 12.51 0 24.84 1 37ZM2298.5 1144.5c-.28.79-.78 1.46-1.5 2-.5-12.66-.67-25.33-.5-38h-64v324c-1-108.17-1.33-216.5-1-325h66c-.33 12.51 0 24.84 1 37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999",
    d: "M4795.5 1147.5c-1-12.25-1.33-25.25-1-39h-64v444c-1-148.17-1.33-296.5-1-445h66v40Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#222",
    d: "M5700.5 1108.5c24.51-.33 48.84 0 73 1-48.15 120.97-96.32 241.97-144.5 363-12.41 32.39-32.91 58.22-61.5 77.5-26.83 13.97-55.16 18.3-85 13-6.75-1.3-13.08-3.47-19-6.5-.65-19.36.01-38.36 2-57 18.89 4.59 37.89 5.09 57 1.5 14.76-4.76 25.93-13.92 33.5-27.5a408.622 408.622 0 0 0 18.5-41.5 44608.636 44608.636 0 0 0-128-323.5c24.23-1.33 48.4-1.33 72.5 0 30.33 79 60.67 158 91 237 30.47-78.91 60.63-157.91 90.5-237Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989797",
    d: "M5887.5 1145.5c-.06.54-.39.88-1 1-1-12.65-1.33-25.32-1-38h-64v324c-1-108.17-1.33-216.5-1-325h66c-.33 12.84 0 25.51 1 38Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M6806.5 1144.5c-.28.79-.78 1.46-1.5 2-.5-12.66-.67-25.33-.5-38h-64v324c-1-108.17-1.33-216.5-1-325h66c-.33 12.51 0 24.84 1 37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#222",
    d: "M9363.5 1108.5c24.51-.33 48.84 0 73 1-48.15 120.97-96.32 241.97-144.5 363-12.41 32.39-32.91 58.22-61.5 77.5-26.83 13.97-55.16 18.3-85 13-6.75-1.3-13.08-3.47-19-6.5-.65-19.36.01-38.36 2-57 18.89 4.59 37.89 5.09 57 1.5 14.76-4.76 25.93-13.92 33.5-27.5a408.622 408.622 0 0 0 18.5-41.5 44608.636 44608.636 0 0 0-128-323.5c24.23-1.33 48.4-1.33 72.5 0 30.33 79 60.67 158 91 237 30.47-78.91 60.63-157.91 90.5-237ZM9862.5 1108.5h67c-.33 65.84 0 131.5 1 197 2.75 44.75 26.41 68.41 71 71 42.2-2.17 66.2-24.17 72-66 1-67.16 1.3-134.5 1-202h67v324h-64c.2-13 0-26-.5-39-16.9 25.05-40.4 39.88-70.5 44.5-44 7.22-81.5-4.94-112.5-36.5-18.35-22.68-28.68-48.68-31-78-.5-71.67-.67-143.33-.5-215Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#545353",
    d: "M9862.5 1108.5c22.49-1 45.16-1.33 68-1v198c-1-65.5-1.33-131.16-1-197h-67Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5b4b4",
    d: "M10141.5 1108.5h-67c.3 67.5 0 134.84-1 202v-203c22.8-.33 45.5 0 68 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M2813.5 1228.5v7h-170c7.32-43.49 32.66-69.32 76-77.5 44.48-3.36 74.98 15.47 91.5 56.5 1.47 4.56 2.31 9.23 2.5 14ZM4487.5 1228.5v7h-170c7.32-43.49 32.66-69.32 76-77.5 44.48-3.36 74.98 15.47 91.5 56.5 1.47 4.56 2.31 9.23 2.5 14ZM6601.5 1228.5v7h-170c7.32-43.49 32.66-69.32 76-77.5 44.48-3.36 74.98 15.47 91.5 56.5 1.47 4.56 2.31 9.23 2.5 14ZM1633.5 1163.5c53.06-2.41 88.56 21.26 106.5 71 10.19 38.22 4.19 73.56-18 106-27.96 32.2-62.79 43.03-104.5 32.5-42.57-15.6-66.07-46.1-70.5-91.5-3.68-36.63 7.49-67.8 33.5-93.5 15.46-13.07 33.13-21.23 53-24.5ZM4885.5 1163.5c60.69-.81 97.19 28.52 109.5 88 4 30.74-2.34 59.07-19 85-23.45 30.83-54.62 44-93.5 39.5-48.92-10.59-76.75-40.76-83.5-90.5-6.01-47.06 10.49-83.56 49.5-109.5 11.7-6.49 24.04-10.66 37-12.5ZM9622.5 1163.5c53.06-2.41 88.56 21.26 106.5 71 10.19 38.22 4.19 73.56-18 106-27.96 32.2-62.79 43.03-104.5 32.5-42.57-15.6-66.07-46.1-70.5-91.5-3.68-36.63 7.49-67.8 33.5-93.5 15.46-13.07 33.13-21.23 53-24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999",
    d: "M3304.5 1107.5c-4.13.98-8.47 1.32-13 1v60h57v167c-1-55.16-1.33-110.5-1-166h-57v-62h14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929292",
    d: "M3489.5 1168.5c-24.16 1-48.49 1.33-73 1v163c-1-54.5-1.33-109.16-1-164h74Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999",
    d: "M3652.5 1107.5c-4.13.98-8.47 1.32-13 1v60h57v167c-1-55.16-1.33-110.5-1-166h-57v-62h14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929292",
    d: "M3837.5 1168.5c-24.16 1-48.49 1.33-73 1v163c-1-54.5-1.33-109.16-1-164h74Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999",
    d: "M7080.5 1107.5c-4.13.98-8.47 1.32-13 1v60h57v167c-1-55.16-1.33-110.5-1-166h-57v-62h14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929292",
    d: "M7265.5 1168.5c-24.16 1-48.49 1.33-73 1v163c-1-54.5-1.33-109.16-1-164h74Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999",
    d: "M7736.5 1107.5c-4.13.98-8.47 1.32-13 1v60h57v167c-1-55.16-1.33-110.5-1-166h-57v-62h14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929292",
    d: "M7921.5 1168.5c-24.16 1-48.49 1.33-73 1v163c-1-54.5-1.33-109.16-1-164h74Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f4e4e",
    d: "M2813.5 1228.5c.97 2.45 1.31 5.11 1 8-57.17.33-114.17 0-171-1h170v-7ZM4487.5 1228.5c.97 2.45 1.31 5.11 1 8-57.17.33-114.17 0-171-1h170v-7ZM6601.5 1228.5c.97 2.45 1.31 5.11 1 8-57.17.33-114.17 0-171-1h170v-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M5329.5 1280.5c1.97 7.6 2.63 15.6 2 24-4.91 41.74-27.57 68.24-68 79.5-16.22 3.89-32.22 3.23-48-2-25.84-14.21-32.34-34.71-19.5-61.5 5.31-7.65 12.15-13.48 20.5-17.5 8.98-3.88 18.31-6.55 28-8 28.32-4.97 56.65-9.81 85-14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c6b6b",
    d: "M5329.5 1280.5c.71-.9 1.71-1.24 3-1 .33 8.52-.01 16.85-1 25 .63-8.4-.03-16.4-2-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M8184.5 1280.5c1.97 7.6 2.63 15.6 2 24-4.91 41.74-27.57 68.24-68 79.5-16.22 3.89-32.22 3.23-48-2-25.84-14.21-32.34-34.71-19.5-61.5 5.31-7.65 12.15-13.48 20.5-17.5 8.98-3.88 18.31-6.55 28-8 28.32-4.97 56.65-9.81 85-14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c6b6b",
    d: "M8184.5 1280.5c.71-.9 1.71-1.24 3-1 .33 8.52-.01 16.85-1 25 .63-8.4-.03-16.4-2-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9d9d",
    d: "M4799.5 1396.5c-.67 52-1.33 104-2 156-.33-52.34 0-104.67 1-157 .61.12.94.46 1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#757474",
    d: "M5333.5 1396.5c.06-.54.39-.88 1-1 1 12.32 1.33 24.65 1 37-.67-12-1.33-24-2-36ZM8188.5 1396.5c.06-.54.39-.88 1-1 1 12.32 1.33 24.65 1 37-.67-12-1.33-24-2-36Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#747373",
    d: "M5465.5 1499.5c-1.99 18.64-2.65 37.64-2 57-1-19.16-1.33-38.49-1-58 1.29-.24 2.29.1 3 1ZM9128.5 1499.5c-1.99 18.64-2.65 37.64-2 57-1-19.16-1.33-38.49-1-58 1.29-.24 2.29.1 3 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d4c4c",
    d: "M2372.5 1703.5c.33 55.67 0 111.34-1 167-.61-.12-.94-.46-1-1 .67-55.33 1.33-110.67 2-166Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#222",
    d: "M2372.5 1703.5h66v454h-64c.17-13.34 0-26.67-.5-40-20.87 24.53-47.37 39.36-79.5 44.5-72.08 10.11-127.91-15.05-167.5-75.5-24.31-44.56-30.31-91.56-18-141 22.12-69.45 69.29-109.29 141.5-119.5 40.17-3.6 76.17 6.73 108 31 4.2 4.04 8.2 8.2 12 12.5.06.54.39.88 1 1 1-55.66 1.33-111.33 1-167Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#212221",
    d: "M5641.5 1703.5h67v454h-67v-454ZM2623.5 1710.5h67v78h-67v-78ZM4750.5 1710.5h67v78h-67v-78ZM6261.5 1710.5h67v78h-67v-78ZM8558.5 1710.5h67v78h-67v-78Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#222",
    d: "M6860.5 1758.5v75h74v60h-74c-.33 54.84 0 109.5 1 164 1.8 23.3 14.13 37.46 37 42.5 13.02.69 26.02.52 39-.5v58a272.305 272.305 0 0 1-57 2.5c-43.63-5.96-71.46-30.13-83.5-72.5a123.618 123.618 0 0 1-3.5-31v-163h-57v-60c4.53.32 8.87-.02 13-1 22.62-1.39 36.79-13.06 42.5-35 1.3-12.97 1.8-25.97 1.5-39h67ZM8415.5 1758.5v75h74v60h-74c-.33 54.84 0 109.5 1 164 1.8 23.3 14.13 37.46 37 42.5 13.02.69 26.02.52 39-.5v58a272.305 272.305 0 0 1-57 2.5c-43.63-5.96-71.46-30.13-83.5-72.5a123.618 123.618 0 0 1-3.5-31v-163h-57v-60c4.53.32 8.87-.02 13-1 22.62-1.39 36.79-13.06 42.5-35 1.3-12.97 1.8-25.97 1.5-39h67ZM1028.5 2157.5v-324h64c-.17 12.67 0 25.34.5 38 .72-.54 1.22-1.21 1.5-2 14.45-20.91 34.12-34.41 59-40.5 40.51-8.6 77.51-.94 111 23 25.46 22.42 39.63 50.59 42.5 84.5.5 73.67.67 147.33.5 221h-68c.48-71.36-.02-142.69-1.5-214-6.14-26.13-21.97-43.3-47.5-51.5-34.54-9.59-62.38-.09-83.5 28.5-6.5 11.49-10.16 23.82-11 37-.5 66.67-.67 133.33-.5 200h-67ZM1512.5 1825.5c39.35-2.66 75.35 6.84 108 28.5 34.82 27.8 54.99 63.97 60.5 108.5.92 17.39.42 34.72-1.5 52h-242c4.99 49.16 31.66 78.99 80 89.5 42.87 4.89 75.87-10.61 99-46.5 17.54 8.94 35.21 17.61 53 26 1.08.86 1.25 1.86.5 3-18.98 36.63-48.48 60.46-88.5 71.5-58.32 15.86-110.98 5.2-158-32-35.55-32.95-54.39-73.78-56.5-122.5-2.95-61.93 19.89-111.76 68.5-149.5 23.26-16.14 48.93-25.64 77-28.5ZM1880.5 1825.5c39.35-2.66 75.35 6.84 108 28.5 34.82 27.8 54.99 63.97 60.5 108.5.92 17.39.42 34.72-1.5 52h-242c4.99 49.16 31.66 78.99 80 89.5 42.87 4.89 75.87-10.61 99-46.5 17.54 8.94 35.21 17.61 53 26 1.08.86 1.25 1.86.5 3-18.98 36.63-48.48 60.46-88.5 71.5-58.32 15.86-110.98 5.2-158-32-35.55-32.95-54.39-73.78-56.5-122.5-2.95-61.93 19.89-111.76 68.5-149.5 23.26-16.14 48.93-25.64 77-28.5ZM2770.5 2157.5v-324h64c-.17 12.67 0 25.34.5 38 .72-.54 1.22-1.21 1.5-2 14.45-20.91 34.12-34.41 59-40.5 40.51-8.6 77.51-.94 111 23 25.46 22.42 39.63 50.59 42.5 84.5.5 73.67.67 147.33.5 221h-68c.48-71.36-.02-142.69-1.5-214-6.14-26.13-21.97-43.3-47.5-51.5-34.54-9.59-62.38-.09-83.5 28.5-6.5 11.49-10.16 23.82-11 37-.5 66.67-.67 133.33-.5 200h-67ZM3369.5 1825.5c58.63-3.09 107.13 17.24 145.5 61 29.4 37.57 41.4 80.24 36 128-8.62 66.12-43.45 112.29-104.5 138.5-61.64 21.89-118.64 13.56-171-25-46.89-40.3-67.39-91.47-61.5-153.5 8.88-65.61 43.72-111.45 104.5-137.5 16.66-5.99 33.66-9.82 51-11.5ZM3618.5 2157.5v-324h64c-.17 12.67 0 25.34.5 38 .72-.54 1.22-1.21 1.5-2 14.45-20.91 34.12-34.41 59-40.5 40.51-8.6 77.51-.94 111 23 25.46 22.42 39.63 50.59 42.5 84.5.5 73.67.67 147.33.5 221h-68c.48-71.36-.02-142.69-1.5-214-6.14-26.13-21.97-43.3-47.5-51.5-34.54-9.59-62.38-.09-83.5 28.5-6.5 11.49-10.16 23.82-11 37-.5 66.67-.67 133.33-.5 200h-67ZM4102.5 1825.5c39.35-2.66 75.35 6.84 108 28.5 34.82 27.8 54.99 63.97 60.5 108.5.92 17.39.42 34.72-1.5 52h-242c4.99 49.16 31.66 78.99 80 89.5 42.87 4.89 75.87-10.61 99-46.5 17.54 8.94 35.21 17.61 53 26 1.08.86 1.25 1.86.5 3-18.98 36.63-48.48 60.46-88.5 71.5-58.32 15.86-110.98 5.2-158-32-35.55-32.95-54.39-73.78-56.5-122.5-2.95-61.93 19.89-111.76 68.5-149.5 23.26-16.14 48.93-25.64 77-28.5ZM4541.5 1825.5c37.87-2.12 72.21 7.71 103 29.5 17.43 14.01 30.09 31.51 38 52.5a604.87 604.87 0 0 1-51 25c-22.15-41.24-56.15-56.74-102-46.5-23.18 10.85-29.68 28.02-19.5 51.5 8.63 9.41 19.13 15.91 31.5 19.5 20.29 6.16 40.62 12.16 61 18 29.51 7.82 52.68 24.32 69.5 49.5 12.49 25.36 13.83 51.36 4 78-12.83 27.82-33.99 45.99-63.5 54.5-53.44 16.12-102.78 8.12-148-24-19.62-15.45-33.62-34.95-42-58.5a1221.61 1221.61 0 0 1 51.5-25c11.45 23.11 28.61 40.61 51.5 52.5 21.75 9.25 43.75 9.92 66 2 19.57-8.63 27.4-23.47 23.5-44.5-5.66-11.99-14.83-20.16-27.5-24.5-25.35-7.34-50.68-14.67-76-22-61.85-22.54-83.68-65.37-65.5-128.5 15.89-30.18 40.72-48.68 74.5-55.5 7.18-.93 14.18-2.1 21-3.5ZM4897.5 2157.5v-324h64c-.17 12.67 0 25.34.5 38 .72-.54 1.22-1.21 1.5-2 14.45-20.91 34.12-34.41 59-40.5 40.51-8.6 77.51-.94 111 23 25.46 22.42 39.63 50.59 42.5 84.5.5 73.67.67 147.33.5 221h-68c.48-71.36-.02-142.69-1.5-214-6.14-26.13-21.97-43.3-47.5-51.5-34.54-9.59-62.38-.09-83.5 28.5-6.5 11.49-10.16 23.82-11 37-.5 66.67-.67 133.33-.5 200h-67ZM5496.5 1873.5c.06.54.39.88 1 1 1-13.65 1.33-27.32 1-41h63v315c-4 62.19-34.67 105.35-92 129.5-58.9 20.63-114.57 14.3-167-19-21.38-15.09-37.05-34.76-47-59a1221.44 1221.44 0 0 1 61-25.5c15.25 29.7 39.58 46.87 73 51.5 23.21 2.47 45.21-1.53 66-12 21.96-13.4 34.79-32.9 38.5-58.5.67-17.67.67-35.33 0-53-22.71 26.27-51.54 40.77-86.5 43.5-53.49 4.33-98.32-13.17-134.5-52.5-30.73-38.23-43.06-81.9-37-131 10.23-63.56 45.4-106.72 105.5-129.5 42.22-12.98 82.88-9.31 122 11 13.03 7.53 24.03 17.36 33 29.5ZM5920.5 1825.5c39.35-2.66 75.35 6.84 108 28.5 34.82 27.8 54.99 63.97 60.5 108.5.92 17.39.42 34.72-1.5 52h-242c4.99 49.16 31.66 78.99 80 89.5 42.87 4.89 75.87-10.61 99-46.5 17.54 8.94 35.21 17.61 53 26 1.08.86 1.25 1.86.5 3-18.98 36.63-48.48 60.46-88.5 71.5-58.32 15.86-110.98 5.2-158-32-35.55-32.95-54.39-73.78-56.5-122.5-2.95-61.93 19.89-111.76 68.5-149.5 23.26-16.14 48.93-25.64 77-28.5ZM6408.5 2157.5v-324h64c-.17 12.67 0 25.34.5 38 .72-.54 1.22-1.21 1.5-2 14.45-20.91 34.12-34.41 59-40.5 40.51-8.6 77.51-.94 111 23 25.46 22.42 39.63 50.59 42.5 84.5.5 73.67.67 147.33.5 221h-68c.48-71.36-.02-142.69-1.5-214-6.14-26.13-21.97-43.3-47.5-51.5-34.54-9.59-62.38-.09-83.5 28.5-6.5 11.49-10.16 23.82-11 37-.5 66.67-.67 133.33-.5 200h-67ZM7129.5 1825.5c39.35-2.66 75.35 6.84 108 28.5 34.82 27.8 54.99 63.97 60.5 108.5.92 17.39.42 34.72-1.5 52h-242c4.99 49.16 31.66 78.99 80 89.5 42.87 4.89 75.87-10.61 99-46.5 17.54 8.94 35.21 17.61 53 26 1.08.86 1.25 1.86.5 3-18.98 36.63-48.48 60.46-88.5 71.5-58.32 15.86-110.98 5.2-158-32-35.55-32.95-54.39-73.78-56.5-122.5-2.95-61.93 19.89-111.76 68.5-149.5 23.26-16.14 48.93-25.64 77-28.5ZM7612.5 1873.5c.06.54.39.88 1 1 1-13.65 1.33-27.32 1-41h63v315c-4 62.19-34.67 105.35-92 129.5-58.9 20.63-114.57 14.3-167-19-21.38-15.09-37.05-34.76-47-59a1221.44 1221.44 0 0 1 61-25.5c15.25 29.7 39.58 46.87 73 51.5 23.21 2.47 45.21-1.53 66-12 21.96-13.4 34.79-32.9 38.5-58.5.67-17.67.67-35.33 0-53-22.71 26.27-51.54 40.77-86.5 43.5-53.49 4.33-98.32-13.17-134.5-52.5-30.73-38.23-43.06-81.9-37-131 10.23-63.56 45.4-106.72 105.5-129.5 42.22-12.98 82.88-9.31 122 11 13.03 7.53 24.03 17.36 33 29.5ZM8178.5 2157.5c.33-12.35 0-24.68-1-37-.61.12-.94.46-1 1-28.69 29.58-63.86 43.91-105.5 43-34.29 1.17-63.63-10.16-88-34-17.82-21.84-24.49-46.84-20-75 6.09-32.42 23.93-55.92 53.5-70.5a210.186 210.186 0 0 1 45-15c37.66-6.17 75.33-12.33 113-18.5 2.97-38.54-14.7-60.7-53-66.5-40.84-3.25-70.51 13.25-89 49.5l-54-27c-.33-.67-.67-1.33-1-2 11.55-26.72 30.22-46.88 56-60.5 46.26-23.21 93.6-25.54 142-7 37.08 16.42 59.25 44.58 66.5 84.5.5 78.33.67 156.67.5 235h-64ZM8848.5 1825.5c58.63-3.09 107.13 17.24 145.5 61 29.4 37.57 41.4 80.24 36 128-8.62 66.12-43.45 112.29-104.5 138.5-61.64 21.89-118.64 13.56-171-25-46.89-40.3-67.39-91.47-61.5-153.5 8.88-65.61 43.72-111.45 104.5-137.5 16.66-5.99 33.66-9.82 51-11.5ZM9097.5 2157.5v-324h64c-.17 12.67 0 25.34.5 38 .72-.54 1.22-1.21 1.5-2 14.45-20.91 34.12-34.41 59-40.5 40.51-8.6 77.51-.94 111 23 25.46 22.42 39.63 50.59 42.5 84.5.5 73.67.67 147.33.5 221h-68c.48-71.36-.02-142.69-1.5-214-6.14-26.13-21.97-43.3-47.5-51.5-34.54-9.59-62.38-.09-83.5 28.5-6.5 11.49-10.16 23.82-11 37-.5 66.67-.67 133.33-.5 200h-67ZM7893.5 1829.5h34v61c-13.67-.17-27.34 0-41 .5-37.14 7.74-57.64 30.57-61.5 68.5-.5 66-.67 132-.5 198h-67v-324h64c-.17 13.34 0 26.67.5 40 .72-.54 1.22-1.21 1.5-2 11.24-19.72 27.91-32.56 50-38.5 6.53-2.01 13.2-3.17 20-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e6d6d",
    d: "M7893.5 1829.5c11.49-.99 23.15-1.33 35-1 .33 20.84 0 41.51-1 62v-61h-34Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f7f7f",
    d: "M5561.5 2148.5v-315h-63c.33 13.68 0 27.35-1 41-.61-.12-.94-.46-1-1 1-13.49 1.33-27.16 1-41h65c.33 105.5 0 210.83-1 316Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#828181",
    d: "M6860.5 1758.5c1 24.49 1.33 49.16 1 74 24.51-.33 48.84 0 73 1h-74v-75Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f7f7f",
    d: "M7677.5 2148.5v-315h-63c.33 13.68 0 27.35-1 41-.61-.12-.94-.46-1-1 1-13.49 1.33-27.16 1-41h65c.33 105.5 0 210.83-1 316Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#828181",
    d: "M8415.5 1758.5c1 24.49 1.33 49.16 1 74 24.51-.33 48.84 0 73 1h-74v-75Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M1094.5 1869.5c-.28.79-.78 1.46-1.5 2-.5-12.66-.67-25.33-.5-38h-64v324c-1-108.17-1.33-216.5-1-325h66c-.33 12.51 0 24.84 1 37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999",
    d: "M2690.5 2157.5v-324h-67v324c-1-108.17-1.33-216.5-1-325h69c.33 108.5 0 216.83-1 325Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#212221",
    d: "M2690.5 2157.5h-67v-324h67v324Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M2836.5 1869.5c-.28.79-.78 1.46-1.5 2-.5-12.66-.67-25.33-.5-38h-64v324c-1-108.17-1.33-216.5-1-325h66c-.33 12.51 0 24.84 1 37ZM3684.5 1869.5c-.28.79-.78 1.46-1.5 2-.5-12.66-.67-25.33-.5-38h-64v324c-1-108.17-1.33-216.5-1-325h66c-.33 12.51 0 24.84 1 37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999",
    d: "M4817.5 2157.5v-324h-67v324c-1-108.17-1.33-216.5-1-325h69c.33 108.5 0 216.83-1 325Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#212221",
    d: "M4817.5 2157.5h-67v-324h67v324Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M4963.5 1869.5c-.28.79-.78 1.46-1.5 2-.5-12.66-.67-25.33-.5-38h-64v324c-1-108.17-1.33-216.5-1-325h66c-.33 12.51 0 24.84 1 37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999",
    d: "M6328.5 2157.5v-324h-67v324c-1-108.17-1.33-216.5-1-325h69c.33 108.5 0 216.83-1 325Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#212221",
    d: "M6328.5 2157.5h-67v-324h67v324Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M6474.5 1869.5c-.28.79-.78 1.46-1.5 2-.5-12.66-.67-25.33-.5-38h-64v324c-1-108.17-1.33-216.5-1-325h66c-.33 12.51 0 24.84 1 37ZM7823.5 1871.5c-.28.79-.78 1.46-1.5 2-.5-13.33-.67-26.66-.5-40h-64v324c-1-108.17-1.33-216.5-1-325h66c-.33 13.18 0 26.18 1 39Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999",
    d: "M8625.5 2157.5v-324h-67v324c-1-108.17-1.33-216.5-1-325h69c.33 108.5 0 216.83-1 325Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#212221",
    d: "M8625.5 2157.5h-67v-324h67v324Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M9163.5 1869.5c-.28.79-.78 1.46-1.5 2-.5-12.66-.67-25.33-.5-38h-64v324c-1-108.17-1.33-216.5-1-325h66c-.33 12.51 0 24.84 1 37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M1609.5 1953.5v7h-170c7.32-43.49 32.66-69.32 76-77.5 44.48-3.36 74.98 15.47 91.5 56.5 1.47 4.56 2.31 9.23 2.5 14ZM1977.5 1953.5v7h-170c7.32-43.49 32.66-69.32 76-77.5 44.48-3.36 74.98 15.47 91.5 56.5 1.47 4.56 2.31 9.23 2.5 14ZM4199.5 1953.5v7h-170c7.32-43.49 32.66-69.32 76-77.5 44.48-3.36 74.98 15.47 91.5 56.5 1.47 4.56 2.31 9.23 2.5 14ZM6017.5 1953.5v7h-170c7.32-43.49 32.66-69.32 76-77.5 44.48-3.36 74.98 15.47 91.5 56.5 1.47 4.56 2.31 9.23 2.5 14ZM7226.5 1953.5v7h-170c7.32-43.49 32.66-69.32 76-77.5 44.48-3.36 74.98 15.47 91.5 56.5 1.47 4.56 2.31 9.23 2.5 14ZM2260.5 1888.5c52.88-2.16 88.38 21.51 106.5 71 10.19 36.87 4.86 71.2-16 103-28.14 34.34-63.98 46.18-107.5 35.5-33-11-54.5-33.16-64.5-66.5-10.82-37.07-5.82-71.74 15-104 17.15-21.66 39.32-34.66 66.5-39ZM3370.5 1888.5c53.05-2.42 88.55 21.24 106.5 71 10.27 38.23 4.27 73.56-18 106-27.99 32.22-62.82 43.05-104.5 32.5-42.57-15.6-66.07-46.1-70.5-91.5-3.68-36.63 7.49-67.8 33.5-93.5 15.46-13.07 33.13-21.23 53-24.5ZM5390.5 1888.5c46.18-1.94 78.68 18.06 97.5 60 11.49 33.27 8.15 64.94-10 95-24.44 32.62-56.94 45.45-97.5 38.5-34.93-8.93-58.43-30.43-70.5-64.5-11.42-41.84-1.58-77.68 29.5-107.5 15.08-11.96 32.08-19.13 51-21.5ZM7506.5 1888.5c46.18-1.94 78.68 18.06 97.5 60 11.49 33.27 8.15 64.94-10 95-24.44 32.62-56.94 45.45-97.5 38.5-34.93-8.93-58.43-30.43-70.5-64.5-11.42-41.84-1.58-77.68 29.5-107.5 15.08-11.96 32.08-19.13 51-21.5ZM8849.5 1888.5c53.05-2.42 88.55 21.24 106.5 71 10.27 38.23 4.27 73.56-18 106-27.99 32.22-62.82 43.05-104.5 32.5-42.57-15.6-66.07-46.1-70.5-91.5-3.68-36.63 7.49-67.8 33.5-93.5 15.46-13.07 33.13-21.23 53-24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M6749.5 1832.5c-4.13.98-8.47 1.32-13 1v60h57v163c-1-53.83-1.33-107.83-1-162h-57v-62h14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929292",
    d: "M6934.5 1893.5c-24.16 1-48.49 1.33-73 1v163c-1-54.5-1.33-109.16-1-164h74Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M8304.5 1832.5c-4.13.98-8.47 1.32-13 1v60h57v163c-1-53.83-1.33-107.83-1-162h-57v-62h14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929292",
    d: "M8489.5 1893.5c-24.16 1-48.49 1.33-73 1v163c-1-54.5-1.33-109.16-1-164h74Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f4e4e",
    d: "M1609.5 1953.5c.97 2.45 1.31 5.11 1 8-57.17.33-114.17 0-171-1h170v-7ZM1977.5 1953.5c.97 2.45 1.31 5.11 1 8-57.17.33-114.17 0-171-1h170v-7ZM4199.5 1953.5c.97 2.45 1.31 5.11 1 8-57.17.33-114.17 0-171-1h170v-7ZM6017.5 1953.5c.97 2.45 1.31 5.11 1 8-57.17.33-114.17 0-171-1h170v-7ZM7226.5 1953.5c.97 2.45 1.31 5.11 1 8-57.17.33-114.17 0-171-1h170v-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M8172.5 2005.5c1.97 7.6 2.63 15.6 2 24-4.91 41.74-27.57 68.24-68 79.5-16.23 3.95-32.23 3.29-48-2-25.84-14.21-32.34-34.71-19.5-61.5 5.31-7.65 12.15-13.48 20.5-17.5 8.98-3.88 18.31-6.55 28-8 28.3-5.05 56.64-9.88 85-14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c6b6b",
    d: "M8172.5 2005.5c.71-.9 1.71-1.24 3-1 .33 8.52-.01 16.85-1 25 .63-8.4-.03-16.4-2-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#757474",
    d: "M8176.5 2121.5c.06-.54.39-.88 1-1 1 12.32 1.33 24.65 1 37-.67-12-1.33-24-2-36Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#febc6d",
    d: "M1091.5 3143.5h1479c-.01 1.52-.68 2.68-2 3.5-2.69.16-5.02.99-7 2.5h-7c1.07-.93 2.4-1.27 4-1 2.05-.21 2.38-1.04 1-2.5-488.5-.83-976.83-.67-1465 .5h-10c2.47-.82 5.14-1.32 8-1.5-.56-.38-.89-.88-1-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6eae3",
    d: "M2570.5 3143.5h1492c-1.3 1.53-2.97 2.53-5 3-.62-.11-1.12-.44-1.5-1a100.83 100.83 0 0 1-17.5 3c-486.7-1-973.53-1.33-1460.5-1-7.72.54-15.22 1.87-22.5 4 2-.67 4-1.33 6-2 1.98-1.51 4.31-2.34 7-2.5 1.32-.82 1.99-1.98 2-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9073e8",
    d: "M4062.5 3143.5h1484c-3.17 1.91-6.5 2.91-10 3-489.76-1.33-979.43-1.33-1469 0-3.54.22-6.88.22-10 0 2.03-.47 3.7-1.47 5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e56979",
    d: "M5554.5 3143.5h1484c-.75 2.01-1.92 2.67-3.5 2-.99.57-1.83 1.23-2.5 2-4.13.07-8.13.74-12 2 .73-1.21 1.73-2.21 3-3a21.15 21.15 0 0 0-9-1h-1461c.33-.67.67-1.33 1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efdddc",
    d: "M7038.5 3143.5h1487c-1.3 1.53-2.97 2.53-5 3h-2c-9.22 1.59-18.22 3.92-27 7v-3c2.36.16 4.69 0 7-.5 1.41-.37 2.41-1.2 3-2.5-.47-.96-1.14-.96-2 0 .13-.74-.04-1.41-.5-2-446.93.67-893.76 1.33-1340.5 2-41.8-.02-83.8-.02-126 0 .67-.77 1.51-1.43 2.5-2 1.58.67 2.75.01 3.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "gray",
    d: "M8525.5 3143.5c1035-.33 2070 0 3105 1 2.9.82 5.9 1.32 9 1.5 6.8 2.6 13.4 5.1 20 7.5 2.6 1.24 4.9 2.91 7 5-8.8-3.21-17.4-6.54-26-10-.4-.72-1.1-1.22-2-1.5l-13-1c-1035-.83-2070.01-.67-3105 .5 2.03-.47 3.7-1.47 5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fea843",
    d: "M1094.5 3146.5c488.17-1.17 976.5-1.33 1465-.5 1.38 1.46 1.05 2.29-1 2.5-487.67-2-975.67-2.67-1464-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d48e2",
    d: "M5536.5 3146.5c-1.28 1.43-2.95 2.1-5 2 1.35-1.15 1.18-1.82-.5-2-488.66.05-976.5.05-1463.5 0 489.57-1.33 979.24-1.33 1469 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a74da2",
    d: "M5546.5 3143.5h8c-.33.67-.67 1.33-1 2-1.53-.87-3.03-.54-4.5 1l-1-1c-4.4.9-8.57 2.24-12.5 4h-4v-1c2.05.1 3.72-.57 5-2 3.5-.09 6.83-1.09 10-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e34452",
    d: "M5553.5 3145.5h1461c-485 .67-970 1.33-1455 2-5.37.99-10.53.99-15.5 0-2.74.98-5.57 1.65-8.5 2 3.93-1.76 8.1-3.1 12.5-4l1 1c1.47-1.54 2.97-1.87 4.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eae1df",
    d: "M8499.5 3147.5c-447.45.12-894.45.12-1341 0 446.74-.67 893.57-1.33 1340.5-2 .46.59.63 1.26.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5959",
    d: "M11640.5 3148.5c-6-.81-12-1.14-18-1-1031-1.33-2062-1.33-3093 0h-11v-1h2c1034.99-1.17 2070-1.33 3105-.5l13 1c.9.28 1.6.78 2 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9822",
    d: "M1084.5 3146.5h10c488.33-.67 976.33 0 1464 2-1.6-.27-2.93.07-4 1-3.26 2.22-6.93 3.39-11 3.5a41.686 41.686 0 0 1-14 7 25.305 25.305 0 0 0-4 4.5c-2.61.82-4.61 2.48-6 5-5.4 2.36-10.06 5.69-14 10-2.93 4.18-6.09 8.18-9.5 12-.61 1.65-1.11 3.32-1.5 5-1.59 2.93-3.59 5.59-6 8 1.55-4.44 2.38-9.11 2.5-14 12.42-16.42 27.58-29.59 45.5-39.5 4-.33 8-.67 12-1 1.54-.29 2.88-.96 4-2-490.67-.67-981.33-.67-1472 0a189.01 189.01 0 0 1-22 6.5c6.44-2.79 13.11-5.29 20-7.5 1.97-.5 3.97-.66 6-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#562bde",
    d: "M4057.5 3146.5c3.12.22 6.46.22 10 0 487 .05 974.84.05 1463.5 0 1.68.18 1.85.85.5 2v1h-7c.11-.62.44-1.12 1-1.5-491.33-.77-982.67-.6-1474 .5 2-.67 4-1.33 6-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ea2e31",
    d: "M7014.5 3145.5c3.07-.32 6.07.02 9 1-1.27.79-2.27 1.79-3 3-4.17-.17-8.17.5-12 2 1.25-1.64 2.92-2.8 5-3.5-1.17-.17-2.33-.33-3.5-.5-481.31.74-964.81.74-1450.5 0 485-.67 970-1.33 1455-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#414040",
    d: "M11622.5 3147.5h-3093c1031-1.33 2062-1.33 3093 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe900f",
    d: "M2488.5 3204.5c-.96.45-1.79 1.12-2.5 2-2.15 4.23-4.15 8.56-6 13-2.47 7.88-3.97 15.88-4.5 24-.77.76-1.27 1.76-1.5 3-.67 869.33-.67 1738.67 0 2608 1.15 6.27 1.82 12.6 2 19 1.16.5 1.99 1.33 2.5 2.5 2.46 7.31 5.3 14.47 8.5 21.5 1.21 3.18 1.55 6.52 1 10 4.1 5.17 7.94 10.5 11.5 16 2.55.06 4.05 1.39 4.5 4l1-1c4.12 6.08 9.78 11.08 17 15 1.53-.27 3.03-.61 4.5-1 4.18 2.26 8.52 4.26 13 6v3h6v3c3.2.27 6.2 1.1 9 2.5-1.23.78-2.56 1.28-4 1.5-487.31-.83-974.65-1.33-1462-1.5a89.546 89.546 0 0 0-16-1.5h-1c-8.78-4.22-17.78-8.22-27-12a48.324 48.324 0 0 1-14-9c-4.48-4.19-8.98-8.53-13.5-13-4.31-7.46-9.14-14.46-14.5-21a68.622 68.622 0 0 0-5.5-13 120.31 120.31 0 0 1-5-24c-.383-.56-.883-.89-1.5-1v-4c-.167-872.33 0-1744.67.5-2617a30.444 30.444 0 0 0 1.5-9 279.606 279.606 0 0 1 6.5-22c1.61-2.91 3.44-5.57 5.5-8a363.91 363.91 0 0 1 13-17c.25-1.67.92-3.17 2-4.5 6.83-4.26 13.16-9.26 19-15 6.61-3.47 13.27-6.64 20-9.5a189.01 189.01 0 0 0 22-6.5c490.67-.67 981.33-.67 1472 0-1.12 1.04-2.46 1.71-4 2-4 .33-8 .67-12 1-17.92 9.91-33.08 23.08-45.5 39.5-.12 4.89-.95 9.56-2.5 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3efef",
    d: "M4038.5 3148.5c-6.89 3.45-13.89 6.95-21 10.5-4.18 2.73-7.85 5.9-11 9.5-1.08.04-2.08.37-3 1-1.74 2.06-3.41 4.06-5 6-8.87 5.89-15.21 13.89-19 24-4.4 6.35-8.23 13.02-11.5 20-2.05 9.26-4.22 18.09-6.5 26.5 1.33 868 1.33 1736 0 2604 2.04 10.4 4.21 20.9 6.5 31.5 3.67 7.67 7.33 15.33 11 23 2.46 2.28 4.62 4.62 6.5 7 3.27 6.55 7.94 11.88 14 16 1.41 2.92 3.41 5.42 6 7.5 1.91 1.12 3.91 1.96 6 2.5 3.27 3.31 7.27 5.65 12 7 3.41 3.04 7.41 5.04 12 6a31.8 31.8 0 0 1 9 3c2.7 1.46 5.7 2.3 9 2.5.56.38.89.88 1 1.5-5.04-.11-9.88-.11-14.5 0 .48-3.74-1.36-4.91-5.5-3.5.67 1 1.33 2 2 3-486.17.83-972.17.67-1458-.5-1.46-1.51-3.29-2.51-5.5-3l-1 1c-6.94-.44-13.77-1.6-20.5-3.5a6.603 6.603 0 0 1-3-3c-12-3.21-22.33-9.21-31-18-1.24-.79-2.58-1.29-4-1.5-3.44-3.89-7.11-7.55-11-11-1.38-2.36-2.71-4.7-4-7-3-4.71-6-9.38-9-14-2.79-2.68-4.46-6.01-5-10 .16-2.36 0-4.69-.5-7-1.76-4.62-3.42-9.29-5-14-.67-875.67-.67-1751.33 0-2627a286.61 286.61 0 0 1 6-21 149.78 149.78 0 0 1 9.5-21c1.29-.79 2.46-1.79 3.5-3 2.08-3.84 4.42-7.5 7-11 5.03-4.2 9.86-8.53 14.5-13 1.39-2.52 3.39-4.18 6-5 6.9-3.02 13.57-6.52 20-10.5 3.5-.3 6.83-1.14 10-2.5 7.28-2.13 14.78-3.46 22.5-4 486.97-.33 973.8 0 1460.5 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#491bde",
    d: "M5524.5 3149.5c-1.65 1.43-3.65 2.26-6 2.5-.86 1.36-1.86 2.53-3 3.5-2.47.15-4.47 1.15-6 3-4.31.99-8.31 2.82-12 5.5-2.76 1.53-4.76 3.7-6 6.5-1.93.23-3.6 1.06-5 2.5-20.92 20.12-33.25 44.46-37 73 .03 1.07.36 1.9 1 2.5v1c-.67 0-1 .33-1 1a38.22 38.22 0 0 0-2.5-5c-.17 435-.33 870-.5 1305 .33 435 .67 870 1 1305 .61-.12.94-.46 1-1 .67.33 1.33.67 2 1-.92 2.8-.58 5.96 1 9.5.34 1.03 1 1.53 2 1.5v1c-.91 3.27-.91 6.44 0 9.5 1.23 3.78 3.06 7.28 5.5 10.5 1.61 7.28 4.61 13.95 9 20 1.11.81 2.28 1.47 3.5 2 .11 2.28.94 4.28 2.5 6a162.04 162.04 0 0 0 14.5 15.5c1 .33 2 .67 3 1 2.72 3.88 6.38 6.38 11 7.5-.09 1 .25 1.83 1 2.5 7.67 4.67 15.67 8.5 24 11.5-242.5 1.33-485.33 2-728.5 2-242.83-.17-485.67-.33-728.5-.5l-1.5-1.5c-6.62.07-13.46.07-20.5 0-4.73-2.19-9.73-3.86-15-5-3.37-1.36-6.7-2.69-10-4-3.37-3.35-7.37-5.69-12-7a86.72 86.72 0 0 0-12-10c-4.64-5.22-9.31-10.55-14-16a526.503 526.503 0 0 1-16.5-32c-.5-1.97-.66-3.97-.5-6 .8 1.45 1.3 3.12 1.5 5 1.01.84 2.18 1.17 3.5 1-.16 2.36 0 4.69.5 7 1.18 1.23 2.35 1.23 3.5 0-.41-3.59-1.74-6.76-4-9.5v-8c-1.8-.32-2.13-.98-1-2-.67-1.33-1.33-2.67-2-4 .33-1.67.67-3.33 1-5-.67-3-1.33-6-2-9V3257c.67-3 1.33-6 2-9v-10c-.66-1.52-1.66-2.69-3-3.5.59-3.3 1.26-6.63 2-10 3.25-.21 5.58-1.71 7-4.5-1.33-.67-1.33-1.33 0-2-3.03-2.73-3.03-5.9 0-9.5 1.33 1.33 2.67 1.33 4 0 12.75-25.58 32.75-42.75 60-51.5.33-1.67.67-3.33 1-5 3.5-.12 6.5-1.29 9-3.5 491.33-1.1 982.67-1.27 1474-.5-.56.38-.89.88-1 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef2828",
    d: "M5559.5 3147.5c485.69.74 969.19.74 1450.5 0 1.17.17 2.33.33 3.5.5-2.08.7-3.75 1.86-5 3.5-8.09 3.23-15.43 7.57-22 13-1.05-.15-2.05.02-3 .5-12.95 11.12-23.95 23.95-33 38.5-2.98 4.92-4.98 10.25-6 16v4c-1.9 3.03-3.24 6.37-4 10-1.28 2.06-2.11 4.4-2.5 7-.67 874-.67 1748 0 2622 1.85 4.65 3.02 9.49 3.5 14.5.34 1.03 1 1.53 2 1.5 1.68 4.68 3.34 9.35 5 14 .5 1.98 1 3.98 1.5 6 2.26 3.53 4.76 6.87 7.5 10 .67.33 1.33.67 2 1 2.43 7.43 7.09 13.1 14 17 .52 2.69 2.19 4.19 5 4.5 3.09 4.27 7.09 7.11 12 8.5 2.53 3.97 6.19 6.31 11 7 2.14 2.78 4.81 4.94 8 6.5 2.54.14 4.88.81 7 2-486 .67-972 .67-1458 0-2.18-1.2-4.51-1.7-7-1.5-2.89-.31-5.55.03-8 1a73.09 73.09 0 0 1-20-4.5c-7.3-2.98-14.3-6.48-21-10.5-4.1-2.92-8.1-6.09-12-9.5a184.33 184.33 0 0 1-19-20.5c-2.64-4.17-5.14-8.5-7.5-13a87.065 87.065 0 0 0-4.5-12c-.77-3.17-1.77-6.17-3-9-1.49-2.83-2.49-5.49-3-8v-1c-.43-2.2-.43-4.2 0-6-.33-870.1 0-1740.27 1-2610.5-.54-.72-1.21-1.22-2-1.5.6-2.18 1.27-4.35 2-6.5-.23-.4-.56-.57-1-.5v-1c.97-2.11 1.3-4.44 1-7v-1c1.27-1.61 2.27-3.44 3-5.5-.23-.4-.56-.57-1-.5.65-4.46 1.82-8.8 3.5-13l6-12c.71-.88 1.54-1.55 2.5-2 3.64-4.48 7.14-9.15 10.5-14 2.71-1.09 4.21-3.09 4.5-6 8-6.33 16-12.67 24-19 .34-.84 1.01-1.17 2-1 8.28-2.81 16.28-6.15 24-10h2c2.93-.35 5.76-1.02 8.5-2 4.97.99 10.13.99 15.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#312f2f",
    d: "M8518.5 3147.5h3104c6-.14 12 .19 18 1 8.6 3.46 17.2 6.79 26 10 6.6 4.97 13.6 9.47 21 13.5 2.9 2.7 5.5 5.54 8 8.5 6.2 9.43 12.7 18.76 19.5 28 .9 3.23 2 6.23 3.5 9 .7 0 1 .33 1 1 0 5.59 1 10.92 3 16-.3 4.1.2 8.1 1.5 12 .2 435.33.3 870.67.5 1306-.2 435.33-.3 870.67-.5 1306-1.2 3.92-1.7 7.92-1.5 12-2.3 4.7-3.7 9.7-4 15-.4 2.2-1 4.2-2 6h-3c0 2.43-.5 4.76-1.5 7-2.8 3.89-5.3 7.89-7.5 12v1c-4.7 3.74-8.7 8.07-12 13-4.4 3.26-8.8 6.76-13 10.5-6 3.77-12.3 7.11-19 10-.9.71-1.5 1.54-2 2.5-3.4 1.06-6.7 2.06-10 3-8.7 1.17-17.3 2.67-26 4.5-1030.7.67-2061.33.67-3092 0-6.59-1.21-13.25-1.88-20-2-4.98-1.82-9.98-3.32-15-4.5-2.87-2.43-5.87-4.93-9-7.5-4.55.22-8.22-1.44-11-5a8.394 8.394 0 0 0-4-.5 617.714 617.714 0 0 1-20.5-22c-.64-3.06-1.81-5.89-3.5-8.5.14-.77.48-1.44 1-2-1.35-.77-2.18-1.94-2.5-3.5-.31.81-.81 1.47-1.5 2-1.02-2.36-2.69-4.02-5-5-.88-2.23-2.21-4.23-4-6-.02-2.06-.35-4.06-1-6-.51-5.62-1.84-10.95-4-16 .11-4.05-.23-8.05-1-12 1.17-870.17 1.33-1740.5.5-2611-.28.92-.78 1.58-1.5 2 .33-3.33.67-6.67 1-10 3.51-9.89 6.51-19.89 9-30a243.83 243.83 0 0 1 9-15c2.74-3.6 5.74-7.1 9-10.5 7.35-7.01 15.01-13.68 23-20 6.49-2.19 12.49-5.19 18-9 7-1.83 14-3.67 21-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9e6e6",
    d: "M7158.5 3147.5c446.55.12 893.55.12 1341 0 .86-.96 1.53-.96 2 0-.59 1.3-1.59 2.13-3 2.5-2.31.5-4.64.66-7 .5v3c-1.58.78-2.91 1.95-4 3.5a64.312 64.312 0 0 0-14 6c-7.34 8.2-15.01 16.03-23 23.5-5.34 4.32-9.51 9.65-12.5 16a534.656 534.656 0 0 0-12 33c-.83 873.5-.67 1746.83.5 2620-.38 4.87.28 9.53 2 14 .17 7.83 2.5 14.83 7 21 1.79 1.77 3.12 3.77 4 6 1.44 3.22 2.6 6.55 3.5 10a167.897 167.897 0 0 0 28.5 29c4.07 4.37 9.07 7.2 15 8.5 2.48 2.67 5.48 4.17 9 4.5.45.96 1.12 1.79 2 2.5 6.71 1.46 13.38 3.13 20 5-.56.38-.89.88-1 1.5h-1479c-.45-.96-1.12-1.79-2-2.5-7.62-.6-15.29-2.26-23-5-1.82-2.14-4.15-2.97-7-2.5-4.45-3.39-9.45-6.05-15-8-.64-.98-1.31-1.98-2-3-5.01-3.35-10.01-6.68-15-10a92.629 92.629 0 0 1-9-13c-1.69-1.36-3.35-2.69-5-4-.67-.33-1.33-.67-2-1-1.44-4.34-3.44-8.34-6-12a112.01 112.01 0 0 1-5.5-19c-1.19-1.73-2.36-3.4-3.5-5-.02-2.06-.35-4.06-1-6-.26-4.35-.76-8.69-1.5-13-.67-868.67-.67-1737.33 0-2606 .99-8.12 2.49-16.12 4.5-24v-4a348.367 348.367 0 0 1 18.5-32c7.34-8.24 15.18-15.9 23.5-23a402.822 402.822 0 0 1 34-15 40.78 40.78 0 0 1 12-2c42.2-.02 84.2-.02 126 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#851e9f",
    d: "M5524.5 3149.5h5c-4.5 2.3-9.17 4.3-14 6 1.14-.97 2.14-2.14 3-3.5 2.35-.24 4.35-1.07 6-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cc254e",
    d: "M5529.5 3149.5h4c-7.72 3.85-15.72 7.19-24 10v-1c1.53-1.85 3.53-2.85 6-3 4.83-1.7 9.5-3.7 14-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f17d7b",
    d: "M7020.5 3149.5a402.822 402.822 0 0 0-34 15c6.57-5.43 13.91-9.77 22-13 3.83-1.5 7.83-2.17 12-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7b7a7a",
    d: "M8518.5 3146.5v1c-7 1.83-14 3.67-21 5.5-5.51 3.81-11.51 6.81-18 9a329.387 329.387 0 0 0-23 20c-3.26 3.4-6.26 6.9-9 10.5l3-6c7.99-7.47 15.66-15.3 23-23.5 4.44-2.56 9.11-4.56 14-6 1.09-1.55 2.42-2.72 4-3.5 8.78-3.08 17.78-5.41 27-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8cb98",
    d: "M2554.5 3149.5h7c-2 .67-4 1.33-6 2a32.16 32.16 0 0 1-10 2.5c-6.43 3.98-13.1 7.48-20 10.5 1.13-1.63 2.46-3.13 4-4.5 5.12-1.45 9.78-3.79 14-7 4.07-.11 7.74-1.28 11-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5327df",
    d: "M4051.5 3148.5c-2.5 2.21-5.5 3.38-9 3.5-.33 1.67-.67 3.33-1 5-27.25 8.75-47.25 25.92-60 51.5-1.33 1.33-2.67 1.33-4 0-3.03 3.6-3.03 6.77 0 9.5-1.33.67-1.33 1.33 0 2-1.42 2.79-3.75 4.29-7 4.5-.74 3.37-1.41 6.7-2 10-.49 1.5-1.16 2.83-2 4 .68-5.54 1.68-11.04 3-16.5 3.05-7.67 6.39-15.17 10-22.5 6.19-7.88 12.52-15.88 19-24 3.28-1.62 5.95-3.95 8-7 11.05-6.84 22.38-13 34-18.5 3.69-.42 7.36-.92 11-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aaa9aa",
    d: "m11659.5 3153.5 6 1.5c5.9 3.85 11.9 7.52 18 11 7.2 6.73 13.9 13.9 20 21.5-2.3-2.68-5-5.01-8-7-2.5-2.96-5.1-5.8-8-8.5-7.4-4.03-14.4-8.53-21-13.5-2.1-2.09-4.4-3.76-7-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#831ea1",
    d: "M5509.5 3158.5v1c-.99-.17-1.66.16-2 1-5.6 2.94-10.93 6.27-16 10 1.24-2.8 3.24-4.97 6-6.5 3.69-2.68 7.69-4.51 12-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5a0ea",
    d: "M4057.5 3146.5c-2 .67-4 1.33-6 2-3.64.58-7.31 1.08-11 1.5a344.82 344.82 0 0 0-34 18.5c3.15-3.6 6.82-6.77 11-9.5 7.11-3.55 14.11-7.05 21-10.5 5.95-.49 11.78-1.49 17.5-3 .38.56.88.89 1.5 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cc254d",
    d: "M5507.5 3160.5c-8 6.33-16 12.67-24 19 2.59-2.93 5.25-5.93 8-9 5.07-3.73 10.4-7.06 16-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd19d",
    d: "M1091.5 3143.5c.11.62.44 1.12 1 1.5-2.86.18-5.53.68-8 1.5-2.03-.16-4.03 0-6 .5-6.89 2.21-13.56 4.71-20 7.5-6.73 2.86-13.39 6.03-20 9.5-5.84 5.74-12.17 10.74-19 15-1.08 1.33-1.75 2.83-2 4.5-2.33 2-4.67 4-7 6 3.48-6.11 7.82-11.61 13-16.5a234.24 234.24 0 0 0 20-15c9.61-4.2 19.28-8.2 29-12 6.49-.45 12.83-1.28 19-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ab91e7",
    d: "M4006.5 3168.5a20.324 20.324 0 0 1-8 7c1.59-1.94 3.26-3.94 5-6 .92-.63 1.92-.96 3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a88fe8",
    d: "M3998.5 3175.5c-6.48 8.12-12.81 16.12-19 24 3.79-10.11 10.13-18.11 19-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb056",
    d: "M1017.5 3183.5a363.91 363.91 0 0 0-13 17c.67-1.67 1.33-3.33 2-5a125 125 0 0 1 4-6c2.33-2 4.67-4 7-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbc689",
    d: "M2519.5 3169.5c-4.64 4.47-9.47 8.8-14.5 13-2.58 3.5-4.92 7.16-7 11a14.796 14.796 0 0 1-3.5 3c.39-1.68.89-3.35 1.5-5 3.41-3.82 6.57-7.82 9.5-12 3.94-4.31 8.6-7.64 14-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d22646",
    d: "M5483.5 3179.5c-.29 2.91-1.79 4.91-4.5 6-3.36 4.85-6.86 9.52-10.5 14 3.54-7.75 8.54-14.42 15-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef7678",
    d: "M6986.5 3164.5c-8.32 7.1-16.16 14.76-23.5 23a348.367 348.367 0 0 0-18.5 32c1.02-5.75 3.02-11.08 6-16 9.05-14.55 20.05-27.38 33-38.5.95-.48 1.95-.65 3-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#828181",
    d: "M11695.5 3180.5c3 1.99 5.7 4.32 8 7 1 1.87 1.8 3.87 2.5 6 4.1 4.27 7.8 8.94 11 14 1.3 3.19 1.8 6.52 1.5 10-1.5-2.77-2.6-5.77-3.5-9-6.8-9.24-13.3-18.57-19.5-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#831ea1",
    d: "M5491.5 3170.5c-2.75 3.07-5.41 6.07-8 9-6.46 5.58-11.46 12.25-15 20-.96.45-1.79 1.12-2.5 2l-6 12a57.08 57.08 0 0 0-3.5 13c-1.24 1.71-1.91 3.71-2 6v1a96.18 96.18 0 0 0-2 6.5c.23.4.56.57 1 .5v1c-.84 2.31-1.84 4.65-3 7-.64-.6-.97-1.43-1-2.5 3.75-28.54 16.08-52.88 37-73 1.4-1.44 3.07-2.27 5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf255a",
    d: "M5456.5 3226.5c.44-.07.77.1 1 .5-.73 2.06-1.73 3.89-3 5.5.09-2.29.76-4.29 2-6ZM5454.5 3233.5c.3 2.56-.03 4.89-1 7-.44.07-.77-.1-1-.5a96.18 96.18 0 0 1 2-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4617de",
    d: "M3968.5 3234.5c1.34.81 2.34 1.98 3 3.5v10c-.67 3-1.33 6-2 9v2592c.67 3 1.33 6 2 9-.33 1.67-.67 3.33-1 5 .67 1.33 1.33 2.67 2 4-1.13 1.02-.8 1.68 1 2v8c2.26 2.74 3.59 5.91 4 9.5-1.15 1.23-2.32 1.23-3.5 0-.5-2.31-.66-4.64-.5-7-1.32.17-2.49-.16-3.5-1-.2-1.88-.7-3.55-1.5-5-1.62-2.72-2.29-5.72-2-9v-10c.22-868 .22-1736 0-2604v-12c.84-1.17 1.51-2.5 2-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f7e7e",
    d: "M11719.5 3218.5c4.1 8.1 6.4 16.77 7 26-.6-.11-1.1-.44-1.5-1-.4-3.24-1.2-6.24-2.5-9-2-5.08-3-10.41-3-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4fa",
    d: "M2480.5 3238.5c.89.76 1.56 1.76 2 3-1.33 872.6-1.33 1745.77 0 2619.5-.11 1.28-.78 2.11-2 2.5-1.33-875.04-1.33-1750.04 0-2625Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef1d1d",
    d: "M6934.5 3234.5c.73 1.38 1.4 2.88 2 4.5.5 875.39 0 1750.89-1.5 2626.5-.23-2.59-.73-5.09-1.5-7.5-.18-873.51.15-1748.01 1-2623.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf9f0",
    d: "M3958.5 3245.5c.79.28 1.46.78 2 1.5v2608c-.63.75-1.13 1.58-1.5 2.5-.2-4.59-.7-9.09-1.5-13.5.67-865.83 1-1732 1-2598.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4118e6",
    d: "M5449.5 3250.5c-1 867.93-1.33 1735.93-1 2604-.06.54-.39.88-1 1-.33-435-.67-870-1-1305 .17-435 .33-870 .5-1305a38.22 38.22 0 0 1 2.5 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7d4b0",
    d: "M2494.5 3196.5a149.78 149.78 0 0 0-9.5 21 286.61 286.61 0 0 0-6 21c-.67 875.67-.67 1751.33 0 2627 1.58 4.71 3.24 9.38 5 14 .5 2.31.66 4.64.5 7-1.81-5.7-3.98-11.37-6.5-17-.5-2.31-.66-4.64-.5-7-1.16-868.99-1.33-1737.99-.5-2607 .2-17.83 4.03-34.83 11.5-51 2.41-2.41 4.41-5.07 6-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#992185",
    d: "M5453.5 3241.5c.44-.07.77.1 1 .5-.73 2.15-1.4 4.32-2 6.5-1 868.1-1.33 1736.43-1 2605-1-867.83-1.33-1735.83-1-2604v-1c1.16-2.35 2.16-4.69 3-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ec9595",
    d: "M6944.5 3223.5c-2.01 7.88-3.51 15.88-4.5 24-.67 868.67-.67 1737.33 0 2606 .74 4.31 1.24 8.65 1.5 13-1.25-3.44-2.08-7.11-2.5-11-.17-434.83-.33-869.67-.5-1304.5.17-434.83.33-869.67.5-1304.5.58-4.33 1.08-8.67 1.5-13 .76-3.63 2.1-6.97 4-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdb664",
    d: "M2488.5 3204.5c-7.47 16.17-11.3 33.17-11.5 51-.83 869.01-.66 1738.01.5 2607-.81-1.79-1.31-3.79-1.5-6-.5-871-.67-1742-.5-2613 .53-8.12 2.03-16.12 4.5-24 1.85-4.44 3.85-8.77 6-13 .71-.88 1.54-1.55 2.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d22647",
    d: "M5452.5 3248.5c.79.28 1.46.78 2 1.5-1 870.23-1.33 1740.4-1 2610.5-.67-2-1.33-4-2-6v-1c-.33-868.57 0-1736.9 1-2605Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef5d5d",
    d: "M6940.5 3233.5c-.42 4.33-.92 8.67-1.5 13-.17 434.83-.33 869.67-.5 1304.5.17 434.83.33 869.67.5 1304.5.42 3.89 1.25 7.56 2.5 11 .65 1.94.98 3.94 1 6 .33 2 .67 4 1 6-1 .03-1.66-.47-2-1.5-.48-5.01-1.65-9.85-3.5-14.5-.67-874-.67-1748 0-2622 .39-2.6 1.22-4.94 2.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe9c2b",
    d: "M2475.5 3243.5c-.17 871 0 1742 .5 2613 .19 2.21.69 4.21 1.5 6-.16 2.36 0 4.69.5 7 2.52 5.63 4.69 11.3 6.5 17 .54 3.99 2.21 7.32 5 10 .96 5.97 3.96 10.63 9 14 1.29 2.3 2.62 4.64 4 7 3.89 3.45 7.56 7.11 11 11 1.46 2.76 3.79 4.59 7 5.5 2.18 2.01 4.18 4.18 6 6.5-1.47.39-2.97.73-4.5 1-7.22-3.92-12.88-8.92-17-15l-1 1c-.45-2.61-1.95-3.94-4.5-4-3.56-5.5-7.4-10.83-11.5-16 .55-3.48.21-6.82-1-10-3.2-7.03-6.04-14.19-8.5-21.5-.51-1.17-1.34-2-2.5-2.5-.18-6.4-.85-12.73-2-19-.67-869.33-.67-1738.67 0-2608 .23-1.24.73-2.24 1.5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5428dd",
    d: "M3966.5 3250.5c.22 868 .22 1736 0 2604-1.33-868.1-1.33-1736.1 0-2604Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f3d3d",
    d: "M11722.5 3234.5c1.3 2.76 2.1 5.76 2.5 9 .4.56.9.89 1.5 1v2615c-1.1.29-1.8 1.12-2 2.5-.4 3.03-1.1 5.86-2 8.5-.2-4.08.3-8.08 1.5-12 .2-435.33.3-870.67.5-1306-.2-435.33-.3-870.67-.5-1306-1.3-3.9-1.8-7.9-1.5-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd9ad",
    d: "M1006.5 3195.5c-.67 1.67-1.33 3.33-2 5a48.993 48.993 0 0 0-5.5 8 279.606 279.606 0 0 0-6.5 22c-1.121 2.45-1.954 5.12-2.5 8-.833 872.83-.667 1745.5.5 2618v4a218.315 218.315 0 0 1 3 19c-.617-.11-1.117-.44-1.5-1l-1-9a7.32 7.32 0 0 0-2-3l-1-13c-.333.33-.667.67-1 1-.833-869-.667-1738 .5-2607 1.529-18.17 7.029-34.84 16.5-50 .71-.88 1.54-1.55 2.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffaa45",
    d: "M992.5 3230.5a30.444 30.444 0 0 1-1.5 9c-.5 872.33-.667 1744.67-.5 2617-1.167-872.5-1.333-1745.17-.5-2618 .546-2.88 1.379-5.55 2.5-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b09cea",
    d: "M3979.5 3199.5c-3.61 7.33-6.95 14.83-10 22.5-1.32 5.46-2.32 10.96-3 16.5-.67 3.26-1.5 6.59-2.5 10-.17 433.33-.33 866.67-.5 1300 .17 433.33.33 866.67.5 1300 .52 5.53 1.35 10.86 2.5 16-.29 3.28.38 6.28 2 9-.16 2.03 0 4.03.5 6a526.503 526.503 0 0 0 16.5 32 61.742 61.742 0 0 0-6.5-7c-3.67-7.67-7.33-15.33-11-23-2.29-10.6-4.46-21.1-6.5-31.5 1.33-868 1.33-1736 0-2604 2.28-8.41 4.45-17.24 6.5-26.5 3.27-6.98 7.1-13.65 11.5-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b3939",
    d: "M8429.5 3237.5c-.33 3.33-.67 6.67-1 10-.33 869.71 0 1739.37 1 2609 .77 3.95 1.11 7.95 1 12-1.36-3.08-2.19-6.41-2.5-10-.17-436.17-.33-872.33-.5-1308.5.17-436.17.33-872.33.5-1308.5.21-1.56.71-2.89 1.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7955e2",
    d: "M3966.5 3238.5v12c-1.33 867.9-1.33 1735.9 0 2604v10c-1.15-5.14-1.98-10.47-2.5-16-.17-433.33-.33-866.67-.5-1300 .17-433.33.33-866.67.5-1300 1-3.41 1.83-6.74 2.5-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c1eca",
    d: "M5450.5 3249.5c-.33 868.17 0 1736.17 1 2604v1c-.67 0-1 .33-1 1-.67-.33-1.33-.67-2-1-.33-868.07 0-1736.07 1-2604 0-.67.33-1 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#252424",
    d: "M8429.5 5856.5c-1-869.63-1.33-1739.29-1-2609 .72-.42 1.22-1.08 1.5-2 .83 870.5.67 1740.83-.5 2611Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646363",
    d: "M8438.5 3207.5a314.557 314.557 0 0 1-9 30c-.79 1.11-1.29 2.44-1.5 4-.17 436.17-.33 872.33-.5 1308.5.17 436.17.33 872.33.5 1308.5.31 3.59 1.14 6.92 2.5 10 2.16 5.05 3.49 10.38 4 16-.62-.11-1.12-.44-1.5-1-1.87-4.69-3.37-9.36-4.5-14-1.72-4.47-2.38-9.13-2-14-.33-873 0-1746 1-2619 3.27-8.86 6.11-17.86 8.5-27 .71-.88 1.54-1.55 2.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b9999",
    d: "m8450.5 3186.5-3 6a243.83 243.83 0 0 0-9 15c-.96.45-1.79 1.12-2.5 2-2.39 9.14-5.23 18.14-8.5 27-1 873-1.33 1746-1 2619-1.17-873.17-1.33-1746.5-.5-2620 3.62-11.08 7.62-22.08 12-33 2.99-6.35 7.16-11.68 12.5-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6b1ca",
    d: "M2984.5 3401.5c-6.71-.28-13.38-.94-20-2h-6c-13.83-1.16-27.83-1.33-42-.5-5.6.07-10.93.9-16 2.5-6 1.33-12 2.67-18 4a79.639 79.639 0 0 1-12 2.5c-3.41 1.65-6.75 3.15-10 4.5h-3c6.44-3.88 13.44-6.71 21-8.5 9.88-2.49 19.88-4.49 30-6 17.67-.67 35.33-.67 53 0 7.92.41 15.59 1.58 23 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f5d96",
    d: "M2958.5 3399.5c-19.37-.23-38.7.44-58 2 5.07-1.6 10.4-2.43 16-2.5 14.17-.83 28.17-.66 42 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#95a2c1",
    d: "M2984.5 3401.5c12.99 2.24 24.99 6.57 36 13-4.92-1.4-9.92-2.57-15-3.5-5.36-3.68-11.36-6.02-18-7-1.44-.38-2.44-1.21-3-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0080cc",
    d: "M2980.5 3407.5c4.99 1.77 9.99 3.44 15 5-3.16-1.24-5.99-1.24-8.5 0-3.43-1.3-6.93-2.46-10.5-3.5-3.47.61-6.64.11-9.5-1.5-.41.46-.91.79-1.5 1-4.16-1.13-8.66-2.13-13.5-3-5.65.35-10.98.69-16 1-2.06-.73-3.89-1.73-5.5-3 8.46.81 18.29.81 29.5 0 .85 1.62 1.85 1.96 3 1 6.12 2.21 11.96 3.21 17.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#019feb",
    d: "M2930.5 3403.5c1.61 1.27 3.44 2.27 5.5 3 5.02-.31 10.35-.65 16-1 4.84.87 9.34 1.87 13.5 3 .59-.21 1.09-.54 1.5-1 2.86 1.61 6.03 2.11 9.5 1.5 3.57 1.04 7.07 2.2 10.5 3.5 2.51-1.24 5.34-1.24 8.5 0 3.4.52 6.73 1.35 10 2.5 8.62 4.63 17.62 8.29 27 11 1.07.85 2.07 1.69 3 2.5-.13.74.04 1.41.5 2 2.45 2.13 4.95 4.13 7.5 6-.59 1.3-1.59 2.13-3 2.5-2 .33-4 .67-6 1-1.75 1.87-3.92 3.04-6.5 3.5-2.77-.83-5.44-1.16-8-1-3.2 1.17-6.53 1.84-10 2-6.15-1.43-12.32-2.27-18.5-2.5-3.4-1.92-7.07-2.92-11-3-2.33-1.67-4.67-3.33-7-5-2.92-.42-5.59-1.42-8-3-4.79-.16-9.29-1.32-13.5-3.5-5.96-.08-12.13.09-18.5.5a39.1 39.1 0 0 1-11 4.5 110.75 110.75 0 0 0-5 4c-3.65 2.8-7.49 5.47-11.5 8-.38-.56-.88-.89-1.5-1-6.72-1.33-13.39-1-20 1-6.41-1.01-13.41-1.18-21-.5a192.544 192.544 0 0 1-30-9c5.51-3.59 10.84-7.42 16-11.5 7.02-2.4 14.02-4.9 21-7.5.88-.71 1.55-1.54 2-2.5 2.79-1.22 5.62-2.55 8.5-4l1 1c3.91-1.62 7.91-2.96 12-4 4.83.88 9.5.88 14 0 2-.5 3.66-1.5 5-3 1 .67 2 1.33 3 2 4.56-.56 9.4-1.23 14.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#446299",
    d: "M2882.5 3405.5c-4.18 2.04-8.52 3.88-13 5.5-3.04.36-6.04.86-9 1.5 3.25-1.35 6.59-2.85 10-4.5 4.08-.53 8.08-1.36 12-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ba8c4",
    d: "M2854.5 3414.5c-5.99 3.42-12.33 6.42-19 9 3.58-3.07 7.58-5.57 12-7.5 2.24-.98 4.57-1.48 7-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#abb6cd",
    d: "M3022.5 3414.5a96.82 96.82 0 0 1 11 4.5c3.82 2.01 7.15 4.51 10 7.5-7.05-4.08-14.05-8.08-21-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9b5b5",
    d: "M6442.5 3425.5v2c-243.83-.33-487.5 0-731 1h-4c.59-.65 1.26-1.32 2-2 244.33-1 488.67-1.33 733-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbdede",
    d: "M5711.5 3428.5c243.5-1 487.17-1.33 731-1 2.73-.33 5.06.34 7 2h-7c-243.5-1-487.17-1.33-731-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46c6b",
    d: "M6442.5 3425.5c4.76-.85 8.1.82 10 5-.89-.61-1.89-.94-3-1-1.94-1.66-4.27-2.33-7-2v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f2",
    d: "M5707.5 3428.5h4c243.83-.33 487.5 0 731 1-245-.17-490 0-735 .5-2.93 1.3-5.27 3.3-7 6-1.4.41-2.73.91-4 1.5 2.17-4.84 5.84-7.84 11-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M6442.5 3429.5h7c1.11.06 2.11.39 3 1a36.64 36.64 0 0 1 7.5 10c.81 1.94 1.31 3.94 1.5 6 .3 4.6-.03 9.1-1 13.5-255.33.5-510.67.67-766 .5-.49-6.85.18-13.51 2-20v-3c1.27-.59 2.6-1.09 4-1.5 1.73-2.7 4.07-4.7 7-6 245-.5 490-.67 735-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9da9c5",
    d: "M2835.5 3423.5c-.67 1-1.33 2-2 3-3.38 2.7-7.05 5.04-11 7 .01-1.52.68-2.68 2-3.5 3.55-2.39 7.22-4.56 11-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0175c1",
    d: "M3035.5 3428.5c3.44 1.55 6.77 3.39 10 5.5 1.32.82 1.99 1.98 2 3.5-3.24 1.94-6.58 3.77-10 5.5-3.23.71-6.4 1.54-9.5 2.5-.72-.56-1.56-.89-2.5-1a32.26 32.26 0 0 1-7 3c-3.11-1.12-6.27-1.12-9.5 0-1.26-.26-2.26-.93-3-2l-1 1c-6.78-2.17-13.95-3.67-21.5-4.5-5.45-2.15-10.78-4.48-16-7-6.39-1.9-12.55-3.4-18.5-4.5-3.73.6-7.73.6-12 0-1.33.67-2.67 1.33-4 2-1-.33-2-.67-3-1-4 2.09-8.17 3.75-12.5 5 1.56-1.33 3.23-2.66 5-4a39.1 39.1 0 0 0 11-4.5c6.37-.41 12.54-.58 18.5-.5 4.21 2.18 8.71 3.34 13.5 3.5 2.41 1.58 5.08 2.58 8 3 2.33 1.67 4.67 3.33 7 5 3.93.08 7.6 1.08 11 3 6.18.23 12.35 1.07 18.5 2.5 3.47-.16 6.8-.83 10-2 2.56-.16 5.23.17 8 1 2.58-.46 4.75-1.63 6.5-3.5 2-.33 4-.67 6-1 1.41-.37 2.41-1.2 3-2.5-2.55-1.87-5.05-3.87-7.5-6-.46-.59-.63-1.26-.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9fadc8",
    d: "M2999.5 3450.5c10.93 1.46 21.93 1.12 33-1-2.16.97-4.5 1.8-7 2.5-14.85 1.32-29.52.32-44-3a226.33 226.33 0 0 0-22-10c-13.28-2.61-26.28-1.77-39 2.5 3.58-1.86 7.25-3.53 11-5 10.05-1.16 20.05-.66 30 1.5 9.72 2.76 19.05 6.43 28 11 3.29.83 6.63 1.33 10 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfcfd",
    d: "M3032.5 3449.5c1.7.16 3.37-.01 5-.5 3.91-1.79 7.91-3.46 12-5 2.38-.56 4.72-.39 7 .5 2.17 3.85 5.17 7.19 9 10 1.66 4.66 3.83 8.99 6.5 13 1.07 2.19 2.57 3.86 4.5 5a39.34 39.34 0 0 1 4 12.5c-.15 1.26-.48 2.42-1 3.5-4.96.93-9.96 1.76-15 2.5-2.49 1.03-4.83 2.2-7 3.5a61.77 61.77 0 0 0-18 6c-1.88-.27-3.21.4-4 2-5.71 1.29-11.21 2.96-16.5 5-3.65-2.16-7.15-4.49-10.5-7-1.84-4.68-5.18-7.84-10-9.5-3.04-2.7-5.7-5.7-8-9-5.55-5.04-11.55-9.54-18-13.5-2.11-3.12-4.78-5.45-8-7-2.18-.8-3.85-2.3-5-4.5a8.765 8.765 0 0 0-5-1.5c-2.75-3.44-6.41-4.78-11-4-2.33.17-4.67.33-7 .5-.88.71-1.55 1.54-2 2.5-2.81.33-5.48 1.16-8 2.5-6.3 4.96-12.64 9.96-19 15-4.67.67-9.33.67-14 0-1.02-1.05-1.18-2.22-.5-3.5 8.34-8.51 16.84-16.84 25.5-25 1-.33 1.67-1 2-2 12.72-4.27 25.72-5.11 39-2.5a226.33 226.33 0 0 1 22 10c14.48 3.32 29.15 4.32 44 3 2.5-.7 4.84-1.53 7-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfd",
    d: "M2887.5 3477.5c2.17 2.01 4.83 3.18 8 3.5 3.33.67 6.67.67 10 0 4.1-2.41 8.43-4.41 13-6 2.91-1.41 4.91-3.57 6-6.5 3.7-1.52 7.04-3.69 10-6.5 4.79-2.2 9.79-2.87 15-2 4.23 3.08 8.57 5.92 13 8.5 1.71 2.71 4.05 4.71 7 6 6.14 5.3 11.8 11.14 17 17.5 3.23 2.11 6.56 3.95 10 5.5 1.33 3.33 3.67 5.67 7 7 1.3 1.38 2.13 3.05 2.5 5 3.62 2.29 6.96 4.95 10 8 .67 2.67.67 5.33 0 8-5.25 5.28-10.41 5.28-15.5 0a108.08 108.08 0 0 0-19-18.5c-1.63-.49-3.3-.66-5-.5-.13 2.15.37 4.15 1.5 6 3 2.17 5.83 4.5 8.5 7 3.29 5.12 7.46 9.46 12.5 13 .5 2.31.66 4.64.5 7-2.97.13-4.97 1.63-6 4.5-3 .67-6 .67-9 0a83.398 83.398 0 0 0-8-7.5c-1.64-.31-2.64-1.31-3-3-1.64-1.98-3.31-3.98-5-6-2.24-.97-4.58-1.31-7-1-.07 1.9.27 3.73 1 5.5 3.66 3.93 7.49 7.77 11.5 11.5 5.44 8.89 2.94 13.06-7.5 12.5a46.294 46.294 0 0 0-6-5.5c-1.41-2.41-3.41-4.08-6-5-.94-3.49-3.28-4.82-7-4-.73 3.76.61 6.43 4 8 2.97 2.14 5.47 4.81 7.5 8 .76 1.57.6 2.9-.5 4-4.6.2-9.27-.3-14-1.5 1.07-8.94-1.26-16.94-7-24-2.02-.5-4.02-1-6-1.5-1.14-1.71-2.8-2.38-5-2 .09-3.81-.58-7.47-2-11-3.13-1.63-5.79-3.8-8-6.5-7.05.83-13.05-1.17-18-6-2.85-1.17-5.68-2.34-8.5-3.5-3.9 2.03-8.07 3.03-12.5 3-.79-1.6-2.12-2.27-4-2-5.31-1.45-10.65-1.12-16 1a26.95 26.95 0 0 1-8-4.5c-1.63-.49-3.3-.66-5-.5.03-1-.47-1.66-1.5-2-2.68-.72-5.18-1.72-7.5-3a59.775 59.775 0 0 1-5.5-4c-3.24.4-6.41-.44-9.5-2.5-8.1-1.33-16.1-2.83-24-4.5-.33-.83-.67-1.67-1-2.5.72-3.33 1.72-6.5 3-9.5.33-1.33.67-2.67 1-4 .96-.45 1.79-1.12 2.5-2 4.5-11.67 12.33-20.33 23.5-26 16.94 7.02 34.77 11.36 53.5 13 4.82-.78 9.66-1.44 14.5-2-.11 2.28-.94 4.28-2.5 6-3.17 2.5-6.17 5.16-9 8-1.53 5.28.3 8.61 5.5 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#94a3c2",
    d: "M2815.5 3439.5c-3 3.67-6.33 7-10 10 2.33-4.33 5.67-7.67 10-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#017cc8",
    d: "M2872.5 3413.5c-.45.96-1.12 1.79-2 2.5-6.98 2.6-13.98 5.1-21 7.5-5.16 4.08-10.49 7.91-16 11.5 9.84 3.84 19.84 6.84 30 9 7.59-.68 14.59-.51 21 .5 6.61-2 13.28-2.33 20-1-6.83 1.09-14.17 2.92-22 5.5-3.64-.07-6.8.1-9.5.5-6.97-1.13-13.97-3.13-21-6l-1 1c-6.49-2.44-12.99-4.78-19.5-7-1.11-1.22-1.28-2.56-.5-4 13.27-9.39 27.1-16.06 41.5-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b8c3d7",
    d: "M2918.5 3443.5a896.987 896.987 0 0 0-25.5 25c-.68 1.28-.52 2.45.5 3.5 4.67.67 9.33.67 14 0 6.36-5.04 12.7-10.04 19-15 2.52-1.34 5.19-2.17 8-2.5a46.183 46.183 0 0 1-8 4.5c-5.66 4.59-11.33 9.09-17 13.5-5.53 1.88-11.2 2.38-17 1.5-1.07-.74-1.74-1.74-2-3 3.48-4.98 7.15-9.82 11-14.5 4.81-5.48 10.47-9.81 17-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d75a5",
    d: "M2931.5 3436.5c-3.75 1.47-7.42 3.14-11 5-.33 1-1 1.67-2 2-6.53 3.19-12.19 7.52-17 13 .55-1.89 1.55-3.56 3-5 6.61-5.45 13.61-10.28 21-14.5 1.97-.5 3.97-.66 6-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f79190",
    d: "M6452.5 3430.5c5.11 2.61 8.61 6.61 10.5 12l1-1c.5 6.32.67 12.66.5 19h-2c.32-4.86-.01-9.53-1-14-.19-2.06-.69-4.06-1.5-6a36.64 36.64 0 0 0-7.5-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#25478a",
    d: "M2964.5 3399.5c6.62 1.06 13.29 1.72 20 2 .56 1.29 1.56 2.12 3 2.5 6.64.98 12.64 3.32 18 7 5.08.93 10.08 2.1 15 3.5h2c6.95 3.92 13.95 7.92 21 12 5.29 4.32 10.63 8.66 16 13 2.53 2.7 4.7 5.7 6.5 9 1.45 1.96 3.28 3.3 5.5 4 .92 2.59 2.59 4.59 5 6 2.89 5.79 5.23 11.79 7 18a71.145 71.145 0 0 1-5.5-10c-.65-1.2-1.15-1.2-1.5 0a67.13 67.13 0 0 1 5 17.5c-.07 1.99-.74 3.49-2 4.5.52-1.08.85-2.24 1-3.5a39.34 39.34 0 0 0-4-12.5c-2.18-7.04-5.84-13.04-11-18-2.27-3.94-5.27-7.27-9-10-1.18-2.41-3.18-3.41-6-3 .68-1.68 2.02-2.34 4-2 .15-1.05-.02-2.05-.5-3-1.67-1-3.33-2-5-3-.21 1.56-.71 2.89-1.5 4-.01-1.52-.68-2.68-2-3.5a73.462 73.462 0 0 0-10-5.5c-.93-.81-1.93-1.65-3-2.5-9.38-2.71-18.38-6.37-27-11-3.27-1.15-6.6-1.98-10-2.5-5.01-1.56-10.01-3.23-15-5 1.4-.47 2.73-1.14 4-2-.5-.33-1-.67-1.5-1-6.37-1.3-12.53-2.97-18.5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#536da0",
    d: "M3050.5 3441.5c2.82-.41 4.82.59 6 3-2.28-.89-4.62-1.06-7-.5-4.09 1.54-8.09 3.21-12 5-1.63.49-3.3.66-5 .5-11.07 2.12-22.07 2.46-33 1 17.87 1.22 34.87-1.78 51-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99a9c5",
    d: "M3056.5 3444.5c3.73 2.73 6.73 6.06 9 10-3.83-2.81-6.83-6.15-9-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#798cb3",
    d: "M3059.5 3439.5c3.55 2.04 6.72 4.71 9.5 8 .37 1.95 1.2 3.62 2.5 5-2.22-.7-4.05-2.04-5.5-4-1.8-3.3-3.97-6.3-6.5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#506a9e",
    d: "M2896.5 3454.5c.22-1.18-.11-2.18-1-3-10.64 2.05-21.3 2.22-32 .5-2.6-.39-4.94-1.22-7-2.5 6.76 1.33 13.59 2.33 20.5 3 8.19-.35 16.02-1.68 23.5-4 .15 3.04-1.18 5.04-4 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7086af",
    d: "M2954.5 3455.5c-6.55-2.26-13.21-2.59-20-1 .45-.96 1.12-1.79 2-2.5 2.33-.17 4.67-.33 7-.5 4.59-.78 8.25.56 11 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0afca",
    d: "M2825.5 3439.5c2.86-.42 5.03.58 6.5 3 3.48.42 6.65 1.59 9.5 3.5 4.9 1.69 9.9 2.86 15 3.5 2.06 1.28 4.4 2.11 7 2.5 10.7 1.72 21.36 1.55 32-.5.89.82 1.22 1.82 1 3-2.53 3.19-5.2 6.35-8 9.5-.95.48-1.95.65-3 .5-.37 2.4-1.03 4.74-2 7 1.36 2 2.69 4 4 6-5.2-1.39-7.03-4.72-5.5-10 2.83-2.84 5.83-5.5 9-8 1.56-1.72 2.39-3.72 2.5-6-4.84.56-9.68 1.22-14.5 2-18.73-1.64-36.56-5.98-53.5-13-11.17 5.67-19 14.33-23.5 26-.71.88-1.54 1.55-2.5 2a78.09 78.09 0 0 0 6-14 123.97 123.97 0 0 0 16-16.5c1.29-.49 2.63-.66 4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aec0d7",
    d: "M3065.5 3454.5c5.16 4.96 8.82 10.96 11 18-1.93-1.14-3.43-2.81-4.5-5a59.194 59.194 0 0 1-6.5-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab6b6",
    d: "M5696.5 3440.5c-1.82 6.49-2.49 13.15-2 20 255.33.17 510.67 0 766-.5.97-4.4 1.3-8.9 1-13.5.99 4.47 1.32 9.14 1 14-256.26 1-512.6 1.33-769 1-.17-6.01 0-12.01.5-18 .38-1.44 1.21-2.44 2.5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feaf54",
    d: "M1246.5 3461.5c.11.62.44 1.12 1 1.5-1.24.23-2.24.73-3 1.5-2.03-.16-4.03 0-6 .5a85.742 85.742 0 0 0-18 7.5c2.26-1.81 4.6-3.65 7-5.5 3.72-.69 7.05-2.19 10-4.5a21.15 21.15 0 0 1 9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46f6e",
    d: "M5696.5 3438.5v2c-1.29.56-2.12 1.56-2.5 3-.5 5.99-.67 11.99-.5 18 256.4.33 512.74 0 769-1h2v1c-258 1.33-516 1.33-774 0-.72-7.34.28-14.34 3-21a7.48 7.48 0 0 1 3-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f03636",
    d: "M5690.5 3461.5c258 1.33 516 1.33 774 0a37438.857 37438.857 0 0 1-774 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8463e8",
    d: "M4599.5 3467.5c-1.81-1.13-3.81-1.8-6-2-5.81-.99-11.81-1.32-18-1 1.95-2.02 4.45-3.02 7.5-3 4.18.79 8.35 1.62 12.5 2.5 1.82.66 3.16 1.83 4 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffead2",
    d: "M1277.5 3465.5c-22.43-3.14-43.43.86-63 12 1.44-2.45 3.44-4.12 6-5a85.742 85.742 0 0 1 18-7.5c1.97-.5 3.97-.66 6-.5 11.19-1.44 22.19-1.11 33 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefd",
    d: "M1277.5 3465.5c2.03-.16 4.03 0 6 .5 9.13 3.17 17.8 7.17 26 12 6.65 5.59 13.32 11.09 20 16.5a437.26 437.26 0 0 1 13 25c1.75 11.6 3.08 23.26 4 35-.82 11.08-3.15 21.75-7 32 .24 1.29-.1 2.29-1 3-3.88 3.76-6.88 8.09-9 13-4.64 4.46-8.98 9.13-13 14-4.87 3.27-9.87 6.27-15 9-7.28 2.31-14.28 5.14-21 8.5-20.07 1.99-39.41-.68-58-8-1.85-1.03-3.51-2.2-5-3.5-3.2-3.35-6.86-6.19-11-8.5-3.2-3.86-6.36-7.69-9.5-11.5a10.953 10.953 0 0 0-4.5-3c-.14-3.55-1.81-5.88-5-7-2.96-9.5-6.3-18.83-10-28-.62-.11-1.12-.44-1.5-1-.5-5.99-.67-11.99-.5-18 1.15-.29 1.82-1.12 2-2.5 1.15-14.3 5.48-27.47 13-39.5v-3c6.14-5.64 11.81-11.81 17-18.5 2.7-1.01 5.04-2.51 7-4.5 19.57-11.14 40.57-15.14 63-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd5a5",
    d: "M1246.5 3461.5c22.5-1.81 44.17 3.02 65 14.5 2.57 2.48 4.9 5.15 7 8 4.85 2.35 8.52 5.85 11 10.5a1418.82 1418.82 0 0 1-20-16.5c-8.2-4.83-16.87-8.83-26-12-1.97-.5-3.97-.66-6-.5-10.81-2.11-21.81-2.44-33-1 .76-.77 1.76-1.27 3-1.5-.56-.38-.89-.88-1-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#91a2c1",
    d: "M2964.5 3461.5c3.22 1.55 5.89 3.88 8 7-3.72-1.08-6.39-3.41-8-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4b0c9",
    d: "M3076.5 3458.5c1.63 1.47 3.13 3.14 4.5 5 1.94 4.08 3.11 8.42 3.5 13h-1c-1.77-6.21-4.11-12.21-7-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3b3f0",
    d: "M4575.5 3464.5c6.19-.32 12.19.01 18 1-7.89-.52-15.55.15-23 2l2-2c.71-.9 1.71-1.24 3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfe",
    d: "M4593.5 3465.5c3.74 4.04 8.07 7.37 13 10 .54 1.76 1.54 3.09 3 4 .17 6.67 0 13.34-.5 20a23.405 23.405 0 0 0-2.5 6c-2.59 3.63-5.92 6.47-10 8.5-11.99 4.39-22.99 2.89-33-4.5a43.568 43.568 0 0 1-6-9c-2.03-9.16-.87-17.82 3.5-26 3.06-2.58 6.23-4.91 9.5-7 7.45-1.85 15.11-2.52 23-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cabcf2",
    d: "M4593.5 3465.5c2.19.2 4.19.87 6 2 3 2.67 6 5.33 9 8 .33 1.33.67 2.67 1 4-1.46-.91-2.46-2.24-3-4-4.93-2.63-9.26-5.96-13-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f91b6",
    d: "M2924.5 3468.5c-1.09 2.93-3.09 5.09-6 6.5-4.57 1.59-8.9 3.59-13 6-3.33.67-6.67.67-10 0-3.17-.32-5.83-1.49-8-3.5 4.21 1.47 8.54 2.47 13 3 3.02-.78 6.02-1.61 9-2.5 4.64-3.66 9.64-6.83 15-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a9bbd",
    d: "M2969.5 3474.5c6.9 3.79 12.57 8.96 17 15.5 3.94 1.79 7.27 4.29 10 7.5a73.462 73.462 0 0 1-10-5.5c-5.2-6.36-10.86-12.2-17-17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffcc91",
    d: "M1220.5 3472.5c-2.56.88-4.56 2.55-6 5-1.96 1.99-4.3 3.49-7 4.5a149.497 149.497 0 0 1-17 18.5v-2c1.86-3.22 3.86-6.39 6-9.5 6.71-5.34 13.37-10.68 20-16 1.29-.49 2.63-.66 4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f14b4b",
    d: "M6233.5 3484.5c.79-1.6 2.12-2.27 4-2v-4c-181.17-.33-362.17 0-543 1-.99-.17-1.66.16-2 1h-2c.38-1.43 1.38-2.26 3-2.5 182-.83 364-.67 546 .5.89 4.45-1.11 6.45-6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f24c4b",
    d: "M6464.5 3480.5h-2c-.34-.84-1.01-1.17-2-1a3328.56 3328.56 0 0 0-141-.5c-1.81.76-3.48 1.59-5 2.5h-3c1.62-1.62 3.62-2.78 6-3.5 48.33-.67 96.67-.67 145 0 1.26.42 1.92 1.25 2 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f68484",
    d: "M5694.5 3479.5c180.83-1 361.83-1.33 543-1v4c-1.88-.27-3.21.4-4 2h-2c1-1.33 2-2.67 3-4-179.83-1-359.83-1.33-540-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f68584",
    d: "M6460.5 3479.5c-44.84-.33-89.5 0-134 1-4.03 0-8.03.34-12 1 1.52-.91 3.19-1.74 5-2.5 47.17-.83 94.17-.66 141 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9e83eb",
    d: "m4572.5 3465.5-2 2a89.518 89.518 0 0 0-9.5 7c-4.37 8.18-5.53 16.84-3.5 26-.77-.76-1.27-1.76-1.5-3-.5-3.99-.67-7.99-.5-12 1.36-10.36 7.03-17.03 17-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f47070",
    d: "M5690.5 3480.5h2v248c-2-82.33-2.66-164.99-2-248Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M6234.5 3480.5c-1 1.33-2 2.67-3 4-2.1.91-4.1 2.08-6 3.5a3111.84 3111.84 0 0 1-16 15 23.997 23.997 0 0 0-3 5.5c-3.03 3.69-6.03 7.36-9 11-13.83 16.35-28 32.69-42.5 49-.79 1.24-1.29 2.58-1.5 4-2.25 2.53-4.59 2.53-7 0a25.506 25.506 0 0 0-6-6c-3.48-4.24-6.31-8.9-8.5-14-.67-.75-1.5-1.09-2.5-1-1.33-1-2.67-2-4-3-2.37-3.36-4.7-6.69-7-10-1.01-3.51-3.01-6.35-6-8.5-3.46-1.11-5.46.06-6 3.5a157.466 157.466 0 0 0-19 24c-1.96 3.91-.96 6.58 3 8 .33.67.67 1.33 1 2 2.55 5.22 6.21 9.55 11 13 2.36 3.68 5.02 7.01 8 10-.16 1.37.01 2.71.5 4 4.53 2.86 8.03 6.7 10.5 11.5a61.13 61.13 0 0 1-14.5 17.5c-2.05 3.2-4.22 6.2-6.5 9a97.498 97.498 0 0 0-11.5 15 29.18 29.18 0 0 1-6 4l-3 6c-3.38 1.88-5.88 4.55-7.5 8-8.91 7.12-13.07 16.45-12.5 28 1.25 3.41 3.41 6.08 6.5 8 1 .33 1.67 1 2 2 1.32 2.19 3.32 3.69 6 4.5 3.67.67 7.33.67 11 0 1.48-2.15 3.48-3.48 6-4 1.25-1.4 2.25-2.9 3-4.5 6.94-6.11 13.44-12.78 19.5-20 .33-1.33.67-2.67 1-4 8.97-9.97 18.3-19.64 28-29a33.84 33.84 0 0 0 3.5-6c2.02-1.19 4.02-1.19 6 0 5.7 5.7 11.04 11.7 16 18l7 10c5.21 8.55 11.54 16.21 19 23 1.67 1.33 3.33 2.67 5 4 2.3 2.17 4.14 4.84 5.5 8 2.73 2.24 5.56 4.24 8.5 6 3.81 1.15 7.81 1.31 12 .5 1.57-.61 2.9-1.44 4-2.5 2.16-.22 3.83-1.22 5-3 2.76-1.46 4.59-3.79 5.5-7 1.69-9.43-1.15-17.1-8.5-23-5.74-6.23-10.9-12.9-15.5-20a68.272 68.272 0 0 1-6.5-5c-.58-2.25-1.91-3.92-4-5-4.01-8.37-9.68-15.37-17-21-1.19-4.03-3.69-7.03-7.5-9-.52-2.52-1.85-4.52-4-6-.67-1.67-.67-3.33 0-5 4.88-3.21 8.71-7.38 11.5-12.5 4.59-2.76 7.92-6.59 10-11.5.29-2.63 1.62-4.29 4-5 5.04-4.04 9.37-8.71 13-14 5.45-4.11 9.78-9.11 13-15 10.44-11.28 20.77-22.78 31-34.5a128.87 128.87 0 0 0 15-12c4.6-2.8 9.27-5.3 14-7.5 5.7-2.68 11.7-4.51 18-5.5.75-.67 1.09-1.5 1-2.5 1-.67 2-1.33 3-2h4c3.97-.66 7.97-1 12-1 44.91-.33 89.74 0 134.5 1 .83 81.9.66 163.74-.5 245.5-178.5.83-356.83.67-535-.5 4.3-4.15 8.97-7.82 14-11 7.41-7.07 14.07-14.74 20-23 3.25-4.12 6.75-8.12 10.5-12 .99-2.47 2.16-4.8 3.5-7 1.83-1.65 3.16-3.65 4-6 .67-.33 1.33-.67 2-1a85.37 85.37 0 0 0 14-17c.98-1.35 2.32-2.35 4-3 3.07-4.2 6.07-8.37 9-12.5 2.67-.83 5-.33 7 1.5 1.33 2 3 3.67 5 5 2.26 3.44 4.76 6.77 7.5 10 .82 1.32 1.98 1.99 3.5 2 1.61 3.55 3.94 6.55 7 9 1.67 2.33 3.67 4.33 6 6 1.66 1.24 2.83 2.91 3.5 5 .72.56 1.56.89 2.5 1 2.63-3.3 5.63-6.3 9-9 3.6-4.1 7.44-8.1 11.5-12 1.96-2.28 3.46-4.78 4.5-7.5-.14-1.23-.48-2.39-1-3.5a73.168 73.168 0 0 0-11-9c-4.4-6.79-9.74-12.79-16-18-.84-.34-1.17-1.01-1-2-.21-1.42-.71-2.76-1.5-4-2.02-.86-3.52-2.19-4.5-4-1.56-.23-2.9-.9-4-2 1.76-7.15 5.76-12.82 12-17 3.37-2.99 6.53-6.33 9.5-10 2.36-3.84 4.86-7.51 7.5-11 .67-1 1.33-2 2-3 3.73-2.73 6.73-6.06 9-10 2.6-3.77 5.76-7.1 9.5-10 1.42-1.9 2.59-3.9 3.5-6-.13-.74.04-1.41.5-2 4.41-1.82 6.58-5.15 6.5-10 3.71-8.85 1.71-16.35-6-22.5-13.39-8.19-23.72-5.36-31 8.5-2.87 5.22-6.54 9.88-11 14a175.66 175.66 0 0 0-11.5 11 200.59 200.59 0 0 1-11.5 16c-4.98 5.93-9.98 11.93-15 18-4.65-3.31-8.98-6.98-13-11-1.93-3.6-4.6-6.6-8-9a43.753 43.753 0 0 0-4.5-7 18.25 18.25 0 0 0-3.5-2l-7-10c-.95-3.91-3.28-6.58-7-8-1.35-1.1-2.85-2.1-4.5-3-.33-1-.67-2-1-3a107.27 107.27 0 0 1-8.5-9c-3.69-6.77-9.52-10.1-17.5-10-5.35-.33-9.69 1.67-13 6-.48.95-.65 1.95-.5 3-1-.09-1.83.25-2.5 1-3.33 7-3.33 14 0 21 .72 1.56 1.89 2.56 3.5 3 2.33 2.67 4.67 5.33 7 8l6 6a26.3 26.3 0 0 1 7 10c3.08 5.2 7.08 9.53 12 13 3.69 3.03 7.03 6.36 10 10 2.17 5.84 5.84 10.51 11 14 1.66 3.32 3.32 6.65 5 10a36.705 36.705 0 0 0-5 9c-1 .33-1.67 1-2 2-1-.09-1.83.25-2.5 1-8.69 11.51-17.52 22.85-26.5 34-3.45 3.65-6.95 7.31-10.5 11-.56 2.23-1.56 4.23-3 6-2.4 1.57-4.24 3.57-5.5 6-1-.09-1.83.25-2.5 1-4.1 4.26-7.6 8.93-10.5 14-.74-.13-1.41.04-2 .5-2.57 2.73-4.9 5.56-7 8.5-1.01 1.37-2.01 2.7-3 4-1.91.58-3.58 1.58-5 3-5.29 3.29-10.29 6.95-15 11a74.19 74.19 0 0 0-18 8.5 404.12 404.12 0 0 1-25 6c-47.33.5-94.67.67-142 .5v-247h540Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab4b4",
    d: "M5694.5 3479.5c180.17-.33 360.17 0 540 1h-540v248h-2v-248c.34-.84 1.01-1.17 2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#204488",
    d: "M2833.5 3426.5c-2.92 4.32-6.92 7.49-12 9.5 1.09 1.55 2.42 2.72 4 3.5-1.37-.16-2.71.01-4 .5a123.97 123.97 0 0 1-16 16.5 78.09 78.09 0 0 1-6 14c-.33 1.33-.67 2.67-1 4-.96.45-1.79 1.12-2.5 2a66.53 66.53 0 0 0-2.5 11c6.96 1.59 13.96 2.93 21 4 .33.67.67 1.33 1 2-5.8-.35-11.47-1.35-17-3-1 .17-2 .33-3 .5 1.07.85 2.07 1.69 3 2.5-2.31.49-4.64.83-7 1-.17 4.68 0 9.35.5 14 2.47 6.54 4.64 13.21 6.5 20a59.775 59.775 0 0 0-4-5.5l1-1c-1.3-3.43-2.46-6.93-3.5-10.5l-2.5-2.5c.45-4.6.78-9.26 1-14-.33-.17-.67-.33-1-.5-1 6.63-1.33 13.3-1 20-.99-8.15-1.33-16.48-1-25-.09-3.8.58-7.47 2-11 3.93-9.32 8.59-18.32 14-27 1-.33 1.67-1 2-2 3.67-3 7-6.33 10-10 2.52-1.76 4.85-3.76 7-6 3.95-1.96 7.62-4.3 11-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46765",
    d: "M6310.5 3481.5c-1 .67-2 1.33-3 2-4.37.84-8.71 1.84-13 3 4.71-3.16 10.05-4.82 16-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4c8f5",
    d: "M4609.5 3479.5c2.73 6.03 3.4 12.36 2 19-1.1 1.78-1.93 3.78-2.5 6-.67.75-1.5 1.09-2.5 1 .54-2.09 1.38-4.09 2.5-6 .5-6.66.67-13.33.5-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8667e9",
    d: "M4608.5 3475.5c.96.45 1.79 1.12 2.5 2 2.21 6.49 2.87 13.16 2 20-.38.56-.88.89-1.5 1 1.4-6.64.73-12.97-2-19-.33-1.33-.67-2.67-1-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M4399.5 3533.5c-.14 1.62.53 2.79 2 3.5 10.33.5 20.66.67 31 .5v6c-1.28 2.06-2.11 4.4-2.5 7-.17 7.13-1.01 14.13-2.5 21h-28c-.17 26.67 0 53.34.5 80 2.99 5.74 7.49 8.08 13.5 7h1c4.85 1.12 9.85 1.12 15 0 .17 12 0 24-.5 36l-2.5 2.5c-14.72 1.05-29.05 1.22-43 .5a110.34 110.34 0 0 1-16-5c-1.21-.43-2.21-1.1-3-2-4.62-4.53-8.78-9.53-12.5-15-.82-2.62-1.32-5.28-1.5-8-.74-31.32-1.24-62.66-1.5-94l-1.5-1.5c-6.99-.5-13.99-.67-21-.5v-3c1.15-5.6 1.82-11.27 2-17 .83-3.86 1.66-7.86 2.5-12l1.5-1.5c4.35-.57 8.68-1.24 13-2 .56-.38.89-.88 1-1.5 1.43-1.4 2.6-3.07 3.5-5 1.5-8.65 2.67-17.32 3.5-26-.21-2.42.13-4.75 1-7 9.96-1.93 19.96-3.59 30-5 4.99-.75 9.99-1.41 15-2v44Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fccbca",
    d: "M6307.5 3483.5c.09 1-.25 1.83-1 2.5-6.3.99-12.3 2.82-18 5.5 1.69-1.84 3.69-3.18 6-4v-1c4.29-1.16 8.63-2.16 13-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a78fed",
    d: "M4384.5 3490.5v1a586.198 586.198 0 0 0-30 5 15.45 15.45 0 0 0-1 7c-.67 2.67-1.33 5.33-2 8v-5c.28-3.69.78-7.35 1.5-11 .75-.63 1.58-1.13 2.5-1.5 9.55-2.1 19.21-3.27 29-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1b1f3",
    d: "M4400.5 3489.5v44h-1v-44c-5.01.59-10.01 1.25-15 2v-1c.67 0 1-.33 1-1 5.13-1.25 10.13-1.25 15 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1bed4",
    d: "M2798.5 3474.5c-1.28 3-2.28 6.17-3 9.5.33.83.67 1.67 1 2.5 7.9 1.67 15.9 3.17 24 4.5 3.09 2.06 6.26 2.9 9.5 2.5 1.81 1.48 3.65 2.81 5.5 4-7.04-2-14.04-4-21-6-7.04-1.07-14.04-2.41-21-4a66.53 66.53 0 0 1 2.5-11c.71-.88 1.54-1.55 2.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#353185",
    d: "M7225.5 3492.5c2.89-.31 5.55.03 8 1a391.68 391.68 0 0 1 27 8 109 109 0 0 1 18 8c12.9 11.65 19.23 26.31 19 44-9.9.51-19.73 1.18-29.5 2l-2-2c-2.67.67-5.33 1.33-8 2l-1-1a37.76 37.76 0 0 1-14.5 1.5 96.794 96.794 0 0 0-20-23.5c-.56-1.29-1.56-2.12-3-2.5-7.66-1.85-15.32-1.85-23 0-1.44.38-2.44 1.21-3 2.5-7.3 1.84-10.64 6.68-10 14.5.03 1.07.36 1.9 1 2.5v1c.62 4.79 3.28 7.96 8 9.5a826.931 826.931 0 0 0 54 15c10.37 3.03 20.37 6.86 30 11.5 6.87 6.02 13.54 12.35 20 19 2.52 3.71 4.68 7.71 6.5 12 .49 1.29.66 2.63.5 4 .84 7.99 1.51 15.49 2 22.5-1.56 4.75-2.9 9.58-4 14.5-2.08 1.64-2.42 3.64-1 6-.13 1.72-.46 3.38-1 5-.16 1.65-.83 2.99-2 4-2.74 1.74-4.74 4.07-6 7v1c-3.46 2.96-6.8 6.13-10 9.5-5.63 1.46-10.29 4.3-14 8.5-7.92 2.65-15.92 4.99-24 7a456.38 456.38 0 0 1-46 2c-5.57.27-11.24-.23-17-1.5a240.06 240.06 0 0 1-25-6.5c-4.43-3.39-9.09-6.56-14-9.5-1.5-2.83-3.67-5-6.5-6.5a90.382 90.382 0 0 0-7.5-11c-2.13-3.4-3.46-7.06-4-11-1.65-7.24-2.65-14.57-3-22 10.79-1.5 21.46-2.84 32-4 7.28-1.1 14.62-1.26 22-.5 2.11.91 3.44 2.41 4 4.5a60.484 60.484 0 0 0 7 16c4.01 6.51 9.68 10.84 17 13 19.05 5.23 32.88-1.11 41.5-19 .82-4.66-.35-8.66-3.5-12-.24-1.9-1.24-3.24-3-4-1.52-3.62-4.19-6.12-8-7.5a1456.78 1456.78 0 0 0-50-15.5c-9.48-3.08-18.82-6.75-28-11-2.06-3.22-4.89-5.56-8.5-7-.33-1-.67-2-1-3-2.97-3.67-6.13-7.01-9.5-10-6.28-8.32-8.95-17.82-8-28.5-.34-10.44 2.32-19.94 8-28.5a46.61 46.61 0 0 0 7-9c5.37-3.68 10.7-7.35 16-11h1c2.33-.67 4.67-1.33 7-2 9.53-4.01 19.36-7.01 29.5-9 10.67.07 21.5.07 32.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3b4ca",
    d: "M7466.5 3502.5c-7-2.13-14-3.8-21-5-4.38-1.64-9.04-2.47-14-2.5-38.17-.83-76.17-.66-114 .5h-2c.11-.62.44-1.12 1-1.5 38.67-.67 77.33-.67 116 0 10.89.99 21.56 2.99 32 6 .88.71 1.55 1.54 2 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8582ac",
    d: "M7317.5 3495.5c37.83-1.16 75.83-1.33 114-.5 4.96.03 9.62.86 14 2.5-6.01-.3-12.01-.8-18-1.5-36.67-.5-73.33-.67-110-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe9d0",
    d: "M1255.5 3496.5c19.16-1.16 38.5-1.33 58-.5.56.38.89.88 1 1.5h-2c-18.83-1-37.83-1.33-57-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#50689d",
    d: "M3083.5 3476.5h1c5.98 20.02 5.31 39.69-2 59 .37-6.13 1.37-12.13 3-18 1.86-5.36 2.52-10.86 2-16.5-1.08-8.21-2.41-16.37-4-24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0b880",
    d: "M7511.5 3495.5c55.84-.33 111.5 0 167 1-51.79-.07-107.12.27-166 1-.89.61-1.89.94-3 1 .67-1 1.33-2 2-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcd19f",
    d: "M1255.5 3496.5c19.17-.33 38.17 0 57 1-19.84-.33-39.51 0-59 1-5.92.59-11.58 1.93-17 4 5.31-4.77 11.65-6.77 19-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbc3c2",
    d: "M5854.5 3504.5c-5.38-.79-10.72-1.79-16-3-6.66-2.42-13.66-3.42-21-3-7.1-.08-14.1.59-21 2 2.24-.58 4.24-1.75 6-3.5 14.54-1.3 28.87-.3 43 3a38.28 38.28 0 0 0 9 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faafae",
    d: "M5951.5 3506.5c-1.33-1-2.67-2-4-3-6.75-5.86-14.08-6.53-22-2-2.27.61-3.94 1.94-5 4-.15-1.05.02-2.05.5-3 3.31-4.33 7.65-6.33 13-6 7.98-.1 13.81 3.23 17.5 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa9a9",
    d: "M6231.5 3484.5a52.025 52.025 0 0 1-7 7c-.82.89-1.82 1.22-3 1v3c-3.88 1.54-6.88 4.21-9 8-2.2 1.34-4.2 3-6 5 .74-1.93 1.74-3.76 3-5.5 5.33-4.96 10.66-9.96 16-15 1.9-1.42 3.9-2.59 6-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feb35b",
    d: "M1253.5 3498.5c19.49-1 39.16-1.33 59-1a422.05 422.05 0 0 1 0 58c.33-18.91-.01-37.74-1-56.5-19.33-.5-38.66-.67-58-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5972a3",
    d: "M2787.5 3489.5c-.33 8.52.01 16.85 1 25 1.11 6.31 2.11 12.64 3 19-1.46-4.59-2.96-9.26-4.5-14-.82-10.18-.66-20.18.5-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00a0ec",
    d: "M2811.5 3497.5a227.14 227.14 0 0 0 38 14c0 1.33.67 2 2 2 .44 3.9.44 7.74 0 11.5 3.39 7.16 9.05 11.49 17 13 5.34 8 12.68 13 22 15 .95 1.96 2.29 3.62 4 5 3.09 1.63 6.26 3.13 9.5 4.5 4.61-1.45 8.11.39 10.5 5.5 8.48 3.49 16.81 3.32 25-.5 4.41 2.43 8.91 3.76 13.5 4 2.41-.77 4.91-1.27 7.5-1.5.84-1.01 1.17-2.18 1-3.5 4.33-2.15 8.83-2.48 13.5-1 5.69-3.38 10.02-7.38 13-12 10.67-.01 17.17-5.18 19.5-15.5 2.69.6 5.36.1 8-1.5a73.92 73.92 0 0 0 7.5-7c1.64-2.73 1.8-5.39.5-8v-1c.57-2.29 1.57-4.45 3-6.5 5.33-2 10.67-4 16-6 .75-.67 1.09-1.5 1-2.5h1c.24.6.74.93 1.5 1 9.22-3.82 18.55-6.15 28-7 6.52-4.83 8.85-3.17 7 5a44.693 44.693 0 0 0-2.5 8.5c.33 1 .67 2 1 3-1.2.9-2.03 2.07-2.5 3.5-.58 7.04-3.24 13.04-8 18a8.394 8.394 0 0 0-.5 4c-2.09 1.08-3.42 2.75-4 5-7.59 5.58-14.59 11.92-21 19-3.33 1.67-6.67 3.33-10 5-2.06.19-4.06.69-6 1.5-4.33 3.5-8.99 6.5-14 9-1.53.5-3.03.33-4.5-.5a529.946 529.946 0 0 1-35 11c-1.34-.71-2.68-.38-4 1-9.86.48-20.2.48-31 0-.95.41-1.61 1.07-2 2-28.96-.65-57.13-7.15-84.5-19.5-2-.33-4-.67-6-1-5.88-5.54-12.54-9.88-20-13-1.31-3.98-3.98-6.65-8-8-11.03-11.39-18.69-24.72-23-40l1-1a67.447 67.447 0 0 1-4-14c1.39-1.6 3.22-2.44 5.5-2.5 4.5.75 9 1.42 13.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#343085",
    d: "M7468.5 3504.5c1.53-.07 2.53.59 3 2 5.68 4.51 10.51 9.85 14.5 16 2.03 7.15 4.2 14.15 6.5 21 .17 9.34 0 18.67-.5 28-1.44 6.73-2.94 13.07-4.5 19-.33.67-.67 1.33-1 2-3.4 3.84-6.07 8.17-8 13 .17.99-.16 1.66-1 2-3.35.51-5.68 2.34-7 5.5-5.17 1.28-9.83 3.44-14 6.5-3.19 2.37-6.85 3.37-11 3a1332.75 1332.75 0 0 1-63 3h-4c.17 26 0 52-.5 78-1.68 2.1-3.35 3.43-5 4l-2-2c-2.33.67-4.67 1.33-7 2-3.21-.69-6.38-1.02-9.5-1-12.34.17-24.67 0-37-.5l-1.5-1.5c-.83-69.04-.66-138.04.5-207 35.63-1.15 71.29-1.32 107-.5 6.98.83 13.98 1.5 21 2 8.16 1.34 16.16 3.17 24 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9a443",
    d: "M7512.5 3497.5c58.88-.73 114.21-1.07 166-1 2.25.42 3.75 1.75 4.5 4 .44 12 .6 23.83.5 35.5-.31 1.46-.97 2.63-2 3.5.33-13.35 0-26.68-1-40-.79-.43-1.63-.76-2.5-1-26.1.02-52.1.35-78 1-2.8-.71-5.63-1.38-8.5-2-26.15.02-52.49.02-79 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#555493",
    d: "M7770.5 3497.5v1h-58c7.31-1.06 14.81-1.73 22.5-2 11.82.79 23.65 1.12 35.5 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbebe",
    d: "M6379.5 3502.5c-14.81-3.36-29.81-4.52-45-3.5-7.18.77-14.18 2.27-21 4.5-1.79.2-3.12 1.03-4 2.5-2 .33-4 .67-6 1-.88.71-1.55 1.54-2 2.5-1.79-.13-3.46.2-5 1 3.6-3.37 7.94-5.87 13-7.5 7.95-2.18 15.95-4.18 24-6 10.24-1.19 20.24-.53 30 2 5.83-.18 11.16.99 16 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f67b7a",
    d: "M6379.5 3502.5c1.69 1.36 3.36 2.7 5 4-19.96-6.76-40.3-8.26-61-4.5-7.26 2.8-14.59 5.3-22 7.5.45-.96 1.12-1.79 2-2.5 2-.33 4-.67 6-1 .88-1.47 2.21-2.3 4-2.5 6.82-2.23 13.82-3.73 21-4.5 15.19-1.02 30.19.14 45 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9998b8",
    d: "M7278.5 3509.5a109 109 0 0 0-18-8c-8.38-4.7-17.38-7.37-27-8-2.45-.97-5.11-1.31-8-1-12.16-1.16-24.49-1.33-37-.5-.83.91-1.83 1.58-3 2-3 .33-6 .67-9 1-4.64 1.73-8.97 3.89-13 6.5-2.33.67-4.67 1.33-7 2 2.39-2.12 5.06-3.95 8-5.5 7.47-3.06 15.14-5.4 23-7 31.96-5.46 61.63-.13 89 16 .88.71 1.55 1.54 2 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5795",
    d: "M7233.5 3493.5c9.62.63 18.62 3.3 27 8a391.68 391.68 0 0 0-27-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f5d99",
    d: "M7225.5 3492.5c-11 .07-21.83.07-32.5 0a150.666 150.666 0 0 0-29.5 9c4.03-2.61 8.36-4.77 13-6.5 3-.33 6-.67 9-1a7.379 7.379 0 0 0 3-2c12.51-.83 24.84-.66 37 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8481ac",
    d: "M7315.5 3495.5h2c-.33.67-.67 1.33-1 2-.62.11-1.12.44-1.5 1-.5 68.67-.67 137.33-.5 206-1-68.16-1.33-136.5-1-205 .16-1.65.83-2.99 2-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5b5796",
    d: "M7317.5 3495.5c36.67-.17 73.33 0 110 .5 5.99.7 11.99 1.2 18 1.5 7 1.2 14 2.87 21 5 1 .33 1.67 1 2 2-7.84-2.33-15.84-4.16-24-5.5-7.02-.5-14.02-1.17-21-2-35.71-.82-71.37-.65-107 .5.33-.67.67-1.33 1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe9402",
    d: "M7512.5 3497.5c26.51.02 52.85.02 79 0 2.87.62 5.7 1.29 8.5 2 25.9-.65 51.9-.98 78-1 .87.24 1.71.57 2.5 1 1 13.32 1.33 26.65 1 40-35.33-.17-70.67 0-106 .5-2.63 1.59-4.3 3.92-5 7a50.624 50.624 0 0 1 0 20 27.1 27.1 0 0 1 1.5 6.5c.67.75 1.5 1.09 2.5 1 .34.84 1.01 1.17 2 1 14.17 1.19 28 1.19 41.5 0 1.33.67 2.67 1.33 4 2 4.17-1.4 8.34-2.4 12.5-3h1c1.03.75 2.2 1.42 3.5 2 5.18-.32 10.52-.99 16-2 3.07.53 6.57.86 10.5 1 1.76.96 3.76 1.29 6 1-.26 13.37-.6 26.71-1 40-17.24.33-34.41-.01-51.5-1-14.6.66-29.1 1.33-43.5 2-1.25.08-2.08.74-2.5 2a268.47 268.47 0 0 1-2.5 33.5c.78 4.41 3.28 7.24 7.5 8.5 6.9-.14 14.07-.48 21.5-1 23.23-.38 46.9-1.05 71-2h1c2.21.77 4.55 1.43 7 2 1-.09 1.83.25 2.5 1 .82 13.91.66 27.74-.5 41.5-46.6.43-89.43.93-128.5 1.5-14.12-.71-28.29-1.38-42.5-2v-15c-.93-62.08-.93-125.08 0-189 1.11-.06 2.11-.39 3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#363380",
    d: "M7712.5 3498.5h58c.67 24.33 1.33 48.67 2 73-.01 2.19-1.01 3.02-3 2.5-2.09-4.05-4.76-7.55-8-10.5-4.34-6.71-8.67-13.38-13-20a67.066 67.066 0 0 0-6-9c-1.12-3.31-3.28-4.31-6.5-3-.18 13.05-.68 26.05-1.5 39-8.06 1.3-16.06 1.3-24 0 .21-23.2-.12-45.7-1-67.5.2-2.18 1.2-3.68 3-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9011",
    d: "M1253.5 3498.5c19.34-.17 38.67 0 58 .5a805.13 805.13 0 0 1 1 56.5c-3.25 24.09-16.92 38.93-41 44.5-8.5 1.03-16.83.53-25-1.5-2.04-2.33-4.71-3.5-8-3.5a43.01 43.01 0 0 1-6-5 8.394 8.394 0 0 0-4-.5c-2.7-3.32-5.87-6.32-9.5-9-.61-3.88-2.27-7.21-5-10-.98-2.24-1.48-4.57-1.5-7-.17-9.34 0-18.67.5-28 1.43-4.62 3.43-8.96 6-13 1.38-1.71 3.04-3.05 5-4 1.26-4.06 3.43-7.39 6.5-10l6-6a65.662 65.662 0 0 1 17-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9bad0",
    d: "M7313.5 3499.5c-.33 68.5 0 136.84 1 205 .61.89.94 1.89 1 3-1 .09-1.83-.25-2.5-1-.19-5.92-.69-11.75-1.5-17.5.96-59.28.96-119.28 0-180 .63-3.27 1.3-6.44 2-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a5a2be",
    d: "M7772.5 3497.5c1.16 25.83 1.33 51.83.5 78-1.32 1.38-2.66 1.71-4 1-.44-4.02-2.61-6.52-6.5-7.5l1-1c-1.08-1.33-1.75-2.83-2-4.5 3.24 2.95 5.91 6.45 8 10.5 1.99.52 2.99-.31 3-2.5v-74Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f5de7",
    d: "M4555.5 3485.5c-.17 4.01 0 8.01.5 12 .23 1.24.73 2.24 1.5 3 1.64 3.27 3.64 6.27 6 9v1c-3.26-1.43-5.76-3.76-7.5-7-.73-3.69-1.57-7.36-2.5-11 .22-2.58.89-4.91 2-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef2a2a",
    d: "M5838.5 3501.5c5.28 1.21 10.62 2.21 16 3v1c3.12 1.72 6.46 3.22 10 4.5 2.05 3.15 5.05 4.81 9 5 5.22 3.77 10.22 7.77 15 12a18.25 18.25 0 0 1 2 3.5c2.16 1.71 3.33 4.04 3.5 7 2.64 2.3 5.31 4.64 8 7a75.206 75.206 0 0 0 6.5 16c.82.89 1.82 1.22 3 1 1.62 7.7 3.45 15.37 5.5 23 .5 8.99.67 17.99.5 27v3c-2.31 3.55-3.48 7.55-3.5 12-2 3.91-4 7.91-6 12-.64 1.77-.47 3.43.5 5-.96.45-1.79 1.12-2.5 2-2.46 4.24-4.63 8.57-6.5 13-1-.09-1.83.25-2.5 1a50.831 50.831 0 0 0-7 10c-3.68 1.18-6.18 3.51-7.5 7-3 2.67-6 5.33-9 8-4.81 2.22-9.48 4.72-14 7.5-1.29.49-2.63.66-4 .5-9.4 2.68-18.9 4.68-28.5 6h-18c-4.08-.8-8.25-1.3-12.5-1.5a75.72 75.72 0 0 1-21-7.5c-7.9-4.3-15.56-8.96-23-14a181.648 181.648 0 0 0-16-16c-3.28-6.6-6.94-12.93-11-19-1.43-2.06-2.1-4.39-2-7a65 65 0 0 1-4-17 167.91 167.91 0 0 1-.5-30c1.73-7.75 3.73-15.42 6-23a75.68 75.68 0 0 0 4.5-11c6.15-11.9 14.49-22.24 25-31 6.71-4.07 13.38-8.07 20-12 3.08-1.52 6.41-2.35 10-2.5.84-1.01 1.17-2.18 1-3.5 6.86-1.21 13.86-2.21 21-3 10.8.01 21.47.35 32 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbc1c0",
    d: "M6094.5 3523.5c1.2-18.31-7.13-26.47-25-24.5a94.208 94.208 0 0 0-12 10.5c7.28-13.86 17.61-16.69 31-8.5 7.71 6.15 9.71 13.65 6 22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef2a29",
    d: "M6384.5 3506.5c5.22 2.78 9.89 6.28 14 10.5 4.86 3.02 9.86 5.85 15 8.5 1.38 2.05 3.05 3.72 5 5 1.25 2.43 2.75 4.77 4.5 7 1.13 1.64 2.63 2.64 4.5 3-.16 1.37.01 2.71.5 4 2.78 3.18 4.78 6.85 6 11 .82 1.32 1.98 1.99 3.5 2h1c.68 6.02 2.34 11.69 5 17-.15 7.78.52 15.45 2 23-1.17 10-2.33 20-3.5 30a272.669 272.669 0 0 1-17.5 34 6.603 6.603 0 0 1-3 3 158.48 158.48 0 0 0-15 15c-.33.67-.67 1.33-1 2-8.35 5.21-17.02 9.71-26 13.5-4.74.53-9.41 1.36-14 2.5-13.08 1.35-26.41 1.18-40-.5-5.7-1.64-11.37-3.14-17-4.5h-2c-3.7-3.36-8.04-5.69-13-7 .09-1-.25-1.83-1-2.5a42.446 42.446 0 0 0-11-5.5c.22-1.18-.11-2.18-1-3-2.59-1.88-5.09-3.88-7.5-6-4.44-5.61-8.28-11.61-11.5-18a7.48 7.48 0 0 0-3-2c-1.99-2.66-3.49-5.66-4.5-9-.71-.88-1.54-1.55-2.5-2v-4c-4.76-16.63-6.26-33.63-4.5-51 2.1-4.42 2.94-9.09 2.5-14 1.29-.56 2.12-1.56 2.5-3 .56-2.78 1.39-5.45 2.5-8-.16-1.37.01-2.71.5-4 2.44-3.22 4.6-6.55 6.5-10v-1a10664 10664 0 0 0 14-15c4.68-2.17 8.68-5.33 12-9.5a81.33 81.33 0 0 1 11-5c.86-1.36 1.86-2.53 3-3.5 7.41-2.2 14.74-4.7 22-7.5 20.7-3.76 41.04-2.26 61 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f57977",
    d: "M5838.5 3501.5c-10.53-.65-21.2-.99-32-1-7.14.79-14.14 1.79-21 3 .17 1.32-.16 2.49-1 3.5-3.59.15-6.92.98-10 2.5 2.06-3.32 5.06-5.49 9-6.5 4.33-.9 8.67-1.73 13-2.5 6.9-1.41 13.9-2.08 21-2 7.34-.42 14.34.58 21 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f47371",
    d: "M6094.5 3523.5c.08 4.85-2.09 8.18-6.5 10-.46.59-.63 1.26-.5 2-3.36 3.03-6.69 6.03-10 9 3.58-4.92 7.58-9.59 12-14 4.61-7.42 5.11-15.08 1.5-23-3.6-3.95-7.93-6.61-13-8-3.52.75-7.02 1.59-10.5 2.5a223.052 223.052 0 0 0-21 22.5v-1c4.46-4.12 8.13-8.78 11-14 3.67-3.81 7.67-7.31 12-10.5 17.87-1.97 26.2 6.19 25 24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fecd94",
    d: "M1329.5 3494.5c3.94 4.56 7.44 9.56 10.5 15 2.81 4.27 4.31 8.93 4.5 14-.67-1.33-1.33-2.67-2-4a437.26 437.26 0 0 0-13-25Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0178c3",
    d: "M3080.5 3517.5c.15 2.94-.85 5.77-3 8.5l1 1c-2.81 5.29-6.14 10.12-10 14.5-.16-1.37.01-2.71.5-4 4.76-4.96 7.42-10.96 8-18 .47-1.43 1.3-2.6 2.5-3.5-.33-1-.67-2-1-3 .56-2.94 1.39-5.77 2.5-8.5 1.85-8.17-.48-9.83-7-5-9.45.85-18.78 3.18-28 7-.76-.07-1.26-.4-1.5-1 .11-.62.44-1.12 1-1.5 7.83-2.55 15.33-5.05 22.5-7.5 1.23.61 2.56.94 4 1 3.14-1 6.3-1.5 9.5-1.5.67 1.33 1.33 2.67 2 4a501.32 501.32 0 0 1-3 17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9694b6",
    d: "M7155.5 3503.5c-5.3 3.65-10.63 7.32-16 11 .36-1.87 1.36-3.37 3-4.5 4.12-2.73 8.45-4.89 13-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f78987",
    d: "M6294.5 3487.5c-2.31.82-4.31 2.16-6 4-4.73 2.2-9.4 4.7-14 7.5a128.87 128.87 0 0 1-15 12 1592.574 1592.574 0 0 1-31 34.5c.45-3.53 1.95-6.53 4.5-9 8.81-8.48 17.31-17.31 25.5-26.5 8.19-6.59 16.52-12.92 25-19 2.27-.47 4.27-1.47 6-3 1.63-.49 3.3-.66 5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f26564",
    d: "M5925.5 3501.5a904.8 904.8 0 0 0-7 10c-.25-2.36.42-4.36 2-6 1.06-2.06 2.73-3.39 5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0170bb",
    d: "M2849.5 3511.5a227.14 227.14 0 0 1-38-14c.62-.11 1.12-.44 1.5-1a172.77 172.77 0 0 0 19.5 6.5c6.24 2 11.9 4.84 17 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f57675",
    d: "M6212.5 3503.5c-3 3.84-5.84 7.84-8.5 12a99.802 99.802 0 0 1-9.5 10c.6-2.25 1.6-4.25 3-6 2.97-3.64 5.97-7.31 9-11 1.8-2 3.8-3.66 6-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9579ea",
    d: "M4611.5 3498.5c-.28 5.8-2.94 10.14-8 13l3-6c1 .09 1.83-.25 2.5-1 .57-2.22 1.4-4.22 2.5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#10367f",
    d: "M2958.5 3399.5h6c5.97 2.03 12.13 3.7 18.5 5 .5.33 1 .67 1.5 1-1.27.86-2.6 1.53-4 2-5.54.21-11.38-.79-17.5-3-1.15.96-2.15.62-3-1-11.21.81-21.04.81-29.5 0-5.1.77-9.94 1.44-14.5 2-1-.67-2-1.33-3-2-1.34 1.5-3 2.5-5 3-4.5.88-9.17.88-14 0a87.955 87.955 0 0 0-12 4l-1-1c-2.88 1.45-5.71 2.78-8.5 4-14.4 3.94-28.23 10.61-41.5 20-.78 1.44-.61 2.78.5 4 6.51 2.22 13.01 4.56 19.5 7l1-1c7.03 2.87 14.03 4.87 21 6 2.7-.4 5.86-.57 9.5-.5 7.83-2.58 15.17-4.41 22-5.5.62.11 1.12.44 1.5 1 4.01-2.53 7.85-5.2 11.5-8 4.33-1.25 8.5-2.91 12.5-5 1 .33 2 .67 3 1 1.33-.67 2.67-1.33 4-2 4.27.6 8.27.6 12 0 5.95 1.1 12.11 2.6 18.5 4.5 5.22 2.52 10.55 4.85 16 7 7.55.83 14.72 2.33 21.5 4.5l1-1c.74 1.07 1.74 1.74 3 2 3.23-1.12 6.39-1.12 9.5 0a32.26 32.26 0 0 0 7-3c.94.11 1.78.44 2.5 1 3.1-.96 6.27-1.79 9.5-2.5 3.42-1.73 6.76-3.56 10-5.5.79-1.11 1.29-2.44 1.5-4 1.67 1 3.33 2 5 3 .48.95.65 1.95.5 3-1.98-.34-3.32.32-4 2-16.13 7.22-33.13 10.22-51 9-3.37-.17-6.71-.67-10-1.5-8.95-4.57-18.28-8.24-28-11-9.95-2.16-19.95-2.66-30-1.5-2.03-.16-4.03 0-6 .5-7.39 4.22-14.39 9.05-21 14.5-1.45 1.44-2.45 3.11-3 5-3.85 4.68-7.52 9.52-11 14.5.26 1.26.93 2.26 2 3 5.8.88 11.47.38 17-1.5 5.67-4.41 11.34-8.91 17-13.5 2.86-1.26 5.53-2.76 8-4.5 6.79-1.59 13.45-1.26 20 1 1.81-.01 3.48.49 5 1.5 1.15 2.2 2.82 3.7 5 4.5 1.61 3.59 4.28 5.92 8 7 9.78 9.61 19.78 19.11 30 28.5 1.9 1.42 3.9 2.59 6 3.5 2.73 3.9 6.23 6.9 10.5 9 4.38-2.05 8.88-3.72 13.5-5 3.49-.41 6.82-1.41 10-3 .94.11 1.78.44 2.5 1 1.01-1.76 2.51-2.93 4.5-3.5 8.51-2.71 17.18-5.04 26-7 1.62-.24 2.62-1.07 3-2.5.67 0 1-.33 1-1 1.26-1.01 1.93-2.51 2-4.5a67.13 67.13 0 0 0-5-17.5c.35-1.2.85-1.2 1.5 0 1.61 3.56 3.44 6.89 5.5 10 1.59 8.13 2.92 16.29 4 24.5.52 5.64-.14 11.14-2 16.5.17-4.68 0-9.35-.5-14-1.51 4.72-3.01 9.39-4.5 14a501.32 501.32 0 0 0 3-17.5c-.67-1.33-1.33-2.67-2-4-3.2 0-6.36.5-9.5 1.5-1.44-.06-2.77-.39-4-1-7.17 2.45-14.67 4.95-22.5 7.5-.56.38-.89.88-1 1.5h-1c-6.48 1.83-13.15 4.17-20 7-.79.74-1.45 1.58-2 2.5.61 1.95 1.28 3.78 2 5.5v1c-.15 3.83-1.82 7.33-5 10.5-4.17 2.59-8.67 4.09-13.5 4.5-1.72 11.13-7.72 15.8-18 14-1.59 3.49-3.75 6.66-6.5 9.5a44.136 44.136 0 0 1-15 3c-1.82.66-3.16 1.83-4 3.5-7.64 2.91-15.14 1.91-22.5-3-8.19 7.04-16.53 7.37-25 1-2.64-3.94-5.81-5.28-9.5-4a23.888 23.888 0 0 0-6-2.5c-3.33-3.04-6.5-6.2-9.5-9.5-1 .33-2 .67-3 1-7.05-2.05-11.88-6.55-14.5-13.5-7.98-.65-13.98-4.31-18-11-.03-2.62.3-5.29 1-8-.66-1.52-1.66-2.69-3-3.5-1.33 0-2-.67-2-2-5.1-3.66-10.76-6.5-17-8.5a172.77 172.77 0 0 1-19.5-6.5c-.38.56-.88.89-1.5 1-4.42-1.81-8.75-3.14-13-4-.93-.81-1.93-1.65-3-2.5 1-.17 2-.33 3-.5 5.53 1.65 11.2 2.65 17 3a87.766 87.766 0 0 1 19 6 243.82 243.82 0 0 0 19 9c1.47.39 2.97.73 4.5 1 2.06-1.12 4.23-1.78 6.5-2 3.02-.16 6.02 0 9 .5 2.26 1.69 4.76 2.86 7.5 3.5 5.07-.97 10.24-1.3 15.5-1 1.58.88 3.25 1.72 5 2.5.75.67 1.09 1.5 1 2.5 3.94 1.7 8.28 2.87 13 3.5 1.33 1 2.67 2 4 3-2.78-.89-5.78-1.39-9-1.5-1.87.01-3.54.34-5 1-1.32 1.44-2.99 2.11-5 2 .82-3.72-.51-6.06-4-7-1.53-2.18-3.7-3.18-6.5-3-4.08 1.58-8.25 2.92-12.5 4-3.43-7.13-8.76-8.8-16-5-1.13 1.12-1.8 2.46-2 4-2.15 5.68-.82 10.51 4 14.5 3.2.8 6.2.64 9-.5.75-1.97 1.92-2.3 3.5-1 .46 12.15 6.63 16.98 18.5 14.5.57.99 1.23 1.83 2 2.5.58 1.91 1.58 3.58 3 5 3.82 3.52 7.98 3.86 12.5 1 1.59.86 2.43 2.19 2.5 4 2.25 7.38 7.25 10.22 15 8.5 2.38-.22 4.05-1.39 5-3.5 3.09-.13 4.93-1.79 5.5-5 .22 2.47 1.39 4.14 3.5 5 2.19.2 4.19.87 6 2 13.52 1.89 15.52-2.28 6-12.5 1.69.13 3.36.63 5 1.5 3.94 6.01 9.27 7.51 16 4.5 2.09-1.26 3.09-3.09 3-5.5-.51-3.36-1.85-6.36-4-9-3.5-4-7.34-7.67-11.5-11a8.394 8.394 0 0 1-.5-4h4c.95 2.95 2.95 4.95 6 6 .36 1.69 1.36 2.69 3 3 5.86 11.33 13.7 13 23.5 5 .67-3.33.67-6.67 0-10-4.71-3.88-9.21-7.88-13.5-12-1.6-3.43-4.1-6.1-7.5-8-.48-.95-.65-1.95-.5-3 1.05-.15 2.05.02 3 .5 4.33 3.83 8.33 7.99 12 12.5 2.36 1.38 4.7 2.71 7 4 2.23 5.28 6.23 7.11 12 5.5 5.97-3.39 7.47-8.23 4.5-14.5-2.93-2.26-5.1-5.1-6.5-8.5a17.45 17.45 0 0 0-7-3.5c.13-.74-.04-1.41-.5-2a51.923 51.923 0 0 1-6.5-5c-2.73-3.21-6.06-5.71-10-7.5-4.43-6.54-10.1-11.71-17-15.5-2.95-1.29-5.29-3.29-7-6-3.47-3.3-7.14-6.47-11-9.5-6.29-2.25-12.29-1.59-18 2a99.89 99.89 0 0 0-9 7.5 86.249 86.249 0 0 0-15 9.5c-2.98.89-5.98 1.72-9 2.5-4.46-.53-8.79-1.53-13-3-1.31-2-2.64-4-4-6 .97-2.26 1.63-4.6 2-7 1.05.15 2.05-.02 3-.5 2.8-3.15 5.47-6.31 8-9.5 2.82-.96 4.15-2.96 4-6-7.48 2.32-15.31 3.65-23.5 4-6.91-.67-13.74-1.67-20.5-3a74.25 74.25 0 0 1-15-3.5c-2.85-1.91-6.02-3.08-9.5-3.5-1.47-2.42-3.64-3.42-6.5-3-1.58-.78-2.91-1.95-4-3.5 5.08-2.01 9.08-5.18 12-9.5.67-1 1.33-2 2-3 6.67-2.58 13.01-5.58 19-9 1-.67 2-1.33 3-2h3a95.96 95.96 0 0 1 9-1.5c4.48-1.62 8.82-3.46 13-5.5 6-1.33 12-2.67 18-4 19.3-1.56 38.63-2.23 58-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a1afc9",
    d: "M3008.5 3500.5c3.35 2.51 6.85 4.84 10.5 7 5.29-2.04 10.79-3.71 16.5-5-1 .67-2 1.33-3 2a85.923 85.923 0 0 0-13.5 5c-4.27-2.1-7.77-5.1-10.5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#adbad1",
    d: "M2844.5 3502.5c1.7-.16 3.37.01 5 .5a26.95 26.95 0 0 0 8 4.5c5.35-2.12 10.69-2.45 16-1-3.21-.31-6.21.02-9 1-2.27.22-4.44.88-6.5 2-1.53-.27-3.03-.61-4.5-1a60.723 60.723 0 0 0-9-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#335491",
    d: "M3078.5 3489.5c-.38 1.43-1.38 2.26-3 2.5-8.82 1.96-17.49 4.29-26 7-1.99.57-3.49 1.74-4.5 3.5-.72-.56-1.56-.89-2.5-1a30.027 30.027 0 0 1-10 3c1-.67 2-1.33 3-2 .79-1.6 2.12-2.27 4-2 6.29-1.4 12.29-3.4 18-6 6.96-1.79 13.96-3.46 21-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a8eb4",
    d: "M2996.5 3497.5c1.96 1.78 4.13 3.45 6.5 5 .46.59.63 1.26.5 2-3.33-1.33-5.67-3.67-7-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#889abc",
    d: "M3057.5 3494.5c-5.71 2.6-11.71 4.6-18 6a61.77 61.77 0 0 1 18-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5971a3",
    d: "M2814.5 3491.5c6.96 2 13.96 4 21 6 2.32 1.28 4.82 2.28 7.5 3 1.03.34 1.53 1 1.5 2 3.25 1.78 6.25 3.78 9 6a243.82 243.82 0 0 1-19-9 87.766 87.766 0 0 0-19-6c-.33-.67-.67-1.33-1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#91a2c0",
    d: "M3079.5 3488.5c0 .67-.33 1-1 1-7.04 1.54-14.04 3.21-21 5 2.17-1.3 4.51-2.47 7-3.5 5.04-.74 10.04-1.57 15-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99a9c6",
    d: "M2972.5 3468.5c6.45 3.96 12.45 8.46 18 13.5 2.3 3.3 4.96 6.3 8 9 4.82 1.66 8.16 4.82 10 9.5-2.1-.91-4.1-2.08-6-3.5-10.22-9.39-20.22-18.89-30-28.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a8eb4",
    d: "M2962.5 3468.5c-4.43-2.58-8.77-5.42-13-8.5-5.21-.87-10.21-.2-15 2-2.96 2.81-6.3 4.98-10 6.5a99.89 99.89 0 0 1 9-7.5c5.71-3.59 11.71-4.25 18-2 3.86 3.03 7.53 6.2 11 9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46664",
    d: "M6301.5 3509.5c-1.14.97-2.14 2.14-3 3.5a81.33 81.33 0 0 0-11 5c-3.32 4.17-7.32 7.33-12 9.5 3.74-3.24 7.41-6.74 11-10.5 3.91-1.44 7.24-3.61 10-6.5 1.54-.8 3.21-1.13 5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faaead",
    d: "M5854.5 3505.5c2.43.02 4.76.52 7 1.5 9.78 4.73 18.78 10.73 27 18 1.96 1.45 3.3 3.28 4 5.5h-2a18.25 18.25 0 0 0-2-3.5c-4.78-4.23-9.78-8.23-15-12-3.95-.19-6.95-1.85-9-5-3.54-1.28-6.88-2.78-10-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8363e8",
    d: "M4351.5 3506.5v5c-1.02 6.84-2.69 13.51-5 20 1.14-5.93 1.97-11.93 2.5-18 .7-2.5 1.53-4.84 2.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2c6f4",
    d: "m4606.5 3505.5-3 6c-.67 0-1 .33-1 1-13.53 8.52-26.53 7.86-39-2v-1c10.01 7.39 21.01 8.89 33 4.5 4.08-2.03 7.41-4.87 10-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#04317b",
    d: "M2798.5 3528.5c7.59 16.09 18.92 28.92 34 38.5 10.7 7.45 22.36 12.79 35 16 4.7 3.8 9.87 5.63 15.5 5.5 2.72 2.51 5.39 3.17 8 2 2.18.62 4.01 1.78 5.5 3.5 3.79.44 7.29.27 10.5-.5l15 3c1.96.47 3.8-.2 5.5-2 6.2 1.25 12.37 1.25 18.5 0 .69.86 1.52 1.52 2.5 2 1.57-.19 3.07-.19 4.5 0 1-.67 2-1.33 3-2 2.18-.07 4.18.26 6 1 3.65-1.57 6.98-1.91 10-1 13.5-4.87 27.66-9.04 42.5-12.5 5-2.33 10-4.67 15-7 1.88-1.05 3.22-2.55 4-4.5 3.33-1.67 6.67-3.33 10-5 8.25-4.92 15.25-11.25 21-19 .58-2.25 1.91-3.92 4-5 3.86-4.38 7.19-9.21 10-14.5l-1-1c2.15-2.73 3.15-5.56 3-8.5 1.49-4.61 2.99-9.28 4.5-14 .5 4.65.67 9.32.5 14a86.582 86.582 0 0 0-3 18c-.96.45-1.79 1.12-2.5 2-2.88 10.77-8.04 20.1-15.5 28-8.97 8.8-18.63 16.63-29 23.5-12.47 5.33-24.8 10.83-37 16.5-9.98 1.96-19.98 3.63-30 5-10.91-.32-21.75.01-32.5 1a546.1 546.1 0 0 0-32.5-1.5 57.75 57.75 0 0 0-17-3c-6.01-2.87-12.35-4.87-19-6-2.17-2.2-4.84-3.04-8-2.5-6.61-3.68-13.28-7.51-20-11.5a8.394 8.394 0 0 0-4-.5 45.373 45.373 0 0 1-10-6c-4.33-3.66-8.33-7.66-12-12a69.053 69.053 0 0 0-8-12 81.025 81.025 0 0 0-5-4c-3.15-6.32-6.15-12.66-9-19-.89-6.36-1.89-12.69-3-19-.33-6.7 0-13.37 1-20 .33.17.67.33 1 .5-.22 4.74-.55 9.4-1 14l2.5 2.5c1.04 3.57 2.2 7.07 3.5 10.5l-1 1c1.48 1.81 2.81 3.65 4 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#768ab2",
    d: "M2896.5 3516.5c-6.64-2.12-12.48-.79-17.5 4a83.722 83.722 0 0 1-6.5-7.5c-5.17-1.46-9.51-.29-13 3.5.2-1.54.87-2.88 2-4 7.24-3.8 12.57-2.13 16 5 4.25-1.08 8.42-2.42 12.5-4 2.8-.18 4.97.82 6.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f8fb",
    d: "M2896.5 3516.5c2.64 2.73 3.64 6.07 3 10 4.13.8 7.3-.54 9.5-4 2.7 1.44 5.54 2.44 8.5 3 .69 5.3 1.03 10.64 1 16 5.17-1.59 10.17-1.26 15 1 0 .67.33 1 1 1 1.78 3.1 2.45 6.26 2 9.5-.81 3.72-2.48 6.89-5 9.5-3.48 1.14-7.14 1.31-11 .5a25.305 25.305 0 0 1-4-4.5c-.49-2.31-.83-4.64-1-7-5.35 1.12-10.68 1.12-16 0a11.837 11.837 0 0 1-3-5c.47-2.82-.53-4.82-3-6-6.2 2.84-11.03 1.17-14.5-5-.5-2.98-.66-5.98-.5-9-3.74.03-7.08 1.03-10 3-1.71-.23-3.37-.56-5-1-3.16-3.27-4.49-7.27-4-12 3.49-3.79 7.83-4.96 13-3.5 2.07 2.69 4.24 5.19 6.5 7.5 5.02-4.79 10.86-6.12 17.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e9dbf",
    d: "M3003.5 3504.5c2.59.63 4.92 1.8 7 3.5 1.4 3.4 3.57 6.24 6.5 8.5 2.97 6.27 1.47 11.11-4.5 14.5-5.77 1.61-9.77-.22-12-5.5 5.09 5.28 10.25 5.28 15.5 0 .67-2.67.67-5.33 0-8a57.375 57.375 0 0 0-10-8c-.37-1.95-1.2-3.62-2.5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0174bf",
    d: "M3043.5 3505.5c.09 1-.25 1.83-1 2.5-5.33 2-10.67 4-16 6-1.43 2.05-2.43 4.21-3 6.5-.72-1.72-1.39-3.55-2-5.5.55-.92 1.21-1.76 2-2.5 6.85-2.83 13.52-5.17 20-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#526ca0",
    d: "M2864.5 3507.5c2.79-.98 5.79-1.31 9-1 1.88-.27 3.21.4 4 2 3.83 1.04 7.83 1.04 12 0 2.66-.06 4.99.61 7 2-5.26-.3-10.43.03-15.5 1-2.74-.64-5.24-1.81-7.5-3.5-2.98-.5-5.98-.66-9-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aebad1",
    d: "M2931.5 3534.5c-1.97.24-3.8-.09-5.5-1-2.06-13.2-9.89-19.2-23.5-18 .09-1-.25-1.83-1-2.5a62.97 62.97 0 0 1-5-2.5c-2.01-1.39-4.34-2.06-7-2-4.17 1.04-8.17 1.04-12 0 4.43.03 8.6-.97 12.5-3 2.82 1.16 5.65 2.33 8.5 3.5 4.95 4.83 10.95 6.83 18 6 2.21 2.7 4.87 4.87 8 6.5a27.42 27.42 0 0 1 2 11c2.2-.38 3.86.29 5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f56560",
    d: "M6384.5 3506.5c4.2 1.1 8.2 2.76 12 5 3.46 3.58 7.46 6.25 12 8 .97 2.63 2.64 4.63 5 6-5.14-2.65-10.14-5.48-15-8.5a56.492 56.492 0 0 0-14-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb764",
    d: "M1190.5 3498.5v5c-3.74 2.62-6.4 6.12-8 10.5-2.18 6.38-3.85 12.88-5 19.5-.68.36-1.35.7-2 1-.32-3.4.01-6.73 1-10 3.55-8 6.88-16 10-24 1.7-.03 3.03-.69 4-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feb055",
    d: "M1404.5 3518.5c7.15-1.16 14.49-1.32 22-.5 1.44.38 2.44 1.21 3 2.5a93.903 93.903 0 0 0-25-2ZM1858.5 3519.5a94.604 94.604 0 0 0-23-.5 117.07 117.07 0 0 1-7 3.5c-4.16.71-7.83 2.38-11 5h-1c2.06-2.77 4.73-4.94 8-6.5 3.36-.05 6.36-1.05 9-3 8-.67 16-.67 24 0 .56.38.89.88 1 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#94a3c2",
    d: "M3000.5 3525.5c-2.3-1.29-4.64-2.62-7-4-3.67-4.51-7.67-8.67-12-12.5-.95-.48-1.95-.65-3-.5-.15 1.05.02 2.05.5 3 3.4 1.9 5.9 4.57 7.5 8-2.67-2.5-5.5-4.83-8.5-7-1.13-1.85-1.63-3.85-1.5-6 1.7-.16 3.37.01 5 .5a108.08 108.08 0 0 1 19 18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f99795",
    d: "M5774.5 3509.5c-6.62 3.93-13.29 7.93-20 12-10.51 8.76-18.85 19.1-25 31-.77 1.19-1.77 2.19-3 3 .26-2.52 1.09-4.85 2.5-7 10.32-16.65 24.15-29.48 41.5-38.5 1.29-.49 2.63-.66 4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd29f",
    d: "M1765.5 3525.5c-11.84-6-24.17-7.17-37-3.5-5.91 3.11-11.57 6.45-17 10-1.97.5-3.97.66-6 .5-.59-2.63-.92-5.29-1-8h1c-.05 3.07 1.12 5.41 3.5 7 4.97-2.9 9.47-6.4 13.5-10.5 13.43-3.57 26.76-3.23 40 1 1.56.76 2.56 1.93 3 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fed3a2",
    d: "M1858.5 3519.5v1c-4.68-.04-9.35-.37-14-1l-16 3c2.31-1.06 4.64-2.22 7-3.5 7.72-.77 15.38-.6 23 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f5ee7",
    d: "M4563.5 3510.5c12.47 9.86 25.47 10.52 39 2-4.99 5.17-11.16 7.5-18.5 7a50.338 50.338 0 0 1-17.5-3.5 23.997 23.997 0 0 1-3-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M9088.5 3517.5v189h-22c.17-6.34 0-12.68-.5-19-.72.54-1.22 1.21-1.5 2-8.43 10.56-19.43 17.06-33 19.5-39.56 4.14-65.39-12.69-77.5-50.5-6.64-29.29.86-54.12 22.5-74.5 17.46-13.76 37.12-18.09 59-13 11.66 3.34 21.49 9.5 29.5 18.5.5-24 .67-48 .5-72h23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767676",
    d: "M9088.5 3517.5c1 63.16 1.33 126.5 1 190h-24c.32-6.19-.01-12.19-1-18 .28-.79.78-1.46 1.5-2 .5 6.32.67 12.66.5 19h22v-189Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M9255.5 3517.5v189h-22c.17-6.34 0-12.68-.5-19-.72.54-1.22 1.21-1.5 2-8.43 10.56-19.43 17.06-33 19.5-39.56 4.14-65.39-12.69-77.5-50.5-6.64-29.29.86-54.12 22.5-74.5 17.46-13.76 37.12-18.09 59-13 11.66 3.34 21.49 9.5 29.5 18.5.5-24 .67-48 .5-72h23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767676",
    d: "M9255.5 3517.5c1 63.16 1.33 126.5 1 190h-24c.32-6.19-.01-12.19-1-18 .28-.79.78-1.46 1.5-2 .5 6.32.67 12.66.5 19h22v-189Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M10957.5 3517.5c-.2 23.34 0 46.67.5 70 .7-.54 1.2-1.21 1.5-2 13.5-15.05 30.2-19.88 50-14.5 20.7 5.82 32.7 19.32 36 40.5v95h-22c.3-27.84 0-55.51-1-83-1.7-19.88-12.5-30.54-32.5-32-17.6 1.41-28.1 10.74-31.5 28-1 28.83-1.3 57.83-1 87h-23v-189h23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#706f6f",
    d: "M10957.5 3517.5c.7 22.67 1.3 45.33 2 68-.3.79-.8 1.46-1.5 2-.5-23.33-.7-46.66-.5-70Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M11373.5 3517.5v189h-22c.2-6.34 0-12.68-.5-19-.7.54-1.2 1.21-1.5 2-8.4 10.56-19.4 17.06-33 19.5-39.6 4.14-65.4-12.69-77.5-50.5-6.6-29.29.9-54.12 22.5-74.5 17.5-13.76 37.1-18.09 59-13 11.7 3.34 21.5 9.5 29.5 18.5.5-24 .7-48 .5-72h23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767676",
    d: "M11373.5 3517.5c1 63.16 1.3 126.5 1 190h-24c.3-6.19 0-12.19-1-18 .3-.79.8-1.46 1.5-2 .5 6.32.7 12.66.5 19h22v-189Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feb662",
    d: "M1530.5 3518.5c-8.86-.5-17.53.5-26 3 1.15-2.33 3.15-3.49 6-3.5 6.85-.82 13.51-.65 20 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffad50",
    d: "M1643.5 3518.5c4.05.34 8.05 1.01 12 2 2.38 1.39 4.05 3.39 5 6h-2c-1.07-1.38-2.41-2.55-4-3.5a199.86 199.86 0 0 1-11-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffad4f",
    d: "M2006.5 3546.5v-4c2.99-3.98 5.49-8.31 7.5-13 .5-2.65.66-5.31.5-8-7.36-.33-14.7 0-22 1-4.02 4.05-7.02 8.72-9 14 1.62-5.85 3.62-11.52 6-17 9.58-.32 19.08.01 28.5 1-1.21 6.33-2.88 12.66-5 19-3.11 1.6-5.27 3.93-6.5 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#febd71",
    d: "M1357.5 3521.5c6.81-.99 13.81-1.32 21-1 1.71 2.8 3.05 5.8 4 9a17.789 17.789 0 0 1-4-6c-.11-.62-.44-1.12-1-1.5-6.66-.5-13.33-.67-20-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefd",
    d: "M1451.5 3536.5c-.48 2.78.52 4.78 3 6 2.75 4.49 5.25 9.16 7.5 14 .67 11.67.67 23.33 0 35-2.58 6.16-5.41 12.16-8.5 18-1.35 5.04-4.35 8.71-9 11-6.56 3.69-13.56 6.53-21 8.5-7.43.78-14.76.28-22-1.5-5.78-2.73-11.11-6.23-16-10.5-2.33-.51-4.33.16-6 2 .94 15.87 1.27 32.04 1 48.5-7.03.33-14.03 0-21-1-.49-.95-.82-1.95-1-3-.12-46.44.21-93.11 1-140h19c-.82 4.97 1.02 8.3 5.5 10 3.14-.48 4.98-2.31 5.5-5.5 3.66-.55 6.66-2.21 9-5 7.38-3.05 15.05-4.05 23-3 11.97 2.15 21.97 7.65 30 16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfb",
    d: "M1564.5 3539.5c2.29 7.89 4.96 15.55 8 23 .78 6.64 1.11 13.3 1 20-23.51.94-47.67.94-72.5 0-7.04.37-9.04 3.7-6 10 2.17 2.33 3.83 5 5 8 2.13 2.31 4.63 3.97 7.5 5 1.72.13 3.38.46 5 1 .62 1.92 1.95 3.08 4 3.5 6.33.67 12.67.67 19 0 4.6-1.8 8.93-3.97 13-6.5 2.85-.69 5.35-2.02 7.5-4 2.64 1.42 4.47 3.58 5.5 6.5 3.67.18 6.01 2.01 7 5.5-1.33 2.65-2.99 4.98-5 7-.89.61-1.89.94-3 1-1.05-.15-2.05.02-3 .5-4.08 3.62-8.91 5.78-14.5 6.5-1.03.34-1.53 1-1.5 2h-2c-9.03 1.45-18.03 1.29-27-.5-6.79-2.23-13.45-4.73-20-7.5a22.486 22.486 0 0 0-6-3 6.603 6.603 0 0 0-3-3 26.808 26.808 0 0 1-4-8c-.77-4.2-2.6-7.87-5.5-11-4.56-19.26-2.4-37.59 6.5-55 1.67-4.33 4.67-7.33 9-9 6.32-3.8 12.99-6.97 20-9.5 12.61-3.88 24.78-2.71 36.5 3.5 2.76 2.38 5.93 4.21 9.5 5.5 2.24 1.74 3.91 3.91 5 6.5 1.27.86 2.6 1.53 4 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfc",
    d: "M1658.5 3526.5h2c2.05 2.71 4.38 5.05 7 7-.19 3.53.48 6.87 2 10 .4 3.25 1.07 6.41 2 9.5-.02 23.96-.02 48.13 0 72.5-3.1 1.32-6.6 1.99-10.5 2-3.92-.03-7.75-.37-11.5-1 .17-19.67 0-39.34-.5-59 2.29-13.2-2.54-22.36-14.5-27.5-5.17-1.19-9.84-.36-14 2.5-1.25 1.64-2.92 2.8-5 3.5-.75.67-1.09 1.5-1 2.5-3.07 2.49-5.4 5.49-7 9-.62.11-1.12.44-1.5 1-.67 2.67-1.33 5.33-2 8-.67 19.77-.51 39.44.5 59 0 .67-.33 1-1 1-6.59.31-13.09-.02-19.5-1-.5-34-.67-68-.5-102 5.34-.17 10.68 0 16 .5.92.37 1.75.87 2.5 1.5 2.06 9.52 6.23 10.52 12.5 3 4.11-1.89 8.11-4.05 12-6.5 6.18-2.98 12.52-3.31 19-1 4.46 1.66 8.8 3.49 13 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fedeb9",
    d: "M1643.5 3518.5c3.53 1.57 7.19 3.07 11 4.5 1.59.95 2.93 2.12 4 3.5-4.2-2.01-8.54-3.84-13-5.5-6.48-2.31-12.82-1.98-19 1a104.07 104.07 0 0 1-12 6.5h-2c8.94-7.63 19.27-10.97 31-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfc",
    d: "m1765.5 3525.5 9 6c.99 2.65 1.99 5.31 3 8 2.76 1.59 4.59 3.92 5.5 7 4.88 13.55 6.71 27.55 5.5 42-.5 5.99-2.33 11.66-5.5 17-1.01.84-2.18 1.17-3.5 1-.67 2-1.33 4-2 6a63.522 63.522 0 0 0-7 6.5c-2.83.64-4.83 2.3-6 5-16.7 7.31-33.36 6.98-50-1a14.001 14.001 0 0 1-3-4c-1.63-.49-3.3-.66-5-.5v49c-7.56.09-14.89 1.09-22 3-1-49.5-1.33-99.16-1-149 6.7-.33 13.37 0 20 1 .36.68.7 1.35 1 2 .08 2.71.41 5.37 1 8 2.03.16 4.03 0 6-.5 5.43-3.55 11.09-6.89 17-10 12.83-3.67 25.16-2.5 37 3.5ZM1858.5 3520.5c2.41 2.39 5.08 4.55 8 6.5 4.06 1.28 7.73 3.11 11 5.5 1.27-.07 2.44-.4 3.5-1 .82-2.62 1.32-5.28 1.5-8 6.77-1.31 13.43-1.31 20 0 .17 34 0 68-.5 102-5.42 1.14-10.92 1.31-16.5.5-2.61-1.11-4.28-2.94-5-5.5v-4c-2.1-.3-4.1.03-6 1-7.07 8.03-16.07 12.03-27 12-4.38-.12-8.71-.62-13-1.5a81.596 81.596 0 0 0-16-6c-6.17-5.89-11.5-12.39-16-19.5-3.03-4.41-4.69-9.41-5-15 .43-9.48.59-18.81.5-28 2.14-4.58 3.97-9.25 5.5-14 1.64-3.46 3.47-6.8 5.5-10 3.33-2.17 6.17-4.83 8.5-8 3.17-2.62 6.84-4.29 11-5l16-3c4.65.63 9.32.96 14 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9795b6",
    d: "M7139.5 3514.5a46.61 46.61 0 0 1-7 9c.86-4.19 3.19-7.19 7-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edd5b9",
    d: "M7511.5 3495.5c-.67 1-1.33 2-2 3-.62.11-1.12.44-1.5 1-.17 26.84-.67 53.5-1.5 80-.17-27 0-54 .5-81 .59-2.36 2.09-3.36 4.5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb867",
    d: "M1643.5 3518.5c-11.73-.97-22.06 2.37-31 10-1.55 2.75-3.89 3.59-7 2.5-.75-.67-1.09-1.5-1-2.5 2.78 1.52 4.78.85 6-2 5.44-2.55 10.77-5.39 16-8.5 5.85-.82 11.52-.65 17 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M8845.5 3520.5c10.02-.33 20.02 0 30 1 22.58 61.82 44.58 123.82 66 186-8.69.33-17.36 0-26-1l-15-42a802.504 802.504 0 0 0-80 0l-15 42c-8.64 1-17.31 1.33-26 1a21483.19 21483.19 0 0 1 66-187Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe3c2",
    d: "M1939.5 3537.5c2.36 4.74 4.2 9.74 5.5 15 2.28 4.06 4.45 8.06 6.5 12v1c2.66 6.6 5.33 13.27 8 20 .59.21 1.09.54 1.5 1 1.46-2.44 2.96-4.77 4.5-7 .41 6-2.09 8.33-7.5 7-8.37-20.81-17.03-41.47-26-62-7.08-.98-14.25-1.31-21.5-1 1.51 5.01 3.17 10.01 5 15-1.33-2-2.67-4-4-6-.94-1.55-1.61-3.22-2-5-.65-1.94-.98-3.94-1-6 7.67-.17 15.34 0 23 .5 3.9 4.63 6.56 9.79 8 15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdfbb",
    d: "M2006.5 3542.5c.32-5.77 2.48-10.77 6.5-15 .49-1.29.66-2.63.5-4-6.73-.3-13.39.04-20 1a34.441 34.441 0 0 1-6.5 9c-.92 5.93-3.25 11.26-7 16-3.57 10.8-8.4 20.8-14.5 30 .6-3.46 1.6-6.8 3-10 1.12-4.22 3.28-7.89 6.5-11a139.23 139.23 0 0 1 8.5-22c1.98-5.28 4.98-9.95 9-14 7.3-1 14.64-1.33 22-1 .16 2.69 0 5.35-.5 8a62.602 62.602 0 0 1-7.5 13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab2b2",
    d: "M5920.5 3505.5c-1.58 1.64-2.25 3.64-2 6-1.1 3.91-1.26 7.91-.5 12 .7 2.08 1.86 3.75 3.5 5v2c-1.61-.44-2.78-1.44-3.5-3-3.33-7-3.33-14 0-21 .67-.75 1.5-1.09 2.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd29f",
    d: "M1404.5 3518.5c8.46-.45 16.79.22 25 2 8.23 2.37 15.4 6.7 21.5 13 .48.95.65 1.95.5 3-8.03-8.85-18.03-14.35-30-16.5-7.95-1.05-15.62-.05-23 3-2.34 2.79-5.34 4.45-9 5-.52 3.19-2.36 5.02-5.5 5.5-4.48-1.7-6.32-5.03-5.5-10 .91 2.25 2.24 4.25 4 6 .24.6.74.93 1.5 1 6.77-4.31 13.61-8.31 20.5-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feb35b",
    d: "M1604.5 3523.5c-.79-.28-1.46-.78-2-1.5-7.25-.81-14.41-.65-21.5.5-.67 34.33-.67 68.67 0 103 .37.92.87 1.75 1.5 2.5 7.72.8 15.38.63 23-.5 1-19.32 1.33-38.66 1-58-.11-4.05.23-8.05 1-12 1.6-3.51 3.93-6.51 7-9 .16 1.37-.01 2.71-.5 4-1.82 3.1-3.82 6.1-6 9-.18 23.07-.68 46.07-1.5 69-8.34.17-16.67 0-25-.5-.69-1.07-1.19-2.23-1.5-3.5-.67-35-.67-70 0-105l1.5-1.5c7-.67 14-.67 21 0 1.32.82 1.99 1.98 2 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfc",
    d: "M1965.5 3579.5c6.1-9.2 10.93-19.2 14.5-30 3.75-4.74 6.08-10.07 7-16 2.66-2.66 4.83-5.66 6.5-9 6.61-.96 13.27-1.3 20-1 .16 1.37-.01 2.71-.5 4-4.02 4.23-6.18 9.23-6.5 15-2.32 3.87-4.49 7.87-6.5 12-.28 2.91-1.11 5.58-2.5 8 .17.99-.16 1.66-1 2-1.81 2.94-3.64 5.94-5.5 9-1.69 6.58-3.86 12.91-6.5 19-4.15 9.63-8.82 18.97-14 28-7.26 15.19-14.59 30.52-22 46-6.63 1-13.3 1.33-20 1 .56-3.69 1.23-7.36 2-11 2.79-2.58 4.79-5.74 6-9.5 3.36-6.95 6.03-14.12 8-21.5.67 0 1-.33 1-1 2.18-1.53 3.18-3.7 3-6.5-.19-1.86-.53-3.69-1-5.5-1.78-1.77-3.12-3.77-4-6-2.04-1.41-3.04-3.41-3-6-2.2-8.44-5.04-16.77-8.5-25a14.796 14.796 0 0 0-3.5-3c.27-1.6-.07-2.93-1-4-2.89-6.51-5.22-13.35-7-20.5a515.22 515.22 0 0 0-5-9.5c-1.83-4.99-3.49-9.99-5-15 7.25-.31 14.42.02 21.5 1 8.97 20.53 17.63 41.19 26 62 5.41 1.33 7.91-1 7.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdfbc",
    d: "M1226.5 3509.5c-3.68 6.66-8.35 12.66-14 18 .66-2.99 1.99-5.65 4-8 2.91-3.87 6.24-7.21 10-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feefdd",
    d: "M1604.5 3528.5c-.09 1 .25 1.83 1 2.5 3.11 1.09 5.45.25 7-2.5h2c-6.27 7.52-10.44 6.52-12.5-3a9.186 9.186 0 0 0-2.5-1.5c-5.32-.5-10.66-.67-16-.5-.17 34 0 68 .5 102 6.41.98 12.91 1.31 19.5 1-6.49 1.15-13.15 1.32-20 .5a9.186 9.186 0 0 1-1.5-2.5c-.67-33.67-.67-67.33 0-101 6.08-1.14 12.25-1.31 18.5-.5.92.37 1.75.87 2.5 1.5.21 1.56.71 2.89 1.5 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5e77a6",
    d: "M2859.5 3516.5c-.49 4.73.84 8.73 4 12 .11.62.44 1.12 1 1.5 2.65.5 5.31.66 8 .5-2.8 1.14-5.8 1.3-9 .5-4.82-3.99-6.15-8.82-4-14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdc0f4",
    d: "M4353.5 3503.5c-.83 8.68-2 17.35-3.5 26-.9 1.93-2.07 3.6-3.5 5v-3c2.31-6.49 3.98-13.16 5-20 .67-2.67 1.33-5.33 2-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe5c7",
    d: "M1902.5 3523.5c1 33.83 1.33 67.83 1 102v3c-6.67.17-13.34 0-20-.5-2.25-2-3.25-4.5-3-7.5.72 2.56 2.39 4.39 5 5.5 5.58.81 11.08.64 16.5-.5.5-34 .67-68 .5-102Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feb25a",
    d: "M1939.5 3537.5c-1.44-5.71-4.1-10.87-8-15.5-7.66-.5-15.33-.67-23-.5.02 2.06.35 4.06 1 6-1.63-1.56-2.8-1.23-3.5 1-.17 33.67-.67 67.34-1.5 101a82.497 82.497 0 0 1-25 0c-.04-2.82-.71-5.49-2-8-2.03 1.06-4.03 2.06-6 3 1.57-2.53 3.57-4.53 6-6 1.24.44 2.24 1.11 3 2-.25 3 .75 5.5 3 7.5 6.66.5 13.33.67 20 .5v-3c1.16-34.16 1.33-68.5.5-103-3.58-.65-7.25-.98-11-1-3.9.01-7.4.68-10.5 2-1.66 1.94-2.33 4.27-2 7-1.6.27-2.93-.07-4-1 1 .09 1.83-.25 2.5-1 .06-3.32 1.23-6.16 3.5-8.5 7-.67 14-.67 21 0l2.5 2.5 2.5-2.5c8-.67 16-.67 24 0 5.27 4.53 7.6 10.36 7 17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f35956",
    d: "M5947.5 3503.5c1.33 1 2.67 2 4 3 2.63 3.13 5.46 6.13 8.5 9 .33 1 .67 2 1 3 1.65.9 3.15 1.9 4.5 3 .95 3.91 3.28 6.58 7 8l7 10a156.977 156.977 0 0 1-17.5-17c-1.77-2.1-3.1-4.43-4-7-4.08-3.57-7.58-7.57-10.5-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5e5c9a",
    d: "M7316.5 3497.5c-1.16 68.96-1.33 137.96-.5 207l1.5 1.5c12.33.5 24.66.67 37 .5-12.49 1-25.16 1.33-38 1h-1c-.06-1.11-.39-2.11-1-3-.17-68.67 0-137.33.5-206 .38-.56.88-.89 1.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbab9",
    d: "M5965.5 3521.5c3.72 1.42 6.05 4.09 7 8-3.72-1.42-6.05-4.09-7-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e5de7",
    d: "M4883.5 3531.5c-9.34-.17-18.67 0-28 .5-.92.28-1.58.78-2 1.5-3.83-.08-7.5.58-11 2 1.01-1.33 2.34-2.33 4-3 12.39-3.52 24.72-3.85 37-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbc1c1",
    d: "M6408.5 3519.5c7.87 4.59 13.87 10.93 18 19a29.147 29.147 0 0 0-8-8c-1.95-1.28-3.62-2.95-5-5-2.36-1.37-4.03-3.37-5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#64639b",
    d: "M7222.5 3532.5c-9.71-2.56-19.38-2.56-29 0 .56-1.29 1.56-2.12 3-2.5 7.68-1.85 15.34-1.85 23 0 1.44.38 2.44 1.21 3 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd8ac",
    d: "M1530.5 3518.5c5.65 1.43 11.31 2.93 17 4.5 2.42 3.05 5.42 5.38 9 7 3.28 2.77 5.94 5.93 8 9.5-1.4-.47-2.73-1.14-4-2-1.09-2.59-2.76-4.76-5-6.5-3.57-1.29-6.74-3.12-9.5-5.5-11.72-6.21-23.89-7.38-36.5-3.5-7.01 2.53-13.68 5.7-20 9.5 3.96-4.97 8.96-8.3 15-10 8.47-2.5 17.14-3.5 26-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffcb91",
    d: "M1858.5 3520.5c4.4 1.21 8.73 2.71 13 4.5.89 2.39 2.56 3.89 5 4.5 1.07.93 2.4 1.27 4 1-.33-2.73.34-5.06 2-7-.18 2.72-.68 5.38-1.5 8-1.06.6-2.23.93-3.5 1-3.27-2.39-6.94-4.22-11-5.5-2.92-1.95-5.59-4.11-8-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a8b7d0",
    d: "M2896.5 3516.5c3.49.94 4.82 3.28 4 7 2.01.11 3.68-.56 5-2 13.53-.57 18.19 5.76 14 19 3.96-.94 7.96-1.11 12-.5.88.71 1.55 1.54 2 2.5-4.83-2.26-9.83-2.59-15-1 .03-5.36-.31-10.7-1-16-2.96-.56-5.8-1.56-8.5-3-2.2 3.46-5.37 4.8-9.5 4 .64-3.93-.36-7.27-3-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46866",
    d: "M5921.5 3528.5c3.3 2.59 5.64 5.92 7 10-2.33-2.67-4.67-5.33-7-8v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbdbc",
    d: "M6118.5 3538.5c-3.1-1.36-4.77-3.7-5-7-2.69-.33-5.02.33-7 2 .54-3.44 2.54-4.61 6-3.5 2.99 2.15 4.99 4.99 6 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f47573",
    d: "M6418.5 3530.5c3.22 2.17 5.88 4.84 8 8 .84.34 1.17 1.01 1 2-1.87-.36-3.37-1.36-4.5-3a43.753 43.753 0 0 1-4.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e8db2",
    d: "M7278.5 3509.5c3.46.94 6.29 2.94 8.5 6 8.65 11.91 12.65 25.24 12 40-1.15-.96-2.15-.62-3 1-.56-.52-1.23-.86-2-1-9.65.72-19.32 1.39-29 2-8.18-.6-16.35-.93-24.5-1-4.88-6.59-9.88-13.09-15-19.5-12.41-7.5-24.74-7.33-37 .5-1.97 3.91-3.3 7.91-4 12-.64-.6-.97-1.43-1-2.5-.64-7.82 2.7-12.66 10-14.5 9.62-2.56 19.29-2.56 29 0a96.794 96.794 0 0 1 20 23.5c4.95.44 9.78-.06 14.5-1.5l1 1c2.67-.67 5.33-1.33 8-2l2 2c9.77-.82 19.6-1.49 29.5-2 .23-17.69-6.1-32.35-19-44Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ba8c4",
    d: "M2803.5 3451.5a191.993 191.993 0 0 0-14 27 27.45 27.45 0 0 0-2 11c-1.16 9.82-1.32 19.82-.5 30 1.54 4.74 3.04 9.41 4.5 14 2.85 6.34 5.85 12.68 9 19-2.58-3.45-5.41-6.78-8.5-10-2.18-7.34-4.18-14.67-6-22-.67-12-.67-24 0-36 2.44-7.55 5.44-14.88 9-22 2.31-4.14 5.15-7.8 8.5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ac96ee",
    d: "M4277.5 3531.5c2.45.57 4.79 1.23 7 2-14.29-1.25-28.29-1.25-42 0 1.81-1.7 4.14-2.53 7-2.5 9.35-.65 18.69-.48 28 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a68fed",
    d: "M4738.5 3531.5c1 .67 2 1.33 3 2a120.794 120.794 0 0 0-33 .5c-4.18 1.92-8.18 4.09-12 6.5h-2c.45-.96 1.12-1.79 2-2.5 13.15-7.2 27.15-9.37 42-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcd3f7",
    d: "M4741.5 3533.5c2.13.05 3.47 1.05 4 3-11.86-3.43-23.86-3.76-36-1-4 2.5-8.34 4.17-13 5 3.82-2.41 7.82-4.58 12-6.5 10.99-1.68 21.99-1.84 33-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcd2f7",
    d: "M4886.5 3534.5c-6.02 0-12.02-.33-18-1-6.66.55-13.33 1.05-20 1.5-1.36 2.86-3.36 3.69-6 2.5a27.159 27.159 0 0 1-9 3c1.48-1.57 3.15-2.91 5-4a6.929 6.929 0 0 1 4-1c3.5-1.42 7.17-2.08 11-2 5.2-.47 10.7-.8 16.5-1 5.74-.14 11.24.52 16.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0d8f7",
    d: "M4284.5 3533.5c1.11.06 2.11.39 3 1 3.52 1.5 7.19 2.5 11 3-4.95.54-9.62-.29-14-2.5-15-.67-30-.67-45 0-7.43 2.55-14.77 5.38-22 8.5.33-.67.67-1.33 1-2a82.657 82.657 0 0 1 24-8c13.71-1.25 27.71-1.25 42 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9276eb",
    d: "M4496.5 3533.5c3.03 4.48 4.7 9.48 5 15 .79-1.27 1.79-2.27 3-3-.43 4.14-2.43 5.8-6 5v-1c.29-4.44-.21-8.77-1.5-13-.67-.75-1.5-1.09-2.5-1-7.16-.67-14.49-1-22-1-7.7 0-15.03.67-22 2-1 51.83-1.33 103.83-1 156v3c-1.17-53.5-1.33-107.17-.5-161 15.76-.99 31.59-1.32 47.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8364e8",
    d: "M4611.5 3536.5h-1c-.34-.84-1.01-1.17-2-1a341.907 341.907 0 0 0-52 0c8.47-1.33 17.31-2 26.5-2 8.83.17 17.67.33 26.5.5 1.26.42 1.92 1.25 2 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M4745.5 3536.5c1.7-.16 3.37.01 5 .5 2.72 2.36 5.72 4.19 9 5.5 4.1 5.37 7.93 11.04 11.5 17 1.44 4.89 3.44 9.56 6 14 .33 4 .67 8 1 12 .71.88 1.54 1.55 2.5 2v1c.84 19.48-.33 38.82-3.5 58-1.85 5.42-3.68 10.75-5.5 16-.67 2.33-1.33 4.67-2 7l-2 2c-4.38 4.71-8.72 9.38-13 14-1.05-.15-2.05.02-3 .5a66.182 66.182 0 0 0-7 6.5h-1c-2.81.07-5.48.74-8 2-1.68.37-2.68 1.37-3 3-9.18-.27-18.18.4-27 2h-1c-4.72-.71-9.39-1.71-14-3-1.76-.96-3.76-1.29-6-1v53c-16.67 1.96-33.34 3.96-50 6 .6-71.4.6-142.74 0-214 .11-.94.44-1.78 1-2.5 14.66-.5 29.33-.67 44-.5-.08 3.28.59 6.28 2 9-.08 1.75.75 2.75 2.5 3 2.91-.75 5.08-2.42 6.5-5 1.67-1 3-2.33 4-4h2c4.66-.83 9-2.5 13-5 12.14-2.76 24.14-2.43 36 1ZM4886.5 3534.5c13.85 3.36 25.35 10.69 34.5 22 .48.95.65 1.95.5 3 2.79-.05 4.63 1.29 5.5 4 .96 5.99 2.96 11.65 6 17 .08 5.52 1.08 10.85 3 16 .5 11.66.67 23.33.5 35h-90c-.17 3.68 0 7.35.5 11 1.24 2.36 2.74 4.36 4.5 6 2 4.67 5.33 8 10 10 2.29 1.79 4.96 3.29 8 4.5 8.33.67 16.67.67 25 0 8.83-1.61 17.49-3.61 26-6 .88-.71 1.55-1.54 2-2.5 1.42-.95 3.09-1.28 5-1 .27 8.96 1.61 17.62 4 26-.21 1.64.12 3.14 1 4.5-.6 2.07-1.94 3.24-4 3.5-16.03 7.44-32.87 11.11-50.5 11-8.79-.12-18.62-.45-29.5-1 .09-1-.25-1.83-1-2.5a202.13 202.13 0 0 1-16-4.5 57.632 57.632 0 0 0-15-9c-.33-.67-.67-1.33-1-2-3.31-5.3-6.98-10.3-11-15-3.32-6.63-5.65-13.63-7-21 .06-6.57-.6-12.74-2-18.5-.03-11.34.63-22.84 2-34.5 1.3-4.93 2.3-9.93 3-15 .96-.45 1.79-1.12 2.5-2 1.55-4.7 3.72-9.03 6.5-13v-1c3.37-3.37 6.37-7.04 9-11 2.78-1.57 5.45-3.4 8-5.5 2.35-.85 4.69-1.68 7-2.5 3.14-.46 6.14-1.46 9-3 2.64 1.19 4.64.36 6-2.5 6.67-.45 13.34-.95 20-1.5 5.98.67 11.98 1 18 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f5de7",
    d: "M4277.5 3531.5a160.64 160.64 0 0 0-28-.5c-2.86-.03-5.19.8-7 2.5a82.657 82.657 0 0 0-24 8c.45-.96 1.12-1.79 2-2.5 18.24-9.61 37.24-12.11 57-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfe",
    d: "M4298.5 3537.5c-.09 1 .25 1.83 1 2.5 4.59.48 8.93 1.65 13 3.5a180.54 180.54 0 0 0-3 21c-.65.59-1.32 1.26-2 2-.99 3.95-1.32 7.95-1 12-3.62-1.19-7.29-2.19-11-3h-1c-2.87-3.26-6.54-4.59-11-4h-4c-.93-.81-1.93-1.65-3-2.5-7.67-.67-15.33-.67-23 0a48.24 48.24 0 0 1-6.5 4.5c-.17 1.83-.33 3.67-.5 5.5.05 2.3.71 4.13 2 5.5 1.33 1 2.67 2 4 3-.09 1 .25 1.83 1 2.5 6 3.39 12.33 5.89 19 7.5 3.33.67 6.67 1.33 10 2a66.112 66.112 0 0 0 17 8c3.19 2.53 6.35 5.2 9.5 8 4.09 4.52 7.42 9.52 10 15 .49 1.63.66 3.3.5 5 .17 8.69-.16 17.36-1 26-.42 3.51-1.42 6.84-3 10-1-.09-1.83.25-2.5 1-1.69 4.07-3.86 7.74-6.5 11-1 .33-1.67 1-2 2-1.76.38-3.42 1.04-5 2-1.86 2.7-4.2 4.7-7 6h-1c-3.31.41-6.31 1.58-9 3.5-2.31.5-4.64.66-7 .5-13.48.46-26.81.46-40 0h-9c-4.51-1.5-9.18-2.83-14-4-4.23-1.78-8.57-3.61-13-5.5-2.73-2.9-3.73-6.4-3-10.5.46-5.12 1.46-10.12 3-15a90.34 90.34 0 0 0 2.5-11c.71-.88 1.54-1.55 2.5-2h2c2.04 1.69 4.37 3.03 7 4 .62 1.84 1.96 3 4 3.5 3.52.4 6.85 1.4 10 3 3.32.5 6.65.67 10 .5.3.65.64 1.32 1 2 8.31 1.17 16.65 1.33 25 .5a48.24 48.24 0 0 1 6.5-4.5c.48-.95.65-1.95.5-3 .42-4.24-.25-8.24-2-12a33.164 33.164 0 0 0-6-5.5 753.188 753.188 0 0 0-36-13c-3.78-3.73-8.12-6.73-13-9-1.09-2.71-3.09-4.21-6-4.5-.61-.89-.94-1.89-1-3a96.187 96.187 0 0 0-5.5-12c-.62-4.39-1.45-8.72-2.5-13 .66-5.42 1.33-11.42 2-18 2.48-4.52 5.48-8.85 9-13 .93-1.19 1.26-2.52 1-4a26.15 26.15 0 0 0 7-5c7.23-3.12 14.57-5.95 22-8.5 15-.67 30-.67 45 0 4.38 2.21 9.05 3.04 14 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#987deb",
    d: "M4400.5 3489.5c1 14.49 1.33 29.16 1 44 10.72-.31 21.39.02 32 1 .33 1.17.67 2.33 1 3.5-.68 6.15-1.18 12.32-1.5 18.5-.76 5.23-1.93 10.23-3.5 15l3-28v-3c1.34-1.68 1.18-3.35-.5-5-7.54-.28-15.21.05-23 1-3.25-.34-6.09-1.34-8.5-3v-44Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aa95ec",
    d: "M4494.5 3535.5c-14.93-.24-29.6.09-44 1 6.97-1.33 14.3-2 22-2 7.51 0 14.84.33 22 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b6be9",
    d: "M4538.5 3532.5c-4.35-.17-8.68 0-13 .5-1.56.21-2.89.71-4 1.5a53.551 53.551 0 0 0-12 7c-1.67 1.33-3.33 2.67-5 4a34.35 34.35 0 0 1 8-9.5c6.07-3.24 12.57-5.08 19.5-5.5 2.61.03 4.78.7 6.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M4521.5 3534.5h20a246.866 246.866 0 0 0 0 43.5c-5.68 1.12-11.34 1.95-17 2.5-3.9.68-7.73 1.68-11.5 3-2.6 2.38-5.43 4.38-8.5 6-1.41.47-2.07 1.47-2 3-.83 33.83-1.33 67.83-1.5 102a301.376 301.376 0 0 1-49 0c-.5-52.33-.67-104.67-.5-157 14.67-.17 29.34 0 44 .5.68 4 1.68 7.84 3 11.5v4c1.79.29 3.45-.05 5-1a73.15 73.15 0 0 1 6-11c3.66-2.83 7.66-5.17 12-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c58e6",
    d: "M4890.5 3533.5c3.31.54 6.65 1.04 10 1.5 2 1.19 3.66 2.69 5 4.5-1.7.16-3.37-.01-5-.5-3.36-1.83-6.7-3.67-10-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f57877",
    d: "M5842.5 3539.5c-4.36-.51-8.69-1.17-13-2-10.28-2.6-20.62-2.27-31 1 .85-1.47 2.18-2.3 4-2.5 10.51-2.45 21.17-2.45 32 0 2.87.94 5.54 2.11 8 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab1b0",
    d: "M6296.5 3510.5c-2.76 2.89-6.09 5.06-10 6.5a160.75 160.75 0 0 1-11 10.5 10664 10664 0 0 1-14 15c.95-1.97 1.95-3.97 3-6 7.68-9.53 16.68-17.69 27-24.5a8.765 8.765 0 0 1 5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f25e5d",
    d: "M6354.5 3535.5h-20c3.22-1.45 6.72-2.12 10.5-2 3.48-.17 6.64.49 9.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9274ea",
    d: "M4287.5 3534.5c3.99.5 7.99 1 12 1.5 1.82.2 3.15 1.03 4 2.5-1.62-.54-3.28-.87-5-1-3.81-.5-7.48-1.5-11-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7b57e6",
    d: "M4738.5 3531.5c5.33.25 10.33 1.58 15 4 1.45 2.91 3.78 4.75 7 5.5 2.29 1.78 3.96 3.94 5 6.5-2-1.67-4-3.33-6-5a31.438 31.438 0 0 1-9-5.5c-1.63-.49-3.3-.66-5-.5-.53-1.95-1.87-2.95-4-3-1-.67-2-1.33-3-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f99a98",
    d: "M6334.5 3535.5h20c6.67-.33 12.34 1.67 17 6-5.2-.79-10.2-2.29-15-4.5-8.33-.67-16.67-.67-25 0a133.855 133.855 0 0 0-33 18.5c.01-1.52.68-2.68 2-3.5 4.65-2.99 8.98-6.32 13-10 2.27-.47 4.27-1.47 6-3 4.88-1.68 9.88-2.85 15-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5796",
    d: "M7416.5 3538.5c-11.9-1.94-23.9-2.44-36-1.5-.75.67-1.09 1.5-1 2.5-.98 2.79-1.31 5.79-1 9-1.5-4.21-1.16-8.38 1-12.5 11-.67 22-.67 33 0 1.57.61 2.9 1.44 4 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfd7f7",
    d: "M4399.5 3533.5h1c2.41 1.66 5.25 2.66 8.5 3 7.79-.95 15.46-1.28 23-1 1.68 1.65 1.84 3.32.5 5v-3c-10.34.17-20.67 0-31-.5-1.47-.71-2.14-1.88-2-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b45e2",
    d: "M4633.5 3533.5c-.28.79-.78 1.46-1.5 2-.67 74-.67 148 0 222 2.4 1.1 4.9 1.27 7.5.5 7.95-1.11 15.61-2.94 23-5.5h6c5.35-.57 10.68-1.24 16-2-.11.62-.44 1.12-1 1.5a687.962 687.962 0 0 1-53 7.5c.33-74.9 0-149.74-1-224.5 1.24-.79 2.58-1.29 4-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4645f",
    d: "M5890.5 3530.5h2c8.56 8.75 14.89 19.08 19 31-1.18.22-2.18-.11-3-1a75.206 75.206 0 0 1-6.5-16c-2.69-2.36-5.36-4.7-8-7-.17-2.96-1.34-5.29-3.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffa845",
    d: "M1911.5 3532.5c1.33 2 2.67 4 4 6a95.96 95.96 0 0 1 1.5 9c1.16.5 1.99 1.33 2.5 2.5 2.02 4.26 3.36 8.76 4 13.5-1.86-4.58-4.36-8.91-7.5-13 .21-4.29-1.13-7.96-4-11-.5-2.31-.66-4.64-.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2c4d8d",
    d: "M2902.5 3515.5c13.61-1.2 21.44 4.8 23.5 18 1.7.91 3.53 1.24 5.5 1 4.64 2.48 8.14 6.15 10.5 11 .57 5.24 1.07 10.57 1.5 16-2.11-.86-3.28-2.53-3.5-5-.57 3.21-2.41 4.87-5.5 5 .32-1.55 1.32-2.21 3-2 .91-3.63 1.08-7.3.5-11-.22-2.38-1.39-4.05-3.5-5-.67 0-1-.33-1-1-.45-.96-1.12-1.79-2-2.5-4.04-.61-8.04-.44-12 .5 4.19-13.24-.47-19.57-14-19 1.46-.66 3.13-.99 5-1 3.22.11 6.22.61 9 1.5-1.33-1-2.67-2-4-3-4.72-.63-9.06-1.8-13-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ae98ee",
    d: "M4346.5 3531.5v3c-.11.62-.44 1.12-1 1.5-4.32.76-8.65 1.43-13 2l-1.5 1.5c-.84 4.14-1.67 8.14-2.5 12-.37-4.47.13-8.8 1.5-13 4.17-2.28 8.67-3.78 13.5-4.5 1.19-.7 2.19-1.53 3-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b19deb",
    d: "M4542.5 3534.5c.67 7.49 1 15.16 1 23 0 8.03-.67 15.7-2 23 .98-15.26 1.32-30.59 1-46Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M4562.5 3535.5c15.49 1 31.16 1.33 47 1 .17 52.67 0 105.33-.5 158-8.42.66-16.92.99-25.5 1-8.9-.03-17.56-.7-26-2-.17-52.33 0-104.67.5-157 1.56-.41 3.06-.75 4.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9e85ed",
    d: "M4610.5 3536.5h1c.17 53.67 0 107.33-.5 161-.38.56-.88.89-1.5 1-17.51.33-34.84 0-52-1 17.58.33 35.08-.01 52.5-1 .5-53.33.67-106.67.5-160Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8cff7",
    d: "M4681.5 3546.5c-1.41-2.72-2.08-5.72-2-9-14.67-.17-29.34 0-44 .5-.56.72-.89 1.56-1 2.5.6 71.26.6 142.6 0 214 16.66-2.04 33.33-4.04 50-6v-53c2.24-.29 4.24.04 6 1-1.64-.21-3.14.12-4.5 1-.5 17-.67 34-.5 51v1c-3.68-.17-7.35 0-11 .5-2.47.04-4.47.87-6 2.5h-6c-3.02-.16-6.02 0-9 .5-5.61 1.5-11.27 3-17 4.5-1.25-.54-2.41-1.21-3.5-2-.67-73-.67-146 0-219 15.09-.94 30.26-1.27 45.5-1 .98.48 1.81 1.14 2.5 2 .5 2.98.66 5.98.5 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M5829.5 3537.5c4.31.83 8.64 1.49 13 2 5.86 2.86 11.2 6.52 16 11-.13.74.04 1.41.5 2a123 123 0 0 1 8.5 7c2.82 1.49 4.49 3.83 5 7-.16 1.37.01 2.71.5 4a98.12 98.12 0 0 0 5 9c.56 3.69 1.23 7.35 2 11 .61 9.83.11 19.5-1.5 29-3.62 7.23-7.79 14.23-12.5 21-5.41 5.07-10.91 9.74-16.5 14-15.27 6.98-31.27 8.98-48 6-8.2-.94-15.2-4.27-21-10a361.862 361.862 0 0 1-17-19c-1.86-4.47-3.86-8.81-6-13v-1c-2.35-11.97-2.52-23.97-.5-36 2.57-3.22 4.07-6.88 4.5-11 4.52-3.85 7.85-8.51 10-14 5.1-4.44 10.43-8.44 16-12 13.29-6.64 27.29-8.97 42-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcc7c7",
    d: "M6087.5 3535.5c-.91 2.1-2.08 4.1-3.5 6-3.74 2.9-6.9 6.23-9.5 10 .97-1.98 1.97-3.98 3-6v-1c3.31-2.97 6.64-5.97 10-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faaeae",
    d: "M6197.5 3519.5c-1.4 1.75-2.4 3.75-3 6a352.1 352.1 0 0 0-20 24 340.156 340.156 0 0 0-21 23c.21-1.42.71-2.76 1.5-4 14.5-16.31 28.67-32.65 42.5-49Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M6371.5 3541.5c2.84 3.3 6.5 5.14 11 5.5 2.83 2 5.5 4.17 8 6.5 1.77 2.56 3.77 4.89 6 7 3.76 7.11 7.09 14.44 10 22 .22 4.93.89 9.77 2 14.5a75.814 75.814 0 0 0-2 18.5c-.71 3.52-1.71 6.86-3 10-.88-.13-1.54.2-2 1-1.97 4.46-4.14 8.79-6.5 13-6.13 4.99-11.97 9.99-17.5 15a38.525 38.525 0 0 1-9 4c-4.51.67-8.84 1.84-13 3.5-9.75.86-19.42.36-29-1.5-1.62-.54-3.28-.87-5-1-4.88-2.11-9.55-4.78-14-8-.76-1.76-2.1-2.76-4-3a28.794 28.794 0 0 1-6.5-9c-3.48-1.64-5.65-4.31-6.5-8-2.38-8.32-4.88-16.66-7.5-25-.81-8.79-.31-17.46 1.5-26v-1c4.25-8.25 8.92-16.25 14-24a133.855 133.855 0 0 1 33-18.5c8.33-.67 16.67-.67 25 0 4.8 2.21 9.8 3.71 15 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0adc7",
    d: "M3084.5 3476.5c1-.09 1.83.25 2.5 1 4.18 20.68 3.18 41.01-3 61-1.36.86-2.53 1.86-3.5 3 .2-2.19.87-4.19 2-6 7.31-19.31 7.98-38.98 2-59Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ded5f9",
    d: "M4494.5 3535.5c1-.09 1.83.25 2.5 1 1.29 4.23 1.79 8.56 1.5 13a66.9 66.9 0 0 1-3-11.5c-14.66-.5-29.33-.67-44-.5-.17 52.33 0 104.67.5 157 16.33 1.33 32.67 1.33 49 0 .17-34.17.67-68.17 1.5-102v104c-17 .17-34 0-51-.5-.58-1.3-1.25-2.47-2-3.5-.33-52.17 0-104.17 1-156 14.4-.91 29.07-1.24 44-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbcbc",
    d: "M5829.5 3537.5c-14.71-1.97-28.71.36-42 7 .33-.67.67-1.33 1-2 2.91-2.3 6.24-3.64 10-4 10.38-3.27 20.72-3.6 31-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe6ca",
    d: "M1190.5 3503.5c-7.52 12.03-11.85 25.2-13 39.5-.18 1.38-.85 2.21-2 2.5v-11c.65-.3 1.32-.64 2-1 1.15-6.62 2.82-13.12 5-19.5 1.6-4.38 4.26-7.88 8-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbcd98",
    d: "M1903.5 3625.5c.33-34.17 0-68.17-1-102-6.57-1.31-13.23-1.31-20 0 3.1-1.32 6.6-1.99 10.5-2 3.75.02 7.42.35 11 1 .83 34.5.66 68.84-.5 103Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46966",
    d: "M6118.5 3538.5c2.3 3.31 4.63 6.64 7 10-3.83-3-7.16-6.5-10-10.5-.95-.48-1.95-.65-3-.5v-4c-2.36-.25-4.36.42-6 2v-2c1.98-1.67 4.31-2.33 7-2 .23 3.3 1.9 5.64 5 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e5e5",
    d: "M7425.5 3548.5c-.04 2.92.79 5.59 2.5 8 .67 4 .67 8 0 12a81.57 81.57 0 0 1-5.5 9c-3.86 2.02-7.86 3.85-12 5.5-9.65.96-19.31 1.46-29 1.5-.67 0-1-.33-1-1 .22-14.77.55-29.6 1-44.5 9.82.36 19.49.36 29 0 5.71 2.18 10.71 5.35 15 9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ae57",
    d: "M7681.5 3539.5c-8.2.69-16.54 1.36-25 2-25.99-.9-52.32-1.07-79-.5-1.56.32-2.73 1.15-3.5 2.5-.79 10.38-.62 20.71.5 31-1 .09-1.83-.25-2.5-1a27.1 27.1 0 0 0-1.5-6.5 50.624 50.624 0 0 0 0-20c.7-3.08 2.37-5.41 5-7 35.33-.5 70.67-.67 106-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b8b8c9",
    d: "M7742.5 3534.5c2.27 2.88 4.27 5.88 6 9a6.929 6.929 0 0 0-4-1c.36-2.41-.64-3.91-3-4.5.71-1.56.04-2.72-2-3.5-1.31 7.89-1.31 15.73 0 23.5-.33 4.21-1.33 8.05-3 11.5v-37c2.2.1 4.2.77 6 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ababc4",
    d: "M7416.5 3538.5c3.71 2.71 6.71 6.04 9 10-4.29-4.15-9.29-7.32-15-9.5-9.51.36-19.18.36-29 0-.45 14.9-.78 29.73-1 44.5-1-14.49-1.33-29.16-1-44-.09-1 .25-1.83 1-2.5 12.1-.94 24.1-.44 36 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fead51",
    d: "M1517.5 3539.5c4.2-.32 8.2.02 12 1-3.68-.17-7.35 0-11 .5a81.222 81.222 0 0 1-11 5c-1.78 3.95-4.45 7.11-8 9.5-.16-1.37.01-2.71.5-4 1.38-1.21 2.54-2.54 3.5-4 4.28-3.15 8.94-5.81 14-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9113",
    d: "m1529.5 3540.5 2 2a58.5 58.5 0 0 0 9 5c1.42 1.42 2.42 3.09 3 5 .74 3.79 1.74 7.46 3 11-16 .17-32 0-48-.5-.52-.56-.86-1.23-1-2 1.36-1.57 2.02-3.4 2-5.5 3.55-2.39 6.22-5.55 8-9.5 3.79-1.39 7.45-3.06 11-5 3.65-.5 7.32-.67 11-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffcb91",
    d: "M1816.5 3527.5h1c-2.33 3.17-5.17 5.83-8.5 8-2.03 3.2-3.86 6.54-5.5 10a34.375 34.375 0 0 0-7 13c.28-4.23 1.44-8.23 3.5-12 3.76-4.75 7.09-9.75 10-15 1.68-2.17 3.84-3.5 6.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9275ea",
    d: "M4633.5 3533.5c15.67-.17 31.34 0 47 .5 1.39 1.17 2.23 2.67 2.5 4.5.5 2.98.66 5.98.5 9 2.54-.54 4.87-1.54 7-3-1.42 2.58-3.59 4.25-6.5 5-1.75-.25-2.58-1.25-2.5-3 .16-3.02 0-6.02-.5-9a7.239 7.239 0 0 0-2.5-2c-15.24-.27-30.41.06-45.5 1-.67 73-.67 146 0 219 1.09.79 2.25 1.46 3.5 2 5.73-1.5 11.39-3 17-4.5 2.98-.5 5.98-.66 9-.5-7.39 2.56-15.05 4.39-23 5.5-2.6.77-5.1.6-7.5-.5-.67-74-.67-148 0-222 .72-.54 1.22-1.21 1.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9274ea",
    d: "M4838.5 3536.5a22.668 22.668 0 0 0-5 4c-2.31.82-4.65 1.65-7 2.5-2.55 2.1-5.22 3.93-8 5.5 3.73-3.9 7.9-7.23 12.5-10 2.32-1.37 4.82-2.04 7.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46d6c",
    d: "M5842.5 3539.5c8.78 1.9 15.78 6.56 21 14-1.91-.58-3.58-1.58-5-3a65.291 65.291 0 0 0-16-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab3b3",
    d: "M6046.5 3523.5v1a180.891 180.891 0 0 0-16 20 30.065 30.065 0 0 0-7 6 200.59 200.59 0 0 0 11.5-16c3.78-3.95 7.61-7.61 11.5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebcead",
    d: "M7608.5 3575.5h-32c-.99.17-1.66-.16-2-1a168.01 168.01 0 0 1-.5-31c.77-1.35 1.94-2.18 3.5-2.5 26.68-.57 53.01-.4 79 .5 8.46-.64 16.8-1.31 25-2 1.03-.87 1.69-2.04 2-3.5.1-11.67-.06-23.5-.5-35.5-.75-2.25-2.25-3.58-4.5-4-55.5-1-111.16-1.33-167-1 .67-.77 1.51-1.43 2.5-2 49.18.15 105.02.82 167.5 2 1.35 1.19 2.52 2.52 3.5 4 .67 12.67.67 25.33 0 38-.94 2.27-2.27 4.27-4 6-34.3-.6-69.13-.6-104.5 0-.68 6.89-1.35 13.72-2 20.5.47 2.89 1.13 6.05 2 9.5 10.83.67 21.49 1.33 32 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M10325.5 3541.5h23v31h30v22h-30c-.2 25.67 0 51.34.5 77 1.8 8.47 7 13.64 15.5 15.5 5.4.61 10.7.44 16-.5v21c-10.8 1.83-21.5 1.33-32-1.5-13-6.08-20.5-16.24-22.5-30.5-.5-27-.7-54-.5-81h-25v-22c12.2 1.47 20.4-3.53 24.5-15 .5-5.32.7-10.66.5-16ZM10849.5 3541.5h23v31h30v22h-30c-.2 25.67 0 51.34.5 77 1.8 8.47 7 13.64 15.5 15.5 5.4.61 10.7.44 16-.5v21c-10.8 1.83-21.5 1.33-32-1.5-13-6.08-20.5-16.24-22.5-30.5-.5-27-.7-54-.5-81h-25v-22c12.2 1.47 20.4-3.53 24.5-15 .5-5.32.7-10.66.5-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdbb3",
    d: "M1428.5 3547.5c-2.83-.19-5.5-.86-8-2-2.31-1.55-4.97-2.21-8-2-5.96.24-11.63 1.57-17 4 2.45-1.57 4.95-3.23 7.5-5 9.55-2.32 18.05-.66 25.5 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fea844",
    d: "M1504.5 3521.5c-6.04 1.7-11.04 5.03-15 10-4.33 1.67-7.33 4.67-9 9-.88-.13-1.54.2-2 1-1.98 4.33-4.31 8.33-7 12 1.24-4.77 3.24-9.27 6-13.5 3.21-2.71 5.88-5.88 8-9.5 5.75-4.47 12.09-7.47 19-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fecd96",
    d: "M1755.5 3549.5h-2c-6.55-4.5-13.88-6.16-22-5 .11-.62.44-1.12 1-1.5 6.91-1.04 13.58-.2 20 2.5 1.79.78 2.79 2.12 3 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5c0d5",
    d: "M2896.5 3546.5c-.77-.67-1.43-1.51-2-2.5-11.87 2.48-18.04-2.35-18.5-14.5-1.58-1.3-2.75-.97-3.5 1-2.69.16-5.35 0-8-.5-.56-.38-.89-.88-1-1.5 1.63.44 3.29.77 5 1 2.92-1.97 6.26-2.97 10-3-.16 3.02 0 6.02.5 9 3.47 6.17 8.3 7.84 14.5 5 2.47 1.18 3.47 3.18 3 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a58ced",
    d: "M4218.5 3541.5c-.33.67-.67 1.33-1 2a26.15 26.15 0 0 1-7 5c-2.33 2.67-4.67 5.33-7 8 .82-3.16 2.49-5.83 5-8 3.06-2.73 6.4-5.07 10-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbd1f6",
    d: "M4509.5 3541.5a73.15 73.15 0 0 0-6 11c-1.55.95-3.21 1.29-5 1v-3c3.57.8 5.57-.86 6-5 1.67-1.33 3.33-2.67 5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f47170",
    d: "M5979.5 3539.5c1.22.53 2.39 1.19 3.5 2 1.75 2.23 3.25 4.57 4.5 7-3.38-2.47-6.05-5.47-8-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffaf54",
    d: "M1230.5 3508.5c-3.07 2.61-5.24 5.94-6.5 10-1.96.95-3.62 2.29-5 4a53.703 53.703 0 0 0-6 13c-.5 9.33-.67 18.66-.5 28-1.47-4.24-2.13-8.74-2-13.5.31-7.56.98-15.06 2-22.5 5.65-5.34 10.32-11.34 14-18 1.33-.33 2.67-.67 4-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e91b7",
    d: "M2954.5 3545.5c-1.54-.2-2.88-.87-4-2-.33.5-.67 1-1 1.5.91 1.41 1.58 2.91 2 4.5-3.39-1.57-4.73-4.24-4-8 3.72-.82 6.06.51 7 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c5b6f3",
    d: "M4883.5 3531.5c2.33.67 4.67 1.33 7 2 3.3 1.83 6.64 3.67 10 5.5 1.63.49 3.3.66 5 .5.76 1.76 2.1 2.76 4 3 1.08 2.09 2.75 3.42 5 4 2.67 2.95 5.33 5.95 8 9 3.89 3.91 6.56 8.58 8 14 2.97 7.86 5.3 15.86 7 24 1.29 12.68 1.29 25.35 0 38-29.66.83-59.33 1.33-89 1.5-1.28 3.06-.95 5.9 1 8.5.38 2.42 1.04 4.75 2 7-1.76-1.64-3.26-3.64-4.5-6-.5-3.65-.67-7.32-.5-11h90c.17-11.67 0-23.34-.5-35a47.421 47.421 0 0 1-3-16c-3.04-5.35-5.04-11.01-6-17-.87-2.71-2.71-4.05-5.5-4 .15-1.05-.02-2.05-.5-3-9.15-11.31-20.65-18.64-34.5-22-5.26-1.48-10.76-2.14-16.5-2-5.8.2-11.3.53-16.5 1 .42-.72 1.08-1.22 2-1.5 9.33-.5 18.66-.67 28-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9377e9",
    d: "M4909.5 3542.5c2.25.58 3.92 1.91 5 4-2.25-.58-3.92-1.91-5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f36765",
    d: "M5934.5 3544.5c2.22.7 4.05 2.04 5.5 4 3.06 3.91 5.89 7.91 8.5 12a22.193 22.193 0 0 0-7-6 26.3 26.3 0 0 0-7-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffbb6c",
    d: "M1531.5 3542.5c4.63-1.08 7.63.58 9 5a58.5 58.5 0 0 1-9-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffa846",
    d: "M1862.5 3546.5c.33.67.67 1.33 1 2-12.12-3.86-23.46-2.52-34 4 .36-1.87 1.36-3.37 3-4.5 9.78-5.18 19.78-5.68 30-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7388b1",
    d: "M2986.5 3519.5c4.29 4.12 8.79 8.12 13.5 12 .67 3.33.67 6.67 0 10-9.8 8-17.64 6.33-23.5-5 2.75 2.25 5.42 4.75 8 7.5 3 .67 6 .67 9 0 1.03-2.87 3.03-4.37 6-4.5.16-2.36 0-4.69-.5-7-5.04-3.54-9.21-7.88-12.5-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f88b89",
    d: "M5788.5 3542.5c-.33.67-.67 1.33-1 2-5.57 3.56-10.9 7.56-16 12a57.167 57.167 0 0 0-9 9c5.54-11.21 14.21-18.87 26-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9113",
    d: "M1420.5 3545.5c2.5 1.14 5.17 1.81 8 2 7.93 6.77 11.6 15.44 11 26-.26 5.74-.93 11.4-2 17-3.55 3.48-7.22 6.98-11 10.5-13.78 4.9-26.12 2.73-37-6.5-6.71-15.72-5.05-30.39 5-44 8.09-4.48 16.75-6.14 26-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9114",
    d: "M1727.5 3544.5h4c8.12-1.16 15.45.5 22 5 5.77 4.97 9.27 11.31 10.5 19 .92 8.21.09 16.21-2.5 24-10.05 13.51-23.05 16.84-39 10-2.67-3-5.33-6-8-9-3.08-10.49-3.75-21.16-2-32-.16-1.37.01-2.71.5-4 4.21-5.16 9.04-9.49 14.5-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe2c2",
    d: "M1803.5 3545.5c-1.53 4.75-3.36 9.42-5.5 14 .09 9.19-.07 18.52-.5 28-.79-1.11-1.29-2.44-1.5-4-.5-6.66-.67-13.33-.5-20 .95-1.42 1.28-3.09 1-5 1.39-4.84 3.73-9.18 7-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9011",
    d: "M1863.5 3548.5c1.11.06 2.11.39 3 1 7.76 13.31 9.26 27.31 4.5 42-2.68 4.5-5.84 8.5-9.5 12-4.28.92-8.62 1.59-13 2-4.05-.46-8.05-1.13-12-2-1.43-1.04-3.1-1.7-5-2a549.55 549.55 0 0 1-8.5-17c-.83-7.36-.66-14.69.5-22 1.65-3.62 3.65-6.96 6-10 10.54-6.52 21.88-7.86 34-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#96a5c3",
    d: "M2931.5 3534.5c1.98.5 3.98 1 6 1.5 5.74 7.06 8.07 15.06 7 24 4.73 1.2 9.4 1.7 14 1.5-2.62 1.77-5.62 2.43-9 2-1.81-1.13-3.81-1.8-6-2-.43-5.43-.93-10.76-1.5-16-2.36-4.85-5.86-8.52-10.5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0175c1",
    d: "M3023.5 3521.5c1.3 2.61 1.14 5.27-.5 8a73.92 73.92 0 0 1-7.5 7c-2.64 1.6-5.31 2.1-8 1.5-2.33 10.32-8.83 15.49-19.5 15.5-2.98 4.62-7.31 8.62-13 12-4.67-1.48-9.17-1.15-13.5 1 .84-1.67 2.18-2.84 4-3.5 5.19-.13 10.19-1.13 15-3 2.75-2.84 4.91-6.01 6.5-9.5 10.28 1.8 16.28-2.87 18-14 4.83-.41 9.33-1.91 13.5-4.5 3.18-3.17 4.85-6.67 5-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5726f",
    d: "M6371.5 3541.5c2.03-.16 4.03 0 6 .5 1.22 1.74 2.88 2.74 5 3 1.35 1.62 3.02 2.78 5 3.5 1.45 1.44 2.45 3.11 3 5a76.38 76.38 0 0 0-8-6.5c-4.5-.36-8.16-2.2-11-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe0bc",
    d: "M1428.5 3547.5c2.22-.32 4.06.34 5.5 2 2.4 4.34 4.73 8.68 7 13 2.24 9.13 1.9 18.13-1 27-.85 1.07-1.69 2.07-2.5 3v-2c1.07-5.6 1.74-11.26 2-17 .6-10.56-3.07-19.23-11-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb560",
    d: "M1639.5 3546.5c-2.76-1.79-5.92-2.79-9.5-3-1.83.17-3.67.33-5.5.5a65.76 65.76 0 0 1-10 4.5c-.09-1 .25-1.83 1-2.5 2.08-.7 3.75-1.86 5-3.5 4.64-.9 9.31-1.06 14-.5 2.16 1 3.83 2.5 5 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0066b1",
    d: "M3064.5 3546.5c-5.75 7.75-12.75 14.08-21 19 6.41-7.08 13.41-13.42 21-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#805ee6",
    d: "M4914.5 3546.5c1.89-.2 3.39.46 4.5 2 1.19 2.39 2.36 4.72 3.5 7a727.51 727.51 0 0 0-8-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46b69",
    d: "M6099.5 3544.5c-2.87 5.05-6.37 9.72-10.5 14-.14 2.42.36 4.75 1.5 7-3.96-1.42-4.96-4.09-3-8 4.04-4.37 8.04-8.7 12-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feab4a",
    d: "M1344.5 3523.5c4.44 6.86 6.44 14.53 6 23 .57 12.46-1.76 24.13-7 35 .93-4.63 1.93-9.3 3-14 .77-.76 1.27-1.76 1.5-3 .67-9.33.67-18.67 0-28-.21-1.56-.71-2.89-1.5-4-.92-2.92-1.58-5.92-2-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe2c1",
    d: "M1564.5 3539.5c.96.45 1.79 1.12 2.5 2 1.3 5.25 3.13 10.25 5.5 15v6c-3.04-7.45-5.71-15.11-8-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d5a95",
    d: "M2954.5 3545.5c2.59.92 4.59 2.59 6 5v2c-1.64-.87-3.31-1.37-5-1.5 9.52 10.22 7.52 14.39-6 12.5 3.38.43 6.38-.23 9-2 1.1-1.1 1.26-2.43.5-4-2.03-3.19-4.53-5.86-7.5-8-.42-1.59-1.09-3.09-2-4.5.33-.5.67-1 1-1.5 1.12 1.13 2.46 1.8 4 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbb7b5",
    d: "M6228.5 3545.5c-3.22 5.89-7.55 10.89-13 15 .06-1.11.39-2.11 1-3 2.8-1.48 4.47-3.81 5-7 2.54-1.44 4.87-3.11 7-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fed8ad",
    d: "M2006.5 3542.5v4c-.33.67-.67 1.33-1 2-1.91 3.84-3.74 7.84-5.5 12-.71.88-1.54 1.55-2.5 2 1.39-2.42 2.22-5.09 2.5-8 2.01-4.13 4.18-8.13 6.5-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#714de5",
    d: "M4303.5 3538.5c3.61-.46 6.94.21 10 2 1.62 7.02.95 13.69-2 20 .91-6.3 1.58-12.64 2-19-3.43-1.01-6.76-2.01-10-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f5de7",
    d: "M4765.5 3547.5c2.08 2.42 4.42 4.75 7 7 .95 1.55 1.29 3.21 1 5a75.468 75.468 0 0 1-8-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faafae",
    d: "M6106.5 3533.5v2a45.883 45.883 0 0 0-7 9c-3.96 4.3-7.96 8.63-12 13 5.55-8.61 11.88-16.61 19-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#baa7f1",
    d: "M4298.5 3537.5c1.72.13 3.38.46 5 1 3.24.99 6.57 1.99 10 3-.42 6.36-1.09 12.7-2 19v1c-.67 1-1.33 2-2 3 .59-7.07 1.59-14.07 3-21-4.07-1.85-8.41-3.02-13-3.5-.75-.67-1.09-1.5-1-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f36b69",
    d: "M5987.5 3548.5c3.4 2.4 6.07 5.4 8 9-3.82-1.97-6.49-4.97-8-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f36765",
    d: "M6174.5 3549.5a810.5 810.5 0 0 1-22 26.5c-3.37 1.12-5.37-.05-6-3.5 2.41 2.53 4.75 2.53 7 0 6.63-7.97 13.63-15.63 21-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9896b7",
    d: "M7132.5 3523.5c-5.68 8.56-8.34 18.06-8 28.5-.95 10.68 1.72 20.18 8 28.5 1.36 2.35 2.69 4.68 4 7-1.52-.01-2.68-.68-3.5-2-12.02-18.34-13.69-37.67-5-58 1.31-1.69 2.81-3.03 4.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323030",
    d: "M8859.5 3549.5c1-.03 1.66.47 2 1.5 10.34 29.68 20.67 59.35 31 89-21.33.67-42.67.67-64 0 10.64-30.07 20.97-60.24 31-90.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe0bd",
    d: "M1342.5 3519.5c.67 1.33 1.33 2.67 2 4 .42 3.08 1.08 6.08 2 9 1.33 11.67 1.33 23.33 0 35-1.07 4.7-2.07 9.37-3 14-1.1 1.89-2.44 3.56-4 5 3.85-10.25 6.18-20.92 7-32-.92-11.74-2.25-23.4-4-35Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6ccf6",
    d: "M4210.5 3548.5c.26 1.48-.07 2.81-1 4-3.52 4.15-6.52 8.48-9 13 .55-3.2 1.55-6.2 3-9 2.33-2.67 4.67-5.33 7-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9376eb",
    d: "M4818.5 3548.5a71.329 71.329 0 0 1-9 11c1.87-4.54 4.87-8.21 9-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9796b7",
    d: "M7471.5 3506.5c1.81-.01 3.48.49 5 1.5 9.95 9.82 16.11 21.65 18.5 35.5.67 9.33.67 18.67 0 28-.61 2.93-1.44 5.76-2.5 8.5.46.41.79.91 1 1.5-.31 1.98-1.31 3.32-3 4a66.53 66.53 0 0 1 2.5-11c.83-10.51.66-20.84-.5-31-2.3-6.85-4.47-13.85-6.5-21-3.99-6.15-8.82-11.49-14.5-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7078a6",
    d: "M7770.5 3498.5v-1h2v74c-.67-24.33-1.33-48.67-2-73Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fec582",
    d: "M1346.5 3532.5c.79 1.11 1.29 2.44 1.5 4 .67 9.33.67 18.67 0 28-.23 1.24-.73 2.24-1.5 3 1.33-11.67 1.33-23.33 0-35Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffa949",
    d: "M1939.5 3537.5c3.51 5.09 7.01 10.42 10.5 16 .32 3.71.82 7.38 1.5 11-2.05-3.94-4.22-7.94-6.5-12a72.677 72.677 0 0 0-5.5-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4c9f6",
    d: "m4432.5 3543.5-3 28h-2c1.49-6.87 2.33-13.87 2.5-21 .39-2.6 1.22-4.94 2.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f57776",
    d: "M6077.5 3545.5c-1.03 2.02-2.03 4.02-3 6-3.73 2.73-6.73 6.06-9 10-.67 1-1.33 2-2 3-1.33 1-2.67 2-4 3 3.12-6.64 7.62-12.3 13.5-17 .61-2.61 2.11-4.28 4.5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f57471",
    d: "M6427.5 3540.5c1.48 1.59 2.98 3.26 4.5 5 2.12 3.91 3.96 7.91 5.5 12-1.52-.01-2.68-.68-3.5-2-1.22-4.15-3.22-7.82-6-11a8.394 8.394 0 0 1-.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fed5a7",
    d: "M1915.5 3538.5c1.62 2.99 3.28 6.16 5 9.5 1.78 7.15 4.11 13.99 7 20.5a32.133 32.133 0 0 0-4-5c-.64-4.74-1.98-9.24-4-13.5-.51-1.17-1.34-2-2.5-2.5a95.96 95.96 0 0 0-1.5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a9cbd",
    d: "M2899.5 3551.5c5.32 1.12 10.65 1.12 16 0 .17 2.36.51 4.69 1 7l-2-2c-.07-1.81-.91-3.14-2.5-4-4.52 2.86-8.68 2.52-12.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#98a8c6",
    d: "M2973.5 3533.5c-3.05-1.05-5.05-3.05-6-6h-4c-.16 1.37.01 2.71.5 4 4.16 3.33 8 7 11.5 11 2.15 2.64 3.49 5.64 4 9 .09 2.41-.91 4.24-3 5.5-6.73 3.01-12.06 1.51-16-4.5v-2c2.13 1.63 4.13 3.46 6 5.5 10.44.56 12.94-3.61 7.5-12.5a226.77 226.77 0 0 1-11.5-11.5c-.73-1.77-1.07-3.6-1-5.5 2.42-.31 4.76.03 7 1 1.69 2.02 3.36 4.02 5 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbb9b9",
    d: "M5858.5 3550.5c1.42 1.42 3.09 2.42 5 3 1.75 1.75 3.08 3.75 4 6a123 123 0 0 0-8.5-7c-.46-.59-.63-1.26-.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb968",
    d: "M1420.5 3545.5c-9.25-1.14-17.91.52-26 5-10.05 13.61-11.71 28.28-5 44-.67-.33-1.33-.67-2-1-2.81-9.46-3.64-19.13-2.5-29 1.73-5.14 4.23-9.81 7.5-14 .81-1.23 1.81-2.23 3-3 5.37-2.43 11.04-3.76 17-4 3.03-.21 5.69.45 8 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcd4f7",
    d: "M4538.5 3532.5c1.6-.27 2.93.07 4 1v1c.32 15.41-.02 30.74-1 46h-17c5.66-.55 11.32-1.38 17-2.5a246.866 246.866 0 0 1 0-43.5h-20c1.11-.79 2.44-1.29 4-1.5 4.32-.5 8.65-.67 13-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#514d91",
    d: "M7427.5 3549.5c1.43 1.4 2.6 3.07 3.5 5 .67 5.33.67 10.67 0 16-1.89 1.53-2.89 3.53-3 6a13.248 13.248 0 0 1-5 3c-.48.95-.65 1.95-.5 3a94.469 94.469 0 0 1-13 3c3.23-1.27 6.57-2.61 10-4 1.02-1.35 2.02-2.69 3-4 1.6-.59 2.93-1.59 4-3a21.77 21.77 0 0 1 4-6.5c0-3.3-.17-6.8-.5-10.5a22.487 22.487 0 0 1-2.5-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffddb7",
    d: "M1727.5 3544.5c-5.46 3.51-10.29 7.84-14.5 13a8.394 8.394 0 0 0-.5 4c-.62.11-1.12.44-1.5 1-2.03 9.39-1.86 18.72.5 28-1.25-.08-2.08-.74-2.5-2-3.06-12.67-1.39-24.67 5-36 3.49-4.33 7.99-7 13.5-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#46649a",
    d: "m2914.5 3556.5 2 2c1.13 1.63 2.46 3.13 4 4.5 3.86.81 7.52.64 11-.5.89-.61 1.89-.94 3-1-.95 2.11-2.62 3.28-5 3.5-7.75 1.72-12.75-1.12-15-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f77c78",
    d: "M6129.5 3551.5c1-.09 1.83.25 2.5 1 2.19 5.1 5.02 9.76 8.5 14-5.59-3.59-9.26-8.59-11-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd7a9",
    d: "M1774.5 3531.5c4 5.67 8 11.33 12 17 .26 4.96 1.43 9.62 3.5 14 .67 7 .67 14 0 21-.2 1.88-.7 3.55-1.5 5 1.21-14.45-.62-28.45-5.5-42-.91-3.08-2.74-5.41-5.5-7-1.01-2.69-2.01-5.35-3-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9290b4",
    d: "M7425.5 3548.5c.67.33 1.33.67 2 1 .33 2.81 1.16 5.48 2.5 8 .33 3.7.5 7.2.5 10.5a21.77 21.77 0 0 0-4 6.5c-1.07 1.41-2.4 2.41-4 3a81.57 81.57 0 0 0 5.5-9c.67-4 .67-8 0-12-1.71-2.41-2.54-5.08-2.5-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#575493",
    d: "M7492.5 3543.5c1.16 10.16 1.33 20.49.5 31a66.53 66.53 0 0 0-2.5 11c-.25 2.17-1.25 3.84-3 5 1.56-5.93 3.06-12.27 4.5-19 .5-9.33.67-18.66.5-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9999b3",
    d: "M7770.5 3497.5c-11.85.12-23.68-.21-35.5-1-7.69.27-15.19.94-22.5 2-1.8.82-2.8 2.32-3 4.5.88 21.8 1.21 44.3 1 67.5-.62-.11-1.12-.44-1.5-1-.17-11.67-.33-23.33-.5-35-.15-12.43.35-24.76 1.5-37 1.17-1.39 2.67-2.23 4.5-2.5 18-.67 36-.67 54 0 1.26.42 1.92 1.25 2 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9f9ebc",
    d: "M7748.5 3543.5c4.33 6.62 8.66 13.29 13 20-6.27-5.3-10.61-11.97-13-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#788ab2",
    d: "M3082.5 3535.5c-1.13 1.81-1.8 3.81-2 6a44.69 44.69 0 0 1-5.5 14c-3.3 3.65-6.8 6.98-10.5 10 7.46-7.9 12.62-17.23 15.5-28 .71-.88 1.54-1.55 2.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab7b6",
    d: "M6074.5 3551.5c-2.27 3.94-5.27 7.27-9 10 2.27-3.94 5.27-7.27 9-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#017bc7",
    d: "M2851.5 3513.5c1.34.81 2.34 1.98 3 3.5-.7 2.71-1.03 5.38-1 8 4.02 6.69 10.02 10.35 18 11 2.62 6.95 7.45 11.45 14.5 13.5 1-.33 2-.67 3-1 3 3.3 6.17 6.46 9.5 9.5 2.11.56 4.11 1.39 6 2.5 3.69-1.28 6.86.06 9.5 4 8.47 6.37 16.81 6.04 25-1 7.36 4.91 14.86 5.91 22.5 3 .17 1.32-.16 2.49-1 3.5-2.59.23-5.09.73-7.5 1.5-4.59-.24-9.09-1.57-13.5-4-8.19 3.82-16.52 3.99-25 .5-2.39-5.11-5.89-6.95-10.5-5.5-3.24-1.37-6.41-2.87-9.5-4.5-1.71-1.38-3.05-3.04-4-5-9.32-2-16.66-7-22-15-7.95-1.51-13.61-5.84-17-13 .44-3.76.44-7.6 0-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9b8d0",
    d: "M2934.5 3543.5c2.11.95 3.28 2.62 3.5 5 .58 3.7.41 7.37-.5 11-1.68-.21-2.68.45-3 2-1.11.06-2.11.39-3 1 2.52-2.61 4.19-5.78 5-9.5.45-3.24-.22-6.4-2-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b9aba",
    d: "M7184.5 3550.5c.88-.13 1.54.2 2 1 .57 1.56 1.24 3.06 2 4.5 11.58 4.29 23.24 8.29 35 12 12.38 2.76 24.72 5.76 37 9 2.63 2.15 5.63 3.48 9 4 2.77 1.37 5.1 3.2 7 5.5-9.63-4.64-19.63-8.47-30-11.5a826.931 826.931 0 0 1-54-15c-4.72-1.54-7.38-4.71-8-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fedab2",
    d: "M1862.5 3546.5c3.99.12 7.16 1.79 9.5 5 .84 3.19 2.18 6.19 4 9 .49 1.63.66 3.3.5 5a96.187 96.187 0 0 0-5.5-12 25.305 25.305 0 0 0-4.5-4c-.89-.61-1.89-.94-3-1-.33-.67-.67-1.33-1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a5994",
    d: "M2800.5 3552.5c1.65 1.21 3.32 2.55 5 4 3.11 3.76 5.78 7.76 8 12a18.25 18.25 0 0 1-3.5-2c-2.94-4.91-6.11-9.57-9.5-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab5b5",
    d: "M5941.5 3554.5c2.75 1.51 5.09 3.51 7 6 2.05 2.05 3.72 4.39 5 7-4.92-3.47-8.92-7.8-12-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feb158",
    d: "M1753.5 3549.5h2c2.33 1.67 4.33 3.67 6 6 3.74 9.26 4.91 18.92 3.5 29-.32 3.17-1.49 5.83-3.5 8 2.59-7.79 3.42-15.79 2.5-24-1.23-7.69-4.73-14.03-10.5-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccbef3",
    d: "M4759.5 3542.5c2 1.67 4 3.33 6 5 2.31 4.29 4.97 8.29 8 12 .35 4.35 2.01 8.02 5 11v4c.83 4.31 1.49 8.64 2 13-.96-.45-1.79-1.12-2.5-2-.33-4-.67-8-1-12a64.312 64.312 0 0 1-6-14c-3.57-5.96-7.4-11.63-11.5-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#805fe7",
    d: "M4773.5 3559.5c2.23 3.34 3.9 7 5 11-2.99-2.98-4.65-6.65-5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdcb4",
    d: "M1451.5 3536.5c4.14 3.9 7.47 8.4 10 13.5 1.33 4.56 2.33 9.06 3 13.5.64 13.66-.69 26.99-4 40-2.41 1.41-4.08 3.41-5 6h-2c3.09-5.84 5.92-11.84 8.5-18 .67-11.67.67-23.33 0-35a138.86 138.86 0 0 0-7.5-14c-2.48-1.22-3.48-3.22-3-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdd2a2",
    d: "M1517.5 3539.5c7.26-1.88 14.26-1.05 21 2.5 1.94 1.43 3.27 3.27 4 5.5 5.04 5.24 7.04 11.4 6 18.5-17.33.67-34.67.67-52 0-.92-2.04-1.26-4.21-1-6.5.73-3.48 2.07-6.81 4-10 1.08-1.21 2.41-1.87 4-2-.96 1.46-2.12 2.79-3.5 4a8.394 8.394 0 0 0-.5 4c-1.25.08-2.08.74-2.5 2-.77 2.6-.6 5.1.5 7.5 16.66.5 33.33.67 50 .5.84-5.14-.5-9.47-4-13-.58-1.91-1.58-3.58-3-5-1.37-4.42-4.37-6.08-9-5l-2-2c-3.8-.98-7.8-1.32-12-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffae51",
    d: "M1543.5 3552.5c3.5 3.53 4.84 7.86 4 13-16.67.17-33.34 0-50-.5-1.1-2.4-1.27-4.9-.5-7.5.42-1.26 1.25-1.92 2.5-2 .02 2.1-.64 3.93-2 5.5.14.77.48 1.44 1 2 16 .5 32 .67 48 .5a76.467 76.467 0 0 1-3-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9e84ec",
    d: "M4809.5 3560.5c-2.78 3.97-4.95 8.3-6.5 13-.71.88-1.54 1.55-2.5 2 1.23-6.14 4.23-11.14 9-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fccece",
    d: "M5771.5 3556.5c-2.15 5.49-5.48 10.15-10 14 .54-1.62.87-3.28 1-5 2.64-3.31 5.64-6.31 9-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcc7c7",
    d: "M6261.5 3543.5c-1.9 3.45-4.06 6.78-6.5 10a8.394 8.394 0 0 0-.5 4c-1.29.56-2.12 1.56-2.5 3-.66 2.78-1.49 5.45-2.5 8-1.41 6.46-3.07 12.79-5 19 .63-7.74 1.8-15.4 3.5-23 2.08-4.05 4.08-8.05 6-12 2.04-3.44 4.54-6.44 7.5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f57877",
    d: "M6254.5 3557.5a39.561 39.561 0 0 0-2.5 8c-.38 1.44-1.21 2.44-2.5 3 1.01-2.55 1.84-5.22 2.5-8 .38-1.44 1.21-2.44 2.5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8282ac",
    d: "M7379.5 3539.5c-.33 14.84 0 29.51 1 44 0 .67.33 1 1 1 5.81.99 11.81 1.32 18 1-1.14.84-2.47 1.51-4 2-2.81-.38-5.48-.38-8 0-3.14-.32-5.98-1.32-8.5-3-.5-12-.67-24-.5-36-.31-3.21.02-6.21 1-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffead2",
    d: "M1542.5 3547.5c1.59.13 2.92.79 4 2 3.13 5.36 4.47 11.02 4 17-.83.33-1.67.67-2.5 1-14.71.71-29.21 1.05-43.5 1-2.94-.74-5.94-1.24-9-1.5-1.31-2.6-1.31-5.1 0-7.5-.26 2.29.08 4.46 1 6.5 17.33.67 34.67.67 52 0 1.04-7.1-.96-13.26-6-18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccbef4",
    d: "M4883.5 3577.5h-1c.07-1.53-.59-2.53-2-3-4.18-7.41-10.51-9.91-19-7.5-.74 1.04-1.74 1.54-3 1.5.45-.96 1.12-1.79 2-2.5 9.06-2.44 16.56-.27 22.5 6.5.49 1.63.66 3.3.5 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f67e7c",
    d: "M6030.5 3544.5c-6.37 9.55-13.71 18.38-22 26.5-1.28.68-2.45.52-3.5-.5a196.19 196.19 0 0 0-9.5-13c4.02 4.02 8.35 7.69 13 11 5.02-6.07 10.02-12.07 15-18 2.01-2.35 4.35-4.35 7-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbc6c5",
    d: "M6063.5 3564.5c-2.64 3.49-5.14 7.16-7.5 11-2.97 3.67-6.13 7.01-9.5 10 2.58-3.5 4.92-7.16 7-11 2.22-2.07 4.22-4.4 6-7 1.33-1 2.67-2 4-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe8ce",
    d: "M1392.5 3550.5c-3.27 4.19-5.77 8.86-7.5 14-1.14 9.87-.31 19.54 2.5 29-.88.13-1.54-.2-2-1-3.7-7.95-4.87-16.28-3.5-25 2.45-4 4.11-8.33 5-13 1.65-1.71 3.48-3.04 5.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb157",
    d: "M2005.5 3548.5c-.45 5.41-1.95 10.41-4.5 15a56.243 56.243 0 0 1-8.5 13c1.52-3.91 2.86-7.91 4-12 .84-.34 1.17-1.01 1-2 .96-.45 1.79-1.12 2.5-2 1.76-4.16 3.59-8.16 5.5-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f78987",
    d: "M6216.5 3557.5c-.61.89-.94 1.89-1 3a64.939 64.939 0 0 1-13 14c1.34-2.2 2.51-4.53 3.5-7 3.75-3.25 7.25-6.58 10.5-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c1fde",
    d: "M4880.5 3574.5c1.41.47 2.07 1.47 2 3 1.86 7.15 2.86 14.49 3 22h-37c-.35-5.92.49-11.58 2.5-17 2.22-4.5 4.72-8.84 7.5-13 8.44-2.61 15.77-.94 22 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe0bd",
    d: "M1480.5 3540.5c-8.9 17.41-11.06 35.74-6.5 55 2.9 3.13 4.73 6.8 5.5 11-1-.67-2-1.33-3-2-3.02-3.7-4.68-8.03-5-13a165.115 165.115 0 0 1 0-35v-3c2.69-3.67 5.02-7.67 7-12 .46-.8 1.12-1.13 2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb55f",
    d: "M1712.5 3561.5c-1.75 10.84-1.08 21.51 2 32-1-.67-2-1.33-3-2v-1c-2.36-9.28-2.53-18.61-.5-28 .38-.56.88-.89 1.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8362e8",
    d: "M4880.5 3574.5c-6.23-5.94-13.56-7.61-22-5v-1c1.26.04 2.26-.46 3-1.5 8.49-2.41 14.82.09 19 7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9a0a0",
    d: "M6091.5 3567.5c1.31.98 2.65 1.98 4 3 2.38 3.36 4.71 6.7 7 10-4.79-3.45-8.45-7.78-11-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f89897",
    d: "M6298.5 3555.5c-5.08 7.75-9.75 15.75-14 24v-2c2.69-8.73 7.35-16.06 14-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M9360.5 3690.5c-.28-.79-.78-1.46-1.5-2-.5 22.66-.67 45.33-.5 68h-23v-184h23c-.17 6.01 0 12.01.5 18 14.88-17.3 33.71-24.13 56.5-20.5 26.36 5.02 44.2 20.19 53.5 45.5 8.19 29.38 2.03 55.22-18.5 77.5-16.83 14.04-36.17 19.38-58 16-12.79-2.65-23.46-8.82-32-18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M9609.5 3607.5v99h-22c.17-5.34 0-10.68-.5-16-12.28 13.54-27.62 19.88-46 19-20.95.7-35.28-8.63-43-28-3.93-18.61 1.9-33.11 17.5-43.5a64.966 64.966 0 0 1 20-8c16.97-3.05 33.97-5.88 51-8.5 1.86-16.78-5.48-26.95-22-30.5-11.92-1.35-22.58 1.65-32 9-3.24 3.89-6.41 7.73-9.5 11.5a427.31 427.31 0 0 1-17.5-8.5c-1.05-1.39-1.22-2.89-.5-4.5 9.48-15.01 22.98-24.51 40.5-28.5 17.36-2.67 33.36.67 48 10 9.09 7.01 14.42 16.18 16 27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M9979.5 3615.5v91h-23c.33-29.17 0-58.17-1-87-4.8-21.57-18.13-30.41-40-26.5-12.05 4.88-19.05 13.71-21 26.5-1 28.83-1.33 57.83-1 87h-23c.33-29.17 0-58.17-1-87-4.8-21.57-18.13-30.41-40-26.5-12.05 4.88-19.05 13.71-21 26.5-1 28.83-1.33 57.83-1 87h-23v-134h23c-.17 5.01 0 10.01.5 15 11.49-15.06 26.65-20.89 45.5-17.5 14.49 2.65 25.66 10.15 33.5 22.5 18.91-24.88 42.41-30.05 70.5-15.5 13.42 9.35 20.76 22.18 22 38.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M10060.5 3569.5c39.3-3.28 64.1 14.06 74.5 52 .7 8.36.5 16.69-.5 25h-103c2.4 25.72 16.4 39.72 42 42 17.3.17 30.3-7.16 39-22l18 9c1.1.86 1.2 1.86.5 3-13.1 21.56-32.4 31.89-58 31-29.3-.92-49.6-14.92-61-42-10.7-30.63-5.2-57.79 16.5-81.5 9.5-7.92 20.2-13.42 32-16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M10277.5 3611.5v95h-22c.3-27.84 0-55.51-1-83-1.7-19.87-12.5-30.53-32.5-32-17.6 1.41-28.1 10.74-31.5 28-1 28.83-1.3 57.83-1 87h-23v-134h23c-.2 5.01 0 10.01.5 15 12-14.88 27.5-20.71 46.5-17.5 23.2 4.41 36.9 18.24 41 41.5ZM10648.5 3615.5v91h-23c.3-29.17 0-58.17-1-87-4.8-21.57-18.1-30.41-40-26.5-12.1 4.88-19.1 13.71-21 26.5-1 28.83-1.3 57.83-1 87h-23c.3-29.17 0-58.17-1-87-4.8-21.57-18.1-30.41-40-26.5-12.1 4.88-19.1 13.71-21 26.5-1 28.83-1.3 57.83-1 87h-23v-134h23c-.2 5.01 0 10.01.5 15 11.5-15.06 26.7-20.89 45.5-17.5 14.5 2.65 25.7 10.15 33.5 22.5 18.9-24.88 42.4-30.05 70.5-15.5 13.4 9.35 20.8 22.18 22 38.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M10729.5 3569.5c39.3-3.28 64.1 14.06 74.5 52 .7 8.36.5 16.69-.5 25h-103c2.4 25.72 16.4 39.72 42 42 17.3.17 30.3-7.16 39-22l18 9c1.1.86 1.2 1.86.5 3-13.1 21.56-32.4 31.89-58 31-29.3-.92-49.6-14.92-61-42-10.7-30.63-5.2-57.79 16.5-81.5 9.5-7.92 20.2-13.42 32-16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M11130.5 3569.5c35.8-3.87 61.6 10.13 77.5 42 8.9 27.18 4.9 52.18-12 75-21.7 22.43-47.5 28.93-77.5 19.5-34.3-16.32-48.8-43.49-43.5-81.5 7.8-29.29 26.3-47.62 55.5-55Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffa43c",
    d: "M1866.5 3549.5c1.63 1.13 3.13 2.46 4.5 4 2.14 3.94 3.97 7.94 5.5 12 1.71 11.25-.45 21.58-6.5 31-2.44 2.95-5.27 5.28-8.5 7 3.66-3.5 6.82-7.5 9.5-12 4.76-14.69 3.26-28.69-4.5-42Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1c5f4",
    d: "M4724.5 3582.5c-1.64-1.25-2.8-2.92-3.5-5-.82-1.32-1.98-1.99-3.5-2-1.25-1.64-2.92-2.8-5-3.5-2.98-.5-5.98-.66-9-.5.65-2.09 2.15-3.09 4.5-3 4.15 1.83 8.32 3.66 12.5 5.5a28.38 28.38 0 0 1 4 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe0bd",
    d: "M1649.5 3626.5c-1.44-22.84-2.77-45.84-4-69-.15-4.86-2.15-8.52-6-11-1.17-2-2.84-3.5-5-4.5-4.69-.56-9.36-.4-14 .5 4.16-2.86 8.83-3.69 14-2.5 11.96 5.14 16.79 14.3 14.5 27.5.5 19.66.67 39.33.5 59Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3c7f5",
    d: "M4279.5 3571.5h-4c-3.1-1.32-6.6-1.99-10.5-2-3.5.17-7 .33-10.5.5-.88.71-1.55 1.54-2 2.5-1.54.2-2.88.87-4 2-1.25 3.37-1.25 6.71 0 10-1.29-1.37-1.95-3.2-2-5.5.17-1.83.33-3.67.5-5.5a48.24 48.24 0 0 0 6.5-4.5c7.67-.67 15.33-.67 23 0 1.07.85 2.07 1.69 3 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9276ea",
    d: "M4275.5 3571.5c-7.86-1.65-15.53-1.32-23 1 .45-.96 1.12-1.79 2-2.5 3.5-.17 7-.33 10.5-.5 3.9.01 7.4.68 10.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8584ad",
    d: "M7742.5 3534.5c-1.8-1.23-3.8-1.9-6-2v37c-.26 2.06-1.43 3.4-3.5 4-7.82-.32-15.32-1.32-22.5-3 7.94 1.3 15.94 1.3 24 0 .82-12.95 1.32-25.95 1.5-39 3.22-1.31 5.38-.31 6.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fea742",
    d: "M1672.5 3543.5c1.55.73 2.38 2.06 2.5 4 .67 26.67.67 53.33 0 80l-2.5 2.5c-8.33.67-16.67.67-25 0l-1.5-1.5c-.5-19.66-.67-39.33-.5-59 .83 19.16 1.33 38.5 1.5 58 .75.63 1.58 1.13 2.5 1.5 7.33.67 14.67.67 22 0l1.5-1.5c.81-28.03.64-56.03-.5-84Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#967aeb",
    d: "M4276.5 3571.5h7c2.14 1.15 4.14 2.49 6 4-4.57-.89-8.91-2.22-13-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfc2f3",
    d: "M4283.5 3571.5c4.46-.59 8.13.74 11 4h-5a38.192 38.192 0 0 0-6-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d5ae6",
    d: "M4703.5 3571.5c3.02-.16 6.02 0 9 .5 2.08.7 3.75 1.86 5 3.5-6.15-1.81-12.49-2.48-19-2v-1c1.54-.8 3.21-1.13 5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M9631.5 3572.5c8.59-.32 17.09.02 25.5 1a6843.91 6843.91 0 0 0 40.5 102c13.87-33.75 27.2-67.75 40-102a85.21 85.21 0 0 1 26 0l-61.5 153c-11.19 27.18-31.36 38.68-60.5 34.5-1.37-.4-2.71-.9-4-1.5-1-6.97-1.33-13.97-1-21 7.98.99 15.98 1.16 24 .5 6.64-2.3 11.81-6.47 15.5-12.5a101.67 101.67 0 0 0 8.5-19.5c-17.58-44.9-35.24-89.73-53-134.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe0bc",
    d: "M1669.5 3543.5c1.57 1.18 2.4 2.85 2.5 5 .83 25.84.66 51.5-.5 77-.02-24.37-.02-48.54 0-72.5-.93-3.09-1.6-6.25-2-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e4ddf9",
    d: "M4326.5 3568.5v3c7.01-.17 14.01 0 21 .5l1.5 1.5c.26 31.34.76 62.68 1.5 94-.82-2.47-1.32-5.14-1.5-8-.17-25.17-.67-50.17-1.5-75 .6-3.6.26-7.26-1-11-6.94-.96-13.94-1.3-21-1-.27-1.6.07-2.93 1-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffad51",
    d: "M1471.5 3556.5a165.115 165.115 0 0 0 0 35c-.62-.11-1.12-.44-1.5-1-.3-3.56-1.3-6.89-3-10a60.369 60.369 0 0 0-3 19c-1.03 1.53-2.2 2.86-3.5 4 3.31-13.01 4.64-26.34 4-40 .98.64 1.98 1.31 3 2 .83-2.46 1.49-4.96 2-7.5.34-1.03 1-1.53 2-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe8cc",
    d: "M1607.5 3557.5c-.77 3.95-1.11 7.95-1 12-.67 18.67-1.33 37.33-2 56a690.33 690.33 0 0 1-.5-59c.67-2.67 1.33-5.33 2-8 .38-.56.88-.89 1.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c82ec",
    d: "M4328.5 3551.5c-.18 5.73-.85 11.4-2 17-.93 1.07-1.27 2.4-1 4 7.06-.3 14.06.04 21 1 1.26 3.74 1.6 7.4 1 11-.3 26.69.04 53.36 1 80h-1c-.64-30.14-1.31-60.14-2-90-7.06.3-14.06-.04-21-1-.45-6.67.22-13.34 2-20 .25-1.21.91-1.88 2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8baf4",
    d: "M4426.5 3571.5c-8.48.99-17.15 1.33-26 1-.17 25.34 0 50.67.5 76 .38.56.88.89 1.5 1v1c-.2 1.89.46 3.39 2 4.5 3.07 1.3 6.07 2.46 9 3.5-6.01 1.08-10.51-1.26-13.5-7-.5-26.66-.67-53.33-.5-80h27Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a1dde",
    d: "M4698.5 3573.5c6.51-.48 12.85.19 19 2 2.15 2.24 3.65 4.91 4.5 8 .67.75 1.5 1.09 2.5 1 1.27 2.49 1.94 5.16 2 8v41c.15 3.22-.85 5.88-3 8-2.47 4.72-5.14 9.39-8 14v1c-1.33.33-2.67.67-4 1-3.37.45-6.7 1.12-10 2-4.24-.49-8.41-1.15-12.5-2-.67-25-.67-50 0-75 2.43-3.93 5.6-6.93 9.5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e70e9",
    d: "M4930.5 3569.5c3.27 3.22 4.94 7.22 5 12a38.42 38.42 0 0 1 2 12c-1.7-8.14-4.03-16.14-7-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ecae5e",
    d: "M7634.5 3574.5c-4.16.6-8.33 1.6-12.5 3-1.33-.67-2.67-1.33-4-2-13.5 1.19-27.33 1.19-41.5 0h32c4.5-1.31 9-1.31 13.5 0 3.29-1.53 6.62-1.87 10-1 1.39-2.34 2.23-2.34 2.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fec483",
    d: "M1667.5 3533.5c1.71 3.36 3.38 6.69 5 10 1.14 27.97 1.31 55.97.5 84l-1.5 1.5c-7.33.67-14.67.67-22 0-.92-.37-1.75-.87-2.5-1.5-.17-19.5-.67-38.84-1.5-58v-12c1.23 23.16 2.56 46.16 4 69 3.75.63 7.58.97 11.5 1 3.9-.01 7.4-.68 10.5-2 1.16-25.5 1.33-51.16.5-77-.1-2.15-.93-3.82-2.5-5-1.52-3.13-2.19-6.47-2-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6b7f2",
    d: "M4309.5 3564.5a53.602 53.602 0 0 0-2 16c-3-.67-6-1.33-9-2-.81-1.23-1.81-2.23-3-3 3.71.81 7.38 1.81 11 3-.32-4.05.01-8.05 1-12 .68-.74 1.35-1.41 2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#724fe4",
    d: "M4345.5 3574.5c.69 29.86 1.36 59.86 2 90-.72-.42-1.22-1.08-1.5-2-.5-29.33-.67-58.66-.5-88Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe3c3",
    d: "M1177.5 3564.5c3.7 9.17 7.04 18.5 10 28-1.37-.36-2.37-1.19-3-2.5-3.66-8.15-6-16.65-7-25.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb057",
    d: "M1951.5 3565.5c4.06 4.13 6.56 9.13 7.5 15 .56.52 1.23.86 2 1 2.73-3.89 5.23-7.89 7.5-12-1.4 3.2-2.4 6.54-3 10-1.54 2.23-3.04 4.56-4.5 7-.41-.46-.91-.79-1.5-1-2.67-6.73-5.34-13.4-8-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d6fea",
    d: "M4717.5 3575.5c1.52.01 2.68.68 3.5 2 .7 2.08 1.86 3.75 3.5 5v2c-1 .09-1.83-.25-2.5-1-.85-3.09-2.35-5.76-4.5-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#69659d",
    d: "M7132.5 3580.5c3.37 2.99 6.53 6.33 9.5 10 .33 1 .67 2 1 3 3.61 1.44 6.44 3.78 8.5 7-6.55-2.55-11.55-6.89-15-13-1.31-2.32-2.64-4.65-4-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7652e5",
    d: "M4311.5 3561.5a70.921 70.921 0 0 0-3 21c-1.97-.24-3.8.09-5.5 1-1.71-1.54-3.21-3.2-4.5-5 3 .67 6 1.33 9 2-.14-5.45.53-10.78 2-16 .67-1 1.33-2 2-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46e6c",
    d: "M5911.5 3561.5c1.29.56 2.12 1.56 2.5 3 .44 2.37.94 4.7 1.5 7 3.08 13.33 3.75 26.66 2 40 .17-9.01 0-18.01-.5-27-2.05-7.63-3.88-15.3-5.5-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffaf54",
    d: "M1786.5 3548.5c.62.11 1.12.44 1.5 1 .82 6.61 2.48 12.95 5 19 .1-2.15.93-3.82 2.5-5-.17 6.67 0 13.34.5 20 .21 1.56.71 2.89 1.5 4 .31 5.59 1.97 10.59 5 15 1.38 3.83 3.22 7.5 5.5 11 3.63 3.03 6.79 6.36 9.5 10-4.88-3.37-9.38-7.37-13.5-12a29.404 29.404 0 0 0-6-11c-1.88-7.26-3.55-14.59-5-22-1.38 7.8-3.38 15.47-6 23-1.7 3.02-3.37 6.02-5 9-2.7 2.54-5.2 5.2-7.5 8 .97-1.98 1.97-3.98 3-6 .67-2 1.33-4 2-6 1.32.17 2.49-.16 3.5-1 3.17-5.34 5-11.01 5.5-17 .8-1.45 1.3-3.12 1.5-5 .67-7 .67-14 0-21-2.07-4.38-3.24-9.04-3.5-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3c8f6",
    d: "M4698.5 3572.5v1c-4.33.89-7.67 3.22-10 7-1.33 12.48-2 25.32-2 38.5 0 13 .33 25.84 1 38.5.47 1.41 1.47 2.07 3 2v1c-1.97.24-3.8-.09-5.5-1-.67-26-.67-52 0-78 3.07-5.16 7.57-8.16 13.5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9276eb",
    d: "M4688.5 3580.5c-.99 25.59-1.32 51.26-1 77-.67-12.66-1-25.5-1-38.5 0-13.18.67-26.02 2-38.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa5a4",
    d: "M5963.5 3577.5c1.96 1.46 3.8 3.13 5.5 5a81.57 81.57 0 0 0 5.5 9c-5.16-3.49-8.83-8.16-11-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdbb3",
    d: "M1572.5 3562.5c1.51 3.89 2.17 8.06 2 12.5-.02 3.09-.36 6.09-1 9-25.5.17-50.84.67-76 1.5-1.3 2.19-1.3 4.53 0 7 1.23.84 2.23 1.84 3 3 2.28 3.29 4.61 6.63 7 10-2.87-1.03-5.37-2.69-7.5-5-1.17-3-2.83-5.67-5-8-3.04-6.3-1.04-9.63 6-10 24.83.94 48.99.94 72.5 0 .11-6.7-.22-13.36-1-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#734ee4",
    d: "M4698.5 3573.5c-3.9 2.07-7.07 5.07-9.5 9-.67 25-.67 50 0 75 4.09.85 8.26 1.51 12.5 2 3.3-.88 6.63-1.55 10-2-6.6 4.47-13.6 5.13-21 2-1.53.07-2.53-.59-3-2-.32-25.74.01-51.41 1-77 2.33-3.78 5.67-6.11 10-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6817f",
    d: "M6396.5 3560.5c2.92 3.5 5.75 7.16 8.5 11 1.99 5.98 3.99 11.98 6 18 .67 6.33.67 12.67 0 19a218.19 218.19 0 0 1-6 18c-.71.88-1.54 1.55-2.5 2 .06-1.11.39-2.11 1-3 1.29-3.14 2.29-6.48 3-10 2.32-5.13 3.32-10.63 3-16.5.32-5.87-.68-11.37-3-16.5-2.91-7.56-6.24-14.89-10-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7a7c2",
    d: "M7422.5 3577.5c-.98 1.31-1.98 2.65-3 4-3.43 1.39-6.77 2.73-10 4h-10c-6.19.32-12.19-.01-18-1 9.69-.04 19.35-.54 29-1.5 4.14-1.65 8.14-3.48 12-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fec580",
    d: "M1572.5 3556.5c1.3 1.87 2.3 3.87 3 6v22c-.89.61-1.89.94-3 1h-75c25.16-.83 50.5-1.33 76-1.5.64-2.91.98-5.91 1-9 .17-4.44-.49-8.61-2-12.5v-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#805ee7",
    d: "M4778.5 3574.5c3.61 6.06 4.94 12.72 4 20h-1c.29-2.24-.04-4.24-1-6v-1c-.51-4.36-1.17-8.69-2-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fed9b0",
    d: "M1928.5 3572.5c1.29.79 2.46 1.79 3.5 3 3.46 8.23 6.3 16.56 8.5 25-4.37-9.11-8.37-18.44-12-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a58dee",
    d: "M4252.5 3572.5c-2.2 1.61-3.53 3.78-4 6.5.17 1.17.33 2.33.5 3.5 1.52.66 2.69 1.66 3.5 3 .33.67.67 1.33 1 2h-1c-1.33-1-2.67-2-4-3-1.25-3.29-1.25-6.63 0-10 1.12-1.13 2.46-1.8 4-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c4b4f1",
    d: "M4347.5 3584.5c.83 24.83 1.33 49.83 1.5 75 .18 2.86.68 5.53 1.5 8 .18 2.72.68 5.38 1.5 8 3.72 5.47 7.88 10.47 12.5 15-2-1.33-4-2.67-6-4-1.51-3.52-3.84-6.35-7-8.5a44.2 44.2 0 0 1-3-13.5c-.96-26.64-1.3-53.31-1-80Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fea43c",
    d: "M1497.5 3585.5h75c-23.82 1.38-47.82 2.21-72 2.5l-2 2c1.36 1.58 2.03 3.42 2 5.5-.77-1.16-1.77-2.16-3-3-1.3-2.47-1.3-4.81 0-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#744fe5",
    d: "M4252.5 3585.5c5.63 2.1 11.3 4.27 17 6.5 1.26.42 1.92 1.25 2 2.5h-2c-4.41-1.23-8.74-2.73-13-4.5-1.07-.85-2.07-1.69-3-2.5-.33-.67-.67-1.33-1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6037e1",
    d: "M4402.5 3647.5c-1-24.49-1.33-49.16-1-74 9.4.64 18.4-.03 27-2h1c1.57-4.77 2.74-9.77 3.5-15 .32-6.18.82-12.35 1.5-18.5-.33-1.17-.67-2.33-1-3.5-10.61-.98-21.28-1.31-32-1 .33-14.84 0-29.51-1-44-4.87-1.25-9.87-1.25-15 0 .11-.62.44-1.12 1-1.5 3.85-.35 7.69-.85 11.5-1.5 1.23.14 2.39.48 3.5 1 1 14.99 1.33 29.99 1 45 11.34-.17 22.67 0 34 .5.58.89.91 1.89 1 3-2.72 5.84-3.39 11.84-2 18a92.4 92.4 0 0 0-4.5 20.5c-1 .67-2 1.33-3 2-8.42-.16-16.59-.49-24.5-1-1 23.99-1.33 47.99-1 72Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f35753",
    d: "M6102.5 3580.5a62.16 62.16 0 0 1 12 10c2.35 1.75 3.35 4.08 3 7-1.97-2.64-4.31-4.97-7-7-2.98-2.99-5.64-6.32-8-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0171bc",
    d: "M2798.5 3493.5c4.25.86 8.58 2.19 13 4-4.5-.58-9-1.25-13.5-2-2.28.06-4.11.9-5.5 2.5.83 4.81 2.16 9.48 4 14l-1 1c4.31 15.28 11.97 28.61 23 40 4.02 1.35 6.69 4.02 8 8 7.46 3.12 14.12 7.46 20 13 2 .33 4 .67 6 1 27.37 12.35 55.54 18.85 84.5 19.5.39-.93 1.05-1.59 2-2 10.8.48 21.14.48 31 0 1.32-1.38 2.66-1.71 4-1 11.73-3.24 23.39-6.91 35-11 1.47.83 2.97 1 4.5.5 5.01-2.5 9.67-5.5 14-9 1.94-.81 3.94-1.31 6-1.5-.78 1.95-2.12 3.45-4 4.5-5 2.33-10 4.67-15 7-14.84 3.46-29 7.63-42.5 12.5-3.02-.91-6.35-.57-10 1-1.82-.74-3.82-1.07-6-1-1 .67-2 1.33-3 2-1.43-.19-2.93-.19-4.5 0a7.239 7.239 0 0 1-2.5-2c-6.13 1.25-12.3 1.25-18.5 0-1.7 1.8-3.54 2.47-5.5 2l-15-3c-3.21.77-6.71.94-10.5.5a11.154 11.154 0 0 0-5.5-3.5c-2.61 1.17-5.28.51-8-2-5.63.13-10.8-1.7-15.5-5.5-12.64-3.21-24.3-8.55-35-16-15.08-9.58-26.41-22.41-34-38.5-1.86-6.79-4.03-13.46-6.5-20-.5-4.65-.67-9.32-.5-14 2.36-.17 4.69-.51 7-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323030",
    d: "M10062.5 3590.5c21.8-3.03 37.3 5.3 46.5 25 1.1 3.59 1.6 7.25 1.5 11h-78c2.5-18.3 12.5-30.3 30-36ZM10731.5 3590.5c21.8-3.03 37.3 5.3 46.5 25 1.1 3.59 1.6 7.25 1.5 11h-78c2.5-18.3 12.5-30.3 30-36Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fed9af",
    d: "M1996.5 3564.5c-1.14 4.09-2.48 8.09-4 12-2.33 5.33-4.67 10.67-7 16h-1c2.64-6.09 4.81-12.42 6.5-19 1.86-3.06 3.69-6.06 5.5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9a9a8",
    d: "M5915.5 3571.5c1.67 2.7 2.84 5.7 3.5 9 2.25 20.43.08 40.26-6.5 59.5-.34 1.03-1 1.53-2 1.5 1.07-4.19 2.57-8.19 4.5-12 .43-5.08 1.26-10.08 2.5-15v-3c1.75-13.34 1.08-26.67-2-40Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd9ad",
    d: "M1761.5 3555.5c5.43 5.46 7.43 12.13 6 20-.17 4-.33 8-.5 12-.94 3.1-2.77 5.43-5.5 7v-2c2.01-2.17 3.18-4.83 3.5-8 1.41-10.08.24-19.74-3.5-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f57170",
    d: "M5729.5 3552.5a75.68 75.68 0 0 1-4.5 11c-2.27 7.58-4.27 15.25-6 23-.73 10.03-.56 20.03.5 30-.72-.42-1.22-1.08-1.5-2-.67-11.33-.67-22.67 0-34 2.07-4.87 3.57-9.87 4.5-15 1.38-3.41 2.71-6.74 4-10 1.23-.81 2.23-1.81 3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f26060",
    d: "M5755.5 3582.5a82.835 82.835 0 0 0-1.5 26c.9 3.22 2.07 6.22 3.5 9v5c-1.77-3.8-3.27-7.8-4.5-12-.67-7.33-.67-14.67 0-22 .57-2.22 1.4-4.22 2.5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbc5c4",
    d: "M6438.5 3557.5c2.66 2.77 4.5 6.1 5.5 10 4.82 20.55 4.66 40.88-.5 61 2.19-10.17 3.19-20.5 3-31-.17-5-.33-10-.5-15-.55-2.88-1.38-5.55-2.5-8-2.66-5.31-4.32-10.98-5-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323030",
    d: "M9013.5 3591.5c28.14-.68 45.31 12.65 51.5 40 2.33 21.38-5.17 38.22-22.5 50.5-24.54 11.03-44.37 5.53-59.5-16.5-9.96-20.74-8.29-40.41 5-59 7.27-7.22 15.77-12.22 25.5-15ZM9180.5 3591.5c28.14-.68 45.31 12.65 51.5 40 2.33 21.38-5.17 38.22-22.5 50.5-24.54 11.03-44.37 5.53-59.5-16.5-9.96-20.74-8.29-40.41 5-59 7.27-7.22 15.77-12.22 25.5-15ZM9396.5 3591.5c26.95-.77 43.79 11.89 50.5 38 2.68 19.63-3.15 36.13-17.5 49.5-20.94 12.85-40.44 11.02-58.5-5.5-15.4-20.68-16.4-42.01-3-64 7.45-9.46 16.95-15.46 28.5-18ZM11136.5 3591.5c25.9-.64 42.7 11.36 50.5 36 3.5 20.49-2.3 37.65-17.5 51.5-18.8 11.84-37.1 11.18-55-2-14.2-14.47-19-31.63-14.5-51.5 6.3-17.83 18.5-29.16 36.5-34ZM11298.5 3591.5c28.1-.68 45.3 12.65 51.5 40 2.3 21.38-5.2 38.22-22.5 50.5-24.5 11.03-44.4 5.53-59.5-16.5-10-20.74-8.3-40.41 5-59 7.3-7.22 15.8-12.22 25.5-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe9c2a",
    d: "M1610.5 3526.5c-1.22 2.85-3.22 3.52-6 2v-5c-.01-1.52-.68-2.68-2-3.5-7-.67-14-.67-21 0l-1.5 1.5c-.67 35-.67 70 0 105 .31 1.27.81 2.43 1.5 3.5 8.33.5 16.66.67 25 .5-8.49 1.16-17.16 1.32-26 .5l-1.5-1.5c-.33-15.33-.67-30.67-1-46-.67.75-1.5 1.09-2.5 1v-22c1.37 4.77 2.2 9.77 2.5 15 .33-19 .67-38 1-57l1.5-1.5c7.67-.67 15.33-.67 23 0 1.67 2.15 2.67 4.65 3 7.5 1.2.79 2.53.79 4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb560",
    d: "M1829.5 3552.5c-2.35 3.04-4.35 6.38-6 10a81.462 81.462 0 0 0-.5 22c2.74 5.73 5.58 11.4 8.5 17-2.97-3.14-5.8-6.48-8.5-10-2.96-9.86-3.29-19.86-1-30 1.61-3.77 4.11-6.77 7.5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f6a9e",
    d: "M2835.5 3586.5c1.37-.16 2.71.01 4 .5 6.72 3.99 13.39 7.82 20 11.5-2.76-1.42-5.76-2.09-9-2a66.176 66.176 0 0 1-15-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fabcbc",
    d: "M6244.5 3588.5c-.65 14.32.85 28.32 4.5 42 .38 1.44 1.21 2.44 2.5 3v3c-1.13-.97-2.13-2.14-3-3.5-4.61-14.61-5.95-29.45-4-44.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9cff6",
    d: "M4252.5 3587.5h1c.93.81 1.93 1.65 3 2.5 4.26 1.77 8.59 3.27 13 4.5.6 1.4 1.6 2.4 3 3-6.67-1.61-13-4.11-19-7.5-.75-.67-1.09-1.5-1-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9275ea",
    d: "M4800.5 3575.5c-.7 5.07-1.7 10.07-3 15-.9.71-1.24 1.71-1 3-.67 1-1.33 2-2 3v-2c.61-3.97 1.11-7.97 1.5-12 1.35-2.61 2.85-4.94 4.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46f6e",
    d: "M5881.5 3585.5c.62.11 1.12.44 1.5 1 2.24 14.56.07 28.22-6.5 41 .19-2.83.86-5.5 2-8 .66-4.07 1.83-8.07 3.5-12 .64-7.36.47-14.69-.5-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f88d8b",
    d: "M6198.5 3579.5c-2.08 4.91-5.41 8.74-10 11.5-2.79 5.12-6.62 9.29-11.5 12.5-.67 1.67-.67 3.33 0 5 2.15 1.48 3.48 3.48 4 6 3.81 1.97 6.31 4.97 7.5 9-2.28-.26-3.44-1.59-3.5-4-7.09-3.86-10.09-9.53-9-17 7.06-8.13 14.56-15.79 22.5-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46e6d",
    d: "M6284.5 3577.5v3c-1.28 2.06-2.11 4.4-2.5 7-.67 7-.67 14 0 21a356.98 356.98 0 0 0 5.5 20c-3.06-5.54-5.23-11.54-6.5-18-.67-8.33-.67-16.67 0-25 .7-2.98 1.87-5.64 3.5-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fabbbb",
    d: "M6284.5 3580.5c-1.81 8.54-2.31 17.21-1.5 26 2.62 8.34 5.12 16.68 7.5 25-.77-1.19-1.77-2.19-3-3a356.98 356.98 0 0 1-5.5-20c-.67-7-.67-14 0-21 .39-2.6 1.22-4.94 2.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a993ed",
    d: "M4269.5 3594.5h2c3.81 1.3 7.48 2.97 11 5-3.33-.67-6.67-1.33-10-2-1.4-.6-2.4-1.6-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f36b69",
    d: "M6249.5 3568.5c.44 4.91-.4 9.58-2.5 14-1.76 17.37-.26 34.37 4.5 51-1.29-.56-2.12-1.56-2.5-3-3.65-13.68-5.15-27.68-4.5-42v-1c1.93-6.21 3.59-12.54 5-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbcbc",
    d: "M6406.5 3582.5c2.32 5.13 3.32 10.63 3 16.5.32 5.87-.68 11.37-3 16.5-.09-6.29.58-12.46 2-18.5a78.737 78.737 0 0 1-2-14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdab1",
    d: "M1312.5 3497.5h2a664.35 664.35 0 0 1 .5 63c-.97 6.89-3.3 13.23-7 19-1.17 1.39-2.67 2.23-4.5 2.5-9.94 13.67-23.44 21.17-40.5 22.5-18.92-1.46-34.25-9.46-46-24-1.13-3.81-3.13-7.14-6-10-.33-3-.67-6-1-9-3.33-7.67-3.33-15.33 0-23 .33-3.33.67-6.67 1-10 .38-.56.88-.89 1.5-1-1.02 7.44-1.69 14.94-2 22.5-.13 4.76.53 9.26 2 13.5.02 2.43.52 4.76 1.5 7 2.73 2.79 4.39 6.12 5 10 3.63 2.68 6.8 5.68 9.5 9 5.07 4.71 11.07 7.71 18 9 8.17 2.03 16.5 2.53 25 1.5 24.08-5.57 37.75-20.41 41-44.5a422.05 422.05 0 0 0 0-58Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb054",
    d: "M1228.5 3589.5c1.37-.16 2.71.01 4 .5a43.01 43.01 0 0 0 6 5c3.29 0 5.96 1.17 8 3.5-6.93-1.29-12.93-4.29-18-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fccc96",
    d: "M1604.5 3523.5v5c-.79-1.11-1.29-2.44-1.5-4a9.186 9.186 0 0 0-2.5-1.5c-6.25-.81-12.42-.64-18.5.5-.67 33.67-.67 67.33 0 101 .37.92.87 1.75 1.5 2.5 6.85.82 13.51.65 20-.5.67 0 1-.33 1-1 .67-18.67 1.33-37.33 2-56 .33 19.34 0 38.68-1 58a91.688 91.688 0 0 1-23 .5 9.186 9.186 0 0 1-1.5-2.5c-.67-34.33-.67-68.67 0-103 7.09-1.15 14.25-1.31 21.5-.5.54.72 1.21 1.22 2 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6ccf6",
    d: "M4200.5 3565.5c-.67 6.58-1.34 12.58-2 18 1.05 4.28 1.88 8.61 2.5 13 2.14 3.94 3.97 7.94 5.5 12-4.6-4.2-7.43-9.53-8.5-16-.67-7-.67-14 0-21 .84-2.11 1.68-4.11 2.5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e5de7",
    d: "M4556.5 3535.5c-.33 53.5 0 106.84 1 160v2c17.16 1 34.49 1.33 52 1-8.66.67-17.49 1-26.5 1-9.23-.01-18.23-.68-27-2-.83-54.17-.67-108.17.5-162Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab3b2",
    d: "M5761.5 3570.5c-.43 4.12-1.93 7.78-4.5 11-2.02 12.03-1.85 24.03.5 36-1.43-2.78-2.6-5.78-3.5-9-.87-8.76-.37-17.43 1.5-26-.29-1.79.05-3.45 1-5 1.85-2.27 3.52-4.6 5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd19c",
    d: "M1338.5 3589.5c-1.68 6.35-4.68 12.02-9 17a94.753 94.753 0 0 0-13 10c4.02-4.87 8.36-9.54 13-14 2.12-4.91 5.12-9.24 9-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e8fb5",
    d: "M3064.5 3565.5c-3.1 4.9-6.77 9.4-11 13.5a80.646 80.646 0 0 0-12 9 313.101 313.101 0 0 1-30 15c-4.37.74-8.7 1.57-13 2.5 12.2-5.67 24.53-11.17 37-16.5 10.37-6.87 20.03-14.7 29-23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46663",
    d: "M6053.5 3574.5c-2.08 3.84-4.42 7.5-7 11-6.24 4.18-10.24 9.85-12 17-2.36-1.82-2.69-4.15-1-7 7.04-5.55 12.88-12.21 17.5-20 .67-.75 1.5-1.09 2.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7552e5",
    d: "M4794.5 3594.5v2c-1.31 15-1.31 30 0 45-.79-1.11-1.29-2.44-1.5-4a418.41 418.41 0 0 1 0-41c.28-.92.78-1.58 1.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9174ea",
    d: "M4858.5 3569.5c-2.78 4.16-5.28 8.5-7.5 13-2.01 5.42-2.85 11.08-2.5 17h37c-.14-7.51-1.14-14.85-3-22h1c2.56 7.43 3.56 15.1 3 23h-39c-.4-6.17.27-12.17 2-18 1.96-2.69 3.46-5.69 4.5-9 1.31-1.69 2.81-3.03 4.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fccbcb",
    d: "M5974.5 3591.5c3 2.33 5.67 5 8 8 .15 1.05-.02 2.05-.5 3a83.723 83.723 0 0 0-7.5 8c1.25-3.24 2.91-6.24 5-9-1.68-3.35-3.34-6.68-5-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6a742",
    d: "M7670.5 3616.5c.4-13.29.74-26.63 1-40-2.24.29-4.24-.04-6-1 4.33-2.16 7-.82 8 4 .09 11.18-.08 22.51-.5 34-.24 1.62-1.07 2.62-2.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fea033",
    d: "M1378.5 3520.5c-7.19-.32-14.19.01-21 1-2 49.32-2.66 98.99-2 149-1-50.16-1.33-100.5-1-151 8.18-.33 16.18.01 24 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a188eb",
    d: "M4282.5 3599.5c4.64 1.65 9.31 3.32 14 5 1.68.37 2.68 1.37 3 3a66.112 66.112 0 0 1-17-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5cbf7",
    d: "M4883.5 3577.5c1.9 1.77 3.06 4.1 3.5 7 .3 4.61 1.14 9.11 2.5 13.5-.14 1.23-.48 2.39-1 3.5-14 1.33-28 1.33-42 0-.21-.59-.54-1.09-1-1.5.81-5.08 1.31-10.25 1.5-15.5.71-.88 1.54-1.55 2.5-2-1.73 5.83-2.4 11.83-2 18h39c.56-7.9-.44-15.57-3-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8380a3",
    d: "M7486.5 3592.5c-.43 5.88-3.09 10.21-8 13 1.93-4.83 4.6-9.16 8-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c6de9",
    d: "M4203.5 3556.5c-1.45 2.8-2.45 5.8-3 9-.82 1.89-1.66 3.89-2.5 6-.67 7-.67 14 0 21 1.07 6.47 3.9 11.8 8.5 16 .06 1.11.39 2.11 1 3-2.59-.75-4.42-2.42-5.5-5-6.11-10.54-8.11-21.88-6-34 1.97-3.7 2.97-7.7 3-12 1.37-1.54 2.87-2.87 4.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcbebd",
    d: "M5872.5 3566.5c4.84 5.35 7.84 11.68 9 19 .97 7.31 1.14 14.64.5 22-1.67 3.93-2.84 7.93-3.5 12 1.61-9.5 2.11-19.17 1.5-29-.77-3.65-1.44-7.31-2-11a98.12 98.12 0 0 1-5-9 8.394 8.394 0 0 1-.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#908fb3",
    d: "M7151.5 3600.5c9.18 4.25 18.52 7.92 28 11-10.63-1.11-19.96-4.78-28-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffab4b",
    d: "M1437.5 3590.5v2c-.84.34-1.17 1.01-1 2a49.793 49.793 0 0 0-11 9.5c-8.23 2.87-16.56 3.2-25 1-3.54-3.05-7.21-5.88-11-8.5v-2c10.88 9.23 23.22 11.4 37 6.5 3.78-3.52 7.45-7.02 11-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46d6c",
    d: "M5982.5 3599.5c1.1 1.1 1.26 2.43.5 4-6.64 6.62-12.8 13.62-18.5 21 3.03-3.71 5.7-7.71 8-12 .33-1 1-1.67 2-2 2.27-2.77 4.77-5.44 7.5-8 .48-.95.65-1.95.5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#acb7cd",
    d: "M2850.5 3596.5c3.24-.09 6.24.58 9 2 6.11 3.12 12.45 5.78 19 8-9.99-1.67-19.32-5-28-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fedeb9",
    d: "M1436.5 3594.5c-1.32 3.83-3.65 7-7 9.5-10.04 5.1-20.38 5.77-31 2-3.28-3.11-6.28-6.28-9-9.5 3.79 2.62 7.46 5.45 11 8.5 8.44 2.2 16.77 1.87 25-1 3.22-3.72 6.89-6.89 11-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fec582",
    d: "M1761.5 3592.5v2c-3.98 6-9.31 10-16 12-7.52 1.56-14.86.89-22-2-.36-.68-.7-1.35-1-2 15.95 6.84 28.95 3.51 39-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdeb9",
    d: "M1862.5 3546.5c-10.22-4.18-20.22-3.68-30 1.5-1.64 1.13-2.64 2.63-3 4.5-3.39 2.23-5.89 5.23-7.5 9-2.29 10.14-1.96 20.14 1 30 2.7 3.52 5.53 6.86 8.5 10 1.9.3 3.57.96 5 2 3.52 2.41 7.52 3.41 12 3 4.78.37 9.11-.63 13-3 3.23-1.72 6.06-4.05 8.5-7 6.05-9.42 8.21-19.75 6.5-31 6.41 21.23-.93 35.4-22 42.5-22.95 1.06-35.28-9.94-37-33 1.43-15.42 9.1-26.42 23-33 7.09-1.1 13.92-.26 20.5 2.5 1.03.34 1.53 1 1.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#febb6c",
    d: "M1836.5 3603.5c3.95.87 7.95 1.54 12 2 4.38-.41 8.72-1.08 13-2-3.89 2.37-8.22 3.37-13 3-4.48.41-8.48-.59-12-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbdbc",
    d: "M6110.5 3590.5c2.69 2.03 5.03 4.36 7 7 2 1.8 3.66 3.8 5 6 .72 1.64.88 3.3.5 5a160.29 160.29 0 0 0-9.5 12c-4.35 4.02-8.69 8.02-13 12 2.28-2.8 4.45-5.8 6.5-9a61.13 61.13 0 0 0 14.5-17.5c-2.47-4.8-5.97-8.64-10.5-11.5a8.394 8.394 0 0 1-.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffc786",
    d: "M1563.5 3618.5c2.01-2.02 3.67-4.35 5-7-.99-3.49-3.33-5.32-7-5.5-1.03-2.92-2.86-5.08-5.5-6.5-2.15 1.98-4.65 3.31-7.5 4 1.31-2.65 3.31-4.65 6-6 6.98 2.65 11.98 7.32 15 14-.54 3.54-2.54 5.88-6 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe5c7",
    d: "M1711.5 3591.5c1 .67 2 1.33 3 2 2.67 3 5.33 6 8 9 .3.65.64 1.32 1 2 7.14 2.89 14.48 3.56 22 2-.11.62-.44 1.12-1 1.5-7.6 1.17-14.94.34-22-2.5-3.71-3.08-7.21-6.42-10.5-10a8.394 8.394 0 0 1-.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa4a3",
    d: "M6038.5 3604.5c.98 1.81 2.48 3.14 4.5 4 .79 1.24 1.29 2.58 1.5 4-1 .09-1.83-.25-2.5-1-1.88-2.03-3.05-4.36-3.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#febc70",
    d: "M1476.5 3604.5c1 .67 2 1.33 3 2 .88 2.89 2.22 5.55 4 8-3.78-2.33-6.11-5.67-7-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd5a5",
    d: "M1548.5 3603.5c-4.07 2.53-8.4 4.7-13 6.5-6.33.67-12.67.67-19 0-2.05-.42-3.38-1.58-4-3.5 7.9 1.83 15.9 2.33 24 1.5 3.51-2.68 7.51-4.18 12-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d9fbf",
    d: "M2998.5 3605.5c-6.78 2.47-13.78 4.3-21 5.5-2.98.5-5.98.66-9 .5v-1c10.02-1.37 20.02-3.04 30-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bbabf1",
    d: "M4608.5 3535.5h-46c-1.44.25-2.94.59-4.5 1-.5 52.33-.67 104.67-.5 157v2c-1-53.16-1.33-106.5-1-160 17.43-1.32 34.76-1.32 52 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#febb6e",
    d: "M1984.5 3592.5h1a175.277 175.277 0 0 1-15 32v-4c5.18-9.03 9.85-18.37 14-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#436198",
    d: "M2859.5 3598.5c3.16-.54 5.83.3 8 2.5 6.65 1.13 12.99 3.13 19 6a57.75 57.75 0 0 1 17 3c10.91.18 21.74.68 32.5 1.5 10.75-.99 21.59-1.32 32.5-1v1a469.685 469.685 0 0 1-67-.5c-7.32-1.66-14.65-3.16-22-4.5h-1c-6.55-2.22-12.89-4.88-19-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe9cf",
    d: "M1357.5 3521.5c6.67-.17 13.34 0 20 .5.56.38.89.88 1 1.5h-19c-.79 46.89-1.12 93.56-1 140 .18 1.05.51 2.05 1 3 6.97 1 13.97 1.33 21 1 .27-16.46-.06-32.63-1-48.5 1.67-1.84 3.67-2.51 6-2 4.89 4.27 10.22 7.77 16 10.5-6.02-1.06-11.02-3.89-15-8.5-1.61-.72-3.11-.55-4.5.5-.5 15.66-.67 31.33-.5 47-.68 1.68-2.02 2.34-4 2-6.61.21-13.11.21-19.5 0-.5-48.67-.67-97.33-.5-146v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#97a7c3",
    d: "M2879.5 3606.5c7.35 1.34 14.68 2.84 22 4.5 22.32 1.76 44.66 1.93 67 .5-14.35 2.91-29.01 3.75-44 2.5-8.63-1.09-17.3-1.75-26-2-4.53-1.62-9.2-2.62-14-3-1.99-.37-3.66-1.21-5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe1c0",
    d: "M1187.5 3592.5c3.19 1.12 4.86 3.45 5 7 1.76.63 3.26 1.63 4.5 3 3.14 3.81 6.3 7.64 9.5 11.5 4.14 2.31 7.8 5.15 11 8.5-3.75-2.4-7.75-4.4-12-6-2.85-2.01-5.02-4.67-6.5-8-5.62-4.11-9.46-9.45-11.5-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8768e9",
    d: "M4726.5 3592.5c2.67 13.67 2.67 27.33 0 41v-41Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f35d5b",
    d: "M6122.5 3603.5c2.82 1.29 3.49 3.29 2 6a85.31 85.31 0 0 1-11 11c2.97-4.14 6.13-8.14 9.5-12 .38-1.7.22-3.36-.5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#67639c",
    d: "M7477.5 3607.5c-3.24 5.23-7.91 8.57-14 10-2.25.96-4.58 1.62-7 2 4.17-3.06 8.83-5.22 14-6.5 1.32-3.16 3.65-4.99 7-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cccccd",
    d: "M9609.5 3607.5c1 33.16 1.33 66.5 1 100-7.85.33-15.52-.01-23-1h22v-99Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3b2f2",
    d: "M4207.5 3611.5c2.91.29 4.91 1.79 6 4.5 4.88 2.27 9.22 5.27 13 9 12.11 4.03 24.11 8.36 36 13 2.26 1.62 4.26 3.45 6 5.5-1.11-.06-2.11-.39-3-1-3.84-2.98-8.17-4.98-13-6-5.14-2.63-10.48-4.96-16-7a52.852 52.852 0 0 1-16-6.5 32.701 32.701 0 0 0-10-6.5c-1.26-1.53-2.26-3.2-3-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfd7f8",
    d: "M4797.5 3590.5c-1.37 11.66-2.03 23.16-2 34.5 1.4 5.76 2.06 11.93 2 18.5-3.57-16.46-3.9-33.13-1-50-.24-1.29.1-2.29 1-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ecad59",
    d: "M7670.5 3616.5c-31.5 1-63.16 1.33-95 1 14.4-.67 28.9-1.34 43.5-2 17.09.99 34.26 1.33 51.5 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6a3be",
    d: "M7772.5 3705.5v-86c.26-1.48-.07-2.81-1-4-.33.17-.67.33-1 .5-4.32 6.83-8.99 13.33-14 19.5-.16-1.37.01-2.71.5-4 4.18-5.61 8.18-11.27 12-17 1.11-1.21 2.28-1.21 3.5 0 1.33 30.5 1.33 60.83 0 91Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9479ea",
    d: "M4426.5 3571.5h2c-8.6 1.97-17.6 2.64-27 2-.33 24.84 0 49.51 1 74v2c-.62-.11-1.12-.44-1.5-1-.5-25.33-.67-50.66-.5-76 8.85.33 17.52-.01 26-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8c79d",
    d: "M7670.5 3658.5c-24.1.95-47.77 1.62-71 2-1.03-.75-2.2-1.42-3.5-2-3.08.65-6.25.98-9.5 1-4.2.22-8.2-.45-12-2a208.628 208.628 0 0 1-.5-35c.35-1.75.85-3.41 1.5-5 31.84.33 63.5 0 95-1 1.43-.38 2.26-1.38 2.5-3 .42-11.49.59-22.82.5-34-1-4.82-3.67-6.16-8-4-3.93-.14-7.43-.47-10.5-1-5.48 1.01-10.82 1.68-16 2-1.3-.58-2.47-1.25-3.5-2 2.47-.1 4.97-.1 7.5 0 3.57-1.37 7.24-2.37 11-3 5.15.81 10.15.81 15 0 1.89.63 3.56 1.63 5 3 .67 14 .67 28 0 42l-1.5 1.5c-9.58.18-19.08.68-28.5 1.5-21.87-.55-44.03-.89-66.5-1-.59.21-1.09.54-1.5 1-.83 12.35-.67 24.68.5 37 31.28 1.41 62.62 2.08 94 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab6b5",
    d: "M5722.5 3565.5a70.291 70.291 0 0 1-4.5 15c-.67 11.33-.67 22.67 0 34 .28.92.78 1.58 1.5 2a65 65 0 0 0 4 17c-2.32-2.63-4.16-5.63-5.5-9-2.59-19.25-1.92-38.25 2-57 .71-.88 1.54-1.55 2.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#35327f",
    d: "M7772.5 3619.5c-1 27.83-1.33 55.83-1 84-16.92.8-36.26.8-58 0 .3-26.99-.04-53.99-1-81 6.18-2.23 12.51-2.57 19-1 .83 12.32 1.33 24.65 1.5 37 .87 2.28 2.54 3.61 5 4 1.75-.25 2.58-1.25 2.5-3 5.75-7.75 11.08-15.75 16-24 5.01-6.17 9.68-12.67 14-19.5.33-.17.67-.33 1-.5.93 1.19 1.26 2.52 1 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdc98e",
    d: "M1401.5 3627.5c1.99 1.66 4.32 2.83 7 3.5 5.69.63 11.36.46 17-.5-.42.72-1.08 1.22-2 1.5-14.11 2.23-26.45-1.27-37-10.5-.75-1.97-1.92-2.3-3.5-1-.17 15.51-.67 30.84-1.5 46-.17-15.67 0-31.34.5-47 1.39-1.05 2.89-1.22 4.5-.5 3.98 4.61 8.98 7.44 15 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feb867",
    d: "M1453.5 3609.5h2c-3.45 8.39-9.45 14.05-18 17 2.52-1.76 4.85-3.76 7-6 4.65-2.29 7.65-5.96 9-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5caf5",
    d: "M4724.5 3582.5c1.64 1.25 2.8 2.92 3.5 5 .45 8.39 1.29 16.72 2.5 25-.88 8.99-1.71 17.99-2.5 27-2.36 2.73-4.2 5.73-5.5 9 .17-2.36.51-4.69 1-7 2.15-2.12 3.15-4.78 3-8 2.67-13.67 2.67-27.33 0-41-.06-2.84-.73-5.51-2-8v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab7b6",
    d: "M5972.5 3612.5c-2.3 4.29-4.97 8.29-8 12-1.37 1.67-2.7 3.34-4 5-4.43 3.1-7.77 7.1-10 12-2.33 2-4.67 4-7 6 8.98-11.15 17.81-22.49 26.5-34 .67-.75 1.5-1.09 2.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9090b4",
    d: "M7179.5 3611.5a1456.78 1456.78 0 0 1 50 15.5c3.81 1.38 6.48 3.88 8 7.5-3.18-2.34-6.51-4.5-10-6.5a799.99 799.99 0 0 1-43-13c-1.85-1.03-3.51-2.2-5-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#524f91",
    d: "M7740.5 3659.5c.08 1.75-.75 2.75-2.5 3-2.46-.39-4.13-1.72-5-4-.17-12.35-.67-24.68-1.5-37-6.49-1.57-12.82-1.23-19 1-.09-1 .25-1.83 1-2.5 6.58-.81 13.08-.64 19.5.5.33 12 .67 24 1 36 1.09 4.31 3.25 5.31 6.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fea53d",
    d: "M1713.5 3624.5h-3c.17 15 0 30-.5 45-8.74 2.91-17.58 3.91-26.5 3 1.91.28 3.58-.05 5-1 6.53-1.65 13.2-2.65 20-3v-47c2.43-.23 4.1.77 5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdcb4",
    d: "M1943.5 3606.5c.88 2.23 2.22 4.23 4 6 .47 1.81.81 3.64 1 5.5.18 2.8-.82 4.97-3 6.5a37.2 37.2 0 0 0 1-6 43.487 43.487 0 0 1-3-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#585695",
    d: "M7712.5 3622.5c.96 27.01 1.3 54.01 1 81 21.74.8 41.08.8 58 0l-2 2h-1c-18.34.17-36.67 0-55-.5a6.603 6.603 0 0 1-3-3c.67-6.33 1.33-12.67 2-19-.91-20-.91-40.16 0-60.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feb661",
    d: "M1386.5 3621.5h-3c.32 15.71-.02 31.38-1 47-1.72 1.43-3.72 2.27-6 2.5-4.83.57-9.66 1.07-14.5 1.5-2.3-.05-4.13-.71-5.5-2 1.74.59 3.58.92 5.5 1 5.17-1.29 10.33-2.29 15.5-3 1.98.34 3.32-.32 4-2 .83-15.16 1.33-30.49 1.5-46 1.58-1.3 2.75-.97 3.5 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fedeb8",
    d: "M1560.5 3619.5c-2.38 3.78-5.72 6.11-10 7-3.1.26-6.1.92-9 2-.03-1 .47-1.66 1.5-2 5.59-.72 10.42-2.88 14.5-6.5.95-.48 1.95-.65 3-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c6de9",
    d: "M4299.5 3607.5c1.37-.16 2.71.01 4 .5 16.81 13.79 22.81 31.45 18 53-2.3 5.78-4.97 11.28-8 16.5.2-2.19.87-4.19 2-6 1.58-3.16 2.58-6.49 3-10 1.43-2.24 2.43-4.74 3-7.5.39-6.2-.28-12.37-2-18.5.16-1.7-.01-3.37-.5-5a60.894 60.894 0 0 0-10-15c-3.15-2.8-6.31-5.47-9.5-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4716f",
    d: "M6045.5 3614.5c6.26 5.21 11.6 11.21 16 18-1.63-1.45-3.47-2.78-5.5-4-3.71-4.54-7.21-9.21-10.5-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#514e90",
    d: "M7445.5 3622.5c-3.76 1.33-7.76 2.17-12 2.5-17 .5-34 .67-51 .5 21.17-.51 42.17-1.51 63-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe2c2",
    d: "M1492.5 3620.5c6.55 2.77 13.21 5.27 20 7.5 8.97 1.79 17.97 1.95 27 .5-7.89 2.94-16.22 3.78-25 2.5a64.709 64.709 0 0 0-16-5.5c-2.44-1.21-4.44-2.88-6-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a7979",
    d: "M9808.5 3619.5v88c-8.18.33-16.18-.01-24-1h23c-.33-29.17 0-58.17 1-87ZM10190.5 3619.5v88c-8.2.33-16.2-.01-24-1h23c-.3-29.17 0-58.17 1-87ZM10477.5 3619.5v88c-8.2.33-16.2-.01-24-1h23c-.3-29.17 0-58.17 1-87ZM10958.5 3619.5v88c-8.2.33-16.2-.01-24-1h23c-.3-29.17 0-58.17 1-87Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb765",
    d: "M1329.5 3606.5a135.198 135.198 0 0 1-20 18.5c-3.49.93-6.49 2.59-9 5a84.23 84.23 0 0 1-12 3.5c3.3-2.31 6.96-4.15 11-5.5.88-.71 1.55-1.54 2-2.5 5.13-2.73 10.13-5.73 15-9 4.04-3.71 8.38-7.04 13-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe3c4",
    d: "M1802.5 3602.5c4.5 7.11 9.83 13.61 16 19.5a81.596 81.596 0 0 1 16 6c4.29.88 8.62 1.38 13 1.5 10.93.03 19.93-3.97 27-12 1.9-.97 3.9-1.3 6-1v4c-.76-.89-1.76-1.56-3-2-2.43 1.47-4.43 3.47-6 6-4 1.1-7.66 2.77-11 5-9.99 1.27-19.99 1.27-30 0-.45-.96-1.12-1.79-2-2.5-3.68-1.17-7.34-2.34-11-3.5-2.71-3.64-5.87-6.97-9.5-10-2.28-3.5-4.12-7.17-5.5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d6c6c",
    d: "M9869.5 3619.5c1 28.83 1.33 57.83 1 87h23c-.33-29.17 0-58.17 1-87v88h-25v-88Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c6b6b",
    d: "M9979.5 3615.5c1 30.5 1.33 61.16 1 92h-25v-88c1 28.83 1.33 57.83 1 87h23v-91Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cac9ca",
    d: "M10277.5 3611.5c1 31.83 1.3 63.83 1 96h-24v-84c1 27.49 1.3 55.16 1 83h22v-95Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d6c6c",
    d: "M10538.5 3619.5c1 28.83 1.3 57.83 1 87h23c-.3-29.17 0-58.17 1-87v88h-25v-88Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c6b6b",
    d: "M10648.5 3615.5c1 30.5 1.3 61.16 1 92h-25v-88c1 28.83 1.3 57.83 1 87h23v-91Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cac9ca",
    d: "M11045.5 3611.5c1 31.83 1.3 63.83 1 96h-24v-84c1 27.49 1.3 55.16 1 83h22v-95Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb25b",
    d: "M1486.5 3617.5c2.17.71 4.17 1.71 6 3 1.56 2.12 3.56 3.79 6 5a64.709 64.709 0 0 1 16 5.5c8.78 1.28 17.11.44 25-2.5h2c2.9-1.08 5.9-1.74 9-2-1.25 1.64-2.92 2.8-5 3.5-9.75 3.21-19.75 4.21-30 3-4.93-1.53-9.93-2.87-15-4-5.18-3.36-9.84-7.19-14-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffbb6d",
    d: "M1817.5 3623.5c3.66 1.16 7.32 2.33 11 3.5.88.71 1.55 1.54 2 2.5a31.507 31.507 0 0 0-9-2.5c-1.82-.66-3.16-1.83-4-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8887ab",
    d: "M7463.5 3617.5c.13.88-.2 1.54-1 2-14.06 5.85-28.73 8.51-44 8-11.73-.91-23.73-1.24-36-1h-3v77c-.34 2.86-2.01 4.36-5 4.5-19.5.83-38.84.66-58-.5 12.84.33 25.51 0 38-1 3.12-.02 6.29.31 9.5 1 2.33-.67 4.67-1.33 7-2l2 2c1.65-.57 3.32-1.9 5-4 .5-26 .67-52 .5-78h4c17 .17 34 0 51-.5 4.24-.33 8.24-1.17 12-2.5 4.15.37 7.81-.63 11-3 2.42-.38 4.75-1.04 7-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdeb8",
    d: "M1444.5 3620.5a46.927 46.927 0 0 1-7 6c-3.63 2.32-7.63 3.65-12 4-5.64.96-11.31 1.13-17 .5-2.68-.67-5.01-1.84-7-3.5a63.623 63.623 0 0 0 22 1.5c7.44-1.97 14.44-4.81 21-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afaec6",
    d: "M7382.5 3626.5c-1.65 25.61-2.65 51.28-3 77v-77h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fec380",
    d: "M1830.5 3629.5c10.01 1.27 20.01 1.27 30 0-.42.72-1.08 1.22-2 1.5-4.63.83-9.3 1.33-14 1.5-5.05.23-9.72-.77-14-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fec078",
    d: "M1723.5 3627.5c9.11 2.67 18.44 3.67 28 3-3.7 1.56-7.7 2.22-12 2-3-.33-6-.67-9-1-2.84-.61-5.17-1.94-7-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd7aa",
    d: "M1944.5 3625.5c-1.97 7.38-4.64 14.55-8 21.5-1.21 3.76-3.21 6.92-6 9.5 1.4-3.2 2.4-6.54 3-10 2.84-7.35 6.51-14.35 11-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#555192",
    d: "M7303.5 3621.5c4.55 14.7 3.55 29.03-3 43-1.42-2.36-1.08-4.36 1-6 1.1-4.92 2.44-9.75 4-14.5-.49-7.01-1.16-14.51-2-22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7752e5",
    d: "M4236.5 3629.5c5.52 2.04 10.86 4.37 16 7-6.67.36-12-1.98-16-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d46e3",
    d: "M4935.5 3581.5c1.96 2.47 3.13 5.47 3.5 9 2.82 14.68 2.65 29.18-.5 43.5-3.59.21-7.09.71-10.5 1.5-25.9-.96-52.07-1.3-78.5-1v7c-1.95-2.6-2.28-5.44-1-8.5 29.67-.17 59.34-.67 89-1.5 1.29-12.65 1.29-25.32 0-38-.03-4.12-.7-8.12-2-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f78381",
    d: "M6188.5 3623.5c7.32 5.63 12.99 12.63 17 21a85.873 85.873 0 0 1-17-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a98b9",
    d: "M7178.5 3640.5c-.56-2.09-1.89-3.59-4-4.5-7.38-.76-14.72-.6-22 .5-10.99.07-21.66.74-32 2 1.09-1.62 2.76-2.45 5-2.5 14.49-1.06 28.99-1.89 43.5-2.5 5.98-1.11 9.15 1.23 9.5 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fecf99",
    d: "M1205.5 3616.5c4.25 1.6 8.25 3.6 12 6 1.49 1.3 3.15 2.47 5 3.5 18.59 7.32 37.93 9.99 58 8 6.72-3.36 13.72-6.19 21-8.5-.45.96-1.12 1.79-2 2.5-4.04 1.35-7.7 3.19-11 5.5-2.4-.24-4.4.43-6 2-14.11 1.65-28.11 1.32-42-1-6.78-3.05-13.78-5.55-21-7.5-4.83-3.33-9.5-6.83-14-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdb764",
    d: "M1357.5 3521.5v1c-1 49.16-1.33 98.5-1 148h-1c-.66-50.01 0-99.68 2-149Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbebd",
    d: "M5757.5 3618.5c2.14 4.19 4.14 8.53 6 13 5.46 6.55 11.13 12.89 17 19l-6-3c-3.61-4.79-7.45-9.45-11.5-14-2.33-3.52-4.16-7.18-5.5-11v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46d6b",
    d: "M5960.5 3629.5a88.642 88.642 0 0 1-10 12c2.23-4.9 5.57-8.9 10-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feae50",
    d: "M1240.5 3634.5c13.89 2.32 27.89 2.65 42 1-11.63 3.45-23.63 3.95-36 1.5-2.35-.24-4.35-1.07-6-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#535092",
    d: "M7152.5 3636.5c-10.54 1.16-21.21 2.5-32 4 .35 7.43 1.35 14.76 3 22-1.06-1.1-1.89-2.43-2.5-4-.47-5.23-1.3-10.39-2.5-15.5.02-1.83.69-3.33 2-4.5 10.34-1.26 21.01-1.93 32-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f35753",
    d: "M5917.5 3614.5a93.557 93.557 0 0 0-2.5 15 58.503 58.503 0 0 0-4.5 12l-2 2c-.97-1.57-1.14-3.23-.5-5 2-4.09 4-8.09 6-12 .02-4.45 1.19-8.45 3.5-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f78583",
    d: "M6013.5 3635.5c-2-1.83-4.33-2.33-7-1.5-2.93 4.13-5.93 8.3-9 12.5-1.68.65-3.02 1.65-4 3-1 .67-2 1.33-3 2 4.33-7.84 10-14.67 17-20.5 3.23-.29 5.23 1.21 6 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8b9f1",
    d: "M4319.5 3635.5c1.72 6.13 2.39 12.3 2 18.5-.57 2.76-1.57 5.26-3 7.5.84-8.64 1.17-17.31 1-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#333131",
    d: "M9580.5 3641.5h6c1.77 29.89-12.23 46.22-42 49-17.67-1.48-24.84-10.82-21.5-28 3.09-6.14 7.92-10.3 14.5-12.5 14.42-3.07 28.76-5.9 43-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fec07a",
    d: "M1705.5 3524.5h-1c-.3-.65-.64-1.32-1-2-6.63-1-13.3-1.33-20-1-.33 49.84 0 99.5 1 149 1.07.93 2.4 1.27 4 1-1.42.95-3.09 1.28-5 1-.72-.42-1.22-1.08-1.5-2-.67-49.67-.67-99.33 0-149 7.42-1.15 14.92-1.31 22.5-.5.84 1.01 1.17 2.18 1 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd8aa",
    d: "M1777.5 3612.5c-1.03 2.02-2.03 4.02-3 6-3.6.97-6.27 3.14-8 6.5-5.21 1.57-10.21 3.4-15 5.5-9.56.67-18.89-.33-28-3-3.55-.45-6.88-1.45-10-3-.9-2.23-2.57-3.23-5-3v47c-6.8.35-13.47 1.35-20 3-1.6.27-2.93-.07-4-1 7.11-1.91 14.44-2.91 22-3v-49c1.7-.16 3.37.01 5 .5.76 1.51 1.76 2.85 3 4 16.64 7.98 33.3 8.31 50 1 1.17-2.7 3.17-4.36 6-5 2.22-2.39 4.56-4.56 7-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cec1f3",
    d: "M4562.5 3535.5h46c.99-.17 1.66.16 2 1 .17 53.33 0 106.67-.5 160-17.42.99-34.92 1.33-52.5 1v-4c8.44 1.3 17.1 1.97 26 2 8.58-.01 17.08-.34 25.5-1 .5-52.67.67-105.33.5-158-15.84.33-31.51 0-47-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f88a87",
    d: "M6113.5 3620.5c-3.94 6.78-9.11 12.44-15.5 17a49.526 49.526 0 0 0-7.5 11c-1.57 1.92-3.57 2.92-6 3 .16 1.37-.01 2.71-.5 4-5.41 6.9-11.24 13.24-17.5 19l6-9c1.62-3.45 4.12-6.12 7.5-8l3-6a29.18 29.18 0 0 0 6-4 97.498 97.498 0 0 1 11.5-15c4.31-3.98 8.65-7.98 13-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46d6b",
    d: "M6287.5 3628.5c1.23.81 2.23 1.81 3 3 .85 3.69 3.02 6.36 6.5 8 1.58 3.42 3.75 6.42 6.5 9-7.74-4.85-13.07-11.52-16-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fccd97",
    d: "M1357.5 3522.5c-.17 48.67 0 97.33.5 146 6.39.21 12.89.21 19.5 0-5.17.71-10.33 1.71-15.5 3-1.92-.08-3.76-.41-5.5-1-.33-49.5 0-98.84 1-148Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f6b9f",
    d: "M3102.5 3717.5c-.9.71-1.24 1.71-1 3-2.33 2-4.67 4-7 6 1.21-2.73 3.05-5.06 5.5-7 .12-2.87.78-5.54 2-8 .5-22.33.67-44.66.5-67h-7c2.27-2.26 4.93-2.6 8-1 1.17 22.66 1.33 45.33.5 68-1.32 1.75-1.82 3.75-1.5 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab0af",
    d: "M5878.5 3619.5c-1.14 2.5-1.81 5.17-2 8-3.51 3.69-6.01 8.03-7.5 13-4.83 4.17-9.67 8.33-14.5 12.5-1.65.61-3.32 1.11-5 1.5 5.59-4.26 11.09-8.93 16.5-14 4.71-6.77 8.88-13.77 12.5-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f67c7a",
    d: "M6018.5 3640.5c4.58 3.17 8.25 7.17 11 12-1.52-.01-2.68-.68-3.5-2-2.74-3.23-5.24-6.56-7.5-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f79594",
    d: "M6251.5 3637.5c.96.45 1.79 1.12 2.5 2 1.01 3.34 2.51 6.34 4.5 9v2c-3.27-3.76-5.6-8.1-7-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbb4b3",
    d: "M6403.5 3625.5c-.61.89-.94 1.89-1 3a61.168 61.168 0 0 0-6 12c-6.13 5.15-12.46 9.82-19 14 5.53-5.01 11.37-10.01 17.5-15 2.36-4.21 4.53-8.54 6.5-13 .46-.8 1.12-1.13 2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f67e7c",
    d: "M6443.5 3574.5c1.12 2.45 1.95 5.12 2.5 8 .17 5 .33 10 .5 15 .19 10.5-.81 20.83-3 31-3.49 6.68-6.32 13.68-8.5 21-1.42 1.9-2.92 3.56-4.5 5-1.31 2.84-3.31 5.17-6 7a272.669 272.669 0 0 0 17.5-34c1.17-10 2.33-20 3.5-30a108.39 108.39 0 0 1-2-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02317a",
    d: "M3091.5 3644.5h11c.17 22.34 0 44.67-.5 67-1.22 2.46-1.88 5.13-2 8-2.45 1.94-4.29 4.27-5.5 7-4.09 1.57-8.09 3.4-12 5.5-7.03.67-14.03.51-21-.5h-4c-13.43-10.79-18.27-24.79-14.5-42 2.41-9.75 7.91-17.25 16.5-22.5 3.03-.36 6.03-.86 9-1.5 6.76 1.26 13.1 3.26 19 6-.3-7.78.36-15.44 2-23 .23-1.56.9-2.9 2-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4bacf",
    d: "M3102.5 3717.5c-.32-2.25.18-4.25 1.5-6 .83-22.67.67-45.34-.5-68-3.07-1.6-5.73-1.26-8 1h-4c4.1-2.92 8.6-3.58 13.5-2 .67 23.67.67 47.33 0 71-.61 1.57-1.44 2.9-2.5 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f99c9a",
    d: "M6061.5 3632.5c3.99 2.67 7.66 5.67 11 9 .52 1.11.86 2.27 1 3.5-1.04 2.72-2.54 5.22-4.5 7.5-4.06 3.9-7.9 7.9-11.5 12 .23-1.56.9-2.9 2-4 3.77-3.44 6.77-7.44 9-12 .82-.89 1.82-1.22 3-1v-5c-1.05.15-2.05-.02-3-.5a86.413 86.413 0 0 1-7-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9e85ec",
    d: "M4265.5 3642.5c.89.61 1.89.94 3 1 1.75 3.76 2.42 7.76 2 12-2.49 3.29-5.82 5.29-10 6l2-2c6.03-1.71 8.19-5.71 6.5-12a71.836 71.836 0 0 0-3.5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a58ded",
    d: "M4796.5 3593.5c-2.9 16.87-2.57 33.54 1 50 1.35 7.37 3.68 14.37 7 21 .93 2.91 2.26 5.58 4 8-2.58-1.28-4.41-3.28-5.5-6-2.9-8.43-5.74-16.77-8.5-25-1.31-15-1.31-30 0-45 .67-1 1.33-2 2-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9e84eb",
    d: "M4849.5 3641.5c2.58 2.82 4.41 6.15 5.5 10 2.9 2.01 5.4 4.34 7.5 7h-1c-4.67-2-8-5.33-10-10-.96-2.25-1.62-4.58-2-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f36d6c",
    d: "M5908.5 3643.5v2c-3.18 4.2-6.18 8.53-9 13 1.87-4.43 4.04-8.76 6.5-13 .71-.88 1.54-1.55 2.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#967aeb",
    d: "M4723.5 3641.5c-.49 2.31-.83 4.64-1 7-1.34 1.51-2.5 3.18-3.5 5-.82 1.32-1.98 1.99-3.5 2 2.86-4.61 5.53-9.28 8-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9492b4",
    d: "M7756.5 3635.5a286.697 286.697 0 0 1-16 24c-3.25 2.31-5.41 1.31-6.5-3-.33-12-.67-24-1-36-6.42-1.14-12.92-1.31-19.5-.5-.75.67-1.09 1.5-1 2.5-.91 20.34-.91 40.5 0 60.5-.67 6.33-1.33 12.67-2 19a6.603 6.603 0 0 0 3 3c18.33.5 36.66.67 55 .5-19.91 1.65-39.25 1.98-58 1-.72-2.26-1.05-4.6-1-7 1-25.83 1.33-51.83 1-78 .22-1.23.89-2.23 2-3a74.27 74.27 0 0 1 21-.5l1.5 1.5c1.02 3.14 1.85 6.31 2.5 9.5-.19 9.51-.36 19.34-.5 29.5 1-.33 2-.67 3-1 4.69-6.37 9.03-13.04 13-20 .82-1.32 1.98-1.99 3.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c46e3",
    d: "M4496.5 3533.5c-15.91-.32-31.74.01-47.5 1-.83 53.83-.67 107.5.5 161-.17.99.16 1.66 1 2 18.07 1.33 36.24 1.33 54.5 0 .17-35.84.67-71.5 1.5-107-.33 35.57 0 71.07 1 106.5-.46.41-.79.91-1 1.5a541.89 541.89 0 0 1-57 .5l-1.5-1.5c-.17-54.24-.67-108.4-1.5-162.5.46-.41.79-.91 1-1.5 16.5-1.33 32.83-1.33 49 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e8cb2",
    d: "M7276.5 3586.5h4c.58 3.14 2.58 4.64 6 4.5 2.18 2.51 4.68 4.68 7.5 6.5 14.18 19.39 17.51 40.73 10 64-.86 3.13-2.36 5.8-4.5 8 .54-1.62.87-3.28 1-5 6.55-13.97 7.55-28.3 3-43 .16-1.37-.01-2.71-.5-4-1.82-4.29-3.98-8.29-6.5-12a343.327 343.327 0 0 0-20-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0be80",
    d: "M7509.5 3498.5c-.93 63.92-.93 126.92 0 189-.99 5.48-1.32 11.14-1 17-.95-41.71-1.61-83.38-2-125 .83-26.5 1.33-53.16 1.5-80 .38-.56.88-.89 1.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2afc9",
    d: "M3091.5 3644.5c-1.1 1.1-1.77 2.44-2 4-1.47.85-2.3 2.18-2.5 4-.5 5.99-.67 11.99-.5 18-2.43.23-4.1-.77-5-3 1.52.01 2.68.68 3.5 2 .17-7.02.67-14.02 1.5-21 1.27-1.9 2.93-3.24 5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ae99ee",
    d: "M4204.5 3649.5c-.96.45-1.79 1.12-2.5 2a90.34 90.34 0 0 1-2.5 11v-9c.73-1.38 1.4-2.88 2-4.5 1.25-.74 2.25-.57 3 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8868e8",
    d: "M4206.5 3649.5c3.97-.01 7.31 1.32 10 4h-3c-2.63-.97-4.96-2.31-7-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1c5f4",
    d: "M4780.5 3588.5c.96 1.76 1.29 3.76 1 6 .17 13 0 26-.5 39-1.23 9.34-3.57 18.34-7 27-.71.88-1.54 1.55-2.5 2 1.82-5.25 3.65-10.58 5.5-16 3.17-19.18 4.34-38.52 3.5-58Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4706e",
    d: "M6209.5 3649.5c2.05 1.78 4.21 3.45 6.5 5 4.6 7.1 9.76 13.77 15.5 20v1c-8.36-7.71-15.7-16.37-22-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46867",
    d: "M6307.5 3651.5c4.45 3.22 9.12 5.89 14 8-3.31-1.16-6.65-2.33-10-3.5-2.14-.88-3.47-2.38-4-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f72ea",
    d: "M4781.5 3594.5h1c.4 15.38-.1 30.71-1.5 46-1.89 9.28-4.89 18.28-9 27-.71.88-1.54 1.55-2.5 2 .67-2.33 1.33-4.67 2-7 .96-.45 1.79-1.12 2.5-2 3.43-8.66 5.77-17.66 7-27 .5-13 .67-26 .5-39Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcc5c5",
    d: "M5908.5 3645.5a94.884 94.884 0 0 1-5.5 12c-3.32 2.63-5.65 5.97-7 10-1.45 1.96-3.28 3.3-5.5 4 2.7-4.52 5.7-8.86 9-13 2.82-4.47 5.82-8.8 9-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f49e4",
    d: "M4217.5 3653.5c9.48 1.57 18.81 3.74 28 6.5 5.7.69 11.37.52 17-.5l-2 2c-7.82.42-15.48-.24-23-2-5.61-1.22-11.28-2.39-17-3.5-1.07-.85-2.07-1.69-3-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbb7b6",
    d: "M5725.5 3640.5c4.06 6.07 7.72 12.4 11 19-2.28-1.46-4.12-3.46-5.5-6-1.3-3.26-2.97-6.26-5-9a8.394 8.394 0 0 1-.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a09ebb",
    d: "M7178.5 3640.5c.97 1.14 2.14 2.14 3.5 3 .25 3.29 1.25 6.29 3 9 2.32 2 4.16 4.33 5.5 7-1.91-.58-3.58-1.58-5-3a60.484 60.484 0 0 1-7-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f36665",
    d: "M5990.5 3651.5c-4.08 4.74-7.74 9.74-11 15-.67.33-1.33.67-2 1 .21-1.42.71-2.76 1.5-4 2.67-3.33 5.33-6.67 8-10 .82-1.32 1.98-1.99 3.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfc2f4",
    d: "M4213.5 3653.5h4c.93.81 1.93 1.65 3 2.5 5.72 1.11 11.39 2.28 17 3.5v1c-3.35.17-6.68 0-10-.5a29.17 29.17 0 0 0-10-3c-2.04-.5-3.38-1.66-4-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#653ce2",
    d: "M4402.5 3650.5a23.01 23.01 0 0 0 9 4.5c7.66.11 15.33-.05 23-.5.17 14 0 28-.5 42-.8 2.72-2.3 3.72-4.5 3 .62-1.13 1.46-2.13 2.5-3 .67-13.33.67-26.67 0-40-1.94-1.31-3.78-1.31-5.5 0-3.96.74-7.96 1.4-12 2h-1c-2.93-1.04-5.93-2.2-9-3.5-1.54-1.11-2.2-2.61-2-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab4b4",
    d: "M5993.5 3649.5a85.37 85.37 0 0 1-14 17c3.26-5.26 6.92-10.26 11-15 1-.67 2-1.33 3-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f67e7d",
    d: "M6029.5 3652.5c3.52 2.01 5.85 5.01 7 9a24.152 24.152 0 0 1-7-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9a43d",
    d: "M7575.5 3617.5a27.31 27.31 0 0 0-1.5 5c-.81 11.71-.65 23.38.5 35 3.8 1.55 7.8 2.22 12 2 3.25-.02 6.42-.35 9.5-1 1.3.58 2.47 1.25 3.5 2-7.43.52-14.6.86-21.5 1-4.22-1.26-6.72-4.09-7.5-8.5a268.47 268.47 0 0 0 2.5-33.5c.42-1.26 1.25-1.92 2.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4c9f5",
    d: "M4426.5 3656.5c1.64-.21 3.14.12 4.5 1 .67 12.67.67 25.33 0 38-.9 1.2-2.07 2.03-3.5 2.5-4.98.75-9.98 1.25-15 1.5-9.57.34-19.24-.33-29-2 13.95.72 28.28.55 43-.5l2.5-2.5c.5-12 .67-24 .5-36-5.15 1.12-10.15 1.12-15 0 4.04-.6 8.04-1.26 12-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9fabc6",
    d: "M3172.5 3683.5c-1.29-3.41-3.29-6.41-6-9-3.66-2.66-7.33-5.33-11-8-3.69-2.43-7.86-3.43-12.5-3-5.53-.19-10.69.81-15.5 3-7.15 2.15-11.49 6.82-13 14a24.93 24.93 0 0 0-4 5.5c-.89 6.13-1.23 12.3-1 18.5-3.51-29.66 9.82-43.83 40-42.5 8.11 2.57 14.94 7.07 20.5 13.5 1.71 2.41 2.54 5.08 2.5 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#987deb",
    d: "M4237.5 3660.5v-1c7.52 1.76 15.18 2.42 23 2-6.49 1.15-13.15 1.32-20 .5-.74-1.04-1.74-1.54-3-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad97ed",
    d: "M4715.5 3656.5c-1.79 3-4.46 4.84-8 5.5-5 .67-10 .67-15 0-.54-.72-1.21-1.22-2-1.5v-1c7.4 3.13 14.4 2.47 21-2 1.33-.33 2.67-.67 4-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9a3a2",
    d: "M5849.5 3654.5v3c-7.24 3.44-14.91 5.44-23 6-7.7.07-15.37-.43-23-1.5-.92-.28-1.58-.78-2-1.5 16.73 2.98 32.73.98 48-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f88e8b",
    d: "M6152.5 3640.5c-1.98-1.19-3.98-1.19-6 0a33.84 33.84 0 0 1-3.5 6c-9.7 9.36-19.03 19.03-28 29-.33 1.33-.67 2.67-1 4a185.376 185.376 0 0 1-19.5 20c3.51-7.32 8.68-13.32 15.5-18a57.407 57.407 0 0 1 14-17c6.78-9.78 14.61-18.61 23.5-26.5 2.76-1.08 4.43-.24 5 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3b2ca",
    d: "M7710.5 3621.5c.33 26.17 0 52.17-1 78 .17-22.59-.17-45.09-1-67.5.64-3.6 1.3-7.1 2-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99a8c4",
    d: "M2776.5 3665.5h-4c-.11-.62-.44-1.12-1-1.5-7.01-1.19-13.68-.19-20 3-4.66 6.1-8.99 5.77-13-1-7.24-2.72-14.57-3.06-22-1-2.08.7-3.75 1.86-5 3.5-1.91.58-3.58 1.58-5 3 .01-1.52.68-2.68 2-3.5 7.14-5.22 15.14-6.89 24-5 2.21 1.04 4.55 1.71 7 2 1.6 2.11 3.6 3.61 6 4.5 3.57-2.81 7.57-4.98 12-6.5 5-.67 10-.67 15 0 1.36.93 2.69 1.77 4 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#95a3c2",
    d: "M2825.5 3718.5c-4.3-.75-7.3-3.08-9-7-.27-2.62.06-5.12 1-7.5 14.33-.33 28.67-.67 43-1 2.19-3.04 2.53-6.2 1-9.5.16-2.69 0-5.35-.5-8-2.09-2.28-3.59-4.94-4.5-8-2.26-1.68-3.93-3.84-5-6.5-2.39-1.19-4.72-2.36-7-3.5-.11-.62-.44-1.12-1-1.5a80.433 80.433 0 0 0-13.5-2.5c-4.16.78-8.32 1.44-12.5 2 19.73-7.35 34.56-1.69 44.5 17 .57 4.83 1.07 9.66 1.5 14.5.2 2.79-.47 5.29-2 7.5-14.65 1-29.32 1.33-44 1 .05 3.68 1.05 7.02 3 10 2.49-.26 4.16.74 5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ba9c5",
    d: "M2959.5 3666.5c-5.59-1.38-11.25-2.38-17-3-5.84.8-11.5 2.14-17 4-.13-.88.2-1.54 1-2 8.76-2.92 17.76-3.76 27-2.5 2.23.94 4.23 2.11 6 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7ccf5",
    d: "M4270.5 3655.5c.15 1.05-.02 2.05-.5 3a48.24 48.24 0 0 0-6.5 4.5c-8.35.83-16.69.67-25-.5-.36-.68-.7-1.35-1-2 1.26-.04 2.26.46 3 1.5 6.85.82 13.51.65 20-.5 4.18-.71 7.51-2.71 10-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1c5f3",
    d: "M4922.5 3654.5c-.45.96-1.12 1.79-2 2.5-8.51 2.39-17.17 4.39-26 6-8.33.67-16.67.67-25 0-3.04-1.21-5.71-2.71-8-4.5h3c5.34 2.91 11.18 4.24 17.5 4 7.55 0 14.72-1.33 21.5-4 2.93-.96 5.93-1.63 9-2 3.47-.05 6.8-.71 10-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8363e8",
    d: "M4864.5 3658.5c4.86 1.37 9.86 2.04 15 2 8.02-.54 16.02-1.2 24-2-6.78 2.67-13.95 4-21.5 4-6.32.24-12.16-1.09-17.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8a1a1",
    d: "M6368.5 3658.5c-3.49 2.61-7.49 4.11-12 4.5-6.99.5-13.99.67-21 .5-3.26-.48-6.26-1.48-9-3 9.58 1.86 19.25 2.36 29 1.5 4.16-1.66 8.49-2.83 13-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#47659b",
    d: "M3155.5 3666.5c-4.69.02-9.19-.65-13.5-2-4.85.59-9.69 1.26-14.5 2 4.81-2.19 9.97-3.19 15.5-3 4.64-.43 8.81.57 12.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46a68",
    d: "m5774.5 3647.5 6 3c5.8 5.73 12.8 9.06 21 10 .42.72 1.08 1.22 2 1.5 7.63 1.07 15.3 1.57 23 1.5-6.15 1.15-12.49 1.32-19 .5-9.47-1.84-18.47-4.84-27-9-2.13-2.44-4.13-4.94-6-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2524f",
    d: "M6396.5 3640.5c.13.74-.04 1.41-.5 2-13.72 13.69-30.05 22.02-49 25-4.23-.55-8.06-1.88-11.5-4 7.01.17 14.01 0 21-.5 4.51-.39 8.51-1.89 12-4.5 3.16-.94 6.16-2.28 9-4 6.54-4.18 12.87-8.85 19-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#605e99",
    d: "M7185.5 3656.5c1.42 1.42 3.09 2.42 5 3 1.91 3.57 4.91 5.57 9 6 .27 1.93 1.27 3.26 3 4-7.32-2.16-12.99-6.49-17-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#49649a",
    d: "M2844.5 3667.5c-8.92-2.41-17.92-2.57-27-.5-2.96 2.81-6.3 4.98-10 6.5.67-1 1.33-2 2-3 2.67-1.67 5.33-3.33 8-5 4.18-.56 8.34-1.22 12.5-2 4.57.45 9.07 1.28 13.5 2.5.56.38.89.88 1 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d679c",
    d: "M2959.5 3666.5c3.17.51 5.51 2.18 7 5 .61.89.94 1.89 1 3-6.49-6.15-14.32-9.15-23.5-9-4.87.15-9.7.65-14.5 1.5-2.64 2.48-5.64 4.32-9 5.5a28.17 28.17 0 0 0 5-5c5.5-1.86 11.16-3.2 17-4 5.75.62 11.41 1.62 17 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b5b95",
    d: "M3024.5 3665.5c.47 1.41 1.47 2.07 3 2 .33.67.67 1.33 1 2-2.18.22-3.85-.62-5-2.5-8.77-1.52-17.43-2.02-26-1.5 3.03-1.52 6.36-2.19 10-2 5.69.51 11.36 1.17 17 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#355491",
    d: "M2907.5 3665.5c.17 4.35 0 8.68-.5 13-.38.56-.88.89-1.5 1 .33-4.38-.01-8.72-1-13-4.82-.13-9.82-.13-15 0 5.9-3.39 11.9-3.73 18-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#07327b",
    d: "M2905.5 3679.5c-2.47.82-5.14 1.32-8 1.5-.56.38-.89.88-1 1.5-5.11 1.86-8.11 5.53-9 11-1 12.16-1.33 24.49-1 37-4.93.3-9.76-.03-14.5-1-1.05-16.12-.55-32.12 1.5-48 3.4-3.13 6.06-6.79 8-11 2.67-1.33 5.33-2.67 8-4 5.18-.13 10.18-.13 15 0 .99 4.28 1.33 8.62 1 13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ba8c4",
    d: "M3024.5 3665.5c-5.64-.83-11.31-1.49-17-2-3.64-.19-6.97.48-10 2-3.81 2.26-7.81 4.42-12 6.5a38.134 38.134 0 0 0-3 7.5c-2.01 1.88-2.34 4.04-1 6.5 5 .67 10 .67 15 0 .84-1.01 1.17-2.18 1-3.5a28.17 28.17 0 0 0 5-5c4.35-.17 8.68 0 13 .5.75.67 1.09 1.5 1 2.5-5.5-2.85-10.84-2.52-16 1a15.12 15.12 0 0 1-3 5.5c-5.67.67-11.33.67-17 0-.59-13.29 5.75-21.63 19-25 8.9-1.44 17.24-.27 25 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#05327b",
    d: "M3028.5 3669.5c1.67 1 3 2.33 4 4-.04 1.26.46 2.26 1.5 3 .67 14 .67 28 0 42a45.492 45.492 0 0 1-7.5 8.5c-4.69 2.55-9.69 4.21-15 5-8.23 1.05-16.23.38-24-2a104.96 104.96 0 0 1-8-10.5c-.39-6.19.44-12.19 2.5-18 1.73-1.9 3.56-3.57 5.5-5 8.1-2.24 16.44-3.74 25-4.5 1.59-.86 3.25-1.53 5-2 .84-1.01 1.17-2.18 1-3.5 1.38-.46 2.05-1.46 2-3-1.1-2.28-2.43-4.44-4-6.5-4.85-.82-9.52-.65-14 .5a28.17 28.17 0 0 1-5 5c-1.13.62-2.13 1.46-3 2.5-3.99.5-7.99.67-12 .5v-6c.72-2.57 1.72-5.07 3-7.5 4.19-2.08 8.19-4.24 12-6.5 8.57-.52 17.23-.02 26 1.5 1.15 1.88 2.82 2.72 5 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0b347c",
    d: "M3155.5 3666.5c3.67 2.67 7.34 5.34 11 8 1.7 2.74 2.86 5.74 3.5 9 3.02 2.95 4.19 6.61 3.5 11-.13 5.04-.63 10.04-1.5 15a155.17 155.17 0 0 1-7 15c-13.32 9.12-27.15 10.12-41.5 3h-2c-3.81-2.28-6.14-5.62-7-10-2.02-3.91-3.35-8.07-4-12.5.36-5.95.86-12.11 1.5-18.5 1.66-1.66 2.5-3.66 2.5-6 1.51-7.18 5.85-11.85 13-14 4.81-.74 9.65-1.41 14.5-2 4.31 1.35 8.81 2.02 13.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f78f8e",
    d: "M5736.5 3659.5c5.64 4.97 10.97 10.31 16 16a60.87 60.87 0 0 1-16-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f57472",
    d: "M5899.5 3658.5c-3.3 4.14-6.3 8.48-9 13-1.66 1.3-3.33 2.63-5 4-1.11.06-2.11.39-3 1 1.32-3.49 3.82-5.82 7.5-7 1.91-3.59 4.25-6.92 7-10 .67-.75 1.5-1.09 2.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f88c8a",
    d: "M5950.5 3641.5a257.36 257.36 0 0 0-13.5 18c-5.04 4.87-9.87 9.87-14.5 15 .23-1.56.9-2.9 2-4 1.26-2.43 3.1-4.43 5.5-6 1.44-1.77 2.44-3.77 3-6 3.55-3.69 7.05-7.35 10.5-11 2.33-2 4.67-4 7-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f36867",
    d: "M6059.5 3660.5c-1.1 1.1-1.77 2.44-2 4-3.37 2.7-6.37 5.7-9 9-.94-.11-1.78-.44-2.5-1-.67-2.09-1.84-3.76-3.5-5 2.53.53 4.53 1.86 6 4 3.4-4.07 7.07-7.74 11-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b99b9",
    d: "M7240.5 3638.5c3.15 3.34 4.32 7.34 3.5 12-8.62 17.89-22.45 24.23-41.5 19-1.73-.74-2.73-2.07-3-4 17.48 7.5 31.31 3.17 41.5-13 .42-1.86.92-3.69 1.5-5.5a24.115 24.115 0 0 1-2-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#03317a",
    d: "M2772.5 3665.5c11.19 5.02 17.52 13.68 19 26-.83 12.49-1.33 25.16-1.5 38-3.73.96-7.56 1.29-11.5 1-.17-11.93.16-23.77 1-35.5-.77-2.41-1.27-4.91-1.5-7.5-1.05-2.21-2.55-3.87-4.5-5-.08-1.25-.74-2.08-2-2.5-4.67-.67-9.33-.67-14 0-2.23 1.64-3.57 3.8-4 6.5-1 14.82-1.33 29.82-1 45-4.53.32-8.87-.02-13-1 .33-15.01 0-30.01-1-45-2.6-2.78-5.6-4.94-9-6.5a12.44 12.44 0 0 0-7 0c-1.62.24-2.62 1.07-3 2.5-1.63 1.45-3.47 2.78-5.5 4-.5 15-.67 30-.5 45h-13c-.17-15.34 0-30.67.5-46 1.71-2.41 2.54-5.08 2.5-8 .97-1.65 1.97-3.32 3-5 1.42-1.42 3.09-2.42 5-3 8.28-2.95 16.95-3.45 26-1.5 2.04 2.89 4.7 4.72 8 5.5 4.64-2.99 9.64-5.49 15-7.5 4.02-.5 8.02-.33 12 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#07337b",
    d: "M2844.5 3667.5c2.28 1.14 4.61 2.31 7 3.5 1.07 2.66 2.74 4.82 5 6.5.91 3.06 2.41 5.72 4.5 8 .5 2.65.66 5.31.5 8 .48 3.19-.19 6.02-2 8.5-13.58.82-27.08.66-40.5-.5-5.06 2.35-5.9 5.68-2.5 10 1.7 3.92 4.7 6.25 9 7 4.15 1.15 8.48 1.31 13 .5 2.08-.7 3.75-1.86 5-3.5 5.04-.33 10.04.01 15 1-.89 4.4-3.22 7.9-7 10.5-9.74 5.27-20.07 6.77-31 4.5-16.81-8.29-23.65-21.96-20.5-41 .81-1.94 1.31-3.94 1.5-6 1.56-4 3.56-7.66 6-11 3.7-1.52 7.04-3.69 10-6.5 9.08-2.07 18.08-1.91 27 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#07327b",
    d: "M2967.5 3674.5c1.58 2.17 3.08 4.51 4.5 7 .8 2.54.63 4.87-.5 7-5.01.17-10.01 0-15-.5-4.63-11.48-12.29-14.15-23-8-.75.67-1.09 1.5-1 2.5-1.19 1.03-2.02 2.37-2.5 4-.67 7-.67 14 0 21 .8 2.74 1.8 5.41 3 8 .67.75 1.5 1.09 2.5 1 .3.65.64 1.32 1 2 3.95.99 7.95 1.32 12 1 4.67-1.85 7.33-5.35 8-10.5 4.99-.5 9.99-.67 15-.5-3.23 15.55-12.9 23.55-29 24-3.99-.52-7.99-.86-12-1h-5c-2.67-3-5.33-6-8-9-.11-3.15-1.27-5.82-3.5-8-2.56-10.07-2.73-20.4-.5-31 2.57-3.46 4.9-7.13 7-11 3.36-1.18 6.36-3.02 9-5.5 4.8-.85 9.63-1.35 14.5-1.5 9.18-.15 17.01 2.85 23.5 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9695b7",
    d: "M7120.5 3638.5c-1.31 1.17-1.98 2.67-2 4.5 1.2 5.11 2.03 10.27 2.5 15.5.61 1.57 1.44 2.9 2.5 4 .54 3.94 1.87 7.6 4 11 2.77 3.48 5.27 7.15 7.5 11 2.83 1.5 5 3.67 6.5 6.5 4.91 2.94 9.57 6.11 14 9.5-6.36-2.69-12.36-6.19-18-10.5-10.96-11.92-17.96-25.92-21-42 .78-2.74 1.28-5.57 1.5-8.5.67-.75 1.5-1.09 2.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe2c1",
    d: "M1970.5 3620.5v4a215.143 215.143 0 0 0-14 31c-.93 1.44-2.1 2.77-3.5 4-.48 3.12-1.65 5.96-3.5 8.5-7.65.78-15.32 1.28-23 1.5.33-2 .67-4 1-6-.32-3.08.68-5.41 3-7-.77 3.64-1.44 7.31-2 11 6.7.33 13.37 0 20-1 7.41-15.48 14.74-30.81 22-46Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f35956",
    d: "M6168.5 3658.5c8.38 5.56 14.88 12.89 19.5 22 5.77 3.54 9.6 8.54 11.5 15-1.67-1.33-3.33-2.67-5-4-2.91-4.76-6.07-9.43-9.5-14-2.96-3.19-6.13-6.19-9.5-9l-7-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccbdf0",
    d: "M4504.5 3589.5c-.94 36.53-.94 71.7 0 105.5-.54.72-1.21 1.22-2 1.5v-104c-.07-1.53.59-2.53 2-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0c4f4",
    d: "M4804.5 3664.5c4.02 4.7 7.69 9.7 11 15-.74.13-1.41-.04-2-.5a63.447 63.447 0 0 0-5-6.5c-1.74-2.42-3.07-5.09-4-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aa93ee",
    d: "M4931.5 3679.5c-2.39-8.38-3.73-17.04-4-26-1.91-.28-3.58.05-5 1-3.2 1.29-6.53 1.95-10 2 3.87-1.27 7.54-3.1 11-5.5 1.44-.78 2.78-.61 4 .5a268.03 268.03 0 0 1 4 28Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbebe",
    d: "M6430.5 3654.5c-.39 1.68-.89 3.35-1.5 5-5.73 7.23-12.23 13.56-19.5 19 4.32-4.32 8.32-8.99 12-14a6.603 6.603 0 0 0 3-3c2.69-1.83 4.69-4.16 6-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffc788",
    d: "M1956.5 3655.5c-2.05 3.64-3.55 7.64-4.5 12-.82 1.32-1.98 1.99-3.5 2-8.02.45-16.02 1.11-24 2 .1-3.14 1.1-5.8 3-8-.33 2-.67 4-1 6 7.68-.22 15.35-.72 23-1.5 1.85-2.54 3.02-5.38 3.5-8.5 1.4-1.23 2.57-2.56 3.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#49659b",
    d: "M2772.5 3665.5c-3.98-.83-7.98-1-12-.5-5.36 2.01-10.36 4.51-15 7.5-3.3-.78-5.96-2.61-8-5.5-9.05-1.95-17.72-1.45-26 1.5 1.25-1.64 2.92-2.8 5-3.5 7.43-2.06 14.76-1.72 22 1 4.01 6.77 8.34 7.1 13 1 6.32-3.19 12.99-4.19 20-3 .56.38.89.88 1 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f47170",
    d: "M6421.5 3664.5c-3.68 5.01-7.68 9.68-12 14-1.11.06-2.11.39-3 1a158.48 158.48 0 0 1 15-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feac4c",
    d: "M1933.5 3646.5c-.6 3.46-1.6 6.8-3 10-2.32 1.59-3.32 3.92-3 7-1.9 2.2-2.9 4.86-3 8 7.98-.89 15.98-1.55 24-2a123.72 123.72 0 0 1-23.5 4c-2.19-1.47-2.85-3.47-2-6 2.45-6.36 4.95-12.7 7.5-19a7.48 7.48 0 0 1 3-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7b58e6",
    d: "M4199.5 3653.5v9a70.726 70.726 0 0 0-3 15h-1c-.17-4.35 0-8.68.5-13 1.88-3.51 3.05-7.18 3.5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbab9",
    d: "M5924.5 3670.5c-1.1 1.1-1.77 2.44-2 4-2.64 4.64-6.31 8.31-11 11 2.9-5.07 6.4-9.74 10.5-14 .67-.75 1.5-1.09 2.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f57573",
    d: "M6258.5 3648.5a7.48 7.48 0 0 1 3 2c3.22 6.39 7.06 12.39 11.5 18 2.41 2.12 4.91 4.12 7.5 6 .89.82 1.22 1.82 1 3 3.91 1.29 7.58 3.12 11 5.5.75.67 1.09 1.5 1 2.5a66.295 66.295 0 0 1-9-4.5c-4.58-4.82-9.58-9.16-15-13-3.95-5.76-7.62-11.59-11-17.5v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0c4f5",
    d: "M4315.5 3671.5c-1.13 1.81-1.8 3.81-2 6-2.29 1.95-4.62 3.95-7 6 2.64-3.26 4.81-6.93 6.5-11 .67-.75 1.5-1.09 2.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9478eb",
    d: "M4542.5 3534.5v-1c1.33 7.64 2 15.64 2 24-.33 8-.67 16-1 24-7.95.8-15.95 1.3-24 1.5-4.95 1.48-9.28 3.98-13 7.5-.83 35.5-1.33 71.16-1.5 107a372.708 372.708 0 0 1-54.5 0c17.51.33 34.84 0 52-1 .79-.28 1.46-.78 2-1.5-.94-33.8-.94-68.97 0-105.5 3.07-1.62 5.9-3.62 8.5-6 3.77-1.32 7.6-2.32 11.5-3h17c1.33-7.3 2-14.97 2-23 0-7.84-.33-15.51-1-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f6a9e",
    d: "M3089.5 3648.5a91.394 91.394 0 0 0-2 23c-5.9-2.74-12.24-4.74-19-6-2.97.64-5.97 1.14-9 1.5-8.59 5.25-14.09 12.75-16.5 22.5-3.77 17.21 1.07 31.21 14.5 42-6.36-3.03-11.03-7.69-14-14-2.03-9.87-2.53-19.87-1.5-30 2.46-8.76 7.3-15.92 14.5-21.5 8.57-2.42 16.9-1.92 25 1.5.9 2.23 2.57 3.23 5 3-.17-6.01 0-12.01.5-18 .2-1.82 1.03-3.15 2.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46f6d",
    d: "M5752.5 3675.5c7.44 5.04 15.1 9.7 23 14-6.13-1.62-11.8-4.29-17-8a25.888 25.888 0 0 1-6-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f57372",
    d: "M5977.5 3667.5c-.84 2.35-2.17 4.35-4 6-2.67 3-5.33 6-8 9 2.49-6.16 6.49-11.16 12-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b89b0",
    d: "M7297.5 3673.5c-.42 3.9-2.42 6.23-6 7 1.26-2.93 3.26-5.26 6-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b679c",
    d: "M3002.5 3677.5c4.48-1.15 9.15-1.32 14-.5 1.57 2.06 2.9 4.22 4 6.5.05 1.54-.62 2.54-2 3 .45-2.51-.22-4.51-2-6 .09-1-.25-1.83-1-2.5-4.32-.5-8.65-.67-13-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#365792",
    d: "M3068.5 3719.5c3.21.31 6.21-.02 9-1 1.8-.97 3.63-1.97 5.5-3 6.64-12.13 5.81-23.63-2.5-34.5-.95-.48-1.95-.65-3-.5-2.72-3.18-6.06-3.84-10-2 9.31-2.98 15.81.35 19.5 10 4.2 9.76 3.2 19.09-3 28-4.71 3.91-9.87 4.91-15.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbab9",
    d: "M6175.5 3668.5c3.37 2.81 6.54 5.81 9.5 9 3.43 4.57 6.59 9.24 9.5 14-7.46-6.79-13.79-14.45-19-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7078a6",
    d: "M7772.5 3619.5v86h-3l2-2c-.33-28.17 0-56.17 1-84Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8798ba",
    d: "M2881.5 3670.5c-1.94 4.21-4.6 7.87-8 11 .99-5.03 3.66-8.69 8-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#506a9e",
    d: "M2971.5 3688.5c-5.57 1.3-11.23 1.3-17 0-2.85-9.76-8.85-12.43-18-8-1.56.23-2.9.9-4 2-.09-1 .25-1.83 1-2.5 10.71-6.15 18.37-3.48 23 8 4.99.5 9.99.67 15 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#899bbc",
    d: "M3077.5 3680.5h-3c-5.38-1.2-9.38.47-12 5 .12-2.45 1.12-4.45 3-6 .99.17 1.66-.16 2-1 3.94-1.84 7.28-1.18 10 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cabbf1",
    d: "M4767.5 3671.5c-2.26 3.93-4.92 7.6-8 11-1.91.58-3.58 1.58-5 3 4.28-4.62 8.62-9.29 13-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#49659b",
    d: "M2773.5 3682.5c-.89-.61-1.89-.94-3-1-3.14-1.14-6.47-1.31-10-.5-2.04.5-3.38 1.66-4 3.5-1 .67-2 1.33-3 2 .43-2.7 1.77-4.86 4-6.5 4.67-.67 9.33-.67 14 0 1.26.42 1.92 1.25 2 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d83ad",
    d: "M2907.5 3665.5c1.15 4.82 1.32 9.82.5 15-3.79.77-7.62 1.44-11.5 2 .11-.62.44-1.12 1-1.5 2.86-.18 5.53-.68 8-1.5.62-.11 1.12-.44 1.5-1 .5-4.32.67-8.65.5-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efeced",
    d: "M3150.5 3680.5c1.75 1.75 3.08 3.75 4 6 .5 6.99.83 13.99 1 21-1.81 1.59-3.14 3.59-4 6-8.94 7.66-16.1 6.32-21.5-4-1.04-3.78-1.87-7.62-2.5-11.5.3-3.51.64-7.01 1-10.5 5.51-7.32 12.84-9.66 22-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbc4c3",
    d: "M5973.5 3673.5c-1.34 2.2-2.51 4.53-3.5 7-3.75 3.88-7.25 7.88-10.5 12 1.99-3.31 3.99-6.64 6-10 2.67-3 5.33-6 8-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e7ea",
    d: "M2836.5 3679.5c.67.33 1.33.67 2 1 1.1 1.86 2.43 3.52 4 5 .97 1.9 1.3 3.9 1 6-8.25.32-16.42-.02-24.5-1 0-7.67 3.84-11.67 11.5-12 2.05.17 4.05.51 6 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#92a1c1",
    d: "M2925.5 3667.5a28.17 28.17 0 0 1-5 5c-2.1 3.87-4.43 7.54-7 11-3.1 8.69-3.77 17.69-2 27-4.09-13.56-2.09-26.23 6-38 2.39-2.19 5.05-3.86 8-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eeee",
    d: "M3074.5 3680.5c1.65 1.62 3.65 2.96 6 4 .59 2.41 1.75 4.41 3.5 6 .67 6.33.67 12.67 0 19-1.42 3.72-3.58 6.72-6.5 9-3.02.16-6.02 0-9-.5-1.12-1.89-2.78-2.73-5-2.5.24-2.73-.6-5.06-2.5-7-.95-7.82-.45-15.49 1.5-23 2.62-4.53 6.62-6.2 12-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e70ea",
    d: "M4313.5 3677.5c-3.03 5.03-7.03 9.03-12 12a12.07 12.07 0 0 1 3-4c.33-1 1-1.67 2-2 2.38-2.05 4.71-4.05 7-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9eabc6",
    d: "M2966.5 3671.5c1.52.01 2.68.68 3.5 2 3.39 4.9 4.56 10.23 3.5 16-3.17.33-6.33.67-9.5 1-3.58-.02-6.74-.68-9.5-2 5.77 1.3 11.43 1.3 17 0 1.13-2.13 1.3-4.46.5-7a75.073 75.073 0 0 0-4.5-7c-.06-1.11-.39-2.11-1-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#95a4c2",
    d: "M3150.5 3680.5c-9.16-2.66-16.49-.32-22 7 2.79-7.9 8.45-11.07 17-9.5 1.99.37 3.66 1.21 5 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#98a6c3",
    d: "M3081.5 3667.5c-8.1-3.42-16.43-3.92-25-1.5-7.2 5.58-12.04 12.74-14.5 21.5-1.03 10.13-.53 20.13 1.5 30-1.29-.56-2.12-1.56-2.5-3-.67-9.67-.67-19.33 0-29 5.25-17.59 16.92-24.92 35-22a39.47 39.47 0 0 1 5.5 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab8b8",
    d: "M5885.5 3675.5c-2.4 2.72-5.07 5.22-8 7.5-1.24.79-2.58 1.29-4 1.5 3-2.67 6-5.33 9-8 .89-.61 1.89-.94 3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f25654",
    d: "M6064.5 3678.5a49.97 49.97 0 0 0-.5 15c1.56 1.72 2.39 3.72 2.5 6-2.12-1.49-3.62-3.49-4.5-6-1.22-5.53-.39-10.53 2.5-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8282ac",
    d: "M7291.5 3681.5c-2.39 3.9-5.39 7.4-9 10.5a56.664 56.664 0 0 1-15 7.5c3.71-4.2 8.37-7.04 14-8.5 3.2-3.37 6.54-6.54 10-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faaead",
    d: "m6072.5 3665.5-6 9c-.49 1.5-1.16 2.83-2 4-2.89 4.47-3.72 9.47-2.5 15 .88 2.51 2.38 4.51 4.5 6v2c-3.09-1.92-5.25-4.59-6.5-8-.57-11.55 3.59-20.88 12.5-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#657daa",
    d: "M2772.5 3665.5h4c4.21 1.87 7.87 4.53 11 8 1.29 3.71 2.79 7.38 4.5 11 .83 15.51.66 30.84-.5 46v-39c-1.48-12.32-7.81-20.98-19-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9b4cb",
    d: "M2809.5 3670.5c-.67 1-1.33 2-2 3-2.44 3.34-4.44 7-6 11-1.47.85-2.3 2.18-2.5 4-1.05 9.54-.55 18.87 1.5 28-.81-.93-1.65-1.93-2.5-3-.67-9-.67-18 0-27 1.53-2.92 2.86-5.92 4-9 2.09-2.93 4.59-5.26 7.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f6c9f",
    d: "M2982.5 3679.5v6c4.01.17 8.01 0 12-.5.87-1.04 1.87-1.88 3-2.5.17 1.32-.16 2.49-1 3.5-5 .67-10 .67-15 0-1.34-2.46-1.01-4.62 1-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9174ea",
    d: "M4759.5 3682.5c-2.35 3.35-5.35 6.02-9 8 .61-2.27 1.94-3.94 4-5 1.42-1.42 3.09-2.42 5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfc2f4",
    d: "M4816.5 3681.5a57.632 57.632 0 0 1 15 9 202.13 202.13 0 0 0 16 4.5c.75.67 1.09 1.5 1 2.5-1.33-.33-2.67-.67-4-1-2.58-.5-4.92-1.67-7-3.5-2.33-.33-4.67-.67-7-1-1.35-1.67-3.01-2.84-5-3.5-2.15-2.25-4.82-3.75-8-4.5-.75-.67-1.09-1.5-1-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#46639a",
    d: "M3065.5 3679.5c-1.88 1.55-2.88 3.55-3 6-2.44 1.57-3.61 3.91-3.5 7-.5 4.65-.67 9.32-.5 14-1.11-4.16-1.61-8.5-1.5-13 .77-4.44 2.43-8.44 5-12 .82-1.32 1.98-1.99 3.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#93a3c1",
    d: "M3027.5 3667.5c3.26 1.75 6.09 4.08 8.5 7 .83 13.84.66 27.51-.5 41 .17-13.34 0-26.67-.5-40-.71-.88-1.54-1.55-2.5-2-1-1.67-2.33-3-4-4-.33-.67-.67-1.33-1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcc7c6",
    d: "M5758.5 3681.5c5.2 3.71 10.87 6.38 17 8v2c-3.68-1.06-7.35-2.23-11-3.5-2.07-2.25-4.07-4.41-6-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f57472",
    d: "M6293.5 3685.5c4.96 1.31 9.3 3.64 13 7-3.1-1.73-6.43-3.06-10-4-.81-1.23-1.81-2.23-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c6a9e",
    d: "M2719.5 3681.5c-.75 1.83-1.75 3.5-3 5-.62.11-1.12.44-1.5 1-.17 14.51-.67 28.84-1.5 43-.17-15 0-30 .5-45 2.03-1.22 3.87-2.55 5.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d5d96",
    d: "M2739.5 3730.5c-.67-14.33-1.33-28.67-2-43a6.603 6.603 0 0 0-3-3c-.79-1.29-1.79-2.46-3-3.5-4.09-.76-8.09-.6-12 .5.38-1.43 1.38-2.26 3-2.5 2.33-.67 4.67-.67 7 0 3.4 1.56 6.4 3.72 9 6.5 1 14.99 1.33 29.99 1 45Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbbba",
    d: "M6231.5 3674.5c7.35 5.9 10.19 13.57 8.5 23-.91 3.21-2.74 5.54-5.5 7 1.57-2.05 2.57-4.38 3-7 .62-.11 1.12-.44 1.5-1 1.26-4.92.42-9.26-2.5-13 .26-1.48-.07-2.81-1-4-1.69-1.02-3.02-2.35-4-4v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#98a6c3",
    d: "M2734.5 3684.5c1.33.67 2.33 1.67 3 3-.17 14.67 0 29.34.5 44 4.93 1.32 9.77 1.32 14.5 0-.33-15.18 0-30.18 1-45 1-.67 2-1.33 3-2 .04 1.26-.46 2.26-1.5 3-.33 15-.67 30-1 45-2.38 1.27-5.05 1.93-8 2-2.5-.17-5-.33-7.5-.5l-1.5-1.5c-.33-15-.67-30-1-45-1.04-.74-1.54-1.74-1.5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b7eaa",
    d: "M2737.5 3687.5c.67 14.33 1.33 28.67 2 43 4.13.98 8.47 1.32 13 1-4.73 1.32-9.57 1.32-14.5 0-.5-14.66-.67-29.33-.5-44Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a289ed",
    d: "M4195.5 3677.5h1c-.73 4.1.27 7.6 3 10.5 4.43 1.89 8.77 3.72 13 5.5a67.432 67.432 0 0 1-15-4.5c-1.79-3.58-2.46-7.42-2-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b8a5f0",
    d: "M4304.5 3685.5a12.07 12.07 0 0 0-3 4c-2.63 2.1-5.63 3.43-9 4 2.8-1.3 5.14-3.3 7-6 1.58-.96 3.24-1.62 5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faafaf",
    d: "M5911.5 3685.5a28.85 28.85 0 0 1-9 9c2.1-2.94 4.43-5.77 7-8.5.59-.46 1.26-.63 2-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f57776",
    d: "M5965.5 3682.5c-2.01 3.36-4.01 6.69-6 10a85.95 85.95 0 0 0-11 11 462.15 462.15 0 0 0 14.5-20c.67-.75 1.5-1.09 2.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f57c7a",
    d: "M6236.5 3683.5c2.92 3.74 3.76 8.08 2.5 13-.38.56-.88.89-1.5 1 .15-4.71-.19-9.38-1-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a7979",
    d: "M9360.5 3690.5c-1 22.16-1.33 44.49-1 67-8.18.33-16.18-.01-24-1h23c-.17-22.67 0-45.34.5-68 .72.54 1.22 1.21 1.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9baac5",
    d: "M2716.5 3686.5c-.8 15.62-1.3 31.29-1.5 47-5.07.97-10.24 1.3-15.5 1v-3c4.28 1.04 8.61 1.21 13 .5.56-.38.89-.88 1-1.5.83-14.16 1.33-28.49 1.5-43 .38-.56.88-.89 1.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#49669b",
    d: "M2703.5 3676.5c.04 2.92-.79 5.59-2.5 8-.5 15.33-.67 30.66-.5 46h13c-.11.62-.44 1.12-1 1.5-4.39.71-8.72.54-13-.5v-1c-.17-15.67 0-31.34.5-47 .67-2.67 1.84-5.01 3.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aab3ca",
    d: "M2787.5 3673.5c1-.09 1.83.25 2.5 1 .42 2.92 1.42 5.59 3 8 .82 16.91.66 33.74-.5 50.5-5 .67-10 .67-15 0l-1.5-1.5c-.33-14-.67-28-1-42-.92-3.01-2.42-5.68-4.5-8 1.11.06 2.11.39 3 1 .57 1.47 1.41 2.81 2.5 4 .33 14.33.67 28.67 1 43 .37.92.87 1.75 1.5 2.5 1.83.17 3.67.33 5.5.5 2.87.2 5.37-.47 7.5-2 1.16-15.16 1.33-30.49.5-46-1.71-3.62-3.21-7.29-4.5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#425e96",
    d: "M2773.5 3682.5c1.95 1.13 3.45 2.79 4.5 5 .23 2.59.73 5.09 1.5 7.5-.84 11.73-1.17 23.57-1 35.5 3.94.29 7.77-.04 11.5-1 .17-12.84.67-25.51 1.5-38v39c-2.13 1.53-4.63 2.2-7.5 2-1.83-.17-3.67-.33-5.5-.5a9.186 9.186 0 0 1-1.5-2.5c-.33-14.33-.67-28.67-1-43a12.694 12.694 0 0 1-2.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#798cb3",
    d: "M2836.5 3679.5a37.2 37.2 0 0 0-6-1c-7.66.33-11.5 4.33-11.5 12 8.08.98 16.25 1.32 24.5 1 .3-2.1-.03-4.1-1-6-1.57-1.48-2.9-3.14-4-5 5.64 2.4 7.64 6.56 6 12.5-9.33.67-18.67.67-28 0-.79-9.85 3.88-15.02 14-15.5 1.67.17 3.33.33 5 .5.56.38.89.88 1 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a5b1ca",
    d: "M3016.5 3680.5c1.78 1.49 2.45 3.49 2 6-1.94 2.51-4.6 4.01-8 4.5-7.09.84-14.09 2.01-21 3.5.56-1.29 1.56-2.12 3-2.5 7.64-1.44 15.31-2.77 23-4 1.8-2.39 2.14-4.89 1-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bcaaf0",
    d: "M4754.5 3685.5c-2.06 1.06-3.39 2.73-4 5-1.21.43-2.21 1.1-3 2h-3c2.11-2.27 4.44-4.44 7-6.5.95-.48 1.95-.65 3-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8260e7",
    d: "M4825.5 3688.5c1.99.66 3.65 1.83 5 3.5 2.33.33 4.67.67 7 1 2.08 1.83 4.42 3 7 3.5-5.25-.06-10.25-1.23-15-3.5-2.25-.75-3.58-2.25-4-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#546ea0",
    d: "M3018.5 3686.5c.17 1.32-.16 2.49-1 3.5-1.75.47-3.41 1.14-5 2-8.56.76-16.9 2.26-25 4.5l2-2a225.37 225.37 0 0 1 21-3.5c3.4-.49 6.06-1.99 8-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0c3f5",
    d: "M4743.5 3692.5c-3.43 2.11-7.1 3.78-11 5 .32-1.63 1.32-2.63 3-3 2.52-1.26 5.19-1.93 8-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6ccf5",
    d: "M4928.5 3687.5c-1.25 1.68-2.91 3.01-5 4a54.422 54.422 0 0 1-17 4.5c-3.63 2.24-7.63 3.08-12 2.5-9.98.76-19.98 1.09-30 1-5.47-.57-10.8-1.24-16-2 10.88.55 20.71.88 29.5 1 17.63.11 34.47-3.56 50.5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c59e6",
    d: "M4358.5 3686.5c2 1.33 4 2.67 6 4 .79.9 1.79 1.57 3 2 1.17 2.04 2.84 3.37 5 4-2.73.24-5.06-.6-7-2.5-3.24-1.74-5.57-4.24-7-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#546ea1",
    d: "M2801.5 3684.5c-.19 2.06-.69 4.06-1.5 6-3.15 19.04 3.69 32.71 20.5 41-1.37.16-2.71-.01-4-.5-4.3-2.5-8.3-5.33-12-8.5-.8-2.47-2.13-4.47-4-6-2.05-9.13-2.55-18.46-1.5-28 .2-1.82 1.03-3.15 2.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0b0f3",
    d: "M4449.5 3692.5c.75 1.03 1.42 2.2 2 3.5 17 .5 34 .67 51 .5-17.16 1-34.49 1.33-52 1-.84-.34-1.17-1.01-1-2v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2c8d6",
    d: "M3074.5 3680.5h3c1.05-.15 2.05.02 3 .5 8.31 10.87 9.14 22.37 2.5 34.5-1.87 1.03-3.7 2.03-5.5 3 2.92-2.28 5.08-5.28 6.5-9 .67-6.33.67-12.67 0-19-1.75-1.59-2.91-3.59-3.5-6-2.35-1.04-4.35-2.38-6-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbbdf2",
    d: "M4732.5 3697.5c-.34.84-1.01 1.17-2 1-6.14.81-12.31 1.47-18.5 2-2.36 0-4.53-.34-6.5-1 8.82-1.6 17.82-2.27 27-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1c8d7",
    d: "M2706.5 3671.5c-1.03 1.68-2.03 3.35-3 5-1.66 1.99-2.83 4.33-3.5 7-.5 15.66-.67 31.33-.5 47a385.67 385.67 0 0 1-.5-48c.79-4.98 3.29-8.65 7.5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46c69",
    d: "M5775.5 3689.5a75.72 75.72 0 0 0 21 7.5c4.25.2 8.42.7 12.5 1.5h18c9.6-1.32 19.1-3.32 28.5-6-.85 1.47-2.18 2.3-4 2.5-15.64 5.22-31.64 6.72-48 4.5-3.35.17-6.68 0-10-.5-6.03-2.4-12.03-4.9-18-7.5v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbc2c1",
    d: "M5873.5 3684.5c.22 1.18-.11 2.18-1 3-4.26 1.7-8.26 3.86-12 6.5-8.71 2.12-17.37 4.46-26 7-9.33.67-18.67.67-28 0-1.24-.23-2.24-.73-3-1.5 16.36 2.22 32.36.72 48-4.5 1.82-.2 3.15-1.03 4-2.5 1.37.16 2.71-.01 4-.5 4.52-2.78 9.19-5.28 14-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f47170",
    d: "M6199.5 3695.5c3.67 1.82 6.34 4.65 8 8.5 1.72 1.56 3.72 2.39 6 2.5v3a70.396 70.396 0 0 1-8.5-6c-1.36-3.16-3.2-5.83-5.5-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b679c",
    d: "M2913.5 3683.5c-2.23 10.6-2.06 20.93.5 31 2.23 2.18 3.39 4.85 3.5 8h-1c-2.69-3.65-4.36-7.65-5-12-1.77-9.31-1.1-18.31 2-27Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#45639a",
    d: "M3114.5 3680.5c0 2.34-.84 4.34-2.5 6-.64 6.39-1.14 12.55-1.5 18.5.65 4.43 1.98 8.59 4 12.5-3.32-3.51-4.98-7.84-5-13-.23-6.2.11-12.37 1-18.5a24.93 24.93 0 0 1 4-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8597ba",
    d: "M3154.5 3686.5c3.1 6.65 3.77 13.65 2 21h-1c-.17-7.01-.5-14.01-1-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c46e4",
    d: "M4212.5 3693.5c4.82 1.17 9.49 2.5 14 4 18.47 4.83 37.13 5.16 56 1-4.46 1.54-8.96 3.21-13.5 5-10.42-.82-20.92-1.32-31.5-1.5-4.15-1.27-8.48-1.94-13-2-4-2.34-8-4.51-12-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4a1ee",
    d: "M4367.5 3692.5c5.27 2.09 10.6 3.76 16 5 9.76 1.67 19.43 2.34 29 2-8.51 1.15-17.18 1.15-26 0-4.87-.39-9.54-1.39-14-3-2.16-.63-3.83-1.96-5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a188ed",
    d: "M4291.5 3693.5c-2.98 1.52-5.98 3.19-9 5-18.87 4.16-37.53 3.83-56-1h9c12.13 1.88 24.46 2.38 37 1.5 1.24-.23 2.24-.73 3-1.5 2.36.16 4.69 0 7-.5 2.69-1.92 5.69-3.09 9-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcd3f7",
    d: "M4235.5 3697.5c13.19.46 26.52.46 40 0-.76.77-1.76 1.27-3 1.5-12.54.88-24.87.38-37-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b6eea",
    d: "M4426.5 3656.5c1.72-1.31 3.56-1.31 5.5 0 .67 13.33.67 26.67 0 40-1.04.87-1.88 1.87-2.5 3-8.8 1.04-17.63 1.7-26.5 2-5.75.19-11.25-.48-16.5-2 8.82 1.15 17.49 1.15 26 0 5.02-.25 10.02-.75 15-1.5 1.43-.47 2.6-1.3 3.5-2.5.67-12.67.67-25.33 0-38-1.36-.88-2.86-1.21-4.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f72ea",
    d: "M4730.5 3698.5c-2.38 1.39-5.04 2.22-8 2.5-6.18.82-12.18.65-18-.5v-1h1c1.97.66 4.14 1 6.5 1 6.19-.53 12.36-1.19 18.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d6fea",
    d: "M4931.5 3679.5h3c1.02 2.89 1.02 5.73 0 8.5-28.21 13.69-57.88 17.19-89 10.5-.36-.68-.7-1.35-1-2 1.33.33 2.67.67 4 1 5.2.76 10.53 1.43 16 2 3.99.67 8.15 1 12.5 1 6.08.2 11.92-.47 17.5-2 4.37.58 8.37-.26 12-2.5 5.92-.58 11.58-2.08 17-4.5 2.09-.99 3.75-2.32 5-4 2.06-.26 3.4-1.43 4-3.5-.88-1.36-1.21-2.86-1-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b39fed",
    d: "M4894.5 3698.5c-5.58 1.53-11.42 2.2-17.5 2-4.35 0-8.51-.33-12.5-1 10.02.09 20.02-.24 30-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9aead",
    d: "M6405.5 3681.5c-.45.96-1.12 1.79-2 2.5-24.76 15.77-51.76 20.77-81 15a32.668 32.668 0 0 0-13-3c-4.96-1.48-9.29-3.98-13-7.5 3.57.94 6.9 2.27 10 4h2c.45.96 1.12 1.79 2 2.5 8.58 1.98 17.25 3.64 26 5 10.08 1.19 19.75.35 29-2.5 4.59-1.14 9.26-1.97 14-2.5 8.98-3.79 17.65-8.29 26-13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f36766",
    d: "M6308.5 3692.5c5.63 1.36 11.3 2.86 17 4.5 13.59 1.68 26.92 1.85 40 .5-9.25 2.85-18.92 3.69-29 2.5-8.75-1.36-17.42-3.02-26-5-.88-.71-1.55-1.54-2-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#576ea0",
    d: "M2861.5 3693.5c1.53 3.3 1.19 6.46-1 9.5-14.33.33-28.67.67-43 1-.94 2.38-1.27 4.88-1 7.5-3.4-4.32-2.56-7.65 2.5-10 13.42 1.16 26.92 1.32 40.5.5 1.81-2.48 2.48-5.31 2-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbebe",
    d: "M5959.5 3692.5a163.538 163.538 0 0 1-20 23v-2c3.71-2.71 6.71-6.04 9-10a85.95 85.95 0 0 1 11-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9facc7",
    d: "M2936.5 3680.5c-4.49 4.86-6.15 10.69-5 17.5-.79 6.74.54 12.91 4 18.5-1 .09-1.83-.25-2.5-1a57.04 57.04 0 0 1-3-8c-.67-7-.67-14 0-21 .48-1.63 1.31-2.97 2.5-4 1.1-1.1 2.44-1.77 4-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eeebed",
    d: "M3013.5 3702.5h4c-.66 3.97-1 7.97-1 12-2.1.91-4.1 2.08-6 3.5-4.43 1.43-8.6 1.26-12.5-.5-.5-2.98-.66-5.98-.5-9 4.66-3.47 9.99-5.47 16-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5e35e1",
    d: "M4743.5 3692.5h4a30.416 30.416 0 0 0-5 4.5c-2.33.33-4.67.67-7 1-3.99 1.99-8.16 3.83-12.5 5.5-11.15-.7-22.32-1.7-33.5-3 .28 13.55.61 26.72 1 39.5-.63 3.27-1.3 6.44-2 9.5v-50h5c3.65.44 7.32.78 11 1 5.82 1.15 11.82 1.32 18 .5 2.96-.28 5.62-1.11 8-2.5.99.17 1.66-.16 2-1 3.9-1.22 7.57-2.89 11-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eea43f",
    d: "M7678.5 3660.5c2.26-1.39 3.92-.72 5 2-.05 13.08-.05 26.58 0 40.5-1.23 1.53-2.73 2.7-4.5 3.5-60.02-.37-116.85-.7-170.5-1v-1c-.32-5.86.01-11.52 1-17v15c14.21.62 28.38 1.29 42.5 2 39.07-.57 81.9-1.07 128.5-1.5a290.11 290.11 0 0 0 .5-41.5c-.67-.75-1.5-1.09-2.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffab4d",
    d: "M1803.5 3714.5c.15 4.53-1.68 7.86-5.5 10-1.3-2.51-2.3-5.17-3-8-2.58-2.17-4.42-4.84-5.5-8-.17-5.36-2.67-7.36-7.5-6-.67 1-.67 2 0 3 1.79 2.89 3.29 5.89 4.5 9-1.65-1.31-3.31-2.64-5-4-.85 2.11-1.52 4.27-2 6.5 3.85 5.75 3.85 11.41 0 17-1.29.49-2.63.66-4 .5v-1c3.25-1.43 4.58-3.93 4-7.5-.29-3.43-1.29-6.6-3-9.5 1.18-4.06 1.18-8.06 0-12h3c-.08-1.43.25-2.76 1-4 2.26-1.15 4.6-1.31 7-.5 3.91 6.45 7.24 13.29 10 20.5 1.18.22 2.18-.11 3-1 .46-2.1 1.46-3.76 3-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c679d",
    d: "M3166.5 3674.5c2.71 2.59 4.71 5.59 6 9 .72.42 1.22 1.08 1.5 2 3.56 16.16.06 30.33-10.5 42.5-3.65 1.49-7.31 2.99-11 4.5a62.744 62.744 0 0 1-18 .5c-4.29-.81-7.95-2.64-11-5.5 14.35 7.12 28.18 6.12 41.5-3 2.59-4.85 4.92-9.85 7-15 .87-4.96 1.37-9.96 1.5-15 .69-4.39-.48-8.05-3.5-11-.64-3.26-1.8-6.26-3.5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab6b6",
    d: "M5894.5 3701.5c-3.67 3.33-7.33 6.67-11 10-1.33.33-2.67.67-4 1 4.71-4.05 9.71-7.71 15-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a3b0c9",
    d: "M3013.5 3702.5c1.76-.96 3.76-1.29 6-1-.05 3.7-.39 7.36-1 11l-2 2c0-4.03.34-8.03 1-12h-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#546ea0",
    d: "M3018.5 3712.5c.61-3.64.95-7.3 1-11-2.24-.29-4.24.04-6 1-6.01.53-11.34 2.53-16 6-1.14 3.14-1.31 6.47-.5 10 .99.57 1.83 1.23 2.5 2-1.32.17-2.49-.16-3.5-1-3.49-8.2-.99-14.04 7.5-17.5a46.232 46.232 0 0 1 16-2c.63 1.74.96 3.57 1 5.5.18 2.7-.48 5.04-2 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f36867",
    d: "M5899.5 3698.5c-4.17 5.75-9.5 10.09-16 13 3.67-3.33 7.33-6.67 11-10 1.42-1.42 3.09-2.42 5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9caa2",
    d: "M7508.5 3705.5c53.65.3 110.48.63 170.5 1 1.77-.8 3.27-1.97 4.5-3.5-.05-13.92-.05-27.42 0-40.5-1.08-2.72-2.74-3.39-5-2-2.45-.57-4.79-1.23-7-2 .6-.64 1.43-.97 2.5-1 3.41.49 6.74 1.15 10 2 .28 3.54.78 7.04 1.5 10.5-.61 11.41-.61 22.41 0 33-1.26 2.93-3.43 4.76-6.5 5.5-54.18-.36-110.18-.36-168 0-.9-1.2-2.07-2.03-3.5-2.5.23-.4.56-.57 1-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffebd5",
    d: "M1844.5 3725.5c.65 1.94.98 3.94 1 6-1.48.26-2.81-.07-4-1-.54-1.76-1.54-3.09-3-4-.33-.67-.67-1.33-1-2a46.35 46.35 0 0 0-7-12.5c-2.44-.91-3.78-.08-4 2.5-.88-.13-1.54.2-2 1a37.325 37.325 0 0 0-2.5 8c-2.15 1.48-3.48 3.48-4 6-1.79 1.73-3.96 2.4-6.5 2 .33-3.52 1.83-6.52 4.5-9 1.14-2.6 1.97-5.26 2.5-8 3.06-4.45 5.9-9.11 8.5-14 1.39-1.05 2.89-1.22 4.5-.5 3.91 7.6 7.41 15.43 10.5 23.5.71.88 1.54 1.55 2.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faacab",
    d: "M6094.5 3699.5c-.75 1.6-1.75 3.1-3 4.5-2.52.52-4.52 1.85-6 4-3.67.67-7.33.67-11 0-2.68-.81-4.68-2.31-6-4.5 9.67 4.85 18.34 3.52 26-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b7b7c5",
    d: "M7768.5 3705.5h3c-.42.72-1.08 1.22-2 1.5-7.18.3-14.35.8-21.5 1.5-6.47-.85-13.13-.51-20 1-5-1.33-10-1.33-15 0-1.42-.58-2.25-1.58-2.5-3 18.75.98 38.09.65 58-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe4c6",
    d: "M1772.5 3701.5c1.3.99 2.63 1.99 4 3 1.18 3.94 1.18 7.94 0 12 1.71 2.9 2.71 6.07 3 9.5.58 3.57-.75 6.07-4 7.5v1c-7.88 1.25-15.71 1.25-23.5 0-.5-10.99-.67-21.99-.5-33h21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb560",
    d: "M1771.5 3713.5c.21-1.64-.12-3.14-1-4.5-3.99-.5-7.99-.67-12-.5-.14 1.76.19 3.43 1 5 2.59.98 5.25 1.31 8 1-2.8 1.14-5.8 1.3-9 .5-2.67-2.67-2.67-5.33 0-8 4.73-1 9.23-.5 13.5 1.5.78 1.89.61 3.55-.5 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a3afc8",
    d: "M2972.5 3707.5c-5.68-.17-11.34 0-17 .5-.75 2.17-1.59 4.34-2.5 6.5-1.71 1.54-3.21 3.2-4.5 5-4.05.32-8.05-.01-12-1-.36-.68-.7-1.35-1-2 9.87 4.2 16.2 1.04 19-9.5 6.18-.82 12.18-.65 18 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#514d90",
    d: "M7243.5 3706.5c-8.64 1.55-17.3 2.89-26 4-6.89.1-13.55-.56-20-2 15.34.11 30.68-.56 46-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe961f",
    d: "M1771.5 3713.5c-1.33.33-2.67.67-4 1-2.75.31-5.41-.02-8-1a9.127 9.127 0 0 1-1-5c4.01-.17 8.01 0 12 .5.88 1.36 1.21 2.86 1 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb056",
    d: "M1900.5 3712.5c-14.63-5.03-20.63-.03-18 15-2.16.4-3.5 1.73-4 4-4.17 1.85-8.5 2.35-13 1.5-.88-.71-1.55-1.54-2-2.5 3.95 1.03 7.95 1.19 12 .5 1.54-1.11 2.2-2.61 2-4.5h-4c-.81 1.49-2.15 2.16-4 2-5.51-1.71-7.35-5.38-5.5-11 .5-1.17 1.33-2 2.5-2.5 3.7-.58 7.37-.41 11 .5.57-3.41-.77-5.41-4-6 1.7-.16 3.37.01 5 .5 2.1 4.49 4.43 4.49 7 0 4.67-2 9.33-2 14 0 .75.67 1.09 1.5 1 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f36e6d",
    d: "M5948.5 3703.5a32.249 32.249 0 0 1-9 10 60.85 60.85 0 0 1 5.5-8c.82-1.32 1.98-1.99 3.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46b6a",
    d: "M6229.5 3707.5c-1.1 1.06-2.43 1.89-4 2.5-4.19.81-8.19.65-12-.5 5.5.35 10.84-.32 16-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d8db2",
    d: "M7155.5 3700.5a240.06 240.06 0 0 0 25 6.5c5.76 1.27 11.43 1.77 17 1.5 6.45 1.44 13.11 2.1 20 2-4.52.91-9.02 1.24-13.5 1a182.13 182.13 0 0 0-18.5-1.5c-6.95-1.28-13.79-3.12-20.5-5.5l-1 1a86.332 86.332 0 0 0-8.5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#908eb2",
    d: "M7267.5 3699.5c-4.6 2.97-9.6 5.47-15 7.5-5.41.61-10.74 1.61-16 3-6.32.5-12.66.67-19 .5 8.7-1.11 17.36-2.45 26-4 8.08-2.01 16.08-4.35 24-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeb8ce",
    d: "M2872.5 3681.5c-.19 2.06-.69 4.06-1.5 6-.67 14.33-.67 28.67 0 43l1.5 1.5c4.99.5 9.99.67 15 .5v-39c.89-5.47 3.89-9.14 9-11 3.88-.56 7.71-1.23 11.5-2 .82-5.18.65-10.18-.5-15-6.1-2.73-12.1-2.39-18 1-2.67 1.33-5.33 2.67-8 4 .44-1.57 1.44-2.74 3-3.5 6.75-4.36 14.09-6.03 22-5 .92.37 1.75.87 2.5 1.5.67 6 .67 12 0 18l-1.5 1.5c-4.42.21-8.75.87-13 2-2.23 1.23-3.73 3.06-4.5 5.5-.33 14-.67 28-1 42l-1.5 1.5c-2.83.17-5.67.33-8.5.5-3.28-.06-6.28-.72-9-2-.67-15.67-.67-31.33 0-47 .61-1.57 1.44-2.9 2.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c689d",
    d: "M2872.5 3681.5h1a248.087 248.087 0 0 0-1.5 48c4.74.97 9.57 1.3 14.5 1-.33-12.51 0-24.84 1-37v39c-5.01.17-10.01 0-15-.5l-1.5-1.5c-.67-14.33-.67-28.67 0-43 .81-1.94 1.31-3.94 1.5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fed8ac",
    d: "M1789.5 3708.5c-1.45-1.12-2.45-2.62-3-4.5-.95-.48-1.95-.65-3-.5 1.47 4.41 3.14 8.75 5 13l-2-2a54.801 54.801 0 0 0-4.5-9c-.67-1-.67-2 0-3 4.83-1.36 7.33.64 7.5 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#febc71",
    d: "M1837.5 3724.5c-2.8-3.32-5.47-6.82-8-10.5-1.08-.47-2.08-.3-3 .5.22-2.58 1.56-3.41 4-2.5a46.35 46.35 0 0 1 7 12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffc685",
    d: "M1959.5 3710.5v6c4.15-.05 5.65 1.95 4.5 6-2.99 1.24-5.15.24-6.5-3-.79 1.27-1.79 2.27-3 3 1.15-3.65 2.32-7.31 3.5-11 .38-.56.88-.89 1.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd7a9",
    d: "M2010.5 3713.5c1.32-1.44 2.99-2.11 5-2a39.37 39.37 0 0 1-4.5 11c-.5 2.98-.66 5.98-.5 9h-6c.67-5.48-.49-10.48-3.5-15-1.38-1.71-3.04-3.05-5-4a236.26 236.26 0 0 0-2.5 18c.17-3.68 0-7.35-.5-11-1.52 2.51-3.68 3.34-6.5 2.5-.91-2.25-1.91-4.42-3-6.5 1.63 1.96 3.63 3.3 6 4v-9c4.29.86 8.63 1.03 13 .5 1.69 4.62 4.36 5.46 8 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9fabc6",
    d: "M2858.5 3720.5c1.13-1.81 1.8-3.81 2-6-5.86-.32-11.52.01-17 1-1.25 1.64-2.92 2.8-5 3.5-4.52.81-8.85.65-13-.5 6.97 1.21 12.97-.62 18-5.5 5.99-.5 11.99-.67 18-.5.67 3.44-.33 6.11-3 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe2c2",
    d: "M1873.5 3709.5c3.23.59 4.57 2.59 4 6-3.63-.91-7.3-1.08-11-.5-1.17.5-2 1.33-2.5 2.5-1.85 5.62-.01 9.29 5.5 11 1.85.16 3.19-.51 4-2h4c.2 1.89-.46 3.39-2 4.5-4.05.69-8.05.53-12-.5-4.75-3.84-6.25-8.84-4.5-15 3.7-4.6 8.53-6.6 14.5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9a7f1",
    d: "M4690.5 3696.5c4.61 1.29 9.28 2.29 14 3v1c-3.68-.22-7.35-.56-11-1-2.11-.97-4.44-1.3-7-1 .33 16.84 0 33.51-1 50-.17-17 0-34 .5-51 1.36-.88 2.86-1.21 4.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdcb3",
    d: "M1947.5 3710.5c1.91.07 3.08 1.07 3.5 3 2.17 7.5-.66 11.33-8.5 11.5-1.73 1.79-2.4 3.96-2 6.5h-5c-.17-6.67 0-13.34.5-20 3.73-.96 7.56-1.29 11.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d9cbd",
    d: "M3062.5 3685.5c-1.95 7.51-2.45 15.18-1.5 23 1.9 1.94 2.74 4.27 2.5 7 2.22-.23 3.88.61 5 2.5 2.98.5 5.98.66 9 .5-2.79.98-5.79 1.31-9 1-6.44-1.87-9.78-6.2-10-13-.17-4.68 0-9.35.5-14-.11-3.09 1.06-5.43 3.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffcb90",
    d: "M1700.5 3730.5c1 .03 1.66-.47 2-1.5a69.259 69.259 0 0 0-6-17.5c-2.45-.49-4.12.34-5 2.5 2.47 1.8 4.14 4.13 5 7-.25 1.33-.92 2.33-2 3a26.68 26.68 0 0 0 4 4.5c-3.04-1.23-6.04-1.23-9 0 .17 1.32-.16 2.49-1 3.5-2.31.5-4.64.66-7 .5 2.57-6.84 4.91-13.84 7-21 3-1.33 6-1.33 9 0a59.784 59.784 0 0 1 7 20c-1.6.27-2.93-.07-4-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feaa49",
    d: "M1984.5 3724.5c2 1.48 3.67 3.31 5 5.5 1.45 1.3 2.78 1.46 4 .5.59-5.93 1.42-11.93 2.5-18 1.96.95 3.62 2.29 5 4 3.01 4.52 4.17 9.52 3.5 15h6c-.16-3.02 0-6.02.5-9a39.37 39.37 0 0 0 4.5-11c-2.01-.11-3.68.56-5 2-.09-1 .25-1.83 1-2.5 2.31-.5 4.64-.66 7-.5-2.6 4.75-4.76 9.75-6.5 15-.5 2.65-.66 5.31-.5 8-2.62.27-5.12-.06-7.5-1a34.847 34.847 0 0 1-2-10 85.604 85.604 0 0 0-4.5-7c-.67 5.33-1.33 10.67-2 16-5.93 1.43-9.59-.9-11-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d5ce7",
    d: "M4693.5 3699.5h-5v50c-.89.61-1.89.94-3 1v-2c1-16.49 1.33-33.16 1-50 2.56-.3 4.89.03 7 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff941a",
    d: "M1873.5 3726.5c-6.53.81-9.19-1.86-8-8 1.49-1.67 3.33-2.67 5.5-3 2.68 1.39 5.51 2.06 8.5 2v7c-2.58-.47-4.58.19-6 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffebd4",
    d: "m1700.5 3730.5-2-2a26.68 26.68 0 0 1-4-4.5c1.08-.67 1.75-1.67 2-3-.86-2.87-2.53-5.2-5-7 .88-2.16 2.55-2.99 5-2.5a69.259 69.259 0 0 1 6 17.5c-.34 1.03-1 1.53-2 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fea134",
    d: "M1941.5 3714.5h4v4h-5c-.07-1.46.27-2.79 1-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd5a5",
    d: "M1914.5 3712.5c2.52 1.53 3.52 3.86 3 7h3c-.04-2.59.96-4.59 3-6-.04 4.63-1.87 8.3-5.5 11-.48.95-.65 1.95-.5 3h4c-.7 1.84-2.04 2.34-4 1.5-4.87-10.32-6.87-9.48-6 2.5h-4v-2c.65.3 1.32.64 2 1 .83-3.96 1.33-7.96 1.5-12l1-1c.69.86 1.52 1.52 2.5 2 1.08-2.31 1.08-4.64 0-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b0bacf",
    d: "M2997.5 3708.5c-.16 3.02 0 6.02.5 9 3.9 1.76 8.07 1.93 12.5.5 1.9-1.42 3.9-2.59 6-3.5-1.17 2-2.84 3.5-5 4.5a36.913 36.913 0 0 1-12 1.5c-.67-.77-1.51-1.43-2.5-2-.81-3.53-.64-6.86.5-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99a7c4",
    d: "M3128.5 3687.5c-.36 3.49-.7 6.99-1 10.5.63 3.88 1.46 7.72 2.5 11.5 5.4 10.32 12.56 11.66 21.5 4 .86-2.41 2.19-4.41 4-6-.26 2.52-1.09 4.85-2.5 7a23.205 23.205 0 0 0-6.5 4.5c-3.32.5-6.65.67-10 .5-5.28-3.14-8.45-7.8-9.5-14-.67-5-.67-10 0-15 .23-1.24.73-2.24 1.5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b699d",
    d: "M3155.5 3707.5h1c.04 2.92-.79 5.59-2.5 8-5.11 4.86-10.95 6.2-17.5 4 3.35.17 6.68 0 10-.5 1.91-1.87 4.07-3.37 6.5-4.5 1.41-2.15 2.24-4.48 2.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6ec",
    d: "M1739.5 3727.5c1.57-2.93.91-5.43-2-7.5-5-.67-10-.67-15 0-4.75 8.9-2.09 13.23 8 13-4.13 1.43-8.47 1.93-13 1.5v-1c-.32-10.25.01-20.42 1-30.5 6.36-.83 12.69-.66 19 .5 1.26.88 2.43 1.88 3.5 3 .62 3.53.46 7.03-.5 10.5 1.71 2.56 2.71 5.39 3 8.5-.16 4.66-2.49 7.16-7 7.5 2.18-1.19 3.18-3.02 3-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe9cf",
    d: "M1914.5 3712.5c1.08 2.36 1.08 4.69 0 7a7.239 7.239 0 0 1-2.5-2l-1 1c-.17 4.04-.67 8.04-1.5 12-.68-.36-1.35-.7-2-1v-18c2.51-1.37 4.85-1.03 7 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffebd5",
    d: "M1980.5 3712.5c1.23.81 2.23 1.81 3 3 1.09 2.08 2.09 4.25 3 6.5 2.82.84 4.98.01 6.5-2.5.5 3.65.67 7.32.5 11-1.22.96-2.55.8-4-.5-1.33-2.19-3-4.02-5-5.5-.62-3.28-2.62-4.61-6-4 .17 3.35 0 6.68-.5 10l-1-1c-.83-6.03-.66-12.03.5-18 .92.63 1.92.96 3 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb865",
    d: "M1772.5 3701.5h-21c-.17 11.01 0 22.01.5 33 7.79 1.25 15.62 1.25 23.5 0-.59.65-1.26 1.32-2 2-3.83.33-7.67.67-11.5 1-4.26-.04-8.26-.71-12-2-.67-11.33-.67-22.67 0-34 7.6-1.33 15.1-1.33 22.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fed6a9",
    d: "M1925.5 3710.5h6c.3 6.73-.04 13.39-1 20-.77 1.21-1.61 1.21-2.5 0-.23-2.59-.73-5.09-1.5-7.5-1.57-.3-2.9.2-4 1.5-.09-1 .25-1.83 1-2.5 1.4-1.44 3.07-2.27 5-2.5-.15 1.05.02 2.05.5 3 .94-3.61 1.44-7.28 1.5-11-2.69-.33-5.02.33-7 2-.07-1.53.59-2.53 2-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fff0e0",
    d: "M1788.5 3716.5a153.52 153.52 0 0 1-5-13c1.05-.15 2.05.02 3 .5.55 1.88 1.55 3.38 3 4.5 1.08 3.16 2.92 5.83 5.5 8 .7 2.83 1.7 5.49 3 8 3.82-2.14 5.65-5.47 5.5-10 4.05-2.46 6.22-6.12 6.5-11 1.7-.91 3.53-1.24 5.5-1-4.32 10.44-9.32 20.6-15 30.5-1.28.68-2.45.52-3.5-.5a269.41 269.41 0 0 0-8.5-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffebd4",
    d: "M1922.5 3724.5c.24 1.29-.1 2.29-1 3h-4c-.15-1.05.02-2.05.5-3 3.63-2.7 5.46-6.37 5.5-11 1.98-1.67 4.31-2.33 7-2-.06 3.72-.56 7.39-1.5 11-.48-.95-.65-1.95-.5-3-1.93.23-3.6 1.06-5 2.5-.75.67-1.09 1.5-1 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d5b95",
    d: "M3018.5 3712.5c-.97 3.16-2.64 5.99-5 8.5-3.33.83-6.67 1.67-10 2.5-1.92-.25-3.25-1.25-4-3 4.08.16 8.08-.34 12-1.5 2.16-1 3.83-2.5 5-4.5l2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe8cd",
    d: "M1689.5 3728.5c-1.13.62-2.13 1.46-3 2.5-1.14.75-2.14.58-3-.5 1.15-2.27 2.15-4.61 3-7 1.72-1.16 3.39-.99 5 .5-1.08 1.33-1.75 2.83-2 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdbb2",
    d: "M1959.5 3710.5c2.7-.03 5.2.63 7.5 2 6.02 20.19 8.52 19.52 7.5-2 2.58-.47 4.58.19 6 2a5.576 5.576 0 0 1-3-1 54.662 54.662 0 0 0-.5 18l1 1c.5-3.32.67-6.65.5-10 3.38-.61 5.38.72 6 4-.98-.64-1.98-1.31-3-2-.82 2.95-1.32 5.95-1.5 9-.72.56-1.56.89-2.5 1-5.02.13-9.02-1.7-12-5.5-5.21-1.81-8.55-.14-10 5-1.29.49-2.63.66-4 .5-.64-3.97.36-7.31 3-10 1.21-.73 2.21-1.73 3-3 1.35 3.24 3.51 4.24 6.5 3 1.15-4.05-.35-6.05-4.5-6v-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ca9c5",
    d: "M2916.5 3722.5h1c2.67 3 5.33 6 8 9-4.1-1.86-7.1-4.86-9-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f46a68",
    d: "M5883.5 3711.5c.13.88-.2 1.54-1 2-8.29 4.96-16.96 9.12-26 12.5-2.65.5-5.31.66-8 .5 4.35-2.1 9.01-3.6 14-4.5 5.84-2.89 11.5-6.05 17-9.5 1.33-.33 2.67-.67 4-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#48659b",
    d: "M3032.5 3673.5c.96.45 1.79 1.12 2.5 2 .5 13.33.67 26.66.5 40-.45 3.55-1.45 6.88-3 10-4.17 2.25-8.51 4.25-13 6-11.05 2.83-22.05 2.66-33-.5-3.5-3.18-5.84-7.02-7-11.5 2.36 3.55 5.02 7.05 8 10.5 7.77 2.38 15.77 3.05 24 2 5.31-.79 10.31-2.45 15-5 2.87-2.54 5.37-5.37 7.5-8.5.67-14 .67-28 0-42-1.04-.74-1.54-1.74-1.5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe4c5",
    d: "M1900.5 3712.5c1.25 1.5 2.25 3.17 3 5 .66 11.51-4.68 16.01-16 13.5-1.82-1-3.49-2.16-5-3.5-2.63-15.03 3.37-20.03 18-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9c2f",
    d: "M1889.5 3714.5c3.47-.37 6.47.63 9 3 2.12 6.06-.05 9.39-6.5 10-3.87-.88-5.71-3.38-5.5-7.5.18-2.38 1.18-4.21 3-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbc4c4",
    d: "M5879.5 3712.5c-5.5 3.45-11.16 6.61-17 9.5-4.99.9-9.65 2.4-14 4.5-3.34.39-6.67.89-10 1.5-48 .5-96 .67-144 .5v-1c47.33.17 94.67 0 142-.5a404.12 404.12 0 0 0 25-6 74.19 74.19 0 0 1 18-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbc3c3",
    d: "M6326.5 3480.5c44.5-1 89.16-1.33 134-1 .99-.17 1.66.16 2 1 .33 82.57 0 165.07-1 247.5-179 .83-358 .67-537-.5.12-.61.46-.94 1-1 178.17 1.17 356.5 1.33 535 .5 1.16-81.76 1.33-163.6.5-245.5-44.76-1-89.59-1.33-134.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb35e",
    d: "m1786.5 3714.5 2 2a269.41 269.41 0 0 1 8.5 16c1.05 1.02 2.22 1.18 3.5.5 5.68-9.9 10.68-20.06 15-30.5-1.97-.24-3.8.09-5.5 1-.28 4.88-2.45 8.54-6.5 11a46.98 46.98 0 0 0 5-13.5c2.33-.67 4.67-.67 7 0 1.71 1.13 2.21 2.63 1.5 4.5-4.07 7.09-7.74 14.42-11 22-2.05 2.92-4.21 5.76-6.5 8.5l1 1c-1.63.49-3.3.66-5 .5.16-2.03 0-4.03-.5-6-5.35-4.33-8.18-9.99-8.5-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffa846",
    d: "M1818.5 3714.5c-.53 2.74-1.36 5.4-2.5 8-2.67 2.48-4.17 5.48-4.5 9 2.54.4 4.71-.27 6.5-2 .52-2.52 1.85-4.52 4-6 .53-2.76 1.37-5.43 2.5-8 .46-.8 1.12-1.13 2-1a79.675 79.675 0 0 1-8 19c-4.13.61-7.8-.22-11-2.5a93.3 93.3 0 0 1 11-16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f68989",
    d: "M5848.5 3726.5c-5.63 2.44-11.63 3.44-18 3-45.5.33-90.84 0-136-1 48 .17 96 0 144-.5 3.33-.61 6.66-1.11 10-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f68f8e",
    d: "M6462.5 3480.5h2v248c-180.29 1-360.63 1.33-541 1v-4c5.33-4 10.67-8 16-12v2c-5.03 3.18-9.7 6.85-14 11-.54.06-.88.39-1 1 179 1.17 358 1.33 537 .5 1-82.43 1.33-164.93 1-247.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb35a",
    d: "M1773.5 3723.5c.93 1.07 1.27 2.4 1 4-.95 2.11-2.62 3.28-5 3.5-3.76.76-7.42.59-11-.5-.9-2.89-1.24-5.89-1-9 5.01-.17 10.01 0 15 .5.56.38.89.88 1 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb561",
    d: "M1907.5 3711.5v20c-1.57-1.18-2.4-2.85-2.5-5-5.19 6.51-11.69 8.34-19.5 5.5-1.64-1.13-2.64-2.63-3-4.5 1.51 1.34 3.18 2.5 5 3.5 11.32 2.51 16.66-1.99 16-13.5h3c-.29-2.24.04-4.24 1-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feb25a",
    d: "M1947.5 3710.5c-3.94-.29-7.77.04-11.5 1-.5 6.66-.67 13.33-.5 20-1.6-1.18-2.94-1.01-4 .5-4.86 1.48-7.03-.36-6.5-5.5-1.53 1.23-2.7 2.73-3.5 4.5-4.34.83-6.34-1-6-5.5h-3c.29 2.24-.04 4.24-1 6-.87-11.98 1.13-12.82 6-2.5 1.96.84 3.3.34 4-1.5.9-.71 1.24-1.71 1-3 1.1-1.3 2.43-1.8 4-1.5.77 2.41 1.27 4.91 1.5 7.5.89 1.21 1.73 1.21 2.5 0 .96-6.61 1.3-13.27 1-20h-6c.47-1.19 1.47-1.86 3-2 6.5.55 12.83 1.21 19 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#566fa2",
    d: "M2972.5 3707.5c.35 7.97-2.31 14.64-8 20-4.45 2.39-9.12 4.56-14 6.5-5.33.67-10.67.67-16 0-1.82-.2-3.15-1.03-4-2.5 4.01.14 8.01.48 12 1 16.1-.45 25.77-8.45 29-24-5.01-.17-10.01 0-15 .5-.67 5.15-3.33 8.65-8 10.5 1.29-1.8 2.79-3.46 4.5-5 .91-2.16 1.75-4.33 2.5-6.5 5.66-.5 11.32-.67 17-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9daac5",
    d: "m2989.5 3694.5-2 2c-1.94 1.43-3.77 3.1-5.5 5-2.06 5.81-2.89 11.81-2.5 18 1.16 4.48 3.5 8.32 7 11.5 10.95 3.16 21.95 3.33 33 .5-2.1 1.43-4.43 2.6-7 3.5-6.67.67-13.33.67-20 0-13.69-5.21-18.52-15.05-14.5-29.5 1.78-5.95 5.62-9.62 11.5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f05c5c",
    d: "M5692.5 3728.5h2c45.16 1 90.5 1.33 136 1-22.83.67-45.83 1-69 1-23.34 0-46.34-.67-69-2ZM5923.5 3725.5v4c180.37.33 360.71 0 541-1v1c-180.17.67-360.33 1.33-540.5 2a9.186 9.186 0 0 0-2.5-1.5c1.1-.77 1.1-1.6 0-2.5.33-1 1-1.67 2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f03636",
    d: "M5921.5 3727.5c1.1.9 1.1 1.73 0 2.5.92.37 1.75.87 2.5 1.5 180.17-.67 360.33-1.33 540.5-2-181.01 1.67-362.34 2.67-544 3-.28-1.91.05-3.58 1-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdfba",
    d: "M1737.5 3701.5c5.77 3.37 7.44 8.37 5 15 1.47 2.82 2.47 5.82 3 9-.09 2.91-.92 5.58-2.5 8-1.9 1.52-4.06 2.18-6.5 2-6.52.32-12.86-.01-19-1 4.53.43 8.87-.07 13-1.5-10.09.23-12.75-4.1-8-13 5-.67 10-.67 15 0 2.91 2.07 3.57 4.57 2 7.5.18 2.48-.82 4.31-3 5.5 4.51-.34 6.84-2.84 7-7.5-.29-3.11-1.29-5.94-3-8.5.96-3.47 1.12-6.97.5-10.5a23.215 23.215 0 0 0-3.5-3 60.865 60.865 0 0 0-19-.5c-.99 10.08-1.32 20.25-1 30.5-.99-10.49-1.33-21.15-1-32h21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feaa49",
    d: "M1739.5 3727.5h-1c.09 1-.25 1.83-1 2.5-4.99.5-9.99.67-15 .5v-9c5.01-.17 10.01 0 15 .5 1.66 1.44 2.32 3.28 2 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9214",
    d: "M1738.5 3727.5c-4.77 1.82-9.77 2.48-15 2v-6c4.68-.17 9.35 0 14 .5.84 1.01 1.17 2.18 1 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd19d",
    d: "M1737.5 3713.5c-.45.96-1.12 1.79-2 2.5-4.67.67-9.33.67-14 0l-2-2c.77-2.41 1.27-4.91 1.5-7.5 5.17-1.36 10.34-1.2 15.5.5 2.11 2.02 2.44 4.18 1 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9d2e",
    d: "M1737.5 3713.5a37.232 37.232 0 0 1-14 .5c-.92-2.04-1.26-4.21-1-6.5 4.77-.31 9.43.19 14 1.5.88 1.36 1.21 2.86 1 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4e689d",
    d: "M2843.5 3715.5c5.48-.99 11.14-1.32 17-1-.2 2.19-.87 4.19-2 6-.23 1.56-.9 2.9-2 4-5.17 4.65-11.17 7.81-18 9.5-4.67.67-9.33.67-14 0-1.57-.61-2.9-1.44-4-2.5 10.93 2.27 21.26.77 31-4.5 3.78-2.6 6.11-6.1 7-10.5-4.96-.99-9.96-1.33-15-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef2e3",
    d: "M1758.5 3730.5c3.58 1.09 7.24 1.26 11 .5 2.38-.22 4.05-1.39 5-3.5.57-1.89 1.57-3.55 3-5 .33 1.17.67 2.33 1 3.5-.32 2.8-1.32 5.3-3 7.5a69.384 69.384 0 0 1-22 0 50.405 50.405 0 0 1 0-18 63.26 63.26 0 0 0 21 0c.16 1.7-.01 3.37-.5 5-5.42-1.14-10.92-1.31-16.5-.5l-1.5 1.5c-.5 2.98-.66 5.98-.5 9h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe941a",
    d: "M1773.5 3723.5c.17 1.99-.5 3.66-2 5-4.22 1.3-8.38 1.3-12.5 0-.74-1.94-.58-3.77.5-5.5 4.72-.72 9.39-.55 14 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb25a",
    d: "M1844.5 3725.5c3.27 1.64 4.27 4.14 3 7.5-5.53 1.24-8.53-.92-9-6.5 1.46.91 2.46 2.24 3 4 1.19.93 2.52 1.26 4 1-.02-2.06-.35-4.06-1-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#46649a",
    d: "M3094.5 3726.5c-2.64 3.12-5.97 5.29-10 6.5-7.33.67-14.67.67-22 0-.56-.38-.89-.88-1-1.5a87.815 87.815 0 0 0 21 .5c3.91-2.1 7.91-3.93 12-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#889abc",
    d: "M3121.5 3727.5h2c3.05 2.86 6.71 4.69 11 5.5 6.04.7 12.04.53 18-.5-.11.62-.44 1.12-1 1.5-6.67.67-13.33.67-20 0-3.91-1.44-7.24-3.61-10-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#abb5cc",
    d: "M2804.5 3722.5c3.7 3.17 7.7 6 12 8.5 1.29.49 2.63.66 4 .5 1.1 1.06 2.43 1.89 4 2.5 4.67.67 9.33.67 14 0 6.83-1.69 12.83-4.85 18-9.5-1.3 3.3-3.63 5.63-7 7-15.53 6.63-30.2 4.97-44-5-.93-1.19-1.26-2.52-1-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afb8ce",
    d: "M2964.5 3727.5c-3.42 3.88-7.75 6.38-13 7.5-6.33.67-12.67.67-19 0-2.38-.22-4.05-1.39-5-3.5h3c.85 1.47 2.18 2.3 4 2.5 5.33.67 10.67.67 16 0 4.88-1.94 9.55-4.11 14-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7b1c9",
    d: "M3101.5 3720.5c-8.63 13.63-20.96 18.46-37 14.5-2.94-.14-5.28-1.31-7-3.5h4c.11.62.44 1.12 1 1.5 7.33.67 14.67.67 22 0 4.03-1.21 7.36-3.38 10-6.5 2.33-2 4.67-4 7-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffbc6e",
    d: "M1737.5 3701.5h-21c-.33 10.85.01 21.51 1 32v1c6.14.99 12.48 1.32 19 1-6.59 1.96-13.59 2.63-21 2a236.37 236.37 0 0 1-.5-36c7.6-1.33 15.1-1.33 22.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f13737",
    d: "M6464.5 3746.5c-257.13-1.33-514.13-1.33-771 0-.67 0-1 .33-1 1-.67 0-1-.33-1-1 .11-.62.44-1.12 1-1.5 128.67-.17 257.33-.33 386-.5 129 0 257.67.67 386 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f36969",
    d: "M5693.5 3746.5c256.87-1.33 513.87-1.33 771 0v1h-3c-255.83-1-511.83-1.33-768-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8aaaa",
    d: "M5693.5 3746.5c256.17-.33 512.17 0 768 1h-768v13c-.98-4.13-1.32-8.47-1-13 0-.67.33-1 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbe3e2",
    d: "M6457.5 3747.5c-254.17 1-508.5 1.33-763 1-.25 6.39.08 12.73 1 19-.62-.11-1.12-.44-1.5-1-.5-1.97-.66-3.97-.5-6v-13h764Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M6457.5 3747.5h4c.56 7.97-.44 15.64-3 23v2c-1.33 1-2.67 2-4 3-4.79 1.95-9.79 3.11-15 3.5-243.35.83-486.68.66-730-.5-2.06-.02-4.06-.35-6-1a53.87 53.87 0 0 1-6.5-6c-.79-1.24-1.29-2.58-1.5-4-.92-6.27-1.25-12.61-1-19 254.5.33 508.83 0 763-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f89d9c",
    d: "M6461.5 3747.5h3c.33 5.37-.01 10.71-1 16-1.13 2.79-2.8 5.12-5 7 2.56-7.36 3.56-15.03 3-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a087ec",
    d: "M4685.5 3749.5v1h-1c-5.32.76-10.65 1.43-16 2 1.53-1.63 3.53-2.46 6-2.5 3.65-.5 7.32-.67 11-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5daee",
    d: "M2866.5 3773.5c-1.16-3.83-3.49-6.83-7-9-1.63-1.83-3.3-3.66-5-5.5-2.45-.72-4.78-1.72-7-3-6.17.34-12 .17-17.5-.5-3.76.31-7.26 1.31-10.5 3 .85-1.59 2.18-2.76 4-3.5 16.63-5.09 30.47-.92 41.5 12.5.81 1.94 1.31 3.94 1.5 6ZM2927.5 3764.5a42.377 42.377 0 0 0-7-5c-2.36-1.63-5.02-2.8-8-3.5-7-.67-14-.67-21 0-4.53 1.76-8.53 4.26-12 7.5-.22-1.18.11-2.18 1-3 6.45-5.43 13.95-7.43 22.5-6 7.78-.96 14.94.54 21.5 4.5 1.66 1.49 2.66 3.32 3 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#67c0ee",
    d: "M2990.5 3764.5c-12.18-9.14-25.18-10.98-39-5.5a107.82 107.82 0 0 1-9 8.5c1.25-2.59 2.92-4.93 5-7 2.3-2.82 5.3-4.66 9-5.5 10.17-1.57 19.83-.24 29 4 2.27 1.43 3.93 3.26 5 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#59bcee",
    d: "M2920.5 3759.5c-8.78-2.82-17.78-3.66-27-2.5-3.9.78-6.9 2.78-9 6-1.95.37-3.62 1.2-5 2.5v-2c3.47-3.24 7.47-5.74 12-7.5 7-.67 14-.67 21 0 2.98.7 5.64 1.87 8 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#12a3ed",
    d: "M2859.5 3764.5c1.05 3.76 2.88 7.09 5.5 10 1.36 9.94 1.86 19.94 1.5 30-1.28 5.15-3.44 9.81-6.5 14-2.03 3.06-4.86 4.73-8.5 5-6.71 1.49-13.37 1.33-20-.5l-7.5-7.5c-.41.46-.91.79-1.5 1-1.32 6.15-1.32 12.15 0 18 .43 3.76-.24 7.26-2 10.5-.95.48-1.95.65-3 .5-3.61.29-7.11-.04-10.5-1-.5-22.66-.67-45.33-.5-68 1.22-3.88 2.89-7.55 5-11 1.72-3.39 4.39-5.72 8-7 3.24-1.69 6.74-2.69 10.5-3 5.5.67 11.33.84 17.5.5 2.22 1.28 4.55 2.28 7 3 1.7 1.84 3.37 3.67 5 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0fa3ed",
    d: "M2990.5 3764.5c3.23 6.08 5.23 12.58 6 19.5-.1 14.05-.1 27.72 0 41-1.59 6-3.59 11.83-6 17.5-5.44 3.13-10.94 6.13-16.5 9-7.05.22-14.22-.44-21.5-2-4.75-2.82-8.92-6.49-12.5-11a8.394 8.394 0 0 1-.5-4v-3c5.34-.17 10.68 0 16 .5.81 1.97 2.14 3.47 4 4.5 15.63 4.21 22.46-1.79 20.5-18-10.4 7.25-20.56 7.42-30.5.5-9.92-7.38-14.25-17.38-13-30-1.24-8.19.76-15.36 6-21.5 3.16-2.66 6.16-5.49 9-8.5 13.82-5.48 26.82-3.64 39 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0ca2ed",
    d: "M3058.5 3762.5c3.48 3.96 6.31 8.3 8.5 13 .09 3.53.76 6.86 2 10 .6 5.38.26 10.71-1 16-2.06 3.36-3.23 7.03-3.5 11h-1a32.254 32.254 0 0 0-4 4.5c-3.59 2.1-7.26 4.1-11 6-14.66 3.61-26.99.11-37-10.5-1.34-2.4-2.68-4.74-4-7a153.14 153.14 0 0 1-.5-28c1.28-2.22 2.28-4.55 3-7 3.23-3.19 6.06-6.69 8.5-10.5 5.36-.92 10.52-2.42 15.5-4.5 4.41.8 8.91 1.3 13.5 1.5 3.89 1.56 7.56 3.4 11 5.5ZM2920.5 3759.5c3.36 3.04 6.02 6.71 8 11a204.56 204.56 0 0 1 .5 35c-1.84 2.52-3.01 5.36-3.5 8.5a21.754 21.754 0 0 0-5 6c-3.98 1-7.65 2.5-11 4.5-.62-.11-1.12-.44-1.5-1-4.44.99-8.44 1.66-12 2-.85-1.62-1.85-1.96-3-1-3.86-.62-7.7-1.45-11.5-2.5a47.356 47.356 0 0 1-6.5-9.5c-1.13-4.15-1.63-7.82-1.5-11-.09-5.54 2.24-9.54 7-12 1.92-.29 3.59-1.13 5-2.5 8.86-.87 17.52-2.7 26-5.5 1.25-1.5 2.25-3.17 3-5a21.038 21.038 0 0 1-2-7c-6.11-2.64-12.11-2.47-18 .5-2.25 1.75-3.92 3.91-5 6.5-2.82.24-5.65.57-8.5 1-2.44-.65-3.61-2.32-3.5-5-.06-2.61.61-4.94 2-7 1.38-1.3 3.05-2.13 5-2.5 2.1-3.22 5.1-5.22 9-6 9.22-1.16 18.22-.32 27 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6fc3ee",
    d: "M3058.5 3762.5c-3.44-2.1-7.11-3.94-11-5.5-4.59-.2-9.09-.7-13.5-1.5a71.406 71.406 0 0 1-15.5 4.5 60.772 60.772 0 0 1-8.5 10.5c-.72 2.45-1.72 4.78-3 7-.69 9.36-.52 18.69.5 28a55.914 55.914 0 0 1-3.5-8c-.67-6-.67-12 0-18a26.85 26.85 0 0 0 4.5-10c3.05-3.05 5.72-6.38 8-10 13.21-6.26 26.54-6.43 40-.5 1.32.82 1.99 1.98 2 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5fbdee",
    d: "M2879.5 3765.5c-1.39 2.06-2.06 4.39-2 7-.11 2.68 1.06 4.35 3.5 5 2.85-.43 5.68-.76 8.5-1 1.08-2.59 2.75-4.75 5-6.5 5.89-2.97 11.89-3.14 18-.5.26 2.44.92 4.77 2 7-.75 1.83-1.75 3.5-3 5a120.06 120.06 0 0 1-26 5.5c-1.41 1.37-3.08 2.21-5 2.5.85-1.59 2.18-2.76 4-3.5 8.62-1.6 17.12-3.44 25.5-5.5 3.46-3.21 3.29-6.21-.5-9-4.63-1.16-9.3-1.33-14-.5-2.07 2.3-3.41 4.97-4 8-5.67-.82-11.34-.65-17 .5.17-1.32-.16-2.49-1-3.5 1.79-2.56 2.96-5.39 3.5-8.5.71-.88 1.54-1.55 2.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4625f",
    d: "M5691.5 3746.5c0 .67.33 1 1 1-.32 4.53.02 8.87 1 13-.16 2.03 0 4.03.5 6 .38.56.88.89 1.5 1 .21 1.42.71 2.76 1.5 4a53.87 53.87 0 0 0 6.5 6v1c-5.2-1.04-8.7-4.04-10.5-9a93.93 93.93 0 0 1-2.5-15c0-2.86.34-5.52 1-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efeeef",
    d: "M2846.5 3805.5c-7.42 5.86-14.25 5.19-20.5-2a61.434 61.434 0 0 0-3.5-6.5c.43-7.09 1.76-13.93 4-20.5 7.85-7.19 15.02-6.52 21.5 2 2.95 9.16 2.45 18.16-1.5 27Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eeedef",
    d: "M2979.5 3801.5a17.897 17.897 0 0 1-5 5c-13.04 5.15-20.04.65-21-13.5.66-4.48 1-8.98 1-13.5v-1c5.59-7.47 12.59-8.97 21-4.5 4.98 8.54 6.31 17.71 4 27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6fc3ee",
    d: "M2979.5 3801.5c2.31-9.79.98-18.96-4-27.5-8.41-4.47-15.41-2.97-21 4.5 1.04-5.87 4.54-9.2 10.5-10 3.28.46 6.45 1.29 9.5 2.5 2.7 3.36 5.37 6.7 8 10-.24 5.96-.74 12.13-1.5 18.5-.28.92-.78 1.58-1.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eeeeef",
    d: "M3041.5 3771.5c2.19.2 4.19.87 6 2 .61.89.94 1.89 1 3 .76 4.85 2.1 9.52 4 14-.27 3.02-.6 6.02-1 9-3.35 8.52-9.68 12.18-19 11l-2-2c-2.81-2.26-4.64-5.26-5.5-9-1.14-7.88-.47-15.54 2-23 3.78-4.49 8.61-6.16 14.5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9bd3ef",
    d: "M2850.5 3798.5c-.05 3.11-1.39 5.45-4 7 3.95-8.84 4.45-17.84 1.5-27-6.48-8.52-13.65-9.19-21.5-2-.09-1 .25-1.83 1-2.5 10.03-6.3 17.53-4.13 22.5 6.5.41 3.18.91 6.35 1.5 9.5.27 2.72-.07 5.56-1 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#79c6ee",
    d: "M2920.5 3759.5c2.48 1.41 4.81 3.08 7 5 1.61.44 2.78 1.44 3.5 3 .83 14.34.67 28.68-.5 43-2.68 3.36-5.34 6.7-8 10-3.95 2.54-8.28 3.87-13 4 3.35-2 7.02-3.5 11-4.5 1.31-2.31 2.98-4.31 5-6 .49-3.14 1.66-5.98 3.5-8.5.83-11.68.67-23.35-.5-35-1.98-4.29-4.64-7.96-8-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#58bcee",
    d: "M2990.5 3764.5c4.1 3.07 6.43 7.07 7 12 .9 17.2.9 35.53 0 55-1.42 4.28-3.75 7.94-7 11 2.41-5.67 4.41-11.5 6-17.5-.1-13.28-.1-26.95 0-41-.77-6.92-2.77-13.42-6-19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3deee",
    d: "M2997.5 3776.5c1.25.08 2.08.74 2.5 2 .67 16 .67 32 0 48-.1 2.15-.93 3.82-2.5 5 .9-19.47.9-37.8 0-55Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fde1e1",
    d: "M6454.5 3775.5c-2.14 3.11-5.14 4.45-9 4-244.98 1.16-489.98 1.33-735 .5-.56-.38-.89-.88-1-1.5 243.32 1.16 486.65 1.33 730 .5 5.21-.39 10.21-1.55 15-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fac2c2",
    d: "M5703.5 3778.5v-1c1.94.65 3.94.98 6 1 .11.62.44 1.12 1 1.5 245.02.83 490.02.66 735-.5-.61.89-.94 1.89-1 3-245 .33-490 0-735-1l-6-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f35a57",
    d: "M6458.5 3772.5c-2.8 6.16-7.47 9.5-14 10 .06-1.11.39-2.11 1-3 3.86.45 6.86-.89 9-4 1.33-1 2.67-2 4-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6ec3ee",
    d: "M2859.5 3764.5c3.51 2.17 5.84 5.17 7 9 3.92 10.37 3.92 20.7 0 31 .36-10.06-.14-20.06-1.5-30a24.654 24.654 0 0 1-5.5-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#61bfee",
    d: "M2850.5 3798.5c.93-2.94 1.27-5.78 1-8.5-.59-3.15-1.09-6.32-1.5-9.5-4.97-10.63-12.47-12.8-22.5-6.5-.75.67-1.09 1.5-1 2.5-2.24 6.57-3.57 13.41-4 20.5 1.29 2.09 2.46 4.25 3.5 6.5 6.25 7.19 13.08 7.86 20.5 2-1.42 4.17-4.42 6.17-9 6-6.83-.58-11.83-3.92-15-10-1.82-9.98-.82-19.31 3-28 1.48-.98 2.81-2.15 4-3.5 13.42-3.6 20.92 1.57 22.5 15.5.94 4.64.44 8.97-1.5 13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4db8ee",
    d: "M3047.5 3773.5c-1.81-1.13-3.81-1.8-6-2-3.27-1.82-6.61-1.99-10-.5a31.363 31.363 0 0 1-6 4.5c-3.49 9.11-3.99 18.44-1.5 28 1.53 1.23 2.7 2.73 3.5 4.5.95.48 1.95.65 3 .5l2 2a14.75 14.75 0 0 1-6.5-2c-4.54-7.23-6.7-14.73-6.5-22.5 1.58-3 2.75-6.17 3.5-9.5 5.89-8.25 13.39-10.25 22.5-6 .69 1.02 1.36 2.02 2 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#77c6ee",
    d: "M3048.5 3776.5c1-.09 1.83.25 2.5 1 2.26 6.16 2.93 12.5 2 19-.23 1.24-.73 2.24-1.5 3 .4-2.98.73-5.98 1-9-1.9-4.48-3.24-9.15-4-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#70c4ee",
    d: "M3058.5 3762.5c2.96 1.79 5.46 4.12 7.5 7 2.06 6.97 3.9 13.97 5.5 21-.23 8.11-2.56 15.44-7 22 .27-3.97 1.44-7.64 3.5-11 1.26-5.29 1.6-10.62 1-16-1.24-3.14-1.91-6.47-2-10-2.19-4.7-5.02-9.04-8.5-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5be",
    d: "M2910.5 3807.5c2.13-4.45 2.46-9.12 1-14-1.42-1.28-2.42-.94-3 1h-1c-6.2.29-11.86 1.96-17 5-.09-1 .25-1.83 1-2.5 1.83-.75 3.5-1.75 5-3 5.92-.44 11.59-1.44 17-3 2.67 2 2.67 4 0 6l1 1c-.77 2.41-1.27 4.91-1.5 7.5-.71.88-1.54 1.55-2.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3daee",
    d: "M3041.5 3771.5c-5.89-1.16-10.72.51-14.5 5-2.47 7.46-3.14 15.12-2 23 .86 3.74 2.69 6.74 5.5 9-1.05.15-2.05-.02-3-.5-.8-1.77-1.97-3.27-3.5-4.5-2.49-9.56-1.99-18.89 1.5-28 2.18-1.26 4.18-2.76 6-4.5 3.39-1.49 6.73-1.32 10 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3dfee",
    d: "M2811.5 3765.5a49.435 49.435 0 0 0-5 11c-.62.11-1.12.44-1.5 1-.17 2.67-.33 5.33-.5 8 .12 20.19.12 40.52 0 61-1.16-23.16-1.33-46.5-.5-70 1.41-4.54 3.91-8.21 7.5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4d5ee",
    d: "M2910.5 3807.5a25.305 25.305 0 0 1-4 4.5c-4.7.83-9.37.66-14-.5-3.2-3.48-3.86-7.48-2-12 5.14-3.04 10.8-4.71 17-5-5.06 2.21-10.22 4.21-15.5 6-2.44 6.69-.1 10.36 7 11 9.75-1.26 13.92-6.92 12.5-17h-3c.58-1.94 1.58-2.28 3-1 1.46 4.88 1.13 9.55-1 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0eeef",
    d: "M2907.5 3794.5h4c1.42 10.08-2.75 15.74-12.5 17-7.1-.64-9.44-4.31-7-11 5.28-1.79 10.44-3.79 15.5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8bcdee",
    d: "M2954.5 3779.5c0 4.52-.34 9.02-1 13.5.96 14.15 7.96 18.65 21 13.5-1.75 3.41-4.58 4.75-8.5 4-4.48.2-8.15-1.46-11-5a44.106 44.106 0 0 1-3.5-13.5c.65-4.04 1.65-8.21 3-12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#76c7ee",
    d: "M2806.5 3776.5c-.17 22.67 0 45.34.5 68 3.39.96 6.89 1.29 10.5 1-1.38.73-2.88 1.4-4.5 2-2.03-.49-4.19-.49-6.5 0-.67-.33-1.33-.67-2-1 .12-20.48.12-40.81 0-61 .17-2.67.33-5.33.5-8 .38-.56.88-.89 1.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#68c0ee",
    d: "M3007.5 3805.5c1.32 2.26 2.66 4.6 4 7 10.01 10.61 22.34 14.11 37 10.5 3.74-1.9 7.41-3.9 11-6 1.23-1.67 2.57-3.17 4-4.5-3.33 8.51-9.66 12.85-19 13-12.12 1.35-22.78-1.65-32-9-2.98-3.01-4.65-6.67-5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6ec3ee",
    d: "M2851.5 3823.5c-3.14 1.8-6.64 2.8-10.5 3-3.83-.54-7.66-1.04-11.5-1.5-.88-.71-1.55-1.54-2-2.5-1.04-2.29-2.54-3.29-4.5-3-.5 4.99-.67 9.99-.5 15-1.32-5.85-1.32-11.85 0-18 .59-.21 1.09-.54 1.5-1l7.5 7.5c6.63 1.83 13.29 1.99 20 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8cccee",
    d: "M2947.5 3760.5a25.413 25.413 0 0 0-5 7c-5.24 6.14-7.24 13.31-6 21.5-1.25 12.62 3.08 22.62 13 30 9.94 6.92 20.1 6.75 30.5-.5 1.96 16.21-4.87 22.21-20.5 18-1.86-1.03-3.19-2.53-4-4.5-5.32-.5-10.66-.67-16-.5v3c-2.26-.84-3.26-2.51-3-5 6.34-.17 12.68 0 19 .5 4.05 6.18 9.72 8.18 17 6 5.09-3.16 6.75-7.66 5-13.5a23.888 23.888 0 0 1-6 2.5c-6.36.83-12.69.66-19-.5-1.69-2.51-4.02-4.01-7-4.5a45.316 45.316 0 0 1-9.5-15.5c-.67-9.67-.67-19.33 0-29 1.42-6.91 5.25-11.91 11.5-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#61bfee",
    d: "M2873.5 3801.5c-.13 3.18.37 6.85 1.5 11 1.81 3.48 3.98 6.64 6.5 9.5 3.8 1.05 7.64 1.88 11.5 2.5 1.15-.96 2.15-.62 3 1 3.56-.34 7.56-1.01 12-2 .38.56.88.89 1.5 1-7.45 2.21-15.12 2.54-23 1-4.43-1.24-8.26-3.58-11.5-7-1.04-4.13-1.88-8.3-2.5-12.5.01-1.71.34-3.21 1-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6d6ee",
    d: "M3012.5 3816.5c9.22 7.35 19.88 10.35 32 9-4.67 2.91-9.67 3.41-15 1.5-6.98-1.58-12.65-5.08-17-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2deee",
    d: "M2922.5 3820.5c-1.32 2.19-3.32 3.69-6 4.5-9.08 3.22-18.42 4.22-28 3-1.26-.42-1.92-1.25-2-2.5 7.88 1.54 15.55 1.21 23-1 4.72-.13 9.05-1.46 13-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6dbee",
    d: "M2827.5 3822.5h-3c.17 6.01 0 12.01-.5 18-.47 1.75-1.14 3.41-2 5-3.16 2.21-6.66 3.55-10.5 4-2.14-.06-3.81-.72-5-2 2.31-.49 4.47-.49 6.5 0 1.62-.6 3.12-1.27 4.5-2 1.05.15 2.05-.02 3-.5 1.76-3.24 2.43-6.74 2-10.5-.17-5.01 0-10.01.5-15 1.96-.29 3.46.71 4.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7fc8ee",
    d: "M2990.5 3842.5c.13.74-.04 1.41-.5 2-2.74 2.62-5.57 5.12-8.5 7.5-8.67.67-17.33.67-26 0-1.44-.38-2.44-1.21-3-2.5 7.28 1.56 14.45 2.22 21.5 2 5.56-2.87 11.06-5.87 16.5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#464545",
    d: "M10135.5 4613.5c-12.4-1.21-24.7-2.71-37-4.5-14-.43-27.8-.6-41.5-.5-5.1.56-10.1 1.23-15 2-.3-.33-.7-.67-1-1-14.1 3.02-28.2 5.85-42.5 8.5-3.74.82-7.07 2.49-10 5-8.42 2.1-16.42 5.1-24 9-2.62.82-5.28 1.32-8 1.5 4.52-2.76 9.19-5.26 14-7.5 15.22-5.72 30.9-10.06 47-13 1.1-1.38 2.4-2.38 4-3 6.4-.28 12.8-1.28 19-3 24-.67 48-.67 72 0 6.2 1.84 12.5 2.84 19 3 1.5 1.03 2.9 2.2 4 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#636363",
    d: "M10135.5 4613.5c3.8-.24 7.4.26 11 1.5 13 4.83 26 9.49 39 14 1.8 2.39 4.1 4.06 7 5 5.1 1.04 10.1 2.37 15 4 .5.92 1.2 1.76 2 2.5 6.7 4.01 13.7 7.51 21 10.5 9.3 5.93 17.9 12.6 26 20 1.3.33 2.7.67 4 1 3.7 3.29 7.6 6.45 11.5 9.5 7.4 8.4 14.4 17.07 21 26 4.4 3.48 8.4 7.48 12 12 .3 1.67.7 3.33 1 5 3.8 2.26 6.6 5.26 8.5 9 .8 5.08 3.3 9.08 7.5 12 1.7 5.75 4.7 10.75 9 15 1.6 7.25 4.6 13.92 9 20 2.8 6.45 4.8 13.11 6 20 1.6 3.56 3.4 6.89 5.5 10 12.1 38.22 16.3 77.56 12.5 118-.3-.33-.7-.67-1-1-4.5 21.06-9.1 42.06-14 63-2.6 4.76-4.4 9.76-5.5 15-.8.89-1.8 1.22-3 1-2.9 8.1-6.1 16.1-9.5 24-1.8 2.21-3.5 4.55-5 7-1.1 3.98-3.3 7.31-6.5 10-.1 3.87-2 6.53-5.5 8-4.6 9.15-10.6 17.15-18 24-2.8 6.2-6.9 11.2-12.5 15-4.2 4.38-8.2 8.88-12 13.5-2.4 2.06-5.1 3.73-8 5-2.5 3.49-5.5 6.32-9 8.5-11 7.16-22 14.33-33 21.5-1.7.33-3.3.67-5 1-6.2 3.91-12.5 7.57-19 11-13.3 4.76-26.4 9.93-39.5 15.5-24.3 6.6-49 10.6-74 12-21.3-1.95-42.8-3.95-64.5-6-27.31-5.82-53.31-14.98-78-27.5-9.18-3.42-17.18-8.58-24-15.5-8.8-4.71-16.8-10.38-24-17 .13-.74-.04-1.41-.5-2-4-4.01-8.5-7.18-13.5-9.5-4.19-4.57-8.02-9.4-11.5-14.5a90.33 90.33 0 0 0-10-8c-1.43-5.6-4.6-9.93-9.5-13-4.18-8.36-9.35-16.02-15.5-23a36.944 36.944 0 0 0-8.5-14c-1.92-3.1-4.09-6.1-6.5-9a779.27 779.27 0 0 1-17.5-49c-.37-1.41-1.2-2.41-2.5-3a451.337 451.337 0 0 0-5.5-30c.32-5.66-.35-11.16-2-16.5.6-1.06.93-2.23 1-3.5a204.192 204.192 0 0 1-1.5-40 191.77 191.77 0 0 0 3-33l2-2c1.6-10.73 3.44-21.4 5.5-32a226.9 226.9 0 0 1 18.5-50c.92-.55 1.76-1.21 2.5-2 3.41-8.5 8.08-16.17 14-23 2.55-7.78 7.05-14.11 13.5-19 .44-3.11 1.78-5.78 4-8a372.364 372.364 0 0 1 33-33c2.23-2.76 4.4-5.6 6.5-8.5a628.02 628.02 0 0 1 53-32.5c1.55-.95 3.21-1.29 5-1v-3c2.06-.02 4.06-.35 6-1 2.72-.18 5.38-.68 8-1.5 7.58-3.9 15.58-6.9 24-9 2.93-2.51 6.26-4.18 10-5 14.3-2.65 28.4-5.48 42.5-8.5.3.33.7.67 1 1 4.9-.77 9.9-1.44 15-2 13.7-.1 27.5.07 41.5.5 12.3 1.79 24.6 3.29 37 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b4a4a",
    d: "M10314.5 4733.5c3.1 3.87 6.3 7.87 9.5 12 5.9 9.14 10.7 18.8 14.5 29 1 .48 1.8 1.14 2.5 2 3.5 11.24 7 22.58 10.5 34-2.1-3.11-3.9-6.44-5.5-10-1.2-6.89-3.2-13.55-6-20-4.4-6.08-7.4-12.75-9-20-4.3-4.25-7.3-9.25-9-15-4.2-2.92-6.7-6.92-7.5-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#312f2f",
    d: "M10172.5 4886.5c3.8 5.84 3.8 11.84 0 18-1.8-.01-3.5.49-5 1.5-26.3.5-52.7.67-79 .5v76c.3 5.86-2.4 9.7-8 11.5-6.9 1.81-11.9-.36-15-6.5.2-26.67 0-53.34-.5-80-26.1-.83-52.3-1.33-78.5-1.5-3.44-1.28-6.1-3.44-8-6.5-.17-3.35 0-6.68.5-10 .83-2.17 2.33-3.67 4.5-4.5 27-.33 54-.67 81-1 .8-26.09 1.3-52.26 1.5-78.5 2.6-7.57 7.8-10.07 15.5-7.5 1.4 2.23 3.4 3.39 6 3.5-.2 27 0 54 .5 81 27.1.83 54.3 1.33 81.5 1.5.9 1.04 1.9 1.88 3 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#424141",
    d: "M10172.5 4886.5c-1.1-.62-2.1-1.46-3-2.5-27.2-.17-54.4-.67-81.5-1.5-.5-27-.7-54-.5-81-2.6-.11-4.6-1.27-6-3.5-7.7-2.57-12.9-.07-15.5 7.5-.2 26.24-.7 52.41-1.5 78.5-27 .33-54 .67-81 1-2.17.83-3.67 2.33-4.5 4.5-.5 3.32-.67 6.65-.5 10-1.26-1.01-1.93-2.51-2-4.5.28-4.57 1.95-8.57 5-12 27.4-1.46 54.8-1.96 82-1.5.8-26.62 1.3-53.29 1.5-80 1.9-5.25 5.7-7.58 11.5-7 5 .38 9.1 2.38 12.5 6 .5 27.16.6 54.16.5 81 24.7-.17 49.3 0 74 .5 2.3.33 4.7.67 7 1 1.3.82 2 1.98 2 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c4c4c",
    d: "M9800.5 4814.5c-2.06 10.6-3.9 21.27-5.5 32l-2 2a191.77 191.77 0 0 1-3 33c-.81 13.38-.31 26.72 1.5 40-.07 1.27-.4 2.44-1 3.5 1.65 5.34 2.32 10.84 2 16.5-1.76-6.43-2.92-13.09-3.5-20-2.25-30-.25-59.67 6-89 1.41-6.25 3.24-12.25 5.5-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c4b4b",
    d: "M10172.5 4904.5c-.8 1.29-1.8 2.46-3 3.5-26.7.5-53.3.67-80 .5.3 24.84 0 49.51-1 74v-76c26.3.17 52.7 0 79-.5 1.5-1.01 3.2-1.51 5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a4949",
    d: "M9978.5 4899.5c1.9 3.06 4.56 5.22 8 6.5 26.2.17 52.4.67 78.5 1.5.5 26.66.7 53.33.5 80-2-25.98-2.7-52.31-2-79h-81c-1.33-3-2.67-6-4-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#484747",
    d: "M9824.5 5032.5c3.88 4.03 6.71 8.69 8.5 14 6.15 6.98 11.32 14.64 15.5 23 4.9 3.07 8.07 7.4 9.5 13a90.33 90.33 0 0 1 10 8c3.48 5.1 7.31 9.93 11.5 14.5 5 2.32 9.5 5.49 13.5 9.5.46.59.63 1.26.5 2-12.19-7.18-22.52-16.52-31-28-4.76-2.19-7.59-5.85-8.5-11-4.51-2.66-7.68-6.33-9.5-11-1.18.22-2.18-.11-3-1-.71-2.28-1.21-4.61-1.5-7-5.06-6.73-9.73-13.73-14-21a8.765 8.765 0 0 1-1.5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#454444",
    d: "M10254.5 5121.5c-4.3 4.16-8.6 8.32-13 12.5-14 6.83-27.6 14.5-41 23-20 7.73-40.3 14.73-61 21l-13 1c-.8.31-1.5.81-2 1.5-8.6.83-17.3 1.33-26 1.5.3.33.7.67 1 1-14.7.67-29.3.67-44 0-12.2-1.45-24.2-3.62-36-6.5 21.7 2.05 43.2 4.05 64.5 6 25-1.4 49.7-5.4 74-12 13.1-5.57 26.2-10.74 39.5-15.5 6.5-3.43 12.8-7.09 19-11 1.7-.33 3.3-.67 5-1 11-7.17 22-14.34 33-21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e39e26",
    d: "M1500.5 5656.5c-99.5-.33-198.83 0-298 1-1.91-.28-3.58.05-5 1-.62-.11-1.12-.44-1.5-1-3.67 1.57-7.5 2.57-11.5 3 .88-1.88 2.38-3.22 4.5-4l1 1c3.75-.8 7.58-1.3 11.5-1.5 99.83-.83 199.5-.67 299 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0af36",
    d: "M1202.5 5657.5c99.17-1 198.5-1.33 298-1 1.91-.28 3.58.05 5 1-.87.06-1.87.4-3 1-99.83-1-199.83-1.33-300-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#71d66c",
    d: "M1197.5 5658.5c101.39.01 203.06.01 305 0 1.13-.6 2.13-.94 3-1h1c23.48 4.24 42.48 16.24 57 36 .97 2.6 2.3 4.93 4 7 2.19 5.88 4.52 11.72 7 17.5-.56.38-.89.88-1 1.5.25 3.65.25 7.15 0 10.5.67 2.33 1.33 4.67 2 7-.84 7.08-1.84 14.08-3 21 .23.4.56.57 1 .5a89.1 89.1 0 0 1-7 20c-9.1 14.43-21.1 25.76-36 34-1.11.06-2.11.39-3 1-6.42 2.23-12.92 4.23-19.5 6-.38-.56-.88-.89-1.5-1h-309c-.67.33-1.33.67-2 1-.55-2.19-1.72-2.85-3.5-2-.85-1.62-1.85-1.96-3-1-4.46-1.48-8.96-2.81-13.5-4a66.855 66.855 0 0 1-12-5c-6.94-5.6-13.61-11.6-20-18-3.94-6.21-7.6-12.54-11-19-2.11-1.67-2.78-3.67-2-6-.95-4.1-1.95-7.77-3-11v-1c-.75-8.71-.75-17.71 0-27v-3c.96-.45 1.79-1.12 2.5-2 2.25-7.49 4.75-14.82 7.5-22 1.04-2.89 2.37-5.56 4-8a85.95 85.95 0 0 1 11-11c3.16-2.31 6.5-4.48 10-6.5 1.38-1.27 2.38-2.77 3-4.5a73.75 73.75 0 0 0 18-7c0-.67.33-1 1-1 4-.43 7.83-1.43 11.5-3 .38.56.88.89 1.5 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#98c151",
    d: "M1197.5 5658.5c1.42-.95 3.09-1.28 5-1 100.17-.33 200.17 0 300 1-101.94.01-203.61.01-305 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aab948",
    d: "M1183.5 5661.5a73.75 73.75 0 0 1-18 7c-.09-1 .25-1.83 1-2.5 5.58-1.71 11.24-3.21 17-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6a42c",
    d: "M1563.5 5693.5c-14.52-19.76-33.52-31.76-57-36 2.13-1.13 4.46-1.3 7-.5 16.96 4.56 31.46 13.06 43.5 25.5 3.11 2.98 5.28 6.65 6.5 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6e3c3",
    d: "M3045.5 5686.5a6.929 6.929 0 0 0-4-1c-5.53-5.53-12.19-9.19-20-11-5.3-2.37-10.97-3.87-17-4.5-102.33-.67-204.67-.67-307 0-5.64.91-10.97 2.41-16 4.5-9.4 2.53-17.73 6.86-25 13h-1c5.58-5.14 11.92-9.3 19-12.5 6.44-2.43 12.94-4.6 19.5-6.5h315c10.8 2.65 20.97 6.82 30.5 12.5 2.29 1.67 4.29 3.51 6 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#575db5",
    d: "M4486.5 5669.5c-.67.33-1.33.67-2 1-100.17-1.17-200.5-1.33-301-.5-.92.28-1.58.78-2 1.5-4.62-.09-8.95.91-13 3-1.72.13-3.38.46-5 1 1.25-1.64 2.92-2.8 5-3.5 4.22-.37 8.22-1.37 12-3 102.17-.83 204.17-.67 306 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1663f",
    d: "M5975.5 5669.5H5672a22.755 22.755 0 0 1-8.5 2c1.31-.73 2.64-1.57 4-2.5 102.83-.83 205.5-.67 308 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1e3be",
    d: "M7487.5 5674.5c-3.19-1.26-6.53-1.92-10-2-2.45-1.12-5.12-1.95-8-2.5-103.67-.67-207.33-.67-311 0-8.69 1.42-17.02 3.92-25 7.5 2.96-2.29 6.3-4.12 10-5.5 4.05-.79 8.05-1.79 12-3 106-.67 212-.67 318 0 3.46 1.74 7.12 2.74 11 3 1.44.38 2.44 1.21 3 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8fda8a",
    d: "M1475.5 5669.5c7.98-.77 15.98-.94 24-.5 2.21 1.04 4.55 1.71 7 2 2.07 2.28 4.4 4.11 7 5.5-8.28-3.13-16.78-5.46-25.5-7-2.83-.17-5.66.16-8.5 1-1.33-.33-2.67-.67-4-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9cdd98",
    d: "M3021.5 5674.5c-4.23-.49-8.39-1.15-12.5-2l-1 1c-2.91-2.36-6.24-3.36-10-3-99.35-.15-198.85.02-298.5.5-5.98 2.16-11.98 3.33-18 3.5 5.03-2.09 10.36-3.59 16-4.5 102.33-.67 204.67-.67 307 0 6.03.63 11.7 2.13 17 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#639294",
    d: "M4484.5 5670.5h-291c-2.89-.31-5.55.03-8 1h-4c.42-.72 1.08-1.22 2-1.5 100.5-.83 200.83-.67 301 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#616caa",
    d: "M4505.5 5672.5h-2c-.67.33-1.33.67-2 1-.11-.62-.44-1.12-1-1.5-3.81-.8-7.48-1.63-11-2.5 5.37-.32 10.71.68 16 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9953",
    d: "M5975.5 5669.5c3.35.08 6.52.75 9.5 2l1-1c1.3.58 2.47 1.25 3.5 2-1.64-.09-3.47.24-5.5 1-1.33-.67-2.67-1.33-4-2-1.96.28-4.12.28-6.5 0-97.6-1-195.26-1.33-293-1-3.76.09-7.26 1.09-10.5 3-2.04-.92-4.21-1.26-6.5-1v-1c2.98-.12 5.81-.79 8.5-2h303.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9bdd97",
    d: "M7477.5 5672.5c-.62.11-1.12.44-1.5 1-3.04-1.21-6.2-2.04-9.5-2.5-101.67-.67-203.33-.67-305 0l-15 3c-8.45 3.06-16.45 6.89-24 11.5 2.39-4.37 6.05-7.03 11-8 7.98-3.58 16.31-6.08 25-7.5 103.67-.67 207.33-.67 311 0 2.88.55 5.55 1.38 8 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#69a589",
    d: "M4489.5 5669.5c3.52.87 7.19 1.7 11 2.5.56.38.89.88 1 1.5-5.3-.88-10.63-1.54-16-2-.67 0-1-.33-1-1 .67-.33 1.33-.67 2-1 1-1.33 2-1.33 3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#adb746",
    d: "M1165.5 5668.5c-.62 1.73-1.62 3.23-3 4.5-3.5 2.02-6.84 4.19-10 6.5.06-1.11.39-2.11 1-3 1.84-1.01 3.17-2.51 4-4.5 2.84-.92 5.5-2.09 8-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0e2bc",
    d: "M1475.5 5669.5c1.33.33 2.67.67 4 1-5.66 1.96-11.33 3.13-17 3.5a719.11 719.11 0 0 1-16 5.5c8.7-6.53 18.36-9.87 29-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e8e8",
    d: "M1479.5 5670.5c22.76.21 41.76 8.88 57 26 2.45 2.13 4.12 4.8 5 8 7.46 15.08 10.13 31.08 8 48-.67 3.67-1.33 7.33-2 11-3.71 7.74-8.21 15.07-13.5 22-3.93 3.05-7.76 6.21-11.5 9.5-1.24.79-2.58 1.29-4 1.5-11.39 5.85-23.56 9.19-36.5 10-13.16-.87-25.33-4.54-36.5-11-3.93-1.94-7.6-4.27-11-7-5.04-7.72-9.87-15.72-14.5-24a94.392 94.392 0 0 1-4.5-18.5c-.24-7.24.26-15.08 1.5-23.5 3.13-9.93 7.3-19.26 12.5-28 5.38-5.38 11.04-10.38 17-15 5.35-1.77 10.68-3.6 16-5.5 5.67-.37 11.34-1.54 17-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#71d66c",
    d: "M4193.5 5670.5c-.85 1.47-2.18 2.3-4 2.5.67.33 1.33.67 2 1 97.67.67 195.33.67 293 0 1-.33 2-.67 3-1-.92-.28-1.58-.78-2-1.5 5.37.46 10.7 1.12 16 2 .67-.33 1.33-.67 2-1-.03 1 .47 1.66 1.5 2 4.48 1.58 8.98 3.08 13.5 4.5 3.65 2.89 7.65 5.22 12 7 3.43 4.2 7.43 7.7 12 10.5.29 2.63 1.62 4.29 4 5 2.31 4.18 4.47 8.51 6.5 13 1.36.86 2.53 1.86 3.5 3v1c.88 6.46 2.88 12.46 6 18-.33.67-.67 1.33-1 2-.32 4.2.02 8.2 1 12v1a50.28 50.28 0 0 0-1 18v1c-1-.09-1.83.25-2.5 1-.52 4.08-1.36 8.08-2.5 12v1c-2.77 1.87-4.27 4.53-4.5 8-2.8 2.26-5.13 4.93-7 8-.48.95-.65 1.95-.5 3a83.13 83.13 0 0 1-9 9c-3.55.55-5.89 2.55-7 6h-1c-3.05.22-5.38 1.56-7 4-4.11 1.25-7.78 3.25-11 6h-3c.07-.44-.1-.77-.5-1-5.9 2.95-11.74 3.95-17.5 3h-298c-5.99.8-12.15-.2-18.5-3-.4.23-.57.56-.5 1h-3c-1.7-1.69-3.7-3.03-6-4-5.62-3.33-11.29-6.66-17-10-2.97-2.64-5.97-5.3-9-8a29.43 29.43 0 0 1-5-6c-.64-2.29-1.97-3.96-4-5-.61-1.93-1.61-3.6-3-5-.25-2.47-1.25-4.47-3-6a100.11 100.11 0 0 0-3.5-9 31.465 31.465 0 0 1-1.5-10c.11-.62.44-1.12 1-1.5-.69-3.02-1.69-5.86-3-8.5v-2c-.45-5.14.22-10.64 2-16.5-.23-.4-.56-.57-1-.5v-1c1.42-1.69 2.75-3.52 4-5.5-.56-.72-.89-1.56-1-2.5 1.54-2.86 2.54-5.86 3-9v-1c4.65-5.96 8.82-12.3 12.5-19 7.53-7.18 15.69-13.51 24.5-19 2.45-1.56 5.12-2.56 8-3 2.96-.56 5.8-1.56 8.5-3 2.72.14 5.38.14 8 0 .99-.57 1.83-1.23 2.5-2 2.45-.97 5.11-1.31 8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73db69",
    d: "M4193.5 5670.5h291c0 .67.33 1 1 1 .42.72 1.08 1.22 2 1.5-1 .33-2 .67-3 1-97.67.67-195.33.67-293 0-.67-.33-1.33-.67-2-1 1.82-.2 3.15-1.03 4-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#71d66c",
    d: "M5680.5 5670.5c-.93.81-1.93 1.65-3 2.5 2.16.91 4.33 1.75 6.5 2.5 95.33-1.33 190.67-1.33 286 0 1.82-.83 3.65-1.66 5.5-2.5-.92-.28-1.58-.78-2-1.5 2.38.28 4.54.28 6.5 0 1.33.67 2.67 1.33 4 2 2.03-.76 3.86-1.09 5.5-1h1c3.97 1.32 7.97 2.66 12 4 2.67 1 5.33 2 8 3 1.21 2.61 3.21 4.27 6 5 7.27 6.51 14.1 13.51 20.5 21 1.48 4.98 3.98 9.31 7.5 13 1.13 7.68 3.13 15.01 6 22 .45 14.55-1.55 28.88-6 43-1.85 1.53-2.85 3.53-3 6l-2 2c-2.56 3.74-5.39 7.41-8.5 11-.48.95-.65 1.95-.5 3a6.603 6.603 0 0 0-3 3c-5.16 3.64-10.5 7.14-16 10.5-.75.67-1.09 1.5-1 2.5-.99-.17-1.66.16-2 1-7.95 3.41-16.28 5.74-25 7-103.83-.33-207.5 0-311 1-10.4-1.88-20.4-4.88-30-9-1.67-.67-3.33-1.33-5-2-.33-.67-.67-1.33-1-2-2.43-3.76-5.77-6.43-10-8a565.65 565.65 0 0 0-6-6 26.15 26.15 0 0 1-5-7c-.61-1.93-1.61-3.6-3-5-2.37-2.08-3.71-4.75-4-8-2.99-12.13-5.32-24.13-7-36 1.29-3.77 1.96-7.77 2-12v-1c3.11-5.49 5.11-11.49 6-18 2.19-2.2 3.53-4.87 4-8 1.46-2.54 3.13-4.87 5-7 1.54-.2 2.88-.87 4-2 3.36-4.11 6.7-8.11 10-12 2.95-1.28 5.28-3.28 7-6 1.82-.33 3.49-1 5-2 4.91-1.58 9.91-3.08 15-4.5 1.26-.42 1.92-1.25 2-2.5h2c2.29-.26 4.46.08 6.5 1 3.24-1.91 6.74-2.91 10.5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6eda6e",
    d: "M5680.5 5670.5c97.74-.33 195.4 0 293 1 .42.72 1.08 1.22 2 1.5-1.85.84-3.68 1.67-5.5 2.5-95.33-1.33-190.67-1.33-286 0-2.17-.75-4.34-1.59-6.5-2.5 1.07-.85 2.07-1.69 3-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#71d66c",
    d: "M3021.5 5674.5c7.81 1.81 14.47 5.47 20 11 16.06 12.36 26.56 28.36 31.5 48 .38.56.88.89 1.5 1v1c-.44-.07-.77.1-1 .5.67 2 1.33 4 2 6 .07 5.3-.1 10.8-.5 16.5-1.3 6.23-2.46 12.56-3.5 19-3.57 6.61-7.23 13.27-11 20-4.78 5.93-9.78 11.59-15 17-1.19.77-2.19 1.77-3 3-3.49.91-6.49 2.58-9 5-3.14.69-6.14 1.86-9 3.5-4.32.5-8.65.67-13 .5v3c-102.66.97-205.33 1.3-308 1-.62.11-1.12.44-1.5 1-5.85-.77-11.68-1.77-17.5-3-4.23-.28-8.23-1.44-12-3.5-4.24-2.76-8.58-5.26-13-7.5-1.01-1.84-2.51-3.17-4.5-4-.31-1.27-.81-2.43-1.5-3.5-2.93-2.02-5.76-4.18-8.5-6.5-2.61-4.91-5.44-9.57-8.5-14-.7-4.09-2.2-7.76-4.5-11-.11-4.56-1.11-8.89-3-13-.17-8.51-.67-16.84-1.5-25v-1c1.04-2.58 2.37-5.08 4-7.5l-1-1c1.94-7.72 4.61-15.22 8-22.5l18-21c7.27-6.14 15.6-10.47 25-13 6.02-.17 12.02-1.34 18-3.5 99.65-.48 199.15-.65 298.5-.5 3.76-.36 7.09.64 10 3l1-1c4.11.85 8.27 1.51 12.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d66ae",
    d: "M4506.5 5672.5c2.94.48 5.61 1.48 8 3-3.15.08-5.82-.92-8-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b27f48",
    d: "M5990.5 5672.5c4.82-.76 8.82.57 12 4-4.03-1.34-8.03-2.68-12-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#71d56c",
    d: "M7477.5 5672.5c3.47.08 6.81.74 10 2 5.27 2.72 10.61 5.55 16 8.5 1.56.76 2.56 1.93 3 3.5 3.9 3.72 8.07 7.38 12.5 11 1.61 3.44 3.78 6.44 6.5 9 2.17 1.84 3.5 4.17 4 7a192.08 192.08 0 0 1 9 29c-.66 5.34-.66 10.84 0 16.5-2.9 21.31-12.4 38.81-28.5 52.5-.27 1.83-1.11 3.33-2.5 4.5-4.6 3.36-9.6 5.86-15 7.5a159.46 159.46 0 0 1-15 5.5c-5.67.33-11.33.67-17 1-98 .67-196 .67-294 0-5.02-.41-10.02-.91-15-1.5a30.64 30.64 0 0 1-9-1.5c-5.04-1.77-10.04-3.61-15-5.5-3.73-4.05-7.73-7.88-12-11.5-1.33-.67-2.67-1.33-4-2-.74-2.9-2.4-5.07-5-6.5-.67-.33-1.33-.67-2-1-2.08-3.72-4.08-7.38-6-11-3.47-9.68-6.47-19.52-9-29.5.42-2.96.42-6.13 0-9.5.13-14.18 3.96-27.18 11.5-39 .49-1.29.66-2.63.5-4 3.91-5.92 8.24-11.59 13-17 2.68-1.69 5.35-3.36 8-5 7.55-4.61 15.55-8.44 24-11.5l15-3c101.67-.67 203.33-.67 305 0 3.3.46 6.46 1.29 9.5 2.5.38-.56.88-.89 1.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#69aa86",
    d: "M4181.5 5671.5h4c-.67.77-1.51 1.43-2.5 2-2.62.14-5.28.14-8 0-2.7 1.44-5.54 2.44-8.5 3l2-2c4.05-2.09 8.38-3.09 13-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#96a558",
    d: "M5661.5 5672.5c-.08 1.25-.74 2.08-2 2.5-5.09 1.42-10.09 2.92-15 4.5 5.2-3.29 10.87-5.63 17-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#637ba2",
    d: "m4168.5 5674.5-2 2c-2.88.44-5.55 1.44-8 3a81.67 81.67 0 0 0-11 5c4.44-4.49 9.78-7.49 16-9 1.62-.54 3.28-.87 5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bee2ba",
    d: "M1479.5 5670.5c2.84-.84 5.67-1.17 8.5-1 8.72 1.54 17.22 3.87 25.5 7 10.16 3.83 17.83 10.5 23 20-15.24-17.12-34.24-25.79-57-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6a52c",
    d: "M1153.5 5676.5c-.61.89-.94 1.89-1 3a85.95 85.95 0 0 0-11 11c2.25-6.24 6.25-10.91 12-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4dea0",
    d: "M3002.5 5684.5c-9.24-1.63-18.58-2.29-28-2 .67-.77 1.51-1.43 2.5-2 3.81.95 7.48.95 11 0 5 1.06 9.83 2.39 14.5 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb7343",
    d: "M6010.5 5679.5c3.5 1.25 6.5 3.25 9 6-1.11-.06-2.11-.39-3-1-2.79-.73-4.79-2.39-6-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e8e8",
    d: "M3035.5 5706.5c3.25 4.16 6.25 8.49 9 13 .13 1.72.46 3.38 1 5 .47 4.52 1.64 8.85 3.5 13 .67 9 .67 18 0 27-2.69 9.03-6.19 17.7-10.5 26-5.31 7.67-11.98 14.01-20 19-4.75 1.53-9.42 3.36-14 5.5-10.43 3.26-21.1 4.26-32 3a40.216 40.216 0 0 0-12-3c-4.36-1.95-8.7-3.78-13-5.5-5.4-2.7-10.07-6.37-14-11-2.92-4.77-6.09-9.43-9.5-14-4.45-9.05-7.28-18.55-8.5-28.5.38-6.42.72-13.58 1-21.5 4.51-12.53 11.17-23.86 20-34 3.24-3.41 6.91-6.24 11-8.5 5.29-1.97 10.62-3.97 16-6 3.26-.21 6.42-.71 9.5-1.5 11.44-1.47 23.94.03 37.5 4.5 8.68 5.34 17.01 11.17 25 17.5ZM4497.5 5688.5c1.07.93 2.4 1.27 4 1a37.64 37.64 0 0 0 9 5c2.89 4.73 6.72 8.73 11.5 12 20.12 29.13 20.62 58.13 1.5 87-.89 2.72-2.39 5.06-4.5 7-1.26 2.11-3.1 3.11-5.5 3-22.62 16.59-46.95 19.42-73 8.5a64.616 64.616 0 0 1-9-6 8.394 8.394 0 0 0-4-.5c-10.07-10.42-17.74-22.42-23-36 .08-5.27-.59-10.1-2-14.5.87-6.93 1.53-14.43 2-22.5v-4c3.41-5.17 6.07-10.84 8-17 5.19-4.77 10.19-9.77 15-15h2c4.93-2.8 9.93-5.64 15-8.5 4.6-.66 8.93-1.82 13-3.5 1.19.55 2.36.88 3.5 1 1.33-.67 2.67-1.33 4-2 3.33 1.33 6.67 1.33 10 0 7.64 1.3 15.14 2.97 22.5 5ZM5953.5 5683.5c2.38.1 4.88.1 7.5 0 2.33.67 4.67 1.33 7 2l1-1c12.69 2.89 24.19 8.22 34.5 16 3.92 3.26 7.59 6.92 11 11a108.63 108.63 0 0 1 8 18c6.37 27.71.04 51.88-19 72.5-5.5 3.59-11.17 6.92-17 10-16.6 7.41-33.6 8.41-51 3-4.36-1.95-8.7-3.78-13-5.5-1.67-.67-3.33-1.33-5-2-1.67-3.67-4.33-6.33-8-8-14.32-16.58-20.49-35.58-18.5-57 1.53-9.15 4.37-18.15 8.5-27 1.39-3.11 3.06-6.11 5-9a377.72 377.72 0 0 1 18-14.5c6.18-2.58 12.51-4.92 19-7 3.94-1.02 7.94-1.52 12-1.5ZM7483.5 5694.5c5.94 5.11 11.44 10.78 16.5 17 3.8 6.61 7.3 13.28 10.5 20 1.97 5.2 3.3 10.53 4 16v1c.45 3.78-.21 8.28-2 13.5l1 1c-1.09 2.57-2.09 5.07-3 7.5a248.11 248.11 0 0 1-9 19c-17.38 21.56-39.71 31.22-67 29-8.36-2.67-16.69-5.67-25-9-5.65-4.64-11.31-9.31-17-14-4.25-4.25-7.25-9.25-9-15-2.06-7.17-3.89-14.5-5.5-22-.64-14.75 2.19-28.75 8.5-42 .61-.89.94-1.89 1-3 .55-1.89 1.55-3.56 3-5 3.41-3.09 6.74-6.09 10-9 5.48-4.25 11.48-7.75 18-10.5 7.64-2.58 15.14-4.42 22.5-5.5 3.33 1.33 6.67 1.33 10 0 4.04 1.29 8.2 2.13 12.5 2.5 6.8 2.66 13.46 5.49 20 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#689a90",
    d: "M4158.5 5679.5a151.546 151.546 0 0 0-24.5 19c-3.68 6.7-7.85 13.04-12.5 19-.27-1.6.07-2.93 1-4 1.6-.79 2.27-2.12 2-4 1.33-3.32 3.16-6.32 5.5-9 3.73-3.9 7.56-7.56 11.5-11 2.41-1.2 4.41-2.87 6-5a81.67 81.67 0 0 1 11-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ae844b",
    d: "M5639.5 5681.5c-1.72 2.72-4.05 4.72-7 6 1.4-3.06 3.73-5.06 7-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6e1b2",
    d: "M4501.5 5689.5c-1.6.27-2.93-.07-4-1-12.89-6.12-26.22-7.46-40-4-4.07 1.68-8.4 2.84-13 3.5-5.07 2.86-10.07 5.7-15 8.5 1.26-2.19 3.09-3.85 5.5-5 17.7-10.86 36.2-13.36 55.5-7.5 4.11 1.19 7.78 3.02 11 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cce4c9",
    d: "M4497.5 5688.5c-7.36-2.03-14.86-3.7-22.5-5-3.33 1.33-6.67 1.33-10 0-1.33.67-2.67 1.33-4 2-1.14-.12-2.31-.45-3.5-1 13.78-3.46 27.11-2.12 40 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5b5eb4",
    d: "M4147.5 5684.5c-1.59 2.13-3.59 3.8-6 5 1.14-2.59 3.14-4.25 6-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#689c8f",
    d: "M4503.5 5672.5h3c2.18 2.08 4.85 3.08 8 3 9.48 5.13 18.48 11.13 27 18 .63.92.96 1.92 1 3-4.57-2.8-8.57-6.3-12-10.5a49.299 49.299 0 0 1-12-7c-4.52-1.42-9.02-2.92-13.5-4.5-1.03-.34-1.53-1-1.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6e3c3",
    d: "M5977.5 5684.5c8.32 3.33 16.32 7.5 24 12.5a18.25 18.25 0 0 1 2 3.5c-10.31-7.78-21.81-13.11-34.5-16l-1 1c-2.33-.67-4.67-1.33-7-2-2.62.1-5.12.1-7.5 0 2.14-.66 4.47-1 7-1 5.69.51 11.36 1.17 17 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bee2ba",
    d: "M7483.5 5694.5c-6.54-3.01-13.2-5.84-20-8.5-4.3-.37-8.46-1.21-12.5-2.5-3.33 1.33-6.67 1.33-10 0-7.36 1.08-14.86 2.92-22.5 5.5-6.52 2.75-12.52 6.25-18 10.5 2.8-2.3 5.46-4.8 8-7.5 10.53-5.06 21.36-8.9 32.5-11.5 3.33 1.33 6.67 1.33 10 0 10.08 1.58 19.58 4.75 28.5 9.5.86 2.02 2.19 3.52 4 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ade0aa",
    d: "M7506.5 5686.5c1.37-.16 2.71.01 4 .5 3.47 4.81 7.64 8.97 12.5 12.5.38 2.56 1.22 4.89 2.5 7a29.297 29.297 0 0 1-6.5-9c-4.43-3.62-8.6-7.28-12.5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1e3be",
    d: "M7114.5 5690.5c-4.76 5.41-9.09 11.08-13 17a41.076 41.076 0 0 1-5 7c3.58-9.83 9.58-17.83 18-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ba358",
    d: "M5632.5 5687.5c-3.3 3.89-6.64 7.89-10 12-1.12 1.13-2.46 1.8-4 2 3-6.33 7.67-11 14-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9c54",
    d: "M6016.5 5684.5c.89.61 1.89.94 3 1l19 19c2 4.67 4 9.33 6 14-3.52-3.69-6.02-8.02-7.5-13-6.4-7.49-13.23-14.49-20.5-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#abdfa7",
    d: "M2655.5 5687.5h1l-18 21c-3.39 7.28-6.06 14.78-8 22.5l1 1a40.522 40.522 0 0 0-4 7.5c1.32-8.93 3.65-17.59 7-26 1.89-4.71 4.39-9.05 7.5-13 4.04-4.87 8.54-9.21 13.5-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0de9c",
    d: "M3041.5 5685.5c1.46-.07 2.79.27 4 1 7.3 6.47 14.13 13.47 20.5 21 1.38 5.74 3.54 11.07 6.5 16a49.35 49.35 0 0 1 2 11c-.62-.11-1.12-.44-1.5-1-4.94-19.64-15.44-35.64-31.5-48Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#69a18b",
    d: "M4542.5 5696.5c.99-.17 1.66.16 2 1 .67 1.33 1.33 2.67 2 4-2.38-.71-3.71-2.37-4-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99dc95",
    d: "M4427.5 5696.5c-4.81 5.23-9.81 10.23-15 15 3.33-6.67 8.33-11.67 15-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#595cb6",
    d: "M4544.5 5697.5c2.5.63 3.83 2.3 4 5-.67-.33-1.33-.67-2-1-.67-1.33-1.33-2.67-2-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeb846",
    d: "M1137.5 5698.5c-2.75 7.18-5.25 14.51-7.5 22-.71.88-1.54 1.55-2.5 2-.44.07-.77-.1-1-.5a44.2 44.2 0 0 0 3.5-14.5c2.33-2.15 3.66-4.82 4-8 1.01-.84 2.18-1.17 3.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5851bc",
    d: "M4548.5 5702.5c1.95.78 3.45 2.12 4.5 4 .99 2.47 2.16 4.8 3.5 7a7.48 7.48 0 0 1-3-2 38.665 38.665 0 0 0-5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bbe2b7",
    d: "M2974.5 5682.5c9.42-.29 18.76.37 28 2 11.68 4.83 22.51 11.17 32.5 19 .48.95.65 1.95.5 3a257.464 257.464 0 0 0-25-17.5c-13.56-4.47-26.06-5.97-37.5-4.5-3.08.79-6.24 1.29-9.5 1.5-5.38 2.03-10.71 4.03-16 6a45.324 45.324 0 0 0-11 8.5c-8.83 10.14-15.49 21.47-20 34 1.02-4.75 2.35-9.42 4-14 3.1-3.87 5.44-8.2 7-13 4.79-4.29 9.46-8.79 14-13.5 5.76-3.55 11.76-6.55 18-9 4.86-1.67 9.86-2.51 15-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0e3bc",
    d: "M7483.5 5694.5c11.5 6.5 19.83 15.83 25 28 .37 3.07 1.04 6.07 2 9-3.2-6.72-6.7-13.39-10.5-20-5.06-6.22-10.56-11.89-16.5-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3a62e",
    d: "M1567.5 5700.5c2.46 4.24 4.96 8.57 7.5 13 .26 4.52 1.26 8.85 3 13 .31 8.92.48 17.42.5 25.5-.9 2.31-2.23 4.14-4 5.5-.03-3.34.63-6.5 2-9.5-.14-5.73-.14-11.73 0-18-1.06-3.61-2.06-7.11-3-10.5.11-.62.44-1.12 1-1.5-2.48-5.78-4.81-11.62-7-17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#606aab",
    d: "M4124.5 5709.5c.27 1.88-.4 3.21-2 4 .16-1.65.83-2.99 2-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#69a589",
    d: "M4546.5 5701.5c.67.33 1.33.67 2 1 2.04 2.73 3.71 5.73 5 9a7.48 7.48 0 0 0 3 2v4c-.97-1.14-2.14-2.14-3.5-3-2.03-4.49-4.19-8.82-6.5-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a1de9d",
    d: "M5977.5 5684.5c-5.64-.83-11.31-1.49-17-2-2.53 0-4.86.34-7 1-4.06-.02-8.06.48-12 1.5-6.49 2.08-12.82 4.42-19 7a377.72 377.72 0 0 0-18 14.5 60.237 60.237 0 0 0-5 9c-3.51 4.35-6.01 9.35-7.5 15-6.46 22.51-2.29 44.51 12.5 66-1 .09-1.83-.25-2.5-1-18.22-27.78-19.05-56.11-2.5-85 5.33-6 11-11.67 17-17 6.14-2.9 12.14-6.07 18-9.5 14.89-4.54 29.22-4.37 43 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c9b54",
    d: "M5613.5 5708.5c-.47 3.13-1.81 5.8-4 8 .29-3.25 1.63-5.92 4-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c5eb4",
    d: "M4556.5 5715.5c1.95 1.82 2.95 4.15 3 7-1-1.33-2-2.67-3-4v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a9e56",
    d: "M5609.5 5716.5c-.89 6.51-2.89 12.51-6 18h-1v-1a63.39 63.39 0 0 1 7-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#97dc93",
    d: "M2920.5 5720.5a108.43 108.43 0 0 0-4 14c-1.04 4.06-2.04 8.23-3 12.5.46 6.36 1.13 13.52 2 21.5-.85-3.36-2.02-6.7-3.5-10-.37-5.51-.54-10.84-.5-16a359.22 359.22 0 0 1 6.5-21c.67-.75 1.5-1.09 2.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9edd9a",
    d: "M6014.5 5711.5c1.22.53 2.39 1.19 3.5 2a119.24 119.24 0 0 1 9.5 28.5c-.07.76-.4 1.26-1 1.5-1.04-4.83-2.37-9.5-4-14a108.63 108.63 0 0 0-8-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2de9f",
    d: "M7529.5 5713.5c2.87 4.4 5.2 9.06 7 14a51.55 51.55 0 0 1 2 15 192.08 192.08 0 0 0-9-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cf5538",
    d: "M5618.5 5701.5a43.232 43.232 0 0 0-5 7c-2.37 2.08-3.71 4.75-4 8a63.39 63.39 0 0 0-7 17c-.16-2.69 0-5.35.5-8 1.95-2.64 2.95-5.64 3-9 2.52-3.03 4.52-6.37 6-10 1.78-2.29 3.94-3.96 6.5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5852bb",
    d: "M4559.5 5722.5c3.43 3.19 4.76 7.19 4 12h-1c-1.41-3.9-2.41-7.9-3-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c9c54",
    d: "M6044.5 5718.5c3.8 6.75 5.8 14.08 6 22-2.87-6.99-4.87-14.32-6-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#97c052",
    d: "M1573.5 5719.5c.94 3.39 1.94 6.89 3 10.5-.14 6.27-.14 12.27 0 18-1.37 3-2.03 6.16-2 9.5 0 .67-.33 1-1 1-.44.07-.77-.1-1-.5 1.16-6.92 2.16-13.92 3-21-.67-2.33-1.33-4.67-2-7 .25-3.35.25-6.85 0-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#68a788",
    d: "M4556.5 5718.5c1 1.33 2 2.67 3 4 .59 4.1 1.59 8.1 3 12v2c-3.12-5.54-5.12-11.54-6-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbe4c8",
    d: "M7386.5 5716.5c-6.31 13.25-9.14 27.25-8.5 42 1.61 7.5 3.44 14.83 5.5 22-1.07-2.46-2.4-4.8-4-7-4.16-15.04-4-30.04.5-45 1.52-4.46 3.69-8.46 6.5-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9fdd9b",
    d: "M3044.5 5719.5c2.61 3.56 4.44 7.56 5.5 12 5.05 18.63 3.21 36.63-5.5 54-1.34 1.37-2.67 2.7-4 4 9.72-16.58 12.89-34.25 9.5-53a78.606 78.606 0 0 0-4.5-12c-.54-1.62-.87-3.28-1-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#699394",
    d: "M4121.5 5718.5c-.46 3.14-1.46 6.14-3 9 .11.94.44 1.78 1 2.5a50.092 50.092 0 0 1-4 5.5c.67-4 1.33-8 2-12 1.1-1.89 2.44-3.56 4-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3a62e",
    d: "M1127.5 5725.5c-.75 9.29-.75 18.29 0 27-.72-1.59-1.72-3.09-3-4.5l1-1c-3.24-7.47-2.57-14.63 2-21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbe4c8",
    d: "M1541.5 5704.5c3.13 3.93 5.46 8.26 7 13 1.11 4.87 2.11 10.04 3 15.5-.17 3.74-.17 7.41 0 11-.63 2.94-1.29 5.77-2 8.5 2.13-16.92-.54-32.92-8-48Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8dda88",
    d: "M7387.5 5713.5c-.06 1.11-.39 2.11-1 3-2.81 3.54-4.98 7.54-6.5 12-4.5 14.96-4.66 29.96-.5 45-2.69-5.91-4.19-12.25-4.5-19-1.03-7.79-1.2-15.46-.5-23h3c-.16-1.7.01-3.37.5-5 2.63-2.45 4.3-5.45 5-9 1.37-1.54 2.87-2.87 4.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5550bd",
    d: "M4117.5 5723.5c-.67 4-1.33 8-2 12v1c-2.05 5.59-2.38 11.26-1 17v2c-.33.67-.67 1.33-1 2-.8-5.34-1.47-10.5-2-15.5a44.2 44.2 0 0 0 3.5-14.5c.61-1.57 1.44-2.9 2.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a1de9e",
    d: "M1548.5 5717.5c1.57 1.18 2.4 2.85 2.5 5 1.96 10.66 1.96 21.33 0 32-.66 3.3-1.83 6.3-3.5 9 .67-3.67 1.33-7.33 2-11 .71-2.73 1.37-5.56 2-8.5-.17-3.59-.17-7.26 0-11-.89-5.46-1.89-10.63-3-15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9add96",
    d: "M7508.5 5722.5c.78 1.58 1.95 2.91 3.5 4 .58 4.18 1.58 8.18 3 12 .8 3.2.64 6.2-.5 9-.7-5.47-2.03-10.8-4-16-.96-2.93-1.63-5.93-2-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#69ad84",
    d: "M4561.5 5738.5c1.44 1.45 2.11 3.28 2 5.5-.52 2.44-.86 4.61-1 6.5-.98-3.8-1.32-7.8-1-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a19351",
    d: "M5603.5 5735.5c-.04 4.23-.71 8.23-2 12-.11-.62-.44-1.12-1-1.5.59-3.7 1.59-7.2 3-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbe4c8",
    d: "M3045.5 5724.5c1.79 3.78 3.29 7.78 4.5 12 3.39 18.75.22 36.42-9.5 53-.34.84-1.01 1.17-2 1 4.31-8.3 7.81-16.97 10.5-26 .67-9 .67-18 0-27a42.272 42.272 0 0 1-3.5-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#63839b",
    d: "M4115.5 5736.5c.44-.07.77.1 1 .5-1.78 5.86-2.45 11.36-2 16.5-1.38-5.74-1.05-11.41 1-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cce4c8",
    d: "M2634.5 5713.5c-3.35 8.41-5.68 17.07-7 26v1c-2.43 16.57-.09 32.57 7 48-1.43-1.4-2.6-3.07-3.5-5-6.85-17.23-8.18-34.9-4-53 1.46-6.25 3.96-11.91 7.5-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0dd9c",
    d: "M4535.5 5727.5c1.64 1.25 2.8 2.92 3.5 5 1.29 11.01 1.29 21.67 0 32-.24 2.35-1.07 4.35-2.5 6 2.88-14.42 2.55-28.75-1-43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99dc95",
    d: "M6026.5 5744.5c1.16 7.15 1.32 14.49.5 22-.71.88-1.54 1.55-2.5 2 1.59-7.91 2.26-15.91 2-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ce5538",
    d: "M5602.5 5734.5h1v1c-1.41 3.3-2.41 6.8-3 10.5.56.38.89.88 1 1.5-.86 3.18-1.19 6.34-1 9.5a55.02 55.02 0 0 0 3 10c-.23.4-.56.57-1 .5-2.53-3.96-3.53-8.46-3-13.5.52-4.91.52-9.74 0-14.5.46-2.1 1.46-3.76 3-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9edd9a",
    d: "M3074.5 5735.5c2.93 9.02 3.26 17.85 1 26.5l1 1c-1.11 5.12-2.78 9.95-5 14.5 1.04-6.44 2.2-12.77 3.5-19 .4-5.7.57-11.2.5-16.5-.67-2-1.33-4-2-6 .23-.4.56-.57 1-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a1de9d",
    d: "M7101.5 5707.5c.16 1.37-.01 2.71-.5 4-7.54 11.82-11.37 24.82-11.5 39 .42 3.37.42 6.54 0 9.5 2.53 9.98 5.53 19.82 9 29.5-5.23-8.52-8.4-17.85-9.5-28-.17-6.51-.67-12.85-1.5-19 2.5-9.48 5.5-18.81 9-28 1.91-2.16 3.58-4.49 5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbe4c8",
    d: "M4404.5 5732.5c-.47 8.07-1.13 15.57-2 22.5 1.41 4.4 2.08 9.23 2 14.5-.81-2.8-1.81-5.63-3-8.5-.08-6.3.08-12.8.5-19.5.66-3.18 1.49-6.18 2.5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#68a887",
    d: "M4562.5 5751.5c.83 5.93.83 11.93 0 18h-1a50.28 50.28 0 0 1 1-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d67ad",
    d: "M4562.5 5734.5h1c.2 4.4 1.2 8.56 3 12.5v8l-2 2c-.6 3.52-.6 7.19 0 11-.54.72-1.21 1.22-2 1.5.83-6.07.83-12.07 0-18v-1c.14-1.89.48-4.06 1-6.5.11-2.22-.56-4.05-2-5.5.33-.67.67-1.33 1-2v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#96dc92",
    d: "M4404.5 5728.5v4c-1.01 2.82-1.84 5.82-2.5 9-.42 6.7-.58 13.2-.5 19.5 1.19 2.87 2.19 5.7 3 8.5v4c-3.04-4.45-4.71-9.45-5-15 .71-3.99.71-7.49 0-10.5.67-2.67 1.33-5.33 2-8l-1-1c1.15-3.67 2.48-7.17 4-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#95a558",
    d: "M5601.5 5747.5c1.68 11.87 4.01 23.87 7 36-1.59-3.06-3.26-6.23-5-9.5l1-1c-.74-1.81-1.41-3.65-2-5.5.44.07.77-.1 1-.5a55.02 55.02 0 0 1-3-10c-.19-3.16.14-6.32 1-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6ac34",
    d: "M1127.5 5753.5c1.05 3.23 2.05 6.9 3 11-1.43-2.1-2.6-4.43-3.5-7-.76-1.57-.6-2.9.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2e3bf",
    d: "M4510.5 5694.5c4.7 4.54 9.7 8.88 15 13 3.37 6.71 6.71 13.38 10 20 3.55 14.25 3.88 28.58 1 43-1.48 9.3-5.82 16.97-13 23 19.12-28.87 18.62-57.87-1.5-87-4.78-3.27-8.61-7.27-11.5-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#68a987",
    d: "M4114.5 5755.5c1.31 2.64 2.31 5.48 3 8.5-.56.38-.89.88-1 1.5a46.505 46.505 0 0 1-3-8c.33-.67.67-1.33 1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#97dc93",
    d: "M2627.5 5740.5c.83 8.16 1.33 16.49 1.5 25 1.89 4.11 2.89 8.44 3 13 2.3 3.24 3.8 6.91 4.5 11-.67-.33-1.33-.67-2-1-7.09-15.43-9.43-31.43-7-48Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbe4c8",
    d: "M5899.5 5715.5c-4.13 8.85-6.97 17.85-8.5 27-1.99 21.42 4.18 40.42 18.5 57-1.5-1.25-3.17-2.25-5-3-14.79-21.49-18.96-43.49-12.5-66 1.49-5.65 3.99-10.65 7.5-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cae4c7",
    d: "M3072.5 5723.5c.62.11 1.12.44 1.5 1 6.44 19.3 5.78 38.97-2 59-1.39 3.07-3.22 5.73-5.5 8a62.13 62.13 0 0 0 5-14c2.22-4.55 3.89-9.38 5-14.5l-1-1c2.26-8.65 1.93-17.48-1-26.5v-1a49.35 49.35 0 0 0-2-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f76a3",
    d: "M4113.5 5757.5c.75 2.75 1.75 5.41 3 8-.04 3.41.46 6.74 1.5 10 1.32 2.97 2.49 5.97 3.5 9 .54 1.62.87 3.28 1 5-5.48-10.09-8.48-20.76-9-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bbe2b7",
    d: "M7536.5 5727.5c1.29 1.34 2.13 3.01 2.5 5 .26 7.27 1.09 14.11 2.5 20.5-1.24 6.78-2.4 13.62-3.5 20.5a244.5 244.5 0 0 1-8 19 97.094 97.094 0 0 1-12.5 16c-3.8 1.97-6.8 4.8-9 8.5-6.71 4.47-13.71 8.47-21 12-1.63.49-3.3.66-5 .5 2.46-1.39 5.13-2.56 8-3.5.88-.71 1.55-1.54 2-2.5 5.4-1.64 10.4-4.14 15-7.5 1.39-1.17 2.23-2.67 2.5-4.5 16.1-13.69 25.6-31.19 28.5-52.5-.66-5.66-.66-11.16 0-16.5.07-5.12-.6-10.12-2-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cd5739",
    d: "M6038.5 5704.5c3.98 4.68 7.15 10.01 9.5 16 2.53 9.38 4.69 18.55 6.5 27.5a581.57 581.57 0 0 1-3.5 24.5c-1.4 2.86-2.4 5.86-3 9-1.39 3.07-3.22 5.73-5.5 8 1.13-1.81 1.8-3.81 2-6 3.41-6.74 5.75-13.9 7-21.5.28-7.14-.06-14.31-1-21.5-.2-7.92-2.2-15.25-6-22-2-4.67-4-9.33-6-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#67a18b",
    d: "M4561.5 5770.5c-1.08 2.9-1.74 5.9-2 9 .03 2.12-.97 3.45-3 4 1.14-3.92 1.98-7.92 2.5-12 .67-.75 1.5-1.09 2.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a09552",
    d: "M6050.5 5740.5c.94 7.19 1.28 14.36 1 21.5-1.25 7.6-3.59 14.76-7 21.5 4.45-14.12 6.45-28.45 6-43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5966ac",
    d: "M4561.5 5769.5h1c-.22 3.66-1.22 7-3 10 .26-3.1.92-6.1 2-9v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bae2b6",
    d: "M1429.5 5694.5c-5.2 8.74-9.37 18.07-12.5 28-1.24 8.42-1.74 16.26-1.5 23.5.87 6.29 2.37 12.46 4.5 18.5 4.63 8.28 9.46 16.28 14.5 24-6.5-3.31-10.34-8.64-11.5-16-4.17-4.49-6.84-9.82-8-16-3.65-16.18-2.65-31.85 3-47 3.75-5.23 7.59-10.23 11.5-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bce2b9",
    d: "M4404.5 5769.5c5.26 13.58 12.93 25.58 23 36-3.9-2.39-7.4-5.39-10.5-9a59.974 59.974 0 0 0-10-15 22.487 22.487 0 0 1-2.5-8v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5a52d",
    d: "M1132.5 5770.5c3.4 6.46 7.06 12.79 11 19a18.25 18.25 0 0 1-3.5-2c-2.76-3.76-5.1-7.76-7-12-.49-1.63-.66-3.3-.5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#95dc91",
    d: "M3071.5 5777.5a62.13 62.13 0 0 1-5 14c-3.54 5.72-7.71 11.05-12.5 16-2.43 2.9-5.26 5.23-8.5 7 5.22-5.41 10.22-11.07 15-17 3.77-6.73 7.43-13.39 11-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c5e3c2",
    d: "M7510.5 5770.5c-.69 7.59-3.69 13.93-9 19a248.11 248.11 0 0 0 9-19ZM7087.5 5742.5c.83 6.15 1.33 12.49 1.5 19 1.1 10.15 4.27 19.48 9.5 28 1.92 3.62 3.92 7.28 6 11-4.35-4.57-7.85-9.9-10.5-16-5.89-13.06-8.06-27.06-6.5-42Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a09552",
    d: "M6044.5 5783.5c-.2 2.19-.87 4.19-2 6h-1c.15-2.47 1.15-4.47 3-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#93db8f",
    d: "M7514.5 5748.5c.66 1.29.99 2.79 1 4.5-.79 12.6-3.95 24.43-9.5 35.5a33.164 33.164 0 0 1-5.5 6c.54-1.62.87-3.28 1-5 5.31-5.07 8.31-11.41 9-19 .91-2.43 1.91-4.93 3-7.5l-1-1c1.79-5.22 2.45-9.72 2-13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9e4c5",
    d: "M2916.5 5734.5c-.28 7.92-.62 15.08-1 21.5 1.22 9.95 4.05 19.45 8.5 28.5 3.41 4.57 6.58 9.23 9.5 14-2.01-1.83-4.17-3.5-6.5-5-4.42-8.16-8.25-16.5-11.5-25-.87-7.98-1.54-15.14-2-21.5.96-4.27 1.96-8.44 3-12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#669692",
    d: "M4121.5 5784.5c1.75 1.53 2.75 3.53 3 6-.67-.33-1.33-.67-2-1-.13-1.72-.46-3.38-1-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#585bb5",
    d: "M4556.5 5786.5c.04 2.58-.96 4.58-3 6 .15-2.47 1.15-4.47 3-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f72a6",
    d: "M4124.5 5790.5c1.39 1.4 2.39 3.07 3 5v2c-2.33-1.68-3.33-4.01-3-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#689f8c",
    d: "M4556.5 5784.5v2c-1.85 1.53-2.85 3.53-3 6v1c-3.01 3.37-6.01 6.71-9 10-.15-1.05.02-2.05.5-3 1.87-3.07 4.2-5.74 7-8 .23-3.47 1.73-6.13 4.5-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aa8a4d",
    d: "M5612.5 5791.5c1.39 1.4 2.39 3.07 3 5-2.26-.84-3.26-2.51-3-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#69a08c",
    d: "M4127.5 5795.5c2.03 1.04 3.36 2.71 4 5-1.33-1-2.67-2-4-3v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9e1b5",
    d: "M6022.5 5729.5c1.63 4.5 2.96 9.17 4 14v1c.26 8.09-.41 16.09-2 24 .16 2.03 0 4.03-.5 6-3.26 7.53-7.26 14.53-12 21a181.702 181.702 0 0 1-16.5 15.5c-7.89 3.85-16.06 7.02-24.5 9.5-8.63.11-17.46-.06-26.5-.5-2.89-.63-5.73-1.46-8.5-2.5-4.64-2.59-9.14-5.25-13.5-8 4.3 1.72 8.64 3.55 13 5.5 17.4 5.41 34.4 4.41 51-3 5.83-3.08 11.5-6.41 17-10 19.04-20.62 25.37-44.79 19-72.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3a62e",
    d: "M1566.5 5778.5c-.88 3.58-2.38 6.91-4.5 10a118.995 118.995 0 0 1-20.5 19.5c-3.69 1.51-7.35 3.01-11 4.5 14.9-8.24 26.9-19.57 36-34Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4a52d",
    d: "M1143.5 5789.5c6.39 6.4 13.06 12.4 20 18-8.85-3.51-15.52-9.51-20-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9edd99",
    d: "M5904.5 5796.5c1.83.75 3.5 1.75 5 3 3.67 1.67 6.33 4.33 8 8-5.85-1.85-10.19-5.52-13-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#595ab6",
    d: "M4127.5 5797.5c1.33 1 2.67 2 4 3 1.38 2.2 3.05 4.2 5 6 .67 1.67 1.33 3.33 2 5-3.5-3.66-7-7.33-10.5-11-.48-.95-.65-1.95-.5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999f56",
    d: "M6039.5 5791.5c-1.4 5.73-4.4 10.39-9 14-.15-1.05.02-2.05.5-3 3.11-3.59 5.94-7.26 8.5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#98dc93",
    d: "M7379.5 5773.5c1.6 2.2 2.93 4.54 4 7 1.75 5.75 4.75 10.75 9 15 5.69 4.69 11.35 9.36 17 14 2 1.67 4 3.33 6 5-6.57-2.62-12.57-6.29-18-11-.89-.82-1.22-1.82-1-3-4.53-1.52-7.86-4.52-10-9-.82-.89-1.82-1.22-3-1a62.977 62.977 0 0 0-4-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#554dbf",
    d: "M4553.5 5793.5c-2.25 4.16-4.75 8.16-7.5 12-.82 1.32-1.98 1.99-3.5 2 1.1-1.1 1.77-2.44 2-4 2.99-3.29 5.99-6.63 9-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bde2b9",
    d: "M1445.5 5795.5c11.17 6.46 23.34 10.13 36.5 11 12.94-.81 25.11-4.15 36.5-10-16.93 12.75-35.6 15.75-56 9-4.83-2.78-9.83-5.28-15-7.5-.88-.71-1.55-1.54-2-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfe2bb",
    d: "M2636.5 5789.5c3.06 4.43 5.89 9.09 8.5 14 2.74 2.32 5.57 4.48 8.5 6.5.69 1.07 1.19 2.23 1.5 3.5 1.99.83 3.49 2.16 4.5 4-8.29-4.24-14.46-10.57-18.5-19-3.61-1.88-5.11-4.88-4.5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c7623d",
    d: "M5620.5 5803.5c1.98 1.95 3.98 3.95 6 6 2.51 3.7 5.85 6.36 10 8 .33.67.67 1.33 1 2-2.09-.54-4.09-1.38-6-2.5-1.73-2.7-4.07-4.7-7-6a64.342 64.342 0 0 1-4-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6279a1",
    d: "M4544.5 5803.5c-.23 1.56-.9 2.9-2 4-1.76 2.39-4.09 4.05-7 5a83.13 83.13 0 0 0 9-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9e4c5",
    d: "M2947.5 5809.5c4.3 1.72 8.64 3.55 13 5.5 4.15.38 8.15 1.38 12 3 10.9 1.26 21.57.26 32-3 4.58-2.14 9.25-3.97 14-5.5a22.668 22.668 0 0 0-5 4 396.61 396.61 0 0 1-19 5.5c-7.33.5-14.66.67-22 .5-9.19-1.44-17.52-4.77-25-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#627ba1",
    d: "M4136.5 5806.5c3.03 2.7 6.03 5.36 9 8 .33.67.67 1.33 1 2h-2a16.945 16.945 0 0 0-6-5c-.67-1.67-1.33-3.33-2-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c95f3b",
    d: "M6041.5 5789.5a48.97 48.97 0 0 1-2.5 9 201.876 201.876 0 0 0-16.5 17.5 17.45 17.45 0 0 1-7 3.5 71.56 71.56 0 0 0 12-11 6.603 6.603 0 0 1 3-3c4.6-3.61 7.6-8.27 9-14l2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b8e1b5",
    d: "M7106.5 5801.5c2.6 1.43 4.26 3.6 5 6.5 1.33.67 2.67 1.33 4 2 4.27 3.62 8.27 7.45 12 11.5-1.42-.21-2.76-.71-4-1.5-3.67-3.05-7.34-6.05-11-9-2.29-3.1-4.29-6.26-6-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3e3c0",
    d: "M7409.5 5809.5c8.31 3.33 16.64 6.33 25 9-.62.11-1.12.44-1.5 1a127.96 127.96 0 0 0-17.5-5c-2-1.67-4-3.33-6-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#68a38a",
    d: "M4535.5 5812.5c-2.06 1.06-3.39 2.73-4 5-1.11.06-2.11.39-3 1 1.11-3.45 3.45-5.45 7-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#95a558",
    d: "M5626.5 5809.5c4.23 1.57 7.57 4.24 10 8-4.15-1.64-7.49-4.3-10-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#97a357",
    d: "M6027.5 5808.5a71.56 71.56 0 0 1-12 11c-1.82.33-3.49 1-5 2-.09-1 .25-1.83 1-2.5 5.5-3.36 10.84-6.86 16-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c5e3c2",
    d: "M7501.5 5789.5c-.13 1.72-.46 3.38-1 5-11.85 12.27-26.18 20.43-43 24.5-7.84.82-15.51.66-23-.5 27.29 2.22 49.62-7.44 67-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a3bb4c",
    d: "M1175.5 5812.5c4.54 1.19 9.04 2.52 13.5 4 1.15-.96 2.15-.62 3 1 1.78-.85 2.95-.19 3.5 2-7.34.02-14.01-2.32-20-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e99c20",
    d: "M1163.5 5807.5c3.85 2.06 7.85 3.73 12 5 5.99 4.68 12.66 7.02 20 7 .67-.33 1.33-.67 2-1 .34.84 1.01 1.17 2 1v1c-4.15 1.15-8.48 1.31-13 .5a98.303 98.303 0 0 0-19-8.5c-.89-.82-1.22-1.82-1-3-1.68.21-2.68-.45-3-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#98c151",
    d: "M1506.5 5818.5c-.34.84-1.01 1.17-2 1h-305c-.99.17-1.66-.16-2-1h309Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7a42c",
    d: "M1527.5 5813.5c-1.14.97-2.14 2.14-3 3.5-5.31 1.1-10.47 2.6-15.5 4.5-1.62-.6-3.12-1.27-4.5-2 .99.17 1.66-.16 2-1 .62.11 1.12.44 1.5 1 6.58-1.77 13.08-3.77 19.5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c5e3c2",
    d: "M4513.5 5803.5c-1.5 2.34-3.5 4.17-6 5.5-4.6 2.8-9.27 5.3-14 7.5-15.67 3.97-31.33 3.97-47 0-2.5-2.21-5.5-3.38-9-3.5-3.23-2.74-6.56-5.24-10-7.5 1.37-.16 2.71.01 4 .5 2.83 2.25 5.83 4.25 9 6 26.05 10.92 50.38 8.09 73-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#68a986",
    d: "M4145.5 5814.5c5.71 3.34 11.38 6.67 17 10-5.88-1.61-11.22-4.28-16-8-.33-.67-.67-1.33-1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a1de9d",
    d: "M4446.5 5816.5c15.67 3.97 31.33 3.97 47 0-.56 1.29-1.56 2.12-3 2.5a162.522 162.522 0 0 1-33 1c-3.94-.66-7.61-1.82-11-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#658f94",
    d: "M4527.5 5818.5c-1.62 2.44-3.95 3.78-7 4 1.62-2.44 3.95-3.78 7-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9a32b",
    d: "M1199.5 5820.5v-1h304c-.76.77-1.76 1.27-3 1.5-100.36.83-200.69.66-301-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8eda89",
    d: "M3013.5 5813.5c-.45.96-1.12 1.79-2 2.5-7.97 3.74-16.64 5.58-26 5.5-4-.17-8-.33-12-.5-.56-.38-.89-.88-1-1.5 7.34.17 14.67 0 22-.5 6.46-1.7 12.79-3.53 19-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#544bc0",
    d: "M4531.5 5817.5c-4.87 4.6-10.53 7.94-17 10 2.25-1.32 4.25-2.98 6-5 3.05-.22 5.38-1.56 7-4h1c.89-.61 1.89-.94 3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#595ab6",
    d: "M4144.5 5816.5h2c4.78 3.72 10.12 6.39 16 8 2.3.97 4.3 2.31 6 4-9.12-1.92-17.12-5.92-24-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#96a458",
    d: "M5642.5 5821.5c9.6 4.12 19.6 7.12 30 9v1c-11.04-.58-21.04-3.92-30-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f799f",
    d: "M4520.5 5822.5a23.863 23.863 0 0 1-6 5c-1.62.54-3.28.87-5 1 3.22-2.75 6.89-4.75 11-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73df66",
    d: "M4181.5 5826.5c105.03.87 209.86.87 314.5 0l1.5 1.5c-105.19 1.66-210.53 2-316 1-1.1-.77-1.1-1.6 0-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d25337",
    d: "M6015.5 5819.5c-.01 1.52-.68 2.68-2 3.5-1.83.75-3.5 1.75-5 3a38.91 38.91 0 0 1-14 3.5c4.92-1.79 9.59-4.13 14-7 .34-.84 1.01-1.17 2-1 1.51-1 3.18-1.67 5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86d982",
    d: "M3033.5 5822.5c-5.09 3.54-10.75 6.04-17 7.5-5.06 1.43-10.06 1.93-15 1.5-99.2.33-198.53 0-298-1 102.67.3 205.34-.03 308-1v-3c4.35.17 8.68 0 13-.5 2.86-1.64 5.86-2.81 9-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#617aa2",
    d: "M4190.5 5830.5c1.76.96 3.76 1.29 6 1-2.11.97-4.44 1.3-7 1-5.04-.09-10.04-.59-15-1.5-1.44-.38-2.44-1.21-3-2.5-.07-.44.1-.77.5-1 6.35 2.8 12.51 3.8 18.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#68a788",
    d: "M4190.5 5830.5h298c-2.33.67-4.67 1.33-7 2-95.06-.06-190.06-.39-285-1-2.24.29-4.24-.04-6-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8bb25d",
    d: "M6008.5 5822.5a68.618 68.618 0 0 1-14 7h-1a229.64 229.64 0 0 1-13.5 3c-1.14-.12-2.31-.45-3.5-1-100.17.33-200.17 0-300-1 102.5.33 204.83 0 307-1 8.72-1.26 17.05-3.59 25-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#87d982",
    d: "M7492.5 5823.5c-.45.96-1.12 1.79-2 2.5-2.87.94-5.54 2.11-8 3.5a43.354 43.354 0 0 1-15 2H7162c-3.75-.47-7.25-1.47-10.5-3 4.98.59 9.98 1.09 15 1.5 98 .67 196 .67 294 0 5.67-.33 11.33-.67 17-1a159.46 159.46 0 0 0 15-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a8dea5",
    d: "M2684.5 5828.5c5.82 1.23 11.65 2.23 17.5 3 .38-.56.88-.89 1.5-1 99.47 1 198.8 1.33 298 1-99.17 1-198.5 1.33-298 1-2.2-.43-4.2-.43-6 0-4.54-.6-8.88-1.94-13-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#607b9e",
    d: "M4506.5 5828.5c-.56 1.29-1.56 2.12-3 2.5-2.16.91-4.16 1.08-6 .5-5.4.49-10.73 1.16-16 2v-1c2.33-.67 4.67-1.33 7-2 5.76.95 11.6-.05 17.5-3 .4.23.57.56.5 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a3dea0",
    d: "M7127.5 5821.5c4.96 1.89 9.96 3.73 15 5.5 2.93.95 5.93 1.45 9 1.5 3.25 1.53 6.75 2.53 10.5 3h305.5c-4.07.69-8.23 1.36-12.5 2-94.67-1.33-189.33-1.33-284 0-10.7-.84-21.2-2.84-31.5-6-4.7-.72-8.7-2.72-12-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3e5d0",
    d: "M2703.5 5832.5c98.17 1 196.5 1.33 295 1-98.5 1.17-197.17 1.33-296 .5-1.88-.2-3.55-.7-5-1.5 1.8-.43 3.8-.43 6 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2e3bf",
    d: "M3042.5 5817.5c-.78 1.95-2.12 3.45-4 4.5-12.42 7.75-25.75 11.58-40 11.5-98.5.33-196.83 0-295-1 99.5.33 198.83 0 298-1 4.94.43 9.94-.07 15-1.5 6.25-1.46 11.91-3.96 17-7.5 2.51-2.42 5.51-4.09 9-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5b63b0",
    d: "M4196.5 5831.5c94.94.61 189.94.94 285 1v1h-291c-.67 0-1-.33-1-1 2.56.3 4.89-.03 7-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3643e",
    d: "M5637.5 5819.5c1.67.67 3.33 1.33 5 2 8.96 6.08 18.96 9.42 30 10 1-1.33 2-1.33 3 0 100.33 1.33 200.67 1.33 301 0 1.19.55 2.36.88 3.5 1 4.51-.86 9.01-1.86 13.5-3-.93.81-1.93 1.65-3 2.5-4.61.47-9.11 1.3-13.5 2.5-97.35-.65-194.85-.98-292.5-1-1.53.03-2.7.7-3.5 2-9.45-1.97-18.95-4.14-28.5-6.5-4.13-1.7-8.13-3.7-12-6-1.56-.76-2.56-1.93-3-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a48f4f",
    d: "M5676.5 5830.5c99.83 1 199.83 1.33 300 1-100.33 1.33-200.67 1.33-301 0 0-.67.33-1 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#77d26e",
    d: "M5983.5 5829.5c-102.17 1-204.5 1.33-307 1-.67 0-1 .33-1 1-1-1.33-2-1.33-3 0v-1c103.5-1 207.17-1.33 311-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6e3c3",
    d: "M7139.5 5827.5c10.3 3.16 20.8 5.16 31.5 6 94.67-1.33 189.33-1.33 284 0 4.27-.64 8.43-1.31 12.5-2 5.15.21 10.15-.46 15-2-1.34 1.29-3.01 2.13-5 2.5-4.61.47-9.11 1.3-13.5 2.5h-302c-3.98-1.56-8.14-2.39-12.5-2.5-3.62-1.21-6.95-2.71-10-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5141c6",
    d: "M4497.5 5831.5c-4.48 1.92-8.98 3.25-13.5 4-96.45-.44-192.78-.44-289 0-1.62-.6-3.12-1.27-4.5-2h291c5.27-.84 10.6-1.51 16-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#831ea0",
    d: "M5451.5 5854.5c.67 2 1.33 4 2 6-.43 1.8-.43 3.8 0 6-1 .03-1.66-.47-2-1.5-1.58-3.54-1.92-6.7-1-9.5 0-.67.33-1 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#939393",
    d: "M11726.5 5859.5c-.9 7.86-2.7 15.52-5.5 23-.4 1.44-1.2 2.44-2.5 3 .3-5.3 1.7-10.3 4-15 .9-2.64 1.6-5.47 2-8.5.2-1.38.9-2.21 2-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb663",
    d: "M990.5 5860.5c.617.11 1.117.44 1.5 1 .856 8.2 2.522 16.2 5 24a68.622 68.622 0 0 1 5.5 13l-2-2c-1.29-.56-2.123-1.56-2.5-3a270.514 270.514 0 0 0-4.5-14 218.315 218.315 0 0 0-3-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf255a",
    d: "M5456.5 5875.5c1.23 2.83 2.23 5.83 3 9-2.37-2.46-3.37-5.46-3-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aaa",
    d: "M8428.5 5869.5c1.13 4.64 2.63 9.31 4.5 14 .38.56.88.89 1.5 1 .65 1.94.98 3.94 1 6-4.5-6.17-6.83-13.17-7-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efa7a6",
    d: "M6942.5 5872.5c1.14 1.6 2.31 3.27 3.5 5a112.01 112.01 0 0 0 5.5 19c-.64-1.58-1.64-2.91-3-4-1.66-4.65-3.32-9.32-5-14-.33-2-.67-4-1-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#851e9f",
    d: "M5453.5 5867.5c.51 2.51 1.51 5.17 3 8-.37 3.54.63 6.54 3 9 1.78 3.85 3.28 7.85 4.5 12 2.36 4.5 4.86 8.83 7.5 13a18.25 18.25 0 0 1-3.5-2c-4.39-6.05-7.39-12.72-9-20a35.417 35.417 0 0 1-5.5-10.5c-.91-3.06-.91-6.23 0-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef7576",
    d: "M6948.5 5892.5c1.36 1.09 2.36 2.42 3 4 2.56 3.66 4.56 7.66 6 12a83.584 83.584 0 0 1-7.5-10c-.5-2.02-1-4.02-1.5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5959",
    d: "M8439.5 5896.5c2.31.98 3.98 2.64 5 5 .69-.53 1.19-1.19 1.5-2 .32 1.56 1.15 2.73 2.5 3.5-.52.56-.86 1.23-1 2 1.69 2.61 2.86 5.44 3.5 8.5 6.59 7.43 13.42 14.76 20.5 22a167.897 167.897 0 0 1-28.5-29c-.9-3.45-2.06-6.78-3.5-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7cd9d",
    d: "M2489.5 5896.5c3 4.62 6 9.29 9 14-5.04-3.37-8.04-8.03-9-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a7979",
    d: "M11716.5 5891.5c-2.5 5.73-5.4 11.4-8.5 17-1.1.81-2.3 1.47-3.5 2 2.2-4.11 4.7-8.11 7.5-12 1-2.24 1.5-4.57 1.5-7h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a991ea",
    d: "M3985.5 5911.5c4.69 5.45 9.36 10.78 14 16-6.06-4.12-10.73-9.45-14-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd5a5",
    d: "m1000.5 5896.5 2 2c5.36 6.54 10.19 13.54 14.5 21 4.52 4.47 9.02 8.81 13.5 13-1.68-.39-3.35-.89-5-1.5a159.82 159.82 0 0 0-14.5-15.5c-1.25-3.42-3.42-6.08-6.5-8-1.37-3.71-2.71-7.37-4-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f08382",
    d: "M6959.5 5909.5c1.65 1.31 3.31 2.64 5 4 2.67 4.65 5.67 8.98 9 13-6.91-3.9-11.57-9.57-14-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a1a1a1",
    d: "M11704.5 5911.5c-.6 1.59-1.1 3.25-1.5 5-6.1 5.92-12.2 11.59-18.5 17 2.7-3 5.3-6 8-9 3.3-4.93 7.3-9.26 12-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bdabec",
    d: "M3999.5 5927.5a86.72 86.72 0 0 1 12 10c-2.09-.54-4.09-1.38-6-2.5-2.59-2.08-4.59-4.58-6-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f08a8c",
    d: "M6973.5 5926.5c4.99 3.32 9.99 6.65 15 10 .69 1.02 1.36 2.02 2 3-4.91-1.39-8.91-4.23-12-8.5-2.81-.31-4.48-1.81-5-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#891e9b",
    d: "M5471.5 5909.5a184.33 184.33 0 0 0 19 20.5c3.9 3.41 7.9 6.58 12 9.5-4.62-1.12-8.28-3.62-11-7.5-1-.33-2-.67-3-1a162.04 162.04 0 0 1-14.5-15.5c-1.56-1.72-2.39-3.72-2.5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#676666",
    d: "M11692.5 5924.5c-2.7 3-5.3 6-8 9-8 5.68-16.7 10.35-26 14 .5-.96 1.1-1.79 2-2.5 6.7-2.89 13-6.23 19-10 4.2-3.74 8.6-7.24 13-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#616060",
    d: "M8471.5 5935.5c1.37-.16 2.71.01 4 .5 2.78 3.56 6.45 5.22 11 5 3.13 2.57 6.13 5.07 9 7.5-3.52-.33-6.52-1.83-9-4.5-5.93-1.3-10.93-4.13-15-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a58ae6",
    d: "M4011.5 5937.5c4.63 1.31 8.63 3.65 12 7-4.73-1.35-8.73-3.69-12-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f18585",
    d: "M6990.5 5939.5c5.55 1.95 10.55 4.61 15 8-1.33-.33-2.67-.67-4-1-4.81-.69-8.47-3.03-11-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fac991",
    d: "M2513.5 5928.5c1.42.21 2.76.71 4 1.5 8.67 8.79 19 14.79 31 18a6.603 6.603 0 0 0 3 3c6.73 1.9 13.56 3.06 20.5 3.5l1-1c2.21.49 4.04 1.49 5.5 3-4.24.94-8.57 1.27-13 1-8.89-3.06-17.56-6.73-26-11-4.48-1.74-8.82-3.74-13-6a55.025 55.025 0 0 0-6-6.5c-3.21-.91-5.54-2.74-7-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffaf54",
    d: "M1044.5 5941.5c9.22 3.78 18.22 7.78 27 12-4.07-.75-8.07-1.75-12-3a79.332 79.332 0 0 1-15-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad96e9",
    d: "M4023.5 5944.5c3.3 1.31 6.63 2.64 10 4l2 2c-4.59-.96-8.59-2.96-12-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8621a0",
    d: "M5502.5 5939.5c6.7 4.02 13.7 7.52 21 10.5a73.09 73.09 0 0 0 20 4.5c1.69.36 2.69 1.36 3 3h-9c-1.12-1.45-2.62-2.45-4.5-3-1.87.59-3.54-.08-5-2-.4.23-.57.56-.5 1-8.33-3-16.33-6.83-24-11.5-.75-.67-1.09-1.5-1-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8260e5",
    d: "M4033.5 5948.5c5.27 1.14 10.27 2.81 15 5h-4a31.8 31.8 0 0 0-9-3l-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef898a",
    d: "M7005.5 5947.5c2.85-.47 5.18.36 7 2.5 7.71 2.74 15.38 4.4 23 5 .88.71 1.55 1.54 2 2.5h-10c-.08-1.25-.74-2.08-2-2.5-4.42-1.81-9.09-2.81-14-3-1.91-1.7-3.91-3.2-6-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bebdbe",
    d: "M11684.5 5933.5c-1.1 1.39-2.1 2.89-3 4.5-11 6.24-22.4 11.9-34 17-6 .69-12 1.52-18 2.5.1-1.25.7-2.08 2-2.5 6.3.32 11.9-1.18 17-4.5 3.3-.94 6.6-1.94 10-3 9.3-3.65 18-8.32 26-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d32c4b",
    d: "M5543.5 5954.5c2.45-.97 5.11-1.31 8-1 2.24.63 3.91 1.97 5 4h-10c-.31-1.64-1.31-2.64-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe1bf",
    d: "M1059.5 5950.5c3.93 1.25 7.93 2.25 12 3h1c3.13 1.13 6.46 1.97 10 2.5-.56.38-.89.88-1 1.5-6.75-1.34-13.42-2.84-20-4.5-1.26-.42-1.92-1.25-2-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9820",
    d: "M2539.5 5946.5c8.44 4.27 17.11 7.94 26 11h-1484c.11-.62.44-1.12 1-1.5-3.54-.53-6.87-1.37-10-2.5 5.37.02 10.71.52 16 1.5 487.35.17 974.69.67 1462 1.5 1.44-.22 2.77-.72 4-1.5-2.8-1.4-5.8-2.23-9-2.5v-3h-6v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a7de8",
    d: "M4044.5 5953.5h4c3.81.82 7.81 1.32 12 1.5 1.26.42 1.92 1.25 2 2.5h-8c-.11-.62-.44-1.12-1-1.5-3.3-.2-6.3-1.04-9-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5429e0",
    d: "M5537.5 5957.5h-1475c-.08-1.25-.74-2.08-2-2.5-4.19-.18-8.19-.68-12-1.5 7.04.07 13.88.07 20.5 0l1.5 1.5c242.83.17 485.67.33 728.5.5 243.17 0 486-.67 728.5-2-.07-.44.1-.77.5-1 1.46 1.92 3.13 2.59 5 2 1.88.55 3.38 1.55 4.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f03737",
    d: "M7001.5 5946.5c1.33.33 2.67.67 4 1 2.09 1.3 4.09 2.8 6 4.5 4.91.19 9.58 1.19 14 3 1.26.42 1.92 1.25 2 2.5h-1471c-1.09-2.03-2.76-3.37-5-4 2.49-.2 4.82.3 7 1.5 486 .67 972 .67 1458 0-2.12-1.19-4.46-1.86-7-2-3.19-1.56-5.86-3.72-8-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f3d3d",
    d: "M8495.5 5948.5c5.02 1.18 10.02 2.68 15 4.5 6.75.12 13.41.79 20 2 1030.67.67 2061.3.67 3092 0 8.7-1.83 17.3-3.33 26-4.5-5.1 3.32-10.7 4.82-17 4.5-1.3.42-1.9 1.25-2 2.5h-3113c.11-.62.44-1.12 1-1.5-6.62-1.87-13.29-3.54-20-5-.88-.71-1.55-1.54-2-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M1193.5 7499.5c.98-3.8 1.32-7.8 1-12h-77v-20h101c2.94 30.64-4.56 58.31-22.5 83-26.41 28.14-58.91 39.64-97.5 34.5-47.34-10.34-76.51-39.18-87.5-86.5-10.02-49.74 4.15-90.9 42.5-123.5 34.95-22.63 71.62-25.63 110-9 19.58 9.75 33.92 24.58 43 44.5a312.2 312.2 0 0 1-21 11c-17.93-34.3-46.27-48.47-85-42.5-39.32 10-61.82 35.16-67.5 75.5-4.07 31.4 3.6 59.4 23 84 28.31 26.26 60.47 32.09 96.5 17.5 23.52-11.68 37.18-30.52 41-56.5ZM4860.5 7355.5h23c-.17 28.34 0 56.67.5 85 13.83-17.82 31.99-24.99 54.5-21.5 27.94 4.6 44.77 20.77 50.5 48.5.5 38.33.67 76.67.5 115h-22c.17-34.33 0-68.67-.5-103-5.71-29.7-23.54-42.2-53.5-37.5-14.14 4.81-23.64 14.31-28.5 28.5-1.48 37.29-1.98 74.62-1.5 112h-23v-227Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#959595",
    d: "M6608.5 7355.5c.33 30.01 0 60.01-1 90-.61-.12-.94-.46-1-1 .67-29.67 1.33-59.33 2-89Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M6608.5 7355.5h22v227h-22c.17-8.67 0-17.34-.5-26-.72.54-1.22 1.21-1.5 2-9.51 12.98-22.18 21.48-38 25.5-42.02 7.57-72.52-7.6-91.5-45.5-7.01-20.3-8.34-40.97-4-62 9.59-30.92 30.09-50.09 61.5-57.5 22.26-3.35 42.59 1.32 61 14 3.87 3.7 7.54 7.54 11 11.5.06.54.39.88 1 1 1-29.99 1.33-59.99 1-90Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323232",
    d: "M6860.5 7355.5h23v227h-23v-227Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M7731.5 7355.5c-.33 30.01 0 60.01 1 90 .61-.12.94-.46 1-1 18.2-21.02 41.2-29.52 69-25.5 33.09 6.09 54.59 25.26 64.5 57.5 7.07 29.92 1.73 57.26-16 82-23.83 25.71-52.66 33.55-86.5 23.5-13.15-4.82-23.65-12.99-31.5-24.5-.5 8.33-.67 16.66-.5 25h-23v-227h22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d7d7d",
    d: "M7731.5 7355.5c.67 29.67 1.33 59.33 2 89-.06.54-.39.88-1 1-1-29.99-1.33-59.99-1-90Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M8810.5 7355.5h23c-.17 28.34 0 56.67.5 85 13.83-17.82 31.99-24.99 54.5-21.5 27.94 4.6 44.77 20.77 50.5 48.5.5 38.33.67 76.67.5 115h-22c.17-34.33 0-68.67-.5-103-5.71-29.7-23.54-42.2-53.5-37.5-14.14 4.81-23.64 14.31-28.5 28.5-1.48 37.29-1.98 74.62-1.5 112h-23v-227Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M1258.5 7359.5h22v32h-22v-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868686",
    d: "M1258.5 7359.5c7.48-.99 15.15-1.33 23-1v34c-7.85.33-15.52-.01-23-1h22v-32h-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M3030.5 7359.5h22v32h-22v-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868686",
    d: "M3030.5 7359.5c7.48-.99 15.15-1.33 23-1v34c-7.85.33-15.52-.01-23-1h22v-32h-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M6929.5 7359.5h22v32h-22v-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868686",
    d: "M6929.5 7359.5c7.48-.99 15.15-1.33 23-1v34c-7.85.33-15.52-.01-23-1h22v-32h-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M9579.5 7359.5h22v32h-22v-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868686",
    d: "M9579.5 7359.5c7.48-.99 15.15-1.33 23-1v34c-7.85.33-15.52-.01-23-1h22v-32h-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M10883.5 7359.5h22v32h-22v-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868686",
    d: "M10883.5 7359.5c7.5-.99 15.1-1.33 23-1v34c-7.9.33-15.5-.01-23-1h22v-32h-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M2952.5 7421.5c11.49.99 23.15 1.33 35 1v21c-11.85-.33-23.51.01-35 1-.47 34.38.03 68.72 1.5 103 4.36 11.33 12.69 16.66 25 16 3.86-.18 7.69-.51 11.5-1v20c-15.14 4.09-29.47 2.26-43-5.5-10.12-8.07-15.62-18.57-16.5-31.5-.5-33.67-.67-67.33-.5-101h-30v-23c16.21 2.61 26.05-4.06 29.5-20 .5-5.66.67-11.32.5-17h22v37ZM3710.5 7421.5c11.49.99 23.15 1.33 35 1v21c-11.85-.33-23.51.01-35 1-.47 34.38.03 68.72 1.5 103 4.36 11.33 12.69 16.66 25 16 3.86-.18 7.69-.51 11.5-1v20c-15.14 4.09-29.47 2.26-43-5.5-10.12-8.07-15.62-18.57-16.5-31.5-.5-33.67-.67-67.33-.5-101h-30v-23c16.21 2.61 26.05-4.06 29.5-20 .5-5.66.67-11.32.5-17h22v37ZM6157.5 7421.5c11.49.99 23.15 1.33 35 1v21c-11.85-.33-23.51.01-35 1-.47 34.38.03 68.72 1.5 103 4.36 11.33 12.69 16.66 25 16 3.86-.18 7.69-.51 11.5-1v20c-15.14 4.09-29.47 2.26-43-5.5-10.12-8.07-15.62-18.57-16.5-31.5-.5-33.67-.67-67.33-.5-101h-30v-23c16.21 2.61 26.05-4.06 29.5-20 .5-5.66.67-11.32.5-17h22v37ZM8133.5 7421.5c11.49.99 23.15 1.33 35 1v21c-11.85-.33-23.51.01-35 1-.47 34.38.03 68.72 1.5 103 4.36 11.33 12.69 16.66 25 16 3.86-.18 7.69-.51 11.5-1v20c-15.14 4.09-29.47 2.26-43-5.5-10.12-8.07-15.62-18.57-16.5-31.5-.5-33.67-.67-67.33-.5-101h-30v-23c16.21 2.61 26.05-4.06 29.5-20 .5-5.66.67-11.32.5-17h22v37ZM8249.5 7421.5c11.49.99 23.15 1.33 35 1v21c-11.85-.33-23.51.01-35 1-.47 34.38.03 68.72 1.5 103 4.36 11.33 12.69 16.66 25 16 3.86-.18 7.69-.51 11.5-1v20c-15.14 4.09-29.47 2.26-43-5.5-10.12-8.07-15.62-18.57-16.5-31.5-.5-33.67-.67-67.33-.5-101h-30v-23c16.21 2.61 26.05-4.06 29.5-20 .5-5.66.67-11.32.5-17h22v37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M1623.5 7508.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.43-37.06 43.27-53.9 83.5-50.5 26.63 4.29 45.47 18.79 56.5 43.5 6.33 14.77 8.17 30.1 5.5 46Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M1769.5 7418.5c27.44-3.27 48.77 6.39 64 29 13.36-22.19 33.03-31.69 59-28.5 29.6 5.27 46.77 22.77 51.5 52.5.5 37 .67 74 .5 111h-23c.17-35.67 0-71.33-.5-107-6.75-27.13-23.92-38.29-51.5-33.5-16.49 6.16-25.99 18-28.5 35.5-.5 35-.67 70-.5 105h-22c.17-34.67 0-69.33-.5-104-6.39-30.1-24.56-41.94-54.5-35.5-12.65 5.12-20.82 14.29-24.5 27.5-1.48 37.29-1.98 74.62-1.5 112h-23v-161h23c-.17 6.01 0 12.01.5 18 8.25-10.42 18.75-17.42 31.5-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M2047.5 7418.5c41.15-4.52 70.98 11.48 89.5 48 9.92 27.4 8.26 54.07-5 80-23.98 34.55-56.48 46.39-97.5 35.5-30.92-12.59-48.75-35.42-53.5-68.5-4.09-41 12.08-70.84 48.5-89.5 6.03-2.16 12.03-3.99 18-5.5ZM2428.5 7508.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.43-37.06 43.27-53.9 83.5-50.5 26.63 4.29 45.47 18.79 56.5 43.5 6.33 14.77 8.17 30.1 5.5 46ZM2581.5 7418.5c41.15-4.52 70.98 11.48 89.5 48 9.92 27.4 8.26 54.07-5 80-23.98 34.55-56.48 46.39-97.5 35.5-30.92-12.59-48.75-35.42-53.5-68.5-4.09-41 12.08-70.84 48.5-89.5 6.03-2.16 12.03-3.99 18-5.5ZM2717.5 7642.5v-220h21c-.33 7.7 0 15.36 1 23 .61-.12.94-.46 1-1 18.2-21.02 41.2-29.52 69-25.5 33.09 6.09 54.59 25.26 64.5 57.5 7.07 29.92 1.73 57.26-16 82-22.83 24.72-50.66 32.88-83.5 24.5-14.52-4.5-26.02-13-34.5-25.5-.5 28.33-.67 56.66-.5 85h-22ZM3160.5 7418.5c41.15-4.52 70.98 11.48 89.5 48 9.92 27.4 8.26 54.07-5 80-23.98 34.55-56.48 46.39-97.5 35.5-30.92-12.59-48.75-35.42-53.5-68.5-4.09-41 12.08-70.84 48.5-89.5 6.03-2.16 12.03-3.99 18-5.5ZM3351.5 7418.5c31.18-4 54.01 7.67 68.5 35 1.34 4.68 2.68 9.35 4 14 .5 38.33.67 76.67.5 115h-22c.17-34.67 0-69.33-.5-104-3.9-23.91-17.9-36.57-42-38-20.21.88-33.54 10.88-40 30-1.48 37.29-1.98 74.62-1.5 112h-23v-161h23c-.17 6.01 0 12.01.5 18 8.75-10.44 19.58-17.44 32.5-21ZM3506.5 7418.5c25.55-3.32 47.05 4.35 64.5 23 3.48 4.78 6.31 9.95 8.5 15.5-.14.77-.48 1.44-1 2-5.33 2.89-10.83 5.39-16.5 7.5-2.98-3.33-5.64-7-8-11-15.79-17.1-34.29-20.94-55.5-11.5-9.42 8.49-11.59 18.66-6.5 30.5 4.25 4.87 9.42 8.37 15.5 10.5 12.33 3.67 24.67 7.33 37 11 17.46 5.79 29.29 17.29 35.5 34.5 1.86 31.07-12.64 49.24-43.5 54.5-36.76 5.13-63.09-8.87-79-42 5.85-3.09 11.85-5.93 18-8.5 3.72 4.41 7.22 9.08 10.5 14 17.87 18.6 38.37 22.1 61.5 10.5 8.65-6.46 11.81-14.96 9.5-25.5-3.55-6.55-8.72-11.39-15.5-14.5a512.571 512.571 0 0 1-52-17c-20.06-11.17-27.56-28-22.5-50.5 4.68-13.35 13.51-22.85 26.5-28.5 4.43-1.57 8.76-3.07 13-4.5ZM3842.5 7418.5c41.15-4.52 70.98 11.48 89.5 48 9.92 27.4 8.26 54.07-5 80-23.98 34.55-56.48 46.39-97.5 35.5-30.92-12.59-48.75-35.42-53.5-68.5-4.09-41 12.08-70.84 48.5-89.5 6.03-2.16 12.03-3.99 18-5.5ZM4247.5 7418.5c41.15-4.52 70.98 11.48 89.5 48 9.92 27.4 8.26 54.07-5 80-23.98 34.55-56.48 46.39-97.5 35.5-30.92-12.59-48.75-35.42-53.5-68.5-4.09-41 12.08-70.84 48.5-89.5 6.03-2.16 12.03-3.99 18-5.5ZM4746.5 7418.5c25.55-3.32 47.05 4.35 64.5 23 3.48 4.78 6.31 9.95 8.5 15.5-.14.77-.48 1.44-1 2-5.33 2.89-10.83 5.39-16.5 7.5-2.98-3.33-5.64-7-8-11-15.79-17.1-34.29-20.94-55.5-11.5-9.42 8.49-11.59 18.66-6.5 30.5 4.25 4.87 9.42 8.37 15.5 10.5 12.33 3.67 24.67 7.33 37 11 17.46 5.79 29.29 17.29 35.5 34.5 1.86 31.07-12.64 49.24-43.5 54.5-36.76 5.13-63.09-8.87-79-42 5.85-3.09 11.85-5.93 18-8.5 3.72 4.41 7.22 9.08 10.5 14 17.87 18.6 38.37 22.1 61.5 10.5 8.65-6.46 11.81-14.96 9.5-25.5-3.55-6.55-8.72-11.39-15.5-14.5a512.571 512.571 0 0 1-52-17c-20.06-11.17-27.56-28-22.5-50.5 4.68-13.35 13.51-22.85 26.5-28.5 4.43-1.57 8.76-3.07 13-4.5ZM5093.5 7418.5c41.15-4.52 70.98 11.48 89.5 48 9.92 27.4 8.26 54.07-5 80-23.98 34.55-56.48 46.39-97.5 35.5-30.92-12.59-48.75-35.42-53.5-68.5-4.09-41 12.08-70.84 48.5-89.5 6.03-2.16 12.03-3.99 18-5.5ZM5229.5 7642.5v-220h21c-.33 7.7 0 15.36 1 23 .61-.12.94-.46 1-1 18.2-21.02 41.2-29.52 69-25.5 33.09 6.09 54.59 25.26 64.5 57.5 7.07 29.92 1.73 57.26-16 82-22.83 24.72-50.66 32.88-83.5 24.5-14.52-4.5-26.02-13-34.5-25.5-.5 28.33-.67 56.66-.5 85h-22ZM5429.5 7642.5v-220h21c-.33 7.7 0 15.36 1 23 .61-.12.94-.46 1-1 18.2-21.02 41.2-29.52 69-25.5 33.09 6.09 54.59 25.26 64.5 57.5 7.07 29.92 1.73 57.26-16 82-22.83 24.72-50.66 32.88-83.5 24.5-14.52-4.5-26.02-13-34.5-25.5-.5 28.33-.67 56.66-.5 85h-22ZM5772.5 7508.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.43-37.06 43.27-53.9 83.5-50.5 26.63 4.29 45.47 18.79 56.5 43.5 6.33 14.77 8.17 30.1 5.5 46ZM5953.5 7418.5c25.55-3.32 47.05 4.35 64.5 23 3.48 4.78 6.31 9.95 8.5 15.5-.14.77-.48 1.44-1 2-5.33 2.89-10.83 5.39-16.5 7.5-2.98-3.33-5.64-7-8-11-15.79-17.1-34.29-20.94-55.5-11.5-9.42 8.49-11.59 18.66-6.5 30.5 4.25 4.87 9.42 8.37 15.5 10.5 12.33 3.67 24.67 7.33 37 11 17.46 5.79 29.29 17.29 35.5 34.5 1.86 31.07-12.64 49.24-43.5 54.5-36.76 5.13-63.09-8.87-79-42 5.85-3.09 11.85-5.93 18-8.5 3.72 4.41 7.22 9.08 10.5 14 17.87 18.6 38.37 22.1 61.5 10.5 8.65-6.46 11.81-14.96 9.5-25.5-3.55-6.55-8.72-11.39-15.5-14.5a512.571 512.571 0 0 1-52-17c-20.06-11.17-27.56-28-22.5-50.5 4.68-13.35 13.51-22.85 26.5-28.5 4.43-1.57 8.76-3.07 13-4.5ZM6289.5 7418.5c41.15-4.52 70.98 11.48 89.5 48 9.92 27.4 8.26 54.07-5 80-23.98 34.55-56.48 46.39-97.5 35.5-30.92-12.59-48.75-35.42-53.5-68.5-4.09-41 12.08-70.84 48.5-89.5 6.03-2.16 12.03-3.99 18-5.5ZM6820.5 7508.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.43-37.06 43.27-53.9 83.5-50.5 26.63 4.29 45.47 18.79 56.5 43.5 6.33 14.77 8.17 30.1 5.5 46ZM7294.5 7508.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.43-37.06 43.27-53.9 83.5-50.5 26.63 4.29 45.47 18.79 56.5 43.5 6.33 14.77 8.17 30.1 5.5 46Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M7539.5 7418.5c21.62-2.93 40.95 2.24 58 15.5 9.34 9.19 14.51 20.35 15.5 33.5.5 38.33.67 76.67.5 115h-23c.17-7.34 0-14.67-.5-22-15.02 17.41-34.19 26.08-57.5 26-20.77-.62-36.6-9.62-47.5-27-9.39-36.69 4.44-59.53 41.5-68.5 21.33-3.61 42.66-7.11 64-10.5 1.26-26.41-11.41-40.08-38-41-11.31-.18-21.31 3.32-30 10.5-4.55 5.05-8.88 10.21-13 15.5-6.29-3.13-12.46-6.47-18.5-10 .78-3.91 2.45-7.58 5-11 12.05-12.93 26.55-21.6 43.5-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M8054.5 7508.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.43-37.06 43.27-53.9 83.5-50.5 26.63 4.29 45.47 18.79 56.5 43.5 6.33 14.77 8.17 30.1 5.5 46ZM8465.5 7508.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.43-37.06 43.27-53.9 83.5-50.5 26.63 4.29 45.47 18.79 56.5 43.5 6.33 14.77 8.17 30.1 5.5 46ZM8697.5 7418.5c25.55-3.32 47.05 4.35 64.5 23 3.48 4.78 6.31 9.95 8.5 15.5-.14.77-.48 1.44-1 2-5.33 2.89-10.83 5.39-16.5 7.5-2.98-3.33-5.64-7-8-11-15.79-17.1-34.29-20.94-55.5-11.5-9.42 8.49-11.59 18.66-6.5 30.5 4.25 4.87 9.42 8.37 15.5 10.5 12.33 3.67 24.67 7.33 37 11 17.46 5.79 29.29 17.29 35.5 34.5 1.86 31.07-12.64 49.24-43.5 54.5-36.76 5.13-63.09-8.87-79-42 5.85-3.09 11.85-5.93 18-8.5 3.72 4.41 7.22 9.08 10.5 14 17.87 18.6 38.37 22.1 61.5 10.5 8.65-6.46 11.81-14.96 9.5-25.5-3.55-6.55-8.72-11.39-15.5-14.5a512.571 512.571 0 0 1-52-17c-20.06-11.17-27.56-28-22.5-50.5 4.68-13.35 13.51-22.85 26.5-28.5 4.43-1.57 8.76-3.07 13-4.5ZM9043.5 7418.5c41.15-4.52 70.98 11.48 89.5 48 9.92 27.4 8.26 54.07-5 80-23.98 34.55-56.48 46.39-97.5 35.5-30.92-12.59-48.75-35.42-53.5-68.5-4.09-41 12.08-70.84 48.5-89.5 6.03-2.16 12.03-3.99 18-5.5ZM9180.5 7642.5v-220h21c-.33 7.7 0 15.36 1 23 .61-.12.94-.46 1-1 18.2-21.02 41.2-29.52 69-25.5 33.09 6.09 54.59 25.26 64.5 57.5 7.07 29.92 1.73 57.26-16 82-22.83 24.72-50.66 32.88-83.5 24.5-14.52-4.5-26.02-13-34.5-25.5-.5 28.33-.67 56.66-.5 85h-22ZM9380.5 7642.5v-220h21c-.33 7.7 0 15.36 1 23 .61-.12.94-.46 1-1 18.2-21.02 41.2-29.52 69-25.5 33.09 6.09 54.59 25.26 64.5 57.5 7.07 29.92 1.73 57.26-16 82-22.83 24.72-50.66 32.88-83.5 24.5-14.52-4.5-26.02-13-34.5-25.5-.5 28.33-.67 56.66-.5 85h-22ZM9704.5 7418.5c31.18-4 54.01 7.67 68.5 35 1.34 4.68 2.68 9.35 4 14 .5 38.33.67 76.67.5 115h-22c.17-34.67 0-69.33-.5-104-3.9-23.91-17.9-36.57-42-38-20.21.88-33.54 10.88-40 30-1.48 37.29-1.98 74.62-1.5 112h-23v-161h23c-.17 6.01 0 12.01.5 18 8.75-10.44 19.58-17.44 32.5-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M9878.5 7418.5c23.03-2.91 43.7 2.59 62 16.5 3.54 3.2 6.7 6.7 9.5 10.5.5-7.99.67-15.99.5-24h23c.17 53.67 0 107.33-.5 161-7.8 43.26-33.8 65.26-78 66-23.19-.17-42.86-8.5-59-25-2.67-4-5.33-8-8-12-.67-1-.67-2 0-3 6.03-3.85 12.37-7.18 19-10 13.9 22.52 34.07 31.36 60.5 26.5 24.71-4.38 38.88-18.88 42.5-43.5.67-10 .67-20 0-30-14.33 18.66-33.33 28.33-57 29-33.3-1.66-57.3-17.33-72-47-11.62-30.57-8.29-59.24 10-86 12.75-14.95 28.58-24.61 47.5-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M10213.5 7508.5h-127c-.3 2.56 0 4.89 1 7 5.5 30.82 23.8 47.16 55 49 12.7.82 24-2.68 34-10.5 5.9-5.6 11.4-11.43 16.5-17.5 5.5 2.82 11 5.65 16.5 8.5 1 1.05 1.2 2.22.5 3.5-15.7 25.25-38.5 37.59-68.5 37-35.5-1.41-59.8-18.58-73-51.5-6.5-21.45-6.6-42.95-.5-64.5 15.4-37.06 43.3-53.9 83.5-50.5 26.6 4.29 45.5 18.79 56.5 43.5 6.3 14.77 8.2 30.1 5.5 46ZM10398.5 7642.5v-220h21c-.3 7.7 0 15.36 1 23 .6-.12.9-.46 1-1 18.2-21.02 41.2-29.52 69-25.5 33.1 6.09 54.6 25.26 64.5 57.5 7.1 29.92 1.7 57.26-16 82-22.8 24.72-50.7 32.88-83.5 24.5-14.5-4.5-26-13-34.5-25.5-.5 28.33-.7 56.66-.5 85h-22ZM10741.5 7508.5h-127c-.3 2.56 0 4.89 1 7 5.5 30.82 23.8 47.16 55 49 12.7.82 24-2.68 34-10.5 5.9-5.6 11.4-11.43 16.5-17.5 5.5 2.82 11 5.65 16.5 8.5 1 1.05 1.2 2.22.5 3.5-15.7 25.25-38.5 37.59-68.5 37-35.5-1.41-59.8-18.58-73-51.5-6.5-21.45-6.6-42.95-.5-64.5 15.4-37.06 43.3-53.9 83.5-50.5 26.6 4.29 45.5 18.79 56.5 43.5 6.3 14.77 8.2 30.1 5.5 46ZM11096.5 7508.5h-127c-.3 2.56 0 4.89 1 7 5.5 30.82 23.8 47.16 55 49 12.7.82 24-2.68 34-10.5 5.9-5.6 11.4-11.43 16.5-17.5 5.5 2.82 11 5.65 16.5 8.5 1 1.05 1.2 2.22.5 3.5-15.7 25.25-38.5 37.59-68.5 37-35.5-1.41-59.8-18.58-73-51.5-6.5-21.45-6.6-42.95-.5-64.5 15.4-37.06 43.3-53.9 83.5-50.5 26.6 4.29 45.5 18.79 56.5 43.5 6.3 14.77 8.2 30.1 5.5 46ZM11192.5 7418.5c31.2-4 54 7.67 68.5 35 1.3 4.68 2.7 9.35 4 14 .5 38.33.7 76.67.5 115h-22c.2-34.67 0-69.33-.5-104-3.9-23.91-17.9-36.57-42-38-20.2.88-33.5 10.88-40 30-1.5 37.29-2 74.62-1.5 112h-23v-161h23c-.2 6.01 0 12.01.5 18 8.7-10.44 19.6-17.44 32.5-21ZM11368.5 7418.5c28.8-3.13 53 5.87 72.5 27 2.9 3.93 5.4 8.1 7.5 12.5-.1.77-.5 1.44-1 2-6.2 3.04-12.4 6.21-18.5 9.5-15.5-25.4-37.7-33.9-66.5-25.5-24.1 11.26-36.1 30.26-36 57-.6 25.08 9.7 44.08 31 57 30.5 11.92 54.4 4.09 71.5-23.5 6.3 3.33 12.7 6.66 19 10 .7 1 .7 2 0 3-15.2 25.1-37.5 37.77-67 38-35.2-.77-59.5-17.44-73-50-10.8-31.78-6.8-61.45 12-89 13.1-14.94 29.2-24.27 48.5-28ZM11632.5 7508.5h-127c-.3 2.56 0 4.89 1 7 5.5 30.82 23.8 47.16 55 49 12.7.82 24-2.68 34-10.5 5.9-5.6 11.4-11.43 16.5-17.5 5.5 2.82 11 5.65 16.5 8.5 1 1.05 1.2 2.22.5 3.5-15.7 25.25-38.5 37.59-68.5 37-35.5-1.41-59.8-18.58-73-51.5-6.5-21.45-6.6-42.95-.5-64.5 15.4-37.06 43.3-53.9 83.5-50.5 26.6 4.29 45.5 18.79 56.5 43.5 6.3 14.77 8.2 30.1 5.5 46Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M2237.5 7419.5h21v23c-17.37-3.75-32.21.59-44.5 13-3.42 4.84-5.75 10.18-7 16-.5 37-.67 74-.5 111h-23v-161h23c-.17 5.34 0 10.68.5 16 8.2-9.51 18.36-15.51 30.5-18ZM4609.5 7419.5h21v23c-17.37-3.75-32.21.59-44.5 13-3.42 4.84-5.75 10.18-7 16-.5 37-.67 74-.5 111h-23v-161h23c-.17 5.34 0 10.68.5 16 8.2-9.51 18.36-15.51 30.5-18ZM5867.5 7419.5h21v23c-17.37-3.75-32.21.59-44.5 13-3.42 4.84-5.75 10.18-7 16-.5 37-.67 74-.5 111h-23v-161h23c-.17 5.34 0 10.68.5 16 8.2-9.51 18.36-15.51 30.5-18ZM7388.5 7419.5h21v23c-17.37-3.75-32.21.59-44.5 13-3.42 4.84-5.75 10.18-7 16-.5 37-.67 74-.5 111h-23v-161h23c-.17 5.34 0 10.68.5 16 8.2-9.51 18.36-15.51 30.5-18ZM8559.5 7419.5h21v23c-17.37-3.75-32.21.59-44.5 13-3.42 4.84-5.75 10.18-7 16-.5 37-.67 74-.5 111h-23v-161h23c-.17 5.34 0 10.68.5 16 8.2-9.51 18.36-15.51 30.5-18ZM10835.5 7419.5h21v23c-17.4-3.75-32.2.59-44.5 13-3.4 4.84-5.8 10.18-7 16-.5 37-.7 74-.5 111h-23v-161h23c-.2 5.34 0 10.68.5 16 8.2-9.51 18.4-15.51 30.5-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323232",
    d: "M1258.5 7421.5h23v161h-23v-161Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M1307.5 7421.5h25c15.48 43.27 31.65 86.27 48.5 129 16.26-42.63 32.43-85.29 48.5-128 8.31-1 16.64-1.33 25-1-20.67 53.67-41.33 107.33-62 161-7.7.33-15.36 0-23-1a7768.334 7768.334 0 0 1-62-160Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#424242",
    d: "M2740.5 7444.5c-.06.54-.39.88-1 1-1-7.64-1.33-15.3-1-23h-21v220c-1-73.5-1.33-147.16-1-221h23c-.33 7.85.01 15.52 1 23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323232",
    d: "M3030.5 7421.5h23v161h-23v-161Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M4010.5 7421.5c8.03-.33 16.03 0 24 1 17.22 43.82 34.72 87.49 52.5 131 17.47-43.92 34.64-87.92 51.5-132h25c-23.06 57.67-46.23 115.34-69.5 173-5.6 16.25-14.44 30.42-26.5 42.5-16.16 11.86-33.82 14.7-53 8.5-1-6.97-1.33-13.97-1-21 9.31 1.05 18.64 1.22 28 .5 9.77-2.63 16.94-8.47 21.5-17.5a205.27 205.27 0 0 0 10.5-25 23729.7 23729.7 0 0 1-63-161Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M4486.5 7521.5c1-32.83 1.33-65.83 1-99h21v160h-22c.17-6.01 0-12.01-.5-18-8.68 10.76-19.85 17.6-33.5 20.5-36.04 4.07-59.54-11.09-70.5-45.5-.33-2.67-.67-5.33-1-8-.5-36.67-.67-73.33-.5-110h22c-.17 35.33 0 70.67.5 106 6.02 26.99 22.85 38.83 50.5 35.5 20.75-5.93 31.75-19.76 33-41.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#585757",
    d: "M4508.5 7582.5v-160h-21c.33 33.17 0 66.17-1 99v-100h23c.33 53.84 0 107.5-1 161Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#424242",
    d: "M5252.5 7444.5c-.06.54-.39.88-1 1-1-7.64-1.33-15.3-1-23h-21v220c-1-73.5-1.33-147.16-1-221h23c-.33 7.85.01 15.52 1 23ZM5452.5 7444.5c-.06.54-.39.88-1 1-1-7.64-1.33-15.3-1-23h-21v220c-1-73.5-1.33-147.16-1-221h23c-.33 7.85.01 15.52 1 23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323232",
    d: "M6929.5 7421.5h23v161h-23v-161Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M6979.5 7421.5h25c15.48 43.27 31.65 86.27 48.5 129 16.26-42.63 32.43-85.29 48.5-128 8.31-1 16.64-1.33 25-1-20.67 53.67-41.33 107.33-62 161-7.7.33-15.36 0-23-1a7768.334 7768.334 0 0 1-62-160Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#424242",
    d: "M9203.5 7444.5c-.06.54-.39.88-1 1-1-7.64-1.33-15.3-1-23h-21v220c-1-73.5-1.33-147.16-1-221h23c-.33 7.85.01 15.52 1 23ZM9403.5 7444.5c-.06.54-.39.88-1 1-1-7.64-1.33-15.3-1-23h-21v220c-1-73.5-1.33-147.16-1-221h23c-.33 7.85.01 15.52 1 23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323232",
    d: "M9579.5 7421.5h23v161h-23v-161Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M10232.5 7421.5c9.4-.33 18.7 0 28 1 13.6 20.17 27.4 40.17 41.5 60 13.7-20.25 27.5-40.42 41.5-60.5 9.3-.67 18.7-.67 28 0-18.9 26.51-37.6 53.18-56 80 18.5 26.4 36.8 52.9 55 79.5-9 1.17-18 1.33-27 .5-14-20.08-27.8-40.25-41.5-60.5-14 19.86-27.9 39.86-41.5 60-9.3 1.33-18.7 1.33-28 0 18.7-26.26 37-52.76 55-79.5-18.2-26.96-36.6-53.79-55-80.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#424242",
    d: "M10421.5 7444.5c-.1.54-.4.88-1 1-1-7.64-1.3-15.3-1-23h-21v220c-1-73.5-1.3-147.16-1-221h23c-.3 7.85 0 15.52 1 23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323232",
    d: "M10883.5 7421.5h23v161h-23v-161Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M1599.5 7479.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM2404.5 7479.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM5748.5 7479.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM6796.5 7479.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM7270.5 7479.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM8030.5 7479.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM8441.5 7479.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM10189.5 7479.5v8h-102c3.5-25.05 17.5-40.88 42-47.5 26.3-3.75 45.5 6.08 57.5 29.5 1.4 3.22 2.2 6.55 2.5 10ZM10717.5 7479.5v8h-102c3.5-25.05 17.5-40.88 42-47.5 26.3-3.75 45.5 6.08 57.5 29.5 1.4 3.22 2.2 6.55 2.5 10ZM11072.5 7479.5v8h-102c3.5-25.05 17.5-40.88 42-47.5 26.3-3.75 45.5 6.08 57.5 29.5 1.4 3.22 2.2 6.55 2.5 10ZM11608.5 7479.5v8h-102c3.5-25.05 17.5-40.88 42-47.5 26.3-3.75 45.5 6.08 57.5 29.5 1.4 3.22 2.2 6.55 2.5 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M2052.5 7440.5c36.71-1.23 58.88 16.1 66.5 52 2.82 26.84-6.68 48.01-28.5 63.5-31.64 14.78-57.48 7.95-77.5-20.5-9.36-18.3-11.03-37.3-5-57 8.63-20.15 23.46-32.81 44.5-38ZM2586.5 7440.5c36.71-1.23 58.88 16.1 66.5 52 2.82 26.84-6.68 48.01-28.5 63.5-31.64 14.78-57.48 7.95-77.5-20.5-9.36-18.3-11.03-37.3-5-57 8.63-20.15 23.46-32.81 44.5-38ZM2787.5 7440.5c33.89-1.31 55.39 14.36 64.5 47 4.91 29.3-4.59 52.46-28.5 69.5-30.13 13.09-54.96 6.59-74.5-19.5-10.22-18.83-12.22-38.49-6-59 8.63-20.15 23.47-32.82 44.5-38ZM3165.5 7440.5c36.71-1.23 58.88 16.1 66.5 52 2.82 26.84-6.68 48.01-28.5 63.5-31.64 14.78-57.48 7.95-77.5-20.5-9.36-18.3-11.03-37.3-5-57 8.63-20.15 23.46-32.81 44.5-38ZM3847.5 7440.5c36.71-1.23 58.88 16.1 66.5 52 2.82 26.84-6.68 48.01-28.5 63.5-31.64 14.78-57.48 7.95-77.5-20.5-9.36-18.3-11.03-37.3-5-57 8.63-20.15 23.46-32.81 44.5-38ZM4252.5 7440.5c36.71-1.23 58.88 16.1 66.5 52 2.82 26.84-6.68 48.01-28.5 63.5-31.64 14.78-57.48 7.95-77.5-20.5-9.36-18.3-11.03-37.3-5-57 8.63-20.15 23.46-32.81 44.5-38ZM5098.5 7440.5c36.71-1.23 58.88 16.1 66.5 52 2.82 26.84-6.68 48.01-28.5 63.5-31.64 14.78-57.48 7.95-77.5-20.5-9.36-18.3-11.03-37.3-5-57 8.63-20.15 23.46-32.81 44.5-38ZM5299.5 7440.5c33.89-1.31 55.39 14.36 64.5 47 4.91 29.3-4.59 52.46-28.5 69.5-30.13 13.09-54.96 6.59-74.5-19.5-10.22-18.83-12.22-38.49-6-59 8.63-20.15 23.47-32.82 44.5-38ZM5499.5 7440.5c33.89-1.31 55.39 14.36 64.5 47 4.91 29.3-4.59 52.46-28.5 69.5-30.13 13.09-54.96 6.59-74.5-19.5-10.22-18.83-12.22-38.49-6-59 8.63-20.15 23.47-32.82 44.5-38ZM6294.5 7440.5c36.71-1.23 58.88 16.1 66.5 52 2.82 26.84-6.68 48.01-28.5 63.5-31.64 14.78-57.48 7.95-77.5-20.5-9.36-18.3-11.03-37.3-5-57 8.63-20.15 23.46-32.81 44.5-38Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M6541.5 7440.5c34.72-1.43 56.56 14.57 65.5 48 3.7 20.89-.97 39.55-14 56-23.03 22.02-48.2 24.85-75.5 8.5-22.2-20.96-28.7-46.12-19.5-75.5 8.31-19.82 22.81-32.16 43.5-37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M7780.5 7440.5c33.89-1.31 55.39 14.36 64.5 47 4.91 29.3-4.59 52.46-28.5 69.5-30.13 13.09-54.96 6.59-74.5-19.5-10.22-18.83-12.22-38.49-6-59 8.63-20.15 23.47-32.82 44.5-38ZM9048.5 7440.5c36.71-1.23 58.88 16.1 66.5 52 2.82 26.84-6.68 48.01-28.5 63.5-31.64 14.78-57.48 7.95-77.5-20.5-9.36-18.3-11.03-37.3-5-57 8.63-20.15 23.46-32.81 44.5-38ZM9250.5 7440.5c33.89-1.31 55.39 14.36 64.5 47 4.91 29.3-4.59 52.46-28.5 69.5-30.13 13.09-54.96 6.59-74.5-19.5-10.22-18.83-12.22-38.49-6-59 8.63-20.15 23.47-32.82 44.5-38ZM9450.5 7440.5c33.89-1.31 55.39 14.36 64.5 47 4.91 29.3-4.59 52.46-28.5 69.5-30.13 13.09-54.96 6.59-74.5-19.5-10.22-18.83-12.22-38.49-6-59 8.63-20.15 23.47-32.82 44.5-38Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M9885.5 7440.5c34.66-.82 56.16 15.51 64.5 49 2.87 28.76-8.29 49.92-33.5 63.5-28.7 10.32-51.87 3.15-69.5-21.5-16.49-32.5-10.66-60 17.5-82.5 6.69-3.94 13.69-6.78 21-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M10468.5 7440.5c33.9-1.31 55.4 14.36 64.5 47 4.9 29.3-4.6 52.46-28.5 69.5-30.1 13.09-55 6.59-74.5-19.5-10.2-18.83-12.2-38.49-6-59 8.6-20.15 23.5-32.82 44.5-38Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#676666",
    d: "M2952.5 7421.5h36v23h-36c11.49-.99 23.15-1.33 35-1v-21c-11.85.33-23.51-.01-35-1ZM3710.5 7421.5h36v23h-36c11.49-.99 23.15-1.33 35-1v-21c-11.85.33-23.51-.01-35-1ZM6157.5 7421.5h36v23h-36c11.49-.99 23.15-1.33 35-1v-21c-11.85.33-23.51-.01-35-1ZM8133.5 7421.5h36v23h-36c11.49-.99 23.15-1.33 35-1v-21c-11.85.33-23.51-.01-35-1ZM8249.5 7421.5h36v23h-36c11.49-.99 23.15-1.33 35-1v-21c-11.85.33-23.51-.01-35-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e8e8e",
    d: "M1218.5 7467.5h-101v20h77c.32 4.2-.02 8.2-1 12v-11h-77v-22c34.17-.33 68.17 0 102 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M1599.5 7479.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM2404.5 7479.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM5748.5 7479.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM6796.5 7479.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM7270.5 7479.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM8030.5 7479.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM8441.5 7479.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM10189.5 7479.5c1 2.79 1.3 5.79 1 9-34.5.33-68.8 0-103-1h102v-8ZM10717.5 7479.5c1 2.79 1.3 5.79 1 9-34.5.33-68.8 0-103-1h102v-8ZM11072.5 7479.5c1 2.79 1.3 5.79 1 9-34.5.33-68.8 0-103-1h102v-8ZM11608.5 7479.5c1 2.79 1.3 5.79 1 9-34.5.33-68.8 0-103-1h102v-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M7581.5 7501.5h9c3.05 31.11-9.95 51.94-39 62.5-9.37 1.86-18.7 1.86-28 0-19.24-9.23-23.41-23.06-12.5-41.5 5.33-5.75 11.83-9.58 19.5-11.5 17.13-3.19 34.13-6.35 51-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a8a8a",
    d: "M1623.5 7508.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM2428.5 7508.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM5772.5 7508.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM6820.5 7508.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM7294.5 7508.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM8054.5 7508.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM8465.5 7508.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM10213.5 7508.5c-41.8 1-83.8 1.33-126 1v6c-1-2.11-1.3-4.44-1-7h127ZM10741.5 7508.5c-41.8 1-83.8 1.33-126 1v6c-1-2.11-1.3-4.44-1-7h127ZM11096.5 7508.5c-41.8 1-83.8 1.33-126 1v6c-1-2.11-1.3-4.44-1-7h127ZM11632.5 7508.5c-41.8 1-83.8 1.33-126 1v6c-1-2.11-1.3-4.44-1-7h127Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#959595",
    d: "M6608.5 7582.5c-.67-8-1.33-16-2-24 .28-.79.78-1.46 1.5-2 .5 8.66.67 17.33.5 26ZM4414.5 7792.5c.33 30.01 0 60.01-1 90-.61-.12-.94-.46-1-1 .67-29.67 1.33-59.33 2-89Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M4414.5 7792.5h22v227h-22c.17-8.67 0-17.34-.5-26-.72.54-1.22 1.21-1.5 2-9.51 12.98-22.18 21.48-38 25.5-42.02 7.57-72.52-7.6-91.5-45.5-7.01-20.3-8.34-40.97-4-62 9.59-30.92 30.09-50.09 61.5-57.5 22.26-3.35 42.59 1.32 61 14 3.87 3.7 7.54 7.54 11 11.5.06.54.39.88 1 1 1-29.99 1.33-59.99 1-90ZM6651.5 7792.5h23c-.17 28.34 0 56.67.5 85 13.83-17.82 31.99-24.99 54.5-21.5 27.94 4.6 44.77 20.77 50.5 48.5.5 38.33.67 76.67.5 115h-22c.17-34.33 0-68.67-.5-103-5.71-29.7-23.54-42.2-53.5-37.5-14.14 4.81-23.64 14.31-28.5 28.5-1.48 37.29-1.98 74.62-1.5 112h-23v-227Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323232",
    d: "M8801.5 7792.5h23v227h-23v-227ZM9305.5 7792.5h23v227h-23v-227Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M9742.5 7793.5v20h-4c-31.54-1.45-44.87 13.55-40 45 12.82 1 25.82 1.33 39 1v21c-13.18-.33-26.18 0-39 1v138h-22v-139h-32v-21h32v-22c1.26-14.35 7.59-25.85 19-34.5 14.31-9.61 29.98-12.78 47-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8f8f",
    d: "M9742.5 7793.5c.99 6.81 1.32 13.81 1 21-1.91.28-3.58-.05-5-1h4v-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M1011.5 7796.5h22v32h-22v-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868686",
    d: "M1011.5 7796.5c7.48-.99 15.15-1.33 23-1v34c-7.85.33-15.52-.01-23-1h22v-32h-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M6823.5 7796.5h22v32h-22v-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868686",
    d: "M6823.5 7796.5c7.48-.99 15.15-1.33 23-1v34c-7.85.33-15.52-.01-23-1h22v-32h-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M7313.5 7796.5h22v32h-22v-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868686",
    d: "M7313.5 7796.5c7.48-.99 15.15-1.33 23-1v34c-7.85.33-15.52-.01-23-1h22v-32h-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M8361.5 7796.5h22v32h-22v-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868686",
    d: "M8361.5 7796.5c7.48-.99 15.15-1.33 23-1v34c-7.85.33-15.52-.01-23-1h22v-32h-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M6574.5 7858.5c11.49.99 23.15 1.33 35 1v21c-11.85-.33-23.51.01-35 1-.47 34.38.03 68.72 1.5 103 4.36 11.33 12.69 16.66 25 16 3.86-.18 7.69-.51 11.5-1v20c-15.14 4.09-29.47 2.26-43-5.5-10.12-8.07-15.62-18.57-16.5-31.5-.5-33.67-.67-67.33-.5-101h-30v-23c16.19 2.63 26.03-4.04 29.5-20 .5-5.66.67-11.32.5-17h22v37ZM9581.5 7858.5c11.49.99 23.15 1.33 35 1v21c-11.85-.33-23.51.01-35 1-.47 34.38.03 68.72 1.5 103 4.36 11.33 12.69 16.66 25 16 3.86-.18 7.69-.51 11.5-1v20c-15.14 4.09-29.47 2.26-43-5.5-10.12-8.07-15.62-18.57-16.5-31.5-.5-33.67-.67-67.33-.5-101h-30v-23c16.19 2.63 26.03-4.04 29.5-20 .5-5.66.67-11.32.5-17h22v37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M1136.5 7855.5c31.18-4 54.01 7.67 68.5 35 1.34 4.68 2.68 9.35 4 14 .5 38.33.67 76.67.5 115h-22c.17-34.67 0-69.33-.5-104-3.9-23.91-17.9-36.57-42-38-20.21.88-33.54 10.88-40 30-1.48 37.29-1.98 74.62-1.5 112h-23v-161h23c-.17 6.01 0 12.01.5 18 8.75-10.44 19.58-17.44 32.5-21ZM1522.5 7855.5c41.15-4.52 70.98 11.48 89.5 48 9.92 27.4 8.26 54.07-5 80-23.98 34.55-56.48 46.39-97.5 35.5-30.92-12.59-48.75-35.42-53.5-68.5-4.09-41 12.08-70.84 48.5-89.5 6.03-2.16 12.03-3.99 18-5.5ZM2126.5 7945.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.28-36.58 42.78-53.41 82.5-50.5 31.39 5.72 51.89 23.89 61.5 54.5 2.7 11.56 3.2 23.22 1.5 35ZM2376.5 7855.5c28.8-3.13 52.97 5.87 72.5 27 2.88 3.93 5.38 8.1 7.5 12.5-.14.77-.48 1.44-1 2-6.24 3.04-12.41 6.21-18.5 9.5-15.51-25.4-37.68-33.9-66.5-25.5-24.14 11.26-36.14 30.26-36 57-.63 25.08 9.7 44.08 31 57 30.53 11.92 54.36 4.09 71.5-23.5 6.32 3.33 12.65 6.66 19 10 .67 1 .67 2 0 3-15.33 25.25-37.83 37.92-67.5 38-35.01-.92-59.17-17.59-72.5-50-10.8-31.78-6.8-61.45 12-89 13.06-14.94 29.23-24.27 48.5-28ZM2557.5 7855.5c41.15-4.52 70.98 11.48 89.5 48 9.92 27.4 8.26 54.07-5 80-23.98 34.55-56.48 46.39-97.5 35.5-30.92-12.59-48.75-35.42-53.5-68.5-4.09-41 12.08-70.84 48.5-89.5 6.03-2.16 12.03-3.99 18-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M2747.5 7855.5c27.44-3.27 48.77 6.39 64 29 13.36-22.19 33.03-31.69 59-28.5 29.6 5.27 46.77 22.77 51.5 52.5.5 37 .67 74 .5 111h-23c.17-35.67 0-71.33-.5-107-6.75-27.13-23.92-38.29-51.5-33.5-16.49 6.16-25.99 18-28.5 35.5-.5 35-.67 70-.5 105h-22c.17-34.67 0-69.33-.5-104-6.39-30.1-24.55-41.94-54.5-35.5-12.65 5.12-20.82 14.29-24.5 27.5-1.48 37.29-1.98 74.62-1.5 112h-23v-161h23c-.17 6.01 0 12.01.5 18 8.25-10.42 18.75-17.42 31.5-21ZM3019.5 7855.5c27.44-3.27 48.77 6.39 64 29 13.36-22.19 33.03-31.69 59-28.5 29.6 5.27 46.77 22.77 51.5 52.5.5 37 .67 74 .5 111h-23c.17-35.67 0-71.33-.5-107-6.75-27.13-23.92-38.29-51.5-33.5-16.49 6.16-25.99 18-28.5 35.5-.5 35-.67 70-.5 105h-22c.17-34.67 0-69.33-.5-104-6.39-30.1-24.55-41.94-54.5-35.5-12.65 5.12-20.82 14.29-24.5 27.5-1.48 37.29-1.98 74.62-1.5 112h-23v-161h23c-.17 6.01 0 12.01.5 18 8.25-10.42 18.75-17.42 31.5-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M3381.5 7945.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.28-36.58 42.78-53.41 82.5-50.5 31.39 5.72 51.89 23.89 61.5 54.5 2.7 11.56 3.2 23.22 1.5 35ZM3583.5 7855.5c28.8-3.13 52.97 5.87 72.5 27 2.88 3.93 5.38 8.1 7.5 12.5-.14.77-.48 1.44-1 2-6.24 3.04-12.41 6.21-18.5 9.5-15.51-25.4-37.68-33.9-66.5-25.5-24.14 11.26-36.14 30.26-36 57-.63 25.08 9.7 44.08 31 57 30.53 11.92 54.36 4.09 71.5-23.5 6.32 3.33 12.65 6.66 19 10 .67 1 .67 2 0 3-15.33 25.25-37.83 37.92-67.5 38-35.01-.92-59.17-17.59-72.5-50-10.8-31.78-6.8-61.45 12-89 13.06-14.94 29.23-24.27 48.5-28ZM3847.5 7945.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.28-36.58 42.78-53.41 82.5-50.5 31.39 5.72 51.89 23.89 61.5 54.5 2.7 11.56 3.2 23.22 1.5 35Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M3990.5 7855.5c21.62-2.93 40.95 2.24 58 15.5 9.34 9.19 14.51 20.35 15.5 33.5.5 38.33.67 76.67.5 115h-23c.17-7.34 0-14.67-.5-22-15.02 17.41-34.19 26.08-57.5 26-20.77-.62-36.6-9.62-47.5-27-9.39-36.69 4.44-59.53 41.5-68.5 21.33-3.61 42.66-7.11 64-10.5 1.26-26.41-11.41-40.08-38-41-11.31-.18-21.31 3.32-30 10.5-4.55 5.05-8.88 10.21-13 15.5-6.29-3.13-12.46-6.47-18.5-10 .78-3.91 2.45-7.58 5-11 12.05-12.93 26.55-21.6 43.5-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M4166.5 7855.5c31.18-4 54.01 7.67 68.5 35 1.34 4.68 2.68 9.35 4 14 .5 38.33.67 76.67.5 115h-22c.17-34.67 0-69.33-.5-104-3.9-23.91-17.9-36.57-42-38-20.21.88-33.54 10.88-40 30-1.48 37.29-1.98 74.62-1.5 112h-23v-161h23c-.17 6.01 0 12.01.5 18 8.75-10.44 19.58-17.44 32.5-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M4588.5 7855.5c27.44-3.27 48.77 6.39 64 29 13.36-22.19 33.03-31.69 59-28.5 29.6 5.27 46.77 22.77 51.5 52.5.5 37 .67 74 .5 111h-23c.17-35.67 0-71.33-.5-107-6.75-27.13-23.92-38.29-51.5-33.5-16.49 6.16-25.99 18-28.5 35.5-.5 35-.67 70-.5 105h-22c.17-34.67 0-69.33-.5-104-6.39-30.1-24.55-41.94-54.5-35.5-12.65 5.12-20.82 14.29-24.5 27.5-1.48 37.29-1.98 74.62-1.5 112h-23v-161h23c-.17 6.01 0 12.01.5 18 8.25-10.42 18.75-17.42 31.5-21ZM4857.5 7855.5c21.62-2.93 40.95 2.24 58 15.5 9.34 9.19 14.51 20.35 15.5 33.5.5 38.33.67 76.67.5 115h-23c.17-7.34 0-14.67-.5-22-15.02 17.41-34.19 26.08-57.5 26-20.77-.62-36.6-9.62-47.5-27-9.39-36.69 4.44-59.53 41.5-68.5 21.33-3.61 42.66-7.11 64-10.5 1.26-26.41-11.41-40.08-38-41-11.31-.18-21.31 3.32-30 10.5-4.55 5.05-8.88 10.21-13 15.5-6.29-3.13-12.46-6.47-18.5-10 .78-3.91 2.45-7.58 5-11 12.05-12.93 26.55-21.6 43.5-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M5033.5 7855.5c31.18-4 54.01 7.67 68.5 35 1.34 4.68 2.68 9.35 4 14 .5 38.33.67 76.67.5 115h-22c.17-34.67 0-69.33-.5-104-3.9-23.91-17.9-36.57-42-38-20.21.88-33.54 10.88-40 30-1.48 37.29-1.98 74.62-1.5 112h-23v-161h23c-.17 6.01 0 12.01.5 18 8.75-10.44 19.58-17.44 32.5-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M5201.5 7855.5c21.62-2.93 40.95 2.24 58 15.5 9.34 9.19 14.51 20.35 15.5 33.5.5 38.33.67 76.67.5 115h-23c.17-7.34 0-14.67-.5-22-15.02 17.41-34.19 26.08-57.5 26-20.77-.62-36.6-9.62-47.5-27-9.39-36.69 4.44-59.53 41.5-68.5 21.33-3.61 42.66-7.11 64-10.5 1.26-26.41-11.41-40.08-38-41-11.31-.18-21.31 3.32-30 10.5-4.55 5.05-8.88 10.21-13 15.5-6.29-3.13-12.46-6.47-18.5-10 .78-3.91 2.45-7.58 5-11 12.05-12.93 26.55-21.6 43.5-26ZM5378.5 7855.5c23.03-2.91 43.7 2.59 62 16.5 3.54 3.2 6.7 6.7 9.5 10.5.5-7.99.67-15.99.5-24h23c.17 53.67 0 107.33-.5 161-7.8 43.26-33.8 65.26-78 66-23.18-.17-42.85-8.5-59-25-2.67-4-5.33-8-8-12-.67-1-.67-2 0-3 6.03-3.85 12.37-7.18 19-10 13.9 22.52 34.07 31.36 60.5 26.5 24.71-4.38 38.88-18.88 42.5-43.5.67-10 .67-20 0-30-14.33 18.66-33.33 28.33-57 29-33.3-1.66-57.3-17.33-72-47-11.62-30.57-8.29-59.24 10-86 12.75-14.95 28.58-24.61 47.5-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M5663.5 7945.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.28-36.58 42.78-53.41 82.5-50.5 31.39 5.72 51.89 23.89 61.5 54.5 2.7 11.56 3.2 23.22 1.5 35ZM5898.5 7945.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.28-36.58 42.78-53.41 82.5-50.5 31.39 5.72 51.89 23.89 61.5 54.5 2.7 11.56 3.2 23.22 1.5 35ZM6232.5 7945.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.28-36.58 42.78-53.41 82.5-50.5 31.39 5.72 51.89 23.89 61.5 54.5 2.7 11.56 3.2 23.22 1.5 35ZM6948.5 7855.5c31.18-4 54.01 7.67 68.5 35 1.34 4.68 2.68 9.35 4 14 .5 38.33.67 76.67.5 115h-22c.17-34.67 0-69.33-.5-104-3.9-23.91-17.9-36.57-42-38-20.21.88-33.54 10.88-40 30-1.48 37.29-1.98 74.62-1.5 112h-23v-161h23c-.17 6.01 0 12.01.5 18 8.75-10.44 19.58-17.44 32.5-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M7122.5 7855.5c23.03-2.91 43.7 2.59 62 16.5 3.54 3.2 6.7 6.7 9.5 10.5.5-7.99.67-15.99.5-24h23c.17 53.67 0 107.33-.5 161-7.8 43.26-33.8 65.26-78 66-23.18-.17-42.85-8.5-59-25-2.67-4-5.33-8-8-12-.67-1-.67-2 0-3 6.03-3.85 12.37-7.18 19-10 13.9 22.52 34.07 31.36 60.5 26.5 24.71-4.38 38.88-18.88 42.5-43.5.67-10 .67-20 0-30-14.33 18.66-33.33 28.33-57 29-33.3-1.66-57.3-17.33-72-47-11.62-30.57-8.29-59.24 10-86 12.75-14.95 28.58-24.61 47.5-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M7438.5 7855.5c31.18-4 54.01 7.67 68.5 35 1.34 4.68 2.68 9.35 4 14 .5 38.33.67 76.67.5 115h-22c.17-34.67 0-69.33-.5-104-3.9-23.91-17.9-36.57-42-38-20.21.88-33.54 10.88-40 30-1.48 37.29-1.98 74.62-1.5 112h-23v-161h23c-.17 6.01 0 12.01.5 18 8.75-10.44 19.58-17.44 32.5-21ZM7666.5 7855.5c41.15-4.52 70.98 11.48 89.5 48 9.92 27.4 8.26 54.07-5 80-23.98 34.55-56.48 46.39-97.5 35.5-30.92-12.59-48.75-35.42-53.5-68.5-4.09-41 12.08-70.84 48.5-89.5 6.03-2.16 12.03-3.99 18-5.5ZM7857.5 7855.5c31.18-4 54.01 7.67 68.5 35 1.34 4.68 2.68 9.35 4 14 .5 38.33.67 76.67.5 115h-22c.17-34.67 0-69.33-.5-104-3.9-23.91-17.9-36.57-42-38-20.21.88-33.54 10.88-40 30-1.48 37.29-1.98 74.62-1.5 112h-23v-161h23c-.17 6.01 0 12.01.5 18 8.75-10.44 19.58-17.44 32.5-21ZM8117.5 7945.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.28-36.58 42.78-53.41 82.5-50.5 31.39 5.72 51.89 23.89 61.5 54.5 2.7 11.56 3.2 23.22 1.5 35ZM8248.5 7855.5c25.55-3.32 47.05 4.35 64.5 23 3.48 4.78 6.31 9.95 8.5 15.5-.14.77-.48 1.44-1 2-5.33 2.89-10.83 5.39-16.5 7.5-2.98-3.33-5.64-7-8-11-15.78-17.24-34.28-21.07-55.5-11.5-9.42 8.49-11.59 18.66-6.5 30.5 4.25 4.87 9.42 8.37 15.5 10.5 12.33 3.67 24.67 7.33 37 11 17.46 5.79 29.29 17.29 35.5 34.5 1.86 31.07-12.64 49.24-43.5 54.5-36.76 5.13-63.09-8.87-79-42 5.85-3.09 11.85-5.93 18-8.5 4.62 6.36 9.62 12.53 15 18.5 17.63 14.33 36.63 16.33 57 6 8.5-6.49 11.66-14.99 9.5-25.5-3.55-6.55-8.72-11.39-15.5-14.5a512.571 512.571 0 0 1-52-17c-18.47-10.06-26.3-25.56-23.5-46.5 3.74-15.41 12.91-26.24 27.5-32.5 4.43-1.57 8.76-3.07 13-4.5ZM8486.5 7855.5c31.18-4 54.01 7.67 68.5 35 1.34 4.68 2.68 9.35 4 14 .5 38.33.67 76.67.5 115h-22c.17-34.67 0-69.33-.5-104-3.9-23.91-17.9-36.57-42-38-20.21.88-33.54 10.88-40 30-1.48 37.29-1.98 74.62-1.5 112h-23v-161h23c-.17 6.01 0 12.01.5 18 8.75-10.44 19.58-17.44 32.5-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M8660.5 7855.5c23.03-2.91 43.7 2.59 62 16.5 3.54 3.2 6.7 6.7 9.5 10.5.5-7.99.67-15.99.5-24h23c.17 53.67 0 107.33-.5 161-7.8 43.26-33.8 65.26-78 66-23.18-.17-42.85-8.5-59-25-2.67-4-5.33-8-8-12-.67-1-.67-2 0-3 6.03-3.85 12.37-7.18 19-10 13.9 22.52 34.07 31.36 60.5 26.5 24.71-4.38 38.88-18.88 42.5-43.5.67-10 .67-20 0-30-14.33 18.66-33.33 28.33-57 29-33.3-1.66-57.3-17.33-72-47-11.62-30.57-8.29-59.24 10-86 12.75-14.95 28.58-24.61 47.5-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M9013.5 7945.5h-127c-.3 2.56.03 4.89 1 7 5.49 30.82 23.82 47.16 55 49 12.69.82 24.02-2.68 34-10.5 5.93-5.6 11.43-11.43 16.5-17.5 5.49 2.82 10.99 5.65 16.5 8.5 1.02 1.05 1.18 2.22.5 3.5-15.66 25.25-38.5 37.59-68.5 37-35.49-1.41-59.83-18.58-73-51.5-6.46-21.45-6.62-42.95-.5-64.5 15.28-36.58 42.78-53.41 82.5-50.5 31.39 5.72 51.89 23.89 61.5 54.5 2.7 11.56 3.2 23.22 1.5 35ZM9106.5 8079.5v-220h21c-.33 7.7 0 15.36 1 23 .61-.12.94-.46 1-1 18.2-21.02 41.2-29.52 69-25.5 33.09 6.09 54.59 25.26 64.5 57.5 6.86 29.34 1.86 56.34-15 81-23.98 26.43-53.14 34.6-87.5 24.5-13.15-4.82-23.65-12.99-31.5-24.5-.5 28.33-.67 56.66-.5 85h-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M9426.5 7855.5c21.62-2.93 40.95 2.24 58 15.5 9.34 9.19 14.51 20.35 15.5 33.5.5 38.33.67 76.67.5 115h-23c.17-7.34 0-14.67-.5-22-15.02 17.41-34.19 26.08-57.5 26-20.77-.62-36.6-9.62-47.5-27-9.39-36.69 4.44-59.53 41.5-68.5 21.33-3.61 42.66-7.11 64-10.5 1.26-26.41-11.41-40.08-38-41-11.31-.18-21.31 3.32-30 10.5-4.55 5.05-8.88 10.21-13 15.5-6.29-3.13-12.46-6.47-18.5-10 .78-3.91 2.45-7.58 5-11 12.05-12.93 26.55-21.6 43.5-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M9828.5 7855.5c41.15-4.52 70.98 11.48 89.5 48 9.92 27.4 8.26 54.07-5 80-23.98 34.55-56.48 46.39-97.5 35.5-30.92-12.59-48.75-35.42-53.5-68.5-4.09-41 12.08-70.84 48.5-89.5 6.03-2.16 12.03-3.99 18-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M10120.5 7855.5c27.4-3.27 48.8 6.39 64 29 13.4-22.19 33-31.69 59-28.5 29.6 5.27 46.8 22.77 51.5 52.5.5 37 .7 74 .5 111h-23c.2-35.67 0-71.33-.5-107-6.7-27.13-23.9-38.29-51.5-33.5-16.5 6.16-26 18-28.5 35.5-.5 35-.7 70-.5 105h-22c.2-34.67 0-69.33-.5-104-6.4-30.1-24.6-41.94-54.5-35.5-12.7 5.12-20.8 14.29-24.5 27.5-1.5 37.29-2 74.62-1.5 112h-23v-161h23c-.2 6.01 0 12.01.5 18 8.2-10.42 18.7-17.42 31.5-21ZM1883.5 7856.5h21v23c-17.37-3.75-32.21.59-44.5 13-3.42 4.84-5.75 10.18-7 16-.5 37-.67 74-.5 111h-23v-161h23c-.17 5.34 0 10.68.5 16 8.2-9.51 18.36-15.51 30.5-18ZM3475.5 7856.5h21v23c-17.37-3.75-32.21.59-44.5 13-3.42 4.84-5.75 10.18-7 16-.5 37-.67 74-.5 111h-23v-161h23c-.17 5.34 0 10.68.5 16 8.2-9.51 18.36-15.51 30.5-18ZM6326.5 7856.5h21v23c-17.37-3.75-32.21.59-44.5 13-3.42 4.84-5.75 10.18-7 16-.5 37-.67 74-.5 111h-23v-161h23c-.17 5.34 0 10.68.5 16 8.2-9.51 18.36-15.51 30.5-18ZM10018.5 7856.5h21v23c-17.4-3.75-32.2.59-44.5 13-3.42 4.84-5.75 10.18-7 16-.5 37-.67 74-.5 111h-23v-161h23c-.17 5.34 0 10.68.5 16 8.2-9.51 18.4-15.51 30.5-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323232",
    d: "M1011.5 7858.5h23v161h-23v-161Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M1284.5 7858.5c8.03-.33 16.03 0 24 1 17.22 43.82 34.72 87.49 52.5 131 17.47-43.92 34.64-87.92 51.5-132 8.36-.33 16.69 0 25 1-23.26 57.29-46.43 114.63-69.5 172-5.6 16.25-14.44 30.42-26.5 42.5-16.16 11.86-33.82 14.7-53 8.5-1-6.97-1.33-13.97-1-21 9.31 1.05 18.64 1.22 28 .5 9.77-2.63 16.94-8.47 21.5-17.5a205.27 205.27 0 0 0 10.5-25 23729.7 23729.7 0 0 1-63-161Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M1760.5 7958.5c1-32.83 1.33-65.83 1-99h21v160h-22c.17-6.01 0-12.01-.5-18-7.32 9.59-16.82 16.09-28.5 19.5-38.3 7.11-63.47-7.73-75.5-44.5-.33-2.67-.67-5.33-1-8-.5-36.67-.67-73.33-.5-110h22c-.17 35.33 0 70.67.5 106 6.02 26.99 22.85 38.83 50.5 35.5 20.75-5.93 31.75-19.76 33-41.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#585757",
    d: "M1782.5 8019.5v-160h-21c.33 33.17 0 66.17-1 99v-100h23c.33 53.84 0 107.5-1 161Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303030",
    d: "M5917.5 7858.5h25c15.48 43.27 31.65 86.27 48.5 129 16.26-42.63 32.43-85.29 48.5-128 8.31-1 16.64-1.33 25-1-20.67 53.67-41.33 107.33-62 161-7.7.33-15.36 0-23-1a7768.334 7768.334 0 0 1-62-160ZM6355.5 7858.5c8.03-.33 16.03 0 24 1 17.22 43.82 34.72 87.49 52.5 131 17.47-43.92 34.64-87.92 51.5-132 8.36-.33 16.69 0 25 1-23.26 57.29-46.43 114.63-69.5 172-5.6 16.25-14.44 30.42-26.5 42.5-16.16 11.86-33.82 14.7-53 8.5-1-6.97-1.33-13.97-1-21 9.31 1.05 18.64 1.22 28 .5 9.77-2.63 16.94-8.47 21.5-17.5a205.27 205.27 0 0 0 10.5-25 23729.7 23729.7 0 0 1-63-161Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#323232",
    d: "M6823.5 7858.5h23v161h-23v-161ZM7313.5 7858.5h23v161h-23v-161ZM8361.5 7858.5h23v161h-23v-161Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#424242",
    d: "M9129.5 7881.5c-.06.54-.39.88-1 1-1-7.64-1.33-15.3-1-23h-21v220c-1-73.5-1.33-147.16-1-221h23c-.33 7.85.01 15.52 1 23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M2102.5 7916.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM3357.5 7916.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM3823.5 7916.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM5639.5 7916.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM5874.5 7916.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM6208.5 7916.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM8093.5 7916.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10ZM8989.5 7916.5v8h-102c3.55-25.05 17.55-40.88 42-47.5 26.33-3.75 45.5 6.08 57.5 29.5 1.35 3.22 2.19 6.55 2.5 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M1527.5 7877.5c36.71-1.23 58.88 16.1 66.5 52 2.82 26.84-6.68 48.01-28.5 63.5-31.63 14.79-57.46 7.95-77.5-20.5-9.36-18.3-11.03-37.3-5-57 8.63-20.15 23.46-32.81 44.5-38ZM2562.5 7877.5c36.71-1.23 58.88 16.1 66.5 52 2.82 26.84-6.68 48.01-28.5 63.5-31.63 14.79-57.46 7.95-77.5-20.5-9.36-18.3-11.03-37.3-5-57 8.63-20.15 23.46-32.81 44.5-38ZM4347.5 7877.5c34.73-1.42 56.56 14.58 65.5 48 3.7 20.89-.97 39.55-14 56-23.03 22.02-48.2 24.85-75.5 8.5-22.2-20.96-28.7-46.12-19.5-75.5 8.31-19.82 22.81-32.16 43.5-37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M5385.5 7877.5c34.64-.85 56.14 15.48 64.5 49 2.87 28.76-8.29 49.92-33.5 63.5-28.7 10.32-51.87 3.15-69.5-21.5-16.49-32.5-10.66-60 17.5-82.5 6.69-3.94 13.69-6.78 21-8.5ZM7129.5 7877.5c34.64-.85 56.14 15.48 64.5 49 2.87 28.76-8.29 49.92-33.5 63.5-28.7 10.32-51.87 3.15-69.5-21.5-16.49-32.5-10.66-60 17.5-82.5 6.69-3.94 13.69-6.78 21-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M7671.5 7877.5c36.71-1.23 58.88 16.1 66.5 52 2.82 26.84-6.68 48.01-28.5 63.5-31.63 14.79-57.46 7.95-77.5-20.5-9.36-18.3-11.03-37.3-5-57 8.63-20.15 23.46-32.81 44.5-38Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M8667.5 7877.5c34.64-.85 56.14 15.48 64.5 49 2.87 28.76-8.29 49.92-33.5 63.5-28.7 10.32-51.87 3.15-69.5-21.5-16.49-32.5-10.66-60 17.5-82.5 6.69-3.94 13.69-6.78 21-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M9176.5 7877.5c33.88-1.31 55.38 14.36 64.5 47 4.91 29.3-4.59 52.46-28.5 69.5-30.13 13.09-54.96 6.59-74.5-19.5-10.22-18.83-12.22-38.49-6-59 8.63-20.15 23.47-32.82 44.5-38ZM9833.5 7877.5c36.71-1.23 58.88 16.1 66.5 52 2.82 26.84-6.68 48.01-28.5 63.5-31.63 14.79-57.46 7.95-77.5-20.5-9.36-18.3-11.03-37.3-5-57 8.63-20.15 23.46-32.81 44.5-38Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#676666",
    d: "M6574.5 7858.5h36v23h-36c11.49-.99 23.15-1.33 35-1v-21c-11.85.33-23.51-.01-35-1ZM9581.5 7858.5h36v23h-36c11.49-.99 23.15-1.33 35-1v-21c-11.85.33-23.51-.01-35-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#858484",
    d: "M9676.5 7837.5v22h-32v21h32v139c-1-45.83-1.33-91.83-1-138h-32v-23h32c-.32-7.19.01-14.19 1-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b6b6b",
    d: "M9698.5 7858.5h40v23h-40c12.82-1 25.82-1.33 39-1v-21c-13.18.33-26.18 0-39-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M2102.5 7916.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM3357.5 7916.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM3823.5 7916.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM5639.5 7916.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM5874.5 7916.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM6208.5 7916.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM8093.5 7916.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8ZM8989.5 7916.5c.98 2.79 1.31 5.79 1 9-34.5.33-68.84 0-103-1h102v-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M2165.5 7928.5h105v21h-105v-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M4032.5 7938.5h9c3.05 31.1-9.95 51.93-39 62.5-9.37 1.86-18.7 1.86-28 0-19.24-9.23-23.41-23.06-12.5-41.5 5.33-5.75 11.83-9.58 19.5-11.5 17.13-3.19 34.13-6.35 51-9.5ZM4899.5 7938.5h9c3.05 31.1-9.95 51.93-39 62.5-9.37 1.86-18.7 1.86-28 0-19.24-9.23-23.41-23.06-12.5-41.5 5.33-5.75 11.83-9.58 19.5-11.5 17.13-3.19 34.13-6.35 51-9.5ZM5243.5 7938.5h9c3.05 31.1-9.95 51.93-39 62.5-9.37 1.86-18.7 1.86-28 0-19.24-9.23-23.41-23.06-12.5-41.5 5.33-5.75 11.83-9.58 19.5-11.5 17.13-3.19 34.13-6.35 51-9.5ZM9468.5 7938.5h9c3.05 31.1-9.95 51.93-39 62.5-9.37 1.86-18.7 1.86-28 0-19.24-9.23-23.41-23.06-12.5-41.5 5.33-5.75 11.83-9.58 19.5-11.5 17.13-3.19 34.13-6.35 51-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a8a8a",
    d: "M2126.5 7945.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM3381.5 7945.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM3847.5 7945.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM5663.5 7945.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM5898.5 7945.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM6232.5 7945.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM8117.5 7945.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127ZM9013.5 7945.5c-41.83 1-83.83 1.33-126 1v6c-.97-2.11-1.3-4.44-1-7h127Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f2f2f",
    d: "M10346.5 7986.5h24v33h-24v-33Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#959595",
    d: "M4414.5 8019.5c-.67-8-1.33-16-2-24 .28-.79.78-1.46 1.5-2 .5 8.66.67 17.33.5 26Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#fefffe",
    d: "M-.5 8657.5c1.333.67 1.333.67 0 0ZM550.5 9212.5c-.667-1.33-.667-1.33 0 0ZM12952.5 9212.5c-.7-1.33-.7-1.33 0 0Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.ff3bfa8c94605f16da1c1bf0daeb405c.svg";
export { ForwardRef as ReactComponent };